import { defineComponent as Se, openBlock as $, createElementBlock as Z, createElementVNode as ne, toDisplayString as Oe, createCommentVNode as de, normalizeClass as ye, renderSlot as ve, createBlock as ke, unref as j, createVNode as Fe, mergeProps as Ae, shallowRef as kn, watch as Be, computed as W, toValue as Ge, reactive as ti, h as Bs, getCurrentInstance as ni, inject as Wn, resolveComponent as Na, createPropsRestProxy as ga, resolveDynamicComponent as zt, withCtx as Te, ref as ge, onMounted as pt, Transition as wn, normalizeProps as Lt, guardReactiveProps as Ot, createTextVNode as xt, toRef as Bi, normalizeStyle as Ct, Teleport as ba, useSlots as An, onUpdated as so, onUnmounted as Ln, withModifiers as sa, Fragment as Xe, renderList as ht, useModel as Wa, mergeModels as Sn, useTemplateRef as ot, nextTick as Ya, createSlots as Xa, isRef as zi, onBeforeUnmount as ai, provide as ri, withDirectives as Qt, withKeys as ii, vModelCheckbox as co, vModelDynamic as Vi, readonly as uo, vShow as li, createStaticVNode as zs, TransitionGroup as Vs, getCurrentScope as Hs, onScopeDispose as Us, shallowReadonly as Mn, version as qs, vModelRadio as js, toRefs as Ca, onServerPrefetch as Zs, onBeforeMount as Ws, vModelText as Ys } from "vue";
import { toArray as Xs, unrefElement as fo, tryOnScopeDispose as Gs, refDebounced as Ks, useTransition as Js, TransitionPresets as Qs, useScrollLock as ho, onClickOutside as Ga, onKeyStroke as vo, useEventListener as qt, useMediaQuery as ec, usePreferredReducedMotion as mo, useVibrate as go, useTimeoutFn as ta, useIntervalFn as tc, useDebounceFn as nc, useElementSize as Hr, useResizeObserver as ac, usePointerSwipe as rc } from "@vueuse/core";
import { isNotNestedPath as ic, cleanupNonNestedPath as lc, useForm as oc, useField as sc } from "vee-validate";
const cc = {
  key: 0,
  class: "lc-count-bubble"
}, Ur = /* @__PURE__ */ Se({
  __name: "LcCountBubble",
  props: {
    count: {}
  },
  setup(e) {
    return (t, n) => e.count ? ($(), Z("div", cc, [
      ne("span", null, Oe(Math.min(e.count, 99)), 1)
    ])) : de("", !0);
  }
}), Ke = /* @__PURE__ */ Se({
  __name: "LcIcon",
  props: {
    name: {},
    size: { default: "medium" }
  },
  setup(e) {
    return (t, n) => ($(), Z("i", {
      "aria-hidden": "true",
      class: ye(["lc-icon", `lc-icon--${e.name}`, `lc-icon--size-${e.size}`]),
      focusable: "false"
    }, null, 2));
  }
}), V1 = ["large", "medium", "small"], H1 = [
  "account-balance",
  "add",
  "alarm",
  "alert-circle",
  "alert-triangle",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-right-small",
  "arrow-up",
  "arrowhead-right",
  "award",
  "bank",
  "bell",
  "bell-off",
  "calendar",
  "camera",
  "camera-scan",
  "card-add-funds",
  "card-expired",
  "card-okay",
  "careers",
  "chat",
  "checkmark",
  "checkmark-circle",
  "checkmark-small",
  "chevron-circle",
  "chevron-close",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "close",
  "close-account",
  "close-large",
  "cloud-upload",
  "copy",
  "data",
  "day-afternoon",
  "day-evening",
  "day-midday",
  "day-morning",
  "deposit-limits",
  "download",
  "dropdown-down",
  "dropdown-left",
  "dropdown-right",
  "dropdown-up",
  "edit",
  "edit-active",
  "email",
  "emoji-bad",
  "emoji-good",
  "emoji-ok",
  "exclamation",
  "external-link",
  "eye",
  "eye-close",
  "eye-off",
  "file",
  "file-text",
  "file-type",
  "filter",
  "fire",
  "flash",
  "flash-plus",
  "game",
  "gift",
  "heart",
  "helpcenter",
  "hero",
  "hit-megahit",
  "hit-powerhit",
  "house",
  "id",
  "info",
  "info-help",
  "keno",
  "language",
  "language-lt",
  "limits",
  "limits-purchase",
  "link",
  "list",
  "loader",
  "location",
  "location-not-allowed",
  "lock",
  "login",
  "logout",
  "map",
  "mark-all-as-read",
  "menu",
  "message-circle",
  "message-square",
  "minus",
  "mobile-phone",
  "more-horizontal",
  "more-vertical",
  "orders",
  "orders-canceled",
  "orders-multiple-filled-xx",
  "orders-multiple-filled-xxx",
  "orders-multiple-xx",
  "orders-multiple-xxx",
  "orders-purchased",
  "orders-waiting-for-purchase",
  "passkey",
  "pause",
  "payment-options",
  "phone-call",
  "play",
  "play-filled",
  "plus",
  "plus-small",
  "prepaid",
  "prepaid-participating",
  "pricetag",
  "prize",
  "profile-block",
  "profile-circle",
  "profile-close",
  "profile-customer-id",
  "profile-person",
  "profile-personal-info",
  "profile-self-exclusion",
  "protect",
  "question",
  "quick-pick-settings",
  "reset",
  "retailer",
  "save",
  "scratch-autoreveal",
  "scratch-backside",
  "scratch-demo",
  "scratch-now",
  "scratch-processing",
  "scratch-scratched",
  "scratch-unscratched",
  "scratchcard",
  "search",
  "serial-number",
  "settings",
  "shopping-card-empty",
  "shopping-card-filled",
  "shopping-cart",
  "show-all",
  "shuffle-h",
  "shuffle-numbers",
  "shuffle-v",
  "spades",
  "star",
  "status-of-order",
  "subscription",
  "subscription-deactivated",
  "subscription-paused",
  "swap",
  "sync",
  "tab-lotteries",
  "tab-scratchcards",
  "ticket-processing",
  "time",
  "time-pending",
  "time-sandclock",
  "touch",
  "transaction",
  "transaction-credit-note",
  "transaction-debit-note",
  "transaction-funding",
  "transaction-refund",
  "transactions-chargeback",
  "transactions-old",
  "transactions-payout",
  "transactions-reverse-chargeback",
  "trash-empty",
  "trash-full",
  "unlock",
  "unverified-shield",
  "upload",
  "verify",
  "verify-guard",
  "verify-shield",
  "winning",
  "winning-correction",
  "zoom"
], uc = { class: "lc-badge" }, U1 = /* @__PURE__ */ Se({
  __name: "LcBadge",
  props: {
    count: {},
    icon: {}
  },
  setup(e) {
    return (t, n) => ($(), Z("div", uc, [
      ve(t.$slots, "icon", {}, () => [
        e.icon ? ($(), ke(j(Ke), {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : de("", !0)
      ]),
      Fe(j(Ur), Ae({ count: e.count }, { class: "lc-badge__count" }), null, 16),
      ve(t.$slots, "default")
    ]));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const dc = (e) => e != null;
var bo = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Pa = /* @__PURE__ */ bo.join(","), po = typeof Element > "u", _n = po ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Ba = !po && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, za = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var s = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = s === "" || s === "true", a = i || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : za(t.parentNode));
  return a;
}, fc = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, yo = function(t, n, r) {
  if (za(t))
    return [];
  var s = Array.prototype.slice.apply(t.querySelectorAll(Pa));
  return n && _n.call(t, Pa) && s.unshift(t), s = s.filter(r), s;
}, Va = function(t, n, r) {
  for (var s = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!za(a, !1))
      if (a.tagName === "SLOT") {
        var o = a.assignedElements(), l = o.length ? o : a.children, h = Va(l, !0, r);
        r.flatten ? s.push.apply(s, h) : s.push({
          scopeParent: a,
          candidates: h
        });
      } else {
        var v = _n.call(a, Pa);
        v && r.filter(a) && (n || !t.includes(a)) && s.push(a);
        var u = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), f = !za(u, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (u && f) {
          var m = Va(u === !0 ? a.children : u.children, !0, r);
          r.flatten ? s.push.apply(s, m) : s.push({
            scopeParent: a,
            candidates: m
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return s;
}, wo = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, pn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || fc(t)) && !wo(t) ? 0 : t.tabIndex;
}, hc = function(t, n) {
  var r = pn(t);
  return r < 0 && n && !wo(t) ? 0 : r;
}, vc = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, xo = function(t) {
  return t.tagName === "INPUT";
}, mc = function(t) {
  return xo(t) && t.type === "hidden";
}, gc = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, bc = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, pc = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Ba(t), r = function(o) {
    return n.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = r(window.CSS.escape(t.name));
  else
    try {
      s = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = bc(s, t.form);
  return !i || i === t;
}, yc = function(t) {
  return xo(t) && t.type === "radio";
}, wc = function(t) {
  return yc(t) && !pc(t);
}, xc = function(t) {
  var n, r = t && Ba(t), s = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, o, l;
    for (i = !!((a = s) !== null && a !== void 0 && (o = a.ownerDocument) !== null && o !== void 0 && o.contains(s) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && s; ) {
      var h, v, u;
      r = Ba(s), s = (h = r) === null || h === void 0 ? void 0 : h.host, i = !!((v = s) !== null && v !== void 0 && (u = v.ownerDocument) !== null && u !== void 0 && u.contains(s));
    }
  }
  return i;
}, Hi = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, s = n.height;
  return r === 0 && s === 0;
}, kc = function(t, n) {
  var r = n.displayCheck, s = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  var a = getComputedStyle(t), o = a.visibility;
  if (o === "hidden" || o === "collapse")
    return !0;
  var l = _n.call(t, "details>summary:first-of-type"), h = l ? t.parentElement : t;
  if (_n.call(h, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof s == "function") {
      for (var v = t; t; ) {
        var u = t.parentElement, f = Ba(t);
        if (u && !u.shadowRoot && s(u) === !0)
          return Hi(t);
        t.assignedSlot ? t = t.assignedSlot : !u && f !== t.ownerDocument ? t = f.host : t = u;
      }
      t = v;
    }
    if (xc(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Hi(t);
  return !1;
}, Sc = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var s = n.children.item(r);
          if (s.tagName === "LEGEND")
            return _n.call(n, "fieldset[disabled] *") ? !0 : !s.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ha = function(t, n) {
  return !(n.disabled || mc(n) || kc(n, t) || // For a details element with a summary, the summary element gets the focus
  gc(n) || Sc(n));
}, qr = function(t, n) {
  return !(wc(n) || pn(n) < 0 || !Ha(t, n));
}, _c = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, ko = function(t) {
  var n = [], r = [];
  return t.forEach(function(s, i) {
    var a = !!s.scopeParent, o = a ? s.scopeParent : s, l = hc(o, a), h = a ? ko(s.candidates) : o;
    l === 0 ? a ? n.push.apply(n, h) : n.push(o) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: s,
      isScope: a,
      content: h
    });
  }), r.sort(vc).reduce(function(s, i) {
    return i.isScope ? s.push.apply(s, i.content) : s.push(i.content), s;
  }, []).concat(n);
}, Cc = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Va([t], n.includeContainer, {
    filter: qr.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: _c
  }) : r = yo(t, n.includeContainer, qr.bind(null, n)), ko(r);
}, Ec = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Va([t], n.includeContainer, {
    filter: Ha.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = yo(t, n.includeContainer, Ha.bind(null, n)), r;
}, On = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return _n.call(t, Pa) === !1 ? !1 : qr(n, t);
}, Tc = /* @__PURE__ */ bo.concat("iframe:not([inert]):not([inert] *)").join(","), pr = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return _n.call(t, Tc) === !1 ? !1 : Ha(n, t);
};
function jr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Ac(e) {
  if (Array.isArray(e)) return jr(e);
}
function Ui(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = So(e)) || t) {
      n && (e = n);
      var r = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, o = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return a = l.done, l;
    },
    e: function(l) {
      o = !0, i = l;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (o) throw i;
      }
    }
  };
}
function Lc(e, t, n) {
  return (t = Oc(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function $c(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ic() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ji(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qi(Object(n), !0).forEach(function(r) {
      Lc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Dc(e) {
  return Ac(e) || $c(e) || So(e) || Ic();
}
function Mc(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Oc(e) {
  var t = Mc(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function So(e, t) {
  if (e) {
    if (typeof e == "string") return jr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? jr(e, t) : void 0;
  }
}
var Kt = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(t, n) {
    var r = Kt.getActiveTrap(t);
    n !== r && Kt.pauseTrap(t);
    var s = t.indexOf(n);
    s === -1 || t.splice(s, 1), t.push(n);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), Kt.unpauseTrap(t);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, Rc = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Fc = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, ra = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Nc = function(t) {
  return ra(t) && !t.shiftKey;
}, Pc = function(t) {
  return ra(t) && t.shiftKey;
}, Zi = function(t) {
  return setTimeout(t, 0);
}, Gn = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
    r[s - 1] = arguments[s];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ea = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Bc = [], zc = function(t, n) {
  var r = n?.document || document, s = n?.trapStack || Bc, i = ji({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    delayReturnFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Nc,
    isKeyBackward: Pc
  }, n), a = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, o, l = function(_, E, R) {
    return _ && _[E] !== void 0 ? _[E] : i[R || E];
  }, h = function(_, E) {
    var R = typeof E?.composedPath == "function" ? E.composedPath() : void 0;
    return a.containerGroups.findIndex(function(V) {
      var q = V.container, O = V.tabbableNodes;
      return q.contains(_) || R?.includes(q) || O.find(function(Q) {
        return Q === _;
      });
    });
  }, v = function(_) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, R = E.hasFallback, V = R === void 0 ? !1 : R, q = E.params, O = q === void 0 ? [] : q, Q = i[_];
    if (typeof Q == "function" && (Q = Q.apply(void 0, Dc(O))), Q === !0 && (Q = void 0), !Q) {
      if (Q === void 0 || Q === !1)
        return Q;
      throw new Error("`".concat(_, "` was specified but was not a node, or did not return a node"));
    }
    var ae = Q;
    if (typeof Q == "string") {
      try {
        ae = r.querySelector(Q);
      } catch (le) {
        throw new Error("`".concat(_, '` appears to be an invalid selector; error="').concat(le.message, '"'));
      }
      if (!ae && !V)
        throw new Error("`".concat(_, "` as selector refers to no known node"));
    }
    return ae;
  }, u = function(_) {
    var E = _.activeElement;
    return E ? E.shadowRoot && E.shadowRoot.activeElement !== null ? u(E.shadowRoot) : E : null;
  }, f = function() {
    var _ = v("initialFocus", {
      hasFallback: !0
    });
    if (_ === !1)
      return !1;
    if (_ === void 0 || _ && !pr(_, i.tabbableOptions)) {
      var E = u(r);
      if (h(E) >= 0)
        _ = E;
      else {
        var R = a.tabbableGroups[0], V = R && R.firstTabbableNode;
        _ = V || v("fallbackFocus");
      }
    } else _ === null && (_ = v("fallbackFocus"));
    if (!_)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return _;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(_) {
      var E = Cc(_, i.tabbableOptions), R = Ec(_, i.tabbableOptions), V = E.length > 0 ? E[0] : void 0, q = E.length > 0 ? E[E.length - 1] : void 0, O = R.find(function(le) {
        return On(le);
      }), Q = R.slice().reverse().find(function(le) {
        return On(le);
      }), ae = !!E.find(function(le) {
        return pn(le) > 0;
      });
      return {
        container: _,
        tabbableNodes: E,
        focusableNodes: R,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: ae,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: V,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: q,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: O,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: Q,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(me) {
          var $e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, xe = E.indexOf(me);
          return xe < 0 ? $e ? R.slice(R.indexOf(me) + 1).find(function(fe) {
            return On(fe);
          }) : R.slice(0, R.indexOf(me)).reverse().find(function(fe) {
            return On(fe);
          }) : E[xe + ($e ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(_) {
      return _.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !v("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(_) {
      return _.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, c = function(_) {
    if (_ !== !1 && _ !== u(document)) {
      if (!_ || !_.focus) {
        c(f());
        return;
      }
      _.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = _, Rc(_) && _.select();
    }
  }, p = function(_) {
    var E = v("setReturnFocus", {
      params: [_]
    });
    return E || (E === !1 ? !1 : _);
  }, k = function(_) {
    var E = _.target, R = _.event, V = _.isBackward, q = V === void 0 ? !1 : V;
    E = E || Ea(R), m();
    var O = null;
    if (a.tabbableGroups.length > 0) {
      var Q = h(E, R), ae = Q >= 0 ? a.containerGroups[Q] : void 0;
      if (Q < 0)
        q ? O = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : O = a.tabbableGroups[0].firstTabbableNode;
      else if (q) {
        var le = a.tabbableGroups.findIndex(function(_e) {
          var Me = _e.firstTabbableNode;
          return E === Me;
        });
        if (le < 0 && (ae.container === E || pr(E, i.tabbableOptions) && !On(E, i.tabbableOptions) && !ae.nextTabbableNode(E, !1)) && (le = Q), le >= 0) {
          var me = le === 0 ? a.tabbableGroups.length - 1 : le - 1, $e = a.tabbableGroups[me];
          O = pn(E) >= 0 ? $e.lastTabbableNode : $e.lastDomTabbableNode;
        } else ra(R) || (O = ae.nextTabbableNode(E, !1));
      } else {
        var xe = a.tabbableGroups.findIndex(function(_e) {
          var Me = _e.lastTabbableNode;
          return E === Me;
        });
        if (xe < 0 && (ae.container === E || pr(E, i.tabbableOptions) && !On(E, i.tabbableOptions) && !ae.nextTabbableNode(E)) && (xe = Q), xe >= 0) {
          var fe = xe === a.tabbableGroups.length - 1 ? 0 : xe + 1, be = a.tabbableGroups[fe];
          O = pn(E) >= 0 ? be.firstTabbableNode : be.firstDomTabbableNode;
        } else ra(R) || (O = ae.nextTabbableNode(E));
      }
    } else
      O = v("fallbackFocus");
    return O;
  }, g = function(_) {
    var E = Ea(_);
    if (!(h(E, _) >= 0)) {
      if (Gn(i.clickOutsideDeactivates, _)) {
        o.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Gn(i.allowOutsideClick, _) || _.preventDefault();
    }
  }, b = function(_) {
    var E = Ea(_), R = h(E, _) >= 0;
    if (R || E instanceof Document)
      R && (a.mostRecentlyFocusedNode = E);
    else {
      _.stopImmediatePropagation();
      var V, q = !0;
      if (a.mostRecentlyFocusedNode)
        if (pn(a.mostRecentlyFocusedNode) > 0) {
          var O = h(a.mostRecentlyFocusedNode), Q = a.containerGroups[O].tabbableNodes;
          if (Q.length > 0) {
            var ae = Q.findIndex(function(le) {
              return le === a.mostRecentlyFocusedNode;
            });
            ae >= 0 && (i.isKeyForward(a.recentNavEvent) ? ae + 1 < Q.length && (V = Q[ae + 1], q = !1) : ae - 1 >= 0 && (V = Q[ae - 1], q = !1));
          }
        } else
          a.containerGroups.some(function(le) {
            return le.tabbableNodes.some(function(me) {
              return pn(me) > 0;
            });
          }) || (q = !1);
      else
        q = !1;
      q && (V = k({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), c(V || a.mostRecentlyFocusedNode || f());
    }
    a.recentNavEvent = void 0;
  }, C = function(_) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = _;
    var R = k({
      event: _,
      isBackward: E
    });
    R && (ra(_) && _.preventDefault(), c(R));
  }, A = function(_) {
    (i.isKeyForward(_) || i.isKeyBackward(_)) && C(_, i.isKeyBackward(_));
  }, D = function(_) {
    Fc(_) && Gn(i.escapeDeactivates, _) !== !1 && (_.preventDefault(), o.deactivate());
  }, L = function(_) {
    var E = Ea(_);
    h(E, _) >= 0 || Gn(i.clickOutsideDeactivates, _) || Gn(i.allowOutsideClick, _) || (_.preventDefault(), _.stopImmediatePropagation());
  }, T = function() {
    if (a.active) {
      Kt.activateTrap(s, o);
      var _;
      return i.delayInitialFocus ? _ = new Promise(function(E) {
        a.delayInitialFocusTimer = Zi(function() {
          c(f()), E();
        });
      }) : c(f()), r.addEventListener("focusin", b, !0), r.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", L, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", A, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", D), _;
    }
  }, P = function(_) {
    a.active && !a.paused && o._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var E = /* @__PURE__ */ new Set(), R = /* @__PURE__ */ new Set(), V = Ui(_), q;
    try {
      for (V.s(); !(q = V.n()).done; ) {
        var O = q.value;
        E.add(O);
        for (var Q = typeof ShadowRoot < "u" && O.getRootNode() instanceof ShadowRoot, ae = O; ae; ) {
          E.add(ae);
          var le = ae.parentElement, me = [];
          le ? me = le.children : !le && Q && (me = ae.getRootNode().children, le = ae.getRootNode().host, Q = typeof ShadowRoot < "u" && le.getRootNode() instanceof ShadowRoot);
          var $e = Ui(me), xe;
          try {
            for ($e.s(); !(xe = $e.n()).done; ) {
              var fe = xe.value;
              R.add(fe);
            }
          } catch (be) {
            $e.e(be);
          } finally {
            $e.f();
          }
          ae = le;
        }
      }
    } catch (be) {
      V.e(be);
    } finally {
      V.f();
    }
    E.forEach(function(be) {
      R.delete(be);
    }), a.adjacentElements = R;
  }, U = function() {
    if (a.active)
      return r.removeEventListener("focusin", b, !0), r.removeEventListener("mousedown", g, !0), r.removeEventListener("touchstart", g, !0), r.removeEventListener("click", L, !0), r.removeEventListener("keydown", A, !0), r.removeEventListener("keydown", D), o;
  }, K = function(_) {
    var E = a.mostRecentlyFocusedNode;
    if (E) {
      var R = _.some(function(q) {
        var O = Array.from(q.removedNodes);
        return O.some(function(Q) {
          return Q === E || typeof Q.contains == "function" && Q.contains(E);
        });
      });
      if (R && a.containers.some(function(q) {
        return q?.isConnected;
      })) {
        m();
        var V = f();
        c(V);
      }
    }
  }, B = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(K) : void 0, X = function() {
    B && (B.disconnect(), a.active && !a.paused && a.containers.map(function(_) {
      B.observe(_, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return o = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(_) {
      if (a.active)
        return this;
      var E = l(_, "onActivate"), R = l(_, "onPostActivate"), V = l(_, "checkCanFocusTrap"), q = Kt.getActiveTrap(s), O = !1;
      if (q && !q.paused) {
        var Q;
        (Q = q._setSubtreeIsolation) === null || Q === void 0 || Q.call(q, !1), O = !0;
      }
      try {
        V || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = u(r), E?.({
          trap: o
        });
        var ae = function() {
          V && m();
          var $e = function() {
            o._setSubtreeIsolation(!0), X(), R?.({
              trap: o
            });
          }, xe = T();
          xe ? xe.then($e) : $e();
        };
        if (V)
          return V(a.containers.concat()).then(ae, ae), this;
        ae();
      } catch (me) {
        if (q === Kt.getActiveTrap(s) && O) {
          var le;
          (le = q._setSubtreeIsolation) === null || le === void 0 || le.call(q, !0);
        }
        throw me;
      }
      return this;
    },
    deactivate: function(_) {
      if (!a.active)
        return this;
      var E = ji({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, _);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || o._setSubtreeIsolation(!1), a.alreadySilent.clear(), U(), a.active = !1, a.paused = !1, X(), Kt.deactivateTrap(s, o);
      var R = l(E, "onDeactivate"), V = l(E, "onPostDeactivate"), q = l(E, "checkCanReturnFocus"), O = l(E, "delayReturnFocus"), Q = l(E, "returnFocus", "returnFocusOnDeactivate");
      R?.({
        trap: o
      });
      var ae = function() {
        Q && c(p(a.nodeFocusedBeforeActivation)), V?.({
          trap: o
        });
      }, le = function() {
        O && Q ? Zi(ae) : ae();
      };
      return Q && q ? (q(p(a.nodeFocusedBeforeActivation)).then(le, le), this) : (le(), this);
    },
    pause: function(_) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, _)) : this;
    },
    unpause: function(_) {
      return a.active ? (a.manuallyPaused = !1, s[s.length - 1] !== this ? this : this._setPausedState(!1, _)) : this;
    },
    updateContainerElements: function(_) {
      var E = [].concat(_).filter(Boolean);
      return a.containers = E.map(function(R) {
        return typeof R == "string" ? r.querySelector(R) : R;
      }), i.isolateSubtrees && P(a.containers), a.active && (m(), a.paused || o._setSubtreeIsolation(!0)), X(), this;
    }
  }, Object.defineProperties(o, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(_, E) {
        if (a.paused === _)
          return this;
        if (a.paused = _, _) {
          var R = l(E, "onPause"), V = l(E, "onPostPause");
          R?.({
            trap: o
          }), U(), o._setSubtreeIsolation(!1), X(), V?.({
            trap: o
          });
        } else {
          var q = l(E, "onUnpause"), O = l(E, "onPostUnpause");
          q?.({
            trap: o
          });
          var Q = function() {
            m();
            var le = function() {
              o._setSubtreeIsolation(!0), X(), O?.({
                trap: o
              });
            }, me = T();
            me ? me.then(le) : le();
          };
          Q();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(_) {
        i.isolateSubtrees && a.adjacentElements.forEach(function(E) {
          var R;
          _ ? i.isolateSubtrees === "aria-hidden" ? ((E.ariaHidden === "true" || ((R = E.getAttribute("aria-hidden")) === null || R === void 0 ? void 0 : R.toLowerCase()) === "true") && a.alreadySilent.add(E), E.setAttribute("aria-hidden", "true")) : ((E.inert || E.hasAttribute("inert")) && a.alreadySilent.add(E), E.setAttribute("inert", !0)) : a.alreadySilent.has(E) || (i.isolateSubtrees === "aria-hidden" ? E.removeAttribute("aria-hidden") : E.removeAttribute("inert"));
        });
      }
    }
  }), o.updateContainerElements(t), o;
};
function Vc(e, t = {}) {
  let n;
  const { immediate: r, ...s } = t, i = kn(!1), a = kn(!1), o = (u) => n && n.activate(u), l = (u) => n && n.deactivate(u), h = () => {
    n && (n.pause(), a.value = !0);
  }, v = () => {
    n && (n.unpause(), a.value = !1);
  };
  return Be(W(() => Xs(Ge(e)).map((u) => {
    const f = Ge(u);
    return typeof f == "string" ? f : fo(f);
  }).filter(dc)), (u) => {
    if (u.length)
      if (!n)
        n = zc(u, {
          ...s,
          onActivate(f) {
            i.value = !0, t.onActivate && t.onActivate(f);
          },
          onDeactivate(f) {
            i.value = !1, t.onDeactivate && t.onDeactivate(f);
          }
        }), r && o();
      else {
        const f = n?.active;
        n?.updateContainerElements(u), !f && r && o();
      }
  }, { flush: "post" }), Gs(() => l()), {
    hasFocus: i,
    isPaused: a,
    activate: o,
    deactivate: l,
    pause: h,
    unpause: v
  };
}
const _o = /* @__PURE__ */ Se((e, { slots: t }) => {
  const n = kn(), r = ti(Vc(n, e.options));
  return () => {
    if (t.default) return Bs(e.as || "div", { ref: n }, t.default(r));
  };
}, {
  name: "UseFocusTrap",
  props: ["as", "options"]
}), Hc = 864e5, Uc = 6e4, qc = 36e5, Wi = /* @__PURE__ */ Symbol.for("constructDateFrom");
function qn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Wi in e ? e[Wi](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Rt(e, t) {
  return qn(e, e);
}
function jc(e, t, n) {
  const r = Rt(e);
  return isNaN(t) ? qn(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Zc(e, t, n) {
  const r = Rt(e);
  if (isNaN(t)) return qn(e, NaN);
  if (!t)
    return r;
  const s = r.getDate(), i = qn(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return s >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    s
  ), r);
}
function Kn(e, t, n) {
  const {
    years: r = 0,
    months: s = 0,
    weeks: i = 0,
    days: a = 0,
    hours: o = 0,
    minutes: l = 0,
    seconds: h = 0
  } = t, v = Rt(e), u = s || r ? Zc(v, s + r * 12) : v, f = a || i ? jc(u, a + i * 7) : u, m = l + o * 60, p = (h + m * 60) * 1e3;
  return qn(e, +f + p);
}
function Yi(e) {
  const t = Rt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function cn(e, ...t) {
  const n = qn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Xi(e, t) {
  const n = Rt(e);
  return n.setHours(0, 0, 0, 0), n;
}
function Wc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = Xi(r), a = Xi(s), o = +i - Yi(i), l = +a - Yi(a);
  return Math.round((o - l) / Hc);
}
function ia(e, t) {
  const n = +Rt(e) - +Rt(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Yc(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function oi(e) {
  return !(!Yc(e) && typeof e != "number" || isNaN(+Rt(e)));
}
function Xc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - s.getFullYear(), a = r.getMonth() - s.getMonth();
  return i * 12 + a;
}
function Gc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() - s.getFullYear();
}
function Kc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = Gi(r, s), a = Math.abs(
    Wc(r, s)
  );
  r.setDate(r.getDate() - i * a);
  const o = +(Gi(r, s) === -i), l = i * (a - o);
  return l === 0 ? 0 : l;
}
function Gi(e, t) {
  const n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function si(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function Jc(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = (+r - +s) / qc;
  return si(n?.roundingMethod)(i);
}
function Co(e, t) {
  return +Rt(e) - +Rt(t);
}
function Qc(e, t, n) {
  const r = Co(e, t) / Uc;
  return si(n?.roundingMethod)(r);
}
function eu(e, t) {
  const n = Rt(e);
  return n.setHours(23, 59, 59, 999), n;
}
function tu(e, t) {
  const n = Rt(e), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function nu(e, t) {
  const n = Rt(e);
  return +eu(n) == +tu(n);
}
function au(e, t, n) {
  const [r, s, i] = cn(
    n?.in,
    e,
    e,
    t
  ), a = ia(s, i), o = Math.abs(
    Xc(s, i)
  );
  if (o < 1) return 0;
  s.getMonth() === 1 && s.getDate() > 27 && s.setDate(30), s.setMonth(s.getMonth() - a * o);
  let l = ia(s, i) === -a;
  nu(r) && o === 1 && ia(r, i) === 1 && (l = !1);
  const h = a * (o - +l);
  return h === 0 ? 0 : h;
}
function ru(e, t, n) {
  const r = Co(e, t) / 1e3;
  return si(n?.roundingMethod)(r);
}
function iu(e, t, n) {
  const [r, s] = cn(
    n?.in,
    e,
    t
  ), i = ia(r, s), a = Math.abs(Gc(r, s));
  r.setFullYear(1584), s.setFullYear(1584);
  const o = ia(r, s) === -i, l = i * (a - +o);
  return l === 0 ? 0 : l;
}
function lu(e, t) {
  const [n, r] = cn(e, t.start, t.end);
  return { start: n, end: r };
}
function ou(e, t) {
  const { start: n, end: r } = lu(t?.in, e), s = {}, i = iu(r, n);
  i && (s.years = i);
  const a = Kn(n, { years: s.years }), o = au(r, a);
  o && (s.months = o);
  const l = Kn(a, { months: s.months }), h = Kc(r, l);
  h && (s.days = h);
  const v = Kn(l, { days: s.days }), u = Jc(r, v);
  u && (s.hours = u);
  const f = Kn(v, { hours: s.hours }), m = Qc(r, f);
  m && (s.minutes = m);
  const c = Kn(f, { minutes: s.minutes }), p = ru(r, c);
  return p && (s.seconds = p), s;
}
function Eo(e) {
  return +Rt(e) < Date.now();
}
function su(e, t, n) {
  let r = (s) => e(s, ...t);
  return n === void 0 ? r : Object.assign(r, { lazy: n, lazyArgs: t });
}
function Ka(e, t, n) {
  let r = e.length - t.length;
  if (r === 0) return e(...t);
  if (r === 1) return su(e, t, n);
  throw Error("Wrong number of arguments");
}
function Ki(...e) {
  return Ka(cu, e);
}
const cu = (e, t) => e.length >= t;
function At(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function Ji(e) {
  if (typeof e != "object" || !e) return !1;
  let t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function uu(...e) {
  return Ka(To, e);
}
function To(e, t) {
  let n = { ...e, ...t };
  for (let r in t) Object.hasOwn(e, r) && Ji(e[r]) && Ji(t[r]) && (n[r] = To(e[r], t[r]));
  return n;
}
function en(...e) {
  return Ka(du, e);
}
function du(e, t) {
  if (!Ki(t, 1)) return { ...e };
  if (!Ki(t, 2)) {
    let { [t[0]]: r, ...s } = e;
    return s;
  }
  let n = { ...e };
  for (let r of t) delete n[r];
  return n;
}
function fu(...e) {
  return Ka(hu, e);
}
function hu(e, t) {
  let n = {};
  for (let r of t) r in e && (n[r] = e[r]);
  return n;
}
const Ao = {
  general: {
    currency: "USD",
    locale: "en-US"
  },
  lcButton: {
    longPressHint: "Press & Hold"
  },
  lcCard: {
    toggleAriaLabel: "Toggle content visibility"
  },
  lcCarousel: {
    autoPlayDelayInSeconds: 5,
    nextSlideAriaLabel: "Next slide",
    pauseAriaLabel: "Pause slideshow",
    playAriaLabel: "Play slideshow",
    prevSlideAriaLabel: "Previous slide",
    slideAriaLabel: "Slide {slide}"
  },
  lcFlyOut: {
    buttonAriaLabel: "Close flyout",
    to: "#lc-fly-outs",
    visibleInSeconds: 4
  },
  lcHeader: {
    flyOutToggleAriaLabel: "Toggle flyout visibility",
    leftButtonAriaLabel: "Go back"
  },
  lcInfoButton: {
    closeButtonAriaLabel: "Close info modal",
    openButtonAriaLabel: "Open info modal"
  },
  lcLotteryCutoffTime: {
    textCutoffTime: "Cutoff time",
    textTimeIsAlmostUp: "Time’s almost up",
    textTimeToCutoff: "Time until cutoff"
  },
  lcLotteryEditorCard: {
    clearLabel: "Clear",
    quickPickLabel: "Quick Pick",
    toggleAriaLabel: "Toggle play visibility"
  },
  lcLotteryRemainingPicks: {
    doneLabel: "Done!"
  },
  lcModal: {
    closeTriggers: [],
    fullScreen: !1,
    fullSize: !1,
    isVisible: !1,
    noFocusTrap: !1,
    spacing: "large",
    to: "#lc-modals"
  },
  lcPasswordInput: {
    toggleAriaLabel: "Toggle password visibility"
  },
  lcToast: {
    closeButtonAriaLabel: "Close toast"
  }
}, je = ti(Ao), q1 = (e) => {
  Object.assign(je, uu(Ao, e));
}, vu = /* @__PURE__ */ Symbol(), pa = () => {
  const e = ni();
  if (!e?.proxy)
    throw new Error("No instance of Vue detected");
  return "$nuxt" in e.proxy ? Wn(vu) : null;
}, mu = () => pa() ? Na("NuxtTime") : "time", Lo = /* @__PURE__ */ Se({
  __name: "CommonDateTime",
  props: {
    day: {},
    hour: {},
    minute: {},
    month: {},
    second: {},
    weekday: {},
    year: {},
    datetime: {},
    locale: { default: () => je.general.locale }
  },
  setup(e) {
    const t = ga(e, ["datetime", "locale"]), n = mu(), r = W(() => s.value ? i.value?.toISOString() : void 0), s = W(() => i.value ? oi(i.value) : !1), i = W(() => {
      if (e.datetime)
        return new Date(e.datetime);
    });
    return (a, o) => s.value ? ($(), ke(zt(j(n)), Ae({
      key: 0,
      class: "lc-datetime"
    }, { ...t, locale: e.locale }, { datetime: r.value }), {
      default: Te(() => [
        ve(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["datetime"])) : de("", !0);
  }
}), Yn = (e) => {
  const t = ni(), n = pa();
  return !(t?.proxy && "$router" in t.proxy) || !e ? "a" : n ? Na("NuxtLink") : Na("RouterLink");
}, ci = /* @__PURE__ */ Se({
  __name: "CommonLink",
  props: {
    href: {},
    target: {},
    to: {}
  },
  setup(e) {
    const t = Yn(e.to);
    return (n, r) => ($(), ke(zt(j(t)), Ae(n.$attrs, n.$props), {
      default: Te(() => [
        ve(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ca = /* @__PURE__ */ Se({
  __name: "CommonTransition",
  props: {
    mode: {},
    name: { default: "slide-down-sm" }
  },
  setup(e) {
    const t = ge(!1), n = Ks(t, 1);
    return pt(() => {
      t.value = !0;
    }), (r, s) => ($(), ke(wn, Lt(Ot({ name: e.name, mode: e.mode })), {
      default: Te(() => [
        j(n) ? ve(r.$slots, "default", {}, void 0, void 0, 0) : de("", !0)
      ]),
      _: 3
    }, 16));
  }
}), gu = {
  key: 0,
  class: "lc-feedback-message__content"
}, $n = /* @__PURE__ */ Se({
  __name: "FeedbackMessage",
  props: {
    content: {},
    disabled: { type: Boolean },
    variant: { default: "default" }
  },
  setup(e) {
    const t = W(() => [
      "lc-feedback-message",
      `lc-feedback-message--variant-${e.variant}`,
      {
        "lc-feedback-message--disabled": e.disabled
      }
    ]);
    return (n, r) => ($(), Z("div", {
      class: ye(t.value),
      role: "alert"
    }, [
      Fe(j(ca), {
        mode: "out-in",
        name: "slide-fade"
      }, {
        default: Te(() => [
          e.content ? ($(), Z("p", gu, [
            e.variant === "error" ? ($(), ke(j(Ke), {
              key: 0,
              class: "lc-feedback-message__icon",
              name: "alert-triangle",
              size: "small"
            })) : de("", !0),
            xt(" " + Oe(e.content), 1)
          ])) : de("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), $o = "--vc-auto-duration", bu = `height var(${$o}) cubic-bezier(0.33, 1, 0.68, 1)`, Ta = { padding: 0 }, pu = 300, yu = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
};
function Qi(e) {
  return e.value ? parseFloat(getComputedStyle(e.value).height) : 0;
}
function el(e) {
  if (!e.value) return {};
  const { transition: t } = getComputedStyle(e.value);
  return t === "all 0s ease 0s" || t === "all" ? { transition: bu } : { transition: t };
}
function tl(e) {
  if (!e.value) return !0;
  const { transition: t } = getComputedStyle(e.value);
  return typeof window.requestAnimationFrame > "u" || window.matchMedia("(prefers-reduced-motion: reduce)").matches || t.includes("none") || t.includes("height 0s");
}
function wu(e = 0) {
  if (e === 0) return 0;
  const t = e / 36, n = Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
  return Number.isFinite(n) ? n : 0;
}
const xu = /* @__PURE__ */ Se({
  inheritAttrs: !0,
  __name: "Collapse",
  props: {
    when: { type: Boolean },
    baseHeight: { default: 0 },
    as: { default: "div" }
  },
  emits: ["collapse", "expand", "collapsed", "expanded"],
  setup(e, { emit: t }) {
    const n = e, r = t, s = Bi(n, "when"), i = Bi(n, "baseHeight"), a = W(() => ({ overflow: "hidden", height: `${i.value}px` })), o = W(() => ({
      ...Ta,
      ...i.value === 0 ? { display: "none" } : a.value
    })), l = ge(null), h = ge(s.value ? "expanded" : "collapsed"), v = (L) => h.value = L;
    function u() {
      return s.value ? Ta : i.value === 0 ? yu : o.value;
    }
    const f = kn(u()), m = (L) => f.value = L, c = (L) => m({ ...f.value, ...L }), p = ge(pu), k = (L) => p.value = L, g = W(() => ({ [$o]: `${p.value}ms` }));
    let b = NaN;
    function C() {
      m(Ta), v("expanded"), r("expanded");
    }
    function A() {
      m(o.value), v("collapsed"), r("collapsed");
    }
    pt(() => {
      if (!l.value) return;
      const L = wu(l.value.scrollHeight - i.value);
      L > 0 && k(L), !s.value && i.value === 0 && m(o.value);
    }), Be(s, (L) => {
      if (l.value)
        if (b = NaN, L) {
          if (tl(l)) return C();
          v("expanding"), r("expand"), m({
            ...Ta,
            ...a.value,
            ...g.value
          }), requestAnimationFrame(() => {
            if (l.value) {
              if (l.value.scrollHeight === 0) return C();
              b = l.value.scrollHeight, c({
                ...el(l),
                height: `${b}px`,
                willChange: "height"
              });
            }
          });
        } else {
          if (tl(l) || (v("collapsing"), r("collapse"), c({
            ...g.value,
            height: `${l.value.scrollHeight}px`
          }), l.value.scrollHeight === 0)) return A();
          requestAnimationFrame(() => {
            l.value && c({
              ...a.value,
              ...el(l),
              willChange: "height"
            });
          });
        }
    }), Be(i, (L) => {
      s.value || (L > 0 ? c({ display: void 0, height: `${L}px` }) : c({ display: "none" }));
    });
    function D(L) {
      l.value && L.target && L.target === l.value && L.propertyName === "height" && (s.value ? Math.abs(l.value.scrollHeight - Qi(l)) < 1 ? C() : b < l.value.scrollHeight && c({
        height: `${l.value.scrollHeight}px`
      }) : Math.abs(i.value - Qi(l)) < 1 && A());
    }
    return (L, T) => ($(), ke(zt(n.as), {
      ref_key: "collapseRef",
      ref: l,
      style: Ct(f.value),
      onTransitionend: D,
      "data-collapse": h.value
    }, {
      default: Te(() => [
        ve(L.$slots, "default", Lt(Ot({ state: h.value })))
      ]),
      _: 3
    }, 40, ["style", "data-collapse"]));
  }
}), Io = /* @__PURE__ */ Se({
  __name: "InternalCollapse",
  props: {
    animated: { type: Boolean },
    as: { default: "div" },
    when: { type: Boolean }
  },
  emits: ["collapse", "collapsed", "expand", "expanded"],
  setup(e) {
    return (t, n) => e.animated ? ($(), ke(j(xu), Ae({
      key: 0,
      class: "lc-collapse"
    }, { as: e.as, when: e.when }, {
      onCollapse: n[0] || (n[0] = (r) => t.$emit("collapse")),
      onCollapsed: n[1] || (n[1] = (r) => t.$emit("collapsed")),
      onExpand: n[2] || (n[2] = (r) => t.$emit("expand")),
      onExpanded: n[3] || (n[3] = (r) => t.$emit("expanded"))
    }), {
      default: Te(() => [
        ve(t.$slots, "default")
      ]),
      _: 3
    }, 16)) : ($(), ke(zt(e.as), { key: 1 }, {
      default: Te(() => [
        ve(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), ku = /* @__PURE__ */ Se({
  __name: "InternalOptionalTeleport",
  props: {
    to: {}
  },
  setup(e) {
    return (t, n) => e.to ? ($(), ke(ba, {
      key: 0,
      to: e.to
    }, [
      ve(t.$slots, "default")
    ], 8, ["to"])) : ve(t.$slots, "default", {}, void 0, void 0, 1);
  }
}), Su = ["height", "width"], _u = ["r", "stroke-width"], Cu = ["r", "stroke-dasharray", "stroke-dashoffset", "stroke-width"], Do = /* @__PURE__ */ Se({
  __name: "ProgressCircle",
  props: {
    progress: { default: 0 },
    progressClass: {},
    radius: { default: 24 },
    strokeWidth: { default: 4 },
    trackClass: {}
  },
  setup(e) {
    const t = W(() => Math.min(100, Math.max(0, e.progress))), n = W(() => e.radius - e.strokeWidth), r = W(() => 2 * Math.PI * n.value), s = W(
      () => r.value - t.value / 100 * r.value
    );
    return (i, a) => ($(), Z("svg", {
      class: "lc-progress-circle",
      height: e.radius * 2,
      width: e.radius * 2
    }, [
      ne("circle", {
        class: ye(["lc-progress-circle__track", e.trackClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-width": e.strokeWidth
      }, null, 10, _u),
      ne("circle", {
        class: ye(["lc-progress-circle__progress", e.progressClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-dasharray": `${r.value} ${r.value}`,
        "stroke-dashoffset": s.value,
        "stroke-width": e.strokeWidth
      }, null, 10, Cu)
    ], 8, Su));
  }
}), Eu = { class: "lc-timer-circle" }, Tu = ["aria-valuenow"], Au = { class: "lc-timer-circle__content" }, Lu = /* @__PURE__ */ Se({
  __name: "TimerCircle",
  props: {
    durationInMs: { default: 4e3 }
  },
  setup(e) {
    const t = ge(0), n = Js(t, {
      duration: e.durationInMs,
      transition: Qs.linear
    });
    return pt(() => {
      t.value = 100;
    }), (r, s) => ($(), Z("div", Eu, [
      ne("div", {
        "aria-valuenow": j(n),
        class: "lc-timer-circle__visual",
        role: "progressbar"
      }, [
        Fe(j(Do), Ae({ progress: j(n) }, { class: "lc-timer-circle__progress" }), null, 16)
      ], 8, Tu),
      ne("div", Au, [
        ve(r.$slots, "default")
      ])
    ]));
  }
}), $u = (e, t) => e in t, tn = (e, t) => typeof e == "string" && Object.values(t).includes(e), j1 = ["left", "right"], Z1 = ["large", "medium", "small"], W1 = ["button", "reset", "submit"], Y1 = ["click", "long-press"], X1 = [
  "primary",
  "primary-ghost",
  "secondary",
  "tertiary",
  "filled",
  "raised"
];
var Zr = /* @__PURE__ */ ((e) => (e.Enter = "Enter", e.Space = " ", e))(Zr || {});
const Iu = ["aria-valuenow"], Du = { class: "lc-button__content" }, Mu = {
  key: 0,
  class: "lc-button__label-bubble"
}, Ou = {
  key: 0,
  class: "lc-button__overlay"
}, Ru = { class: "lc-button__long-press-hint" }, Fu = {
  key: 1,
  class: "lc-button__overlay"
}, Nu = {
  key: 0,
  class: "lc-button__loading-text"
}, nl = 1e3 / 25, kt = /* @__PURE__ */ Se({
  __name: "LcButton",
  props: {
    href: {},
    target: {},
    to: {},
    count: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    growAnimationMaxWidth: { default: "100%" },
    icon: {},
    iconPosition: { default: "left" },
    loading: { type: Boolean },
    loadingText: {},
    longPressDelay: { default: 2500 },
    longPressHint: { default: () => je.lcButton.longPressHint },
    longPressHintDelay: { default: 1300 },
    noPadding: { type: Boolean },
    size: { default: "large" },
    title: {},
    trigger: { default: "click" },
    type: { default: "button" },
    variant: { default: "primary" }
  },
  emits: ["longpress"],
  setup(e, { emit: t }) {
    const n = t, r = An(), s = ge(!!r.default), i = ge(!1), a = ge(!1), o = ge(!1), l = ge(!1), h = ge(0), v = ge(null);
    let u, f, m;
    const c = W(() => [
      "lc-button",
      `lc-button--icon-${e.iconPosition}`,
      `lc-button--size-${e.size}`,
      `lc-button--variant-${e.variant}`,
      {
        "lc-button--disabled": p.value,
        "lc-button--icon-only": !s.value,
        "lc-button--link": k.value,
        "lc-button--loading": e.loading,
        "lc-button--long-press-active": e.trigger === "long-press" && o.value,
        "lc-button--long-press-done": i.value,
        "lc-button--no-padding": e.noPadding,
        "lc-button--overlay-visible": g.value || e.loading,
        "lc-button--pressed": b.value
      }
    ]), p = W(() => e.disabled || e.loading), k = W(() => !!(e.href || e.to) && !p.value), g = W(
      () => a.value && !e.loading && e.trigger === "long-press"
    ), b = W(() => l.value || !!v.value), C = W(() => typeof e.to == "string" ? void 0 : e.to?.replace), A = W(() => {
      const V = {
        "--grow-animation-max-width": e.growAnimationMaxWidth
      };
      return e.trigger !== "long-press" ? V : {
        ...V,
        "--progress-transition-duration": `${e.longPressDelay}ms`
      };
    }), D = W(() => k.value ? Yn(e.to) : "button"), L = () => {
      i.value = !1, o.value = !1, X(), _();
    }, T = (V) => {
      p.value || tn(V.key, Zr) && (v.value || (v.value = V.key, U()));
    }, P = (V) => {
      tn(V.key, Zr) && V.key === v.value && (X(), !l.value && H());
    }, U = (V = !1) => {
      e.trigger !== "click" && (V && window.addEventListener("pointerup", B), clearTimeout(m), o.value = !0);
    }, K = () => {
      p.value || (l.value = !0, U(!0));
    }, B = () => {
      window.removeEventListener("pointerup", B), _(), !v.value && H();
    }, X = () => {
      v.value = null;
    }, H = () => {
      !o.value && !i.value || (i.value ? a.value = !1 : m = setTimeout(() => {
        a.value = !1;
      }, e.longPressHintDelay), i.value = !1, o.value = !1);
    }, _ = () => {
      l.value = !1;
    }, E = () => {
      p.value || U();
    }, R = () => {
      _(), H();
    };
    return so(() => {
      s.value = !!r.default;
    }), Ln(() => {
      clearInterval(u), clearTimeout(f), clearTimeout(m);
    }), Be(o, (V) => {
      if (!p.value) {
        if (!V) {
          clearInterval(u), clearTimeout(f), h.value = 0;
          return;
        }
        a.value = !0, u = setInterval(() => {
          h.value += nl / e.longPressDelay * 100;
        }, nl), f = setTimeout(() => {
          clearInterval(u), i.value = !0, n("longpress");
        }, e.longPressDelay);
      }
    }), (V, q) => ($(), ke(zt(D.value), Ae(V.$attrs, {
      autofocus: e.autofocus,
      href: e.href,
      target: e.target,
      title: e.title,
      to: e.to,
      type: e.type,
      style: A.value,
      replace: C.value
    }, {
      "aria-busy": e.loading,
      class: c.value,
      disabled: p.value,
      onBlur: L,
      onContextmenu: q[0] || (q[0] = sa(() => {
      }, ["prevent"])),
      onKeydown: T,
      onKeyup: P,
      onPointerdown: K,
      onPointerup: B,
      onTouchend: R,
      onTouchstartPassive: E
    }), {
      default: Te(() => [
        e.trigger === "long-press" ? ($(), Z("div", {
          key: 0,
          "aria-valuenow": h.value,
          class: "lc-button__progress",
          role: "progressbar"
        }, null, 8, Iu)) : de("", !0),
        ne("div", Du, [
          e.icon ? ($(), ke(j(Ke), {
            key: 0,
            class: "lc-button__icon",
            name: e.icon
          }, null, 8, ["name"])) : de("", !0),
          Fe(wn, { name: "font-size-fade" }, {
            default: Te(() => [
              V.$slots.default ? ($(), Z("span", Mu, [
                ve(V.$slots, "default"),
                Fe(j(Ur), Ae({ count: e.count }, { class: "lc-button__count-text" }), null, 16)
              ])) : de("", !0)
            ]),
            _: 3
          }),
          V.$slots.default ? de("", !0) : ($(), ke(j(Ur), Ae({ key: 1 }, { count: e.count }, { class: "lc-button__count" }), null, 16))
        ]),
        Fe(j(ca), { name: "fade" }, {
          default: Te(() => [
            g.value ? ($(), Z("div", Ou, [
              ne("span", Ru, Oe(e.longPressHint), 1)
            ])) : de("", !0),
            e.loading ? ($(), Z("div", Fu, [
              Fe(j(Ke), {
                class: "lc-button__loading-spinner",
                name: "loader"
              }),
              e.loadingText ? ($(), Z("span", Nu, Oe(e.loadingText), 1)) : de("", !0)
            ])) : de("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["aria-busy", "class", "disabled"]));
  }
}), ui = /* @__PURE__ */ Se({
  __name: "LcSeparator",
  props: {
    variant: { default: "default" }
  },
  setup(e) {
    return (t, n) => ($(), Z("hr", {
      class: ye(["lc-separator", `lc-separator--variant-${e.variant}`])
    }, null, 2));
  }
}), G1 = ["dashed", "default"], $t = (e) => {
  if (e) return `lc-${e}`;
  const t = pa(), n = crypto.randomUUID();
  return t ? `lc-${t.useId() || n}` : `lc-${n}`;
}, di = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, s] of t)
    n[r] = s;
  return n;
}, Pu = {}, Bu = { viewBox: "0 0 752 8" }, zu = { id: "perforation" }, Vu = ["cx"];
function Hu(e, t) {
  return $(), Z("svg", Bu, [
    ne("mask", zu, [
      t[0] || (t[0] = ne("rect", {
        fill: "white",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), Z(Xe, null, ht(new Array(21), (n, r) => ($(), Z("circle", {
        key: r,
        cx: 28 + r * 34.75,
        cy: "18",
        fill: "black",
        r: "16"
      }, null, 8, Vu))), 128))
    ]),
    t[1] || (t[1] = ne("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const Uu = /* @__PURE__ */ di(Pu, [["render", Hu]]), qu = {}, ju = { viewBox: "0 0 752 8" }, Zu = { id: "perforation" }, Wu = ["points"];
function Yu(e, t) {
  return $(), Z("svg", ju, [
    ne("mask", Zu, [
      t[0] || (t[0] = ne("rect", {
        fill: "black",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), Z(Xe, null, ht(new Array(150), (n, r) => ($(), Z("polygon", {
        key: r,
        fill: "white",
        points: `${r * 5},0 ${4 + r * 5},6 ${8 + r * 5},0`
      }, null, 8, Wu))), 128))
    ]),
    t[1] || (t[1] = ne("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const al = /* @__PURE__ */ di(qu, [["render", Yu]]), Xu = ["id"], Gu = {
  key: 0,
  class: "lc-card__background"
}, Ku = {
  key: 1,
  class: /* @__PURE__ */ ye(["lc-card__perforation", "lc-card__perforation--top"])
}, Ju = {
  key: 0,
  class: "lc-card__toggle"
}, Qu = {
  key: 2,
  class: /* @__PURE__ */ ye(["lc-card__perforation", "lc-card__perforation--bottom"])
}, ya = /* @__PURE__ */ Se({
  __name: "LcCard",
  props: /* @__PURE__ */ Sn({
    animated: { type: Boolean },
    bodyClass: {},
    expandable: { type: Boolean },
    footerClass: {},
    headerClass: {},
    headerTo: {},
    id: {},
    modelValue: { type: Boolean },
    onHeaderClick: { type: Function },
    radius: { default: "medium" },
    shadow: { default: "large" },
    showSeparator: { type: Boolean },
    toggleAriaLabel: { default: () => je.lcCard.toggleAriaLabel },
    variant: { default: "default" },
    withWavyBody: { type: Boolean },
    withWavyHeader: { type: Boolean }
  }, {
    modelValue: { default: !1, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Sn(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = An(), n = $t(e.id), r = ge(!!t.default), s = Wa(e, "modelValue"), i = W(() => !!e.expandable && !!e.animated), a = W(() => [
      "lc-card",
      `lc-card--radius-${e.radius}`,
      `lc-card--shadow-${e.shadow}`,
      `lc-card--variant-${e.variant}`,
      {
        "lc-card--animated": i.value,
        "lc-card--expandable": e.expandable,
        "lc-card--expanded": e.expandable && s.value,
        "lc-card--no-body": !r.value,
        "lc-card--wavy-body": e.withWavyBody,
        "lc-card--wavy-header": e.withWavyHeader
      }
    ]), o = () => {
      e.expandable && (s.value = !s.value);
    };
    return so(() => {
      r.value = !!t.default;
    }), (l, h) => ($(), Z("article", {
      id: j(n),
      class: ye(a.value)
    }, [
      l.$slots.background ? ($(), Z("div", Gu, [
        ve(l.$slots, "background")
      ])) : de("", !0),
      e.variant === "transaction" ? ($(), Z("div", Ku, [
        Fe(al)
      ])) : de("", !0),
      l.$slots.header || e.expandable ? ($(), ke(zt(e.expandable ? "button" : "div"), {
        key: 2,
        "aria-controls": e.expandable ? `${j(n)}-region` : void 0,
        "aria-expanded": e.expandable ? s.value : void 0,
        "aria-label": e.expandable ? e.toggleAriaLabel : void 0,
        class: "lc-card__header-wrap",
        type: e.expandable ? "button" : void 0,
        onClickPassive: o
      }, {
        default: Te(() => [
          e.headerTo && !e.expandable ? ($(), ke(j(ci), {
            key: 0,
            tabindex: "-1",
            to: e.headerTo,
            onClick: e.onHeaderClick
          }, {
            default: Te(() => [
              ne("header", {
                class: ye(["lc-card__header", e.headerClass])
              }, [
                ve(l.$slots, "header")
              ], 2)
            ]),
            _: 3
          }, 8, ["to", "onClick"])) : ($(), Z("header", {
            key: 1,
            class: ye(["lc-card__header", e.headerClass])
          }, [
            ve(l.$slots, "header"),
            e.expandable ? ($(), Z(Xe, { key: 0 }, [
              l.$slots.toggle ? ($(), Z("div", Ju, [
                ve(l.$slots, "toggle")
              ])) : ($(), ke(j(Ke), {
                key: 1,
                class: "lc-card__toggle-icon",
                name: "chevron-down"
              }))
            ], 64)) : de("", !0)
          ], 2))
        ]),
        _: 3
      }, 40, ["aria-controls", "aria-expanded", "aria-label", "type"])) : de("", !0),
      (l.$slots.default || l.$slots.footer) && (!e.expandable || i.value || s.value) ? ($(), ke(j(Io), Ae({
        key: 3,
        id: `${j(n)}-region`
      }, { when: s.value }, {
        animated: i.value,
        class: "lc-card__body-wrap",
        onCollapse: h[0] || (h[0] = (v) => l.$emit("collapse")),
        onCollapsed: h[1] || (h[1] = (v) => l.$emit("collapsed")),
        onExpand: h[2] || (h[2] = (v) => l.$emit("expand")),
        onExpanded: h[3] || (h[3] = (v) => l.$emit("expanded"))
      }), {
        default: Te(() => [
          l.$slots.default ? ($(), Z("div", {
            key: 0,
            class: ye(["lc-card__body", e.bodyClass])
          }, [
            ve(l.$slots, "default")
          ], 2)) : de("", !0),
          l.$slots.footer ? ($(), Z("footer", {
            key: 1,
            class: ye(["lc-card__footer", e.footerClass])
          }, [
            e.showSeparator ? ($(), ke(j(ui), {
              key: 0,
              variant: "dashed"
            })) : de("", !0),
            ve(l.$slots, "footer")
          ], 2)) : de("", !0),
          e.variant !== "default" ? ($(), Z("div", Qu, [
            e.variant == "order" ? ($(), ke(Uu, { key: 0 })) : ($(), ke(al, { key: 1 }))
          ])) : de("", !0)
        ]),
        _: 3
      }, 16, ["id", "animated"])) : de("", !0)
    ], 10, Xu));
  }
}), K1 = ["large", "medium", "none"], J1 = ["large", "none", "small"], Q1 = ["default", "order", "transaction"], ed = { class: "lc-modal__card-header-wrap" }, td = { class: "lc-modal__card-header-actions" }, Mo = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcModal",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    backgroundClass: {},
    closeTriggers: { default: () => je.lcModal.closeTriggers },
    containerClass: {},
    fullScreen: { type: Boolean },
    fullSize: { type: Boolean },
    isVisible: { type: Boolean, default: () => je.lcModal.isVisible },
    noFocusTrap: { type: Boolean, default: () => je.lcModal.noFocusTrap },
    spacing: { default: () => je.lcModal.spacing },
    to: { default: () => je.lcModal.to },
    transition: {},
    wrapAttrs: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, r = ge(), s = ho(() => document.documentElement), i = W(() => h("close-button")), l = {
      allowOutsideClick: (f) => {
        const m = f.target;
        return m ? Ge(e.ignoreOutsideClickOn).some((c) => (typeof c == "string" ? document.querySelector(c) : fo(c))?.contains(m) ?? !1) : !1;
      },
      fallbackFocus: (() => {
        const f = document.createElement("button");
        return f.id = "lc-modal-fallback-focus", f.hidden = !0, f;
      })(),
      immediate: !0
    }, h = (f) => e.closeTriggers.includes(f), v = (f) => {
      h(f) && n("close");
    }, u = (f) => {
      r.value = f;
    };
    return Ga(r, () => v("click-outside"), {
      ignore: e.ignoreOutsideClickOn
    }), vo("Escape", () => v("escape")), Be(
      () => e.isVisible,
      (f) => {
        s.value = f;
      },
      { immediate: !0 }
    ), (f, m) => e.isVisible ? ($(), ke(ba, {
      key: 0,
      class: "lc-modal",
      to: e.to
    }, [
      Fe(j(ca), { name: "fade" }, {
        default: Te(() => [
          ne("div", {
            class: ye([
              "lc-modal__bg",
              {
                "lc-modal__bg--full-screen": e.fullScreen,
                "lc-modal__bg--full-size": e.fullSize
              },
              e.backgroundClass
            ])
          }, [
            Fe(j(ca), Ae(e.wrapAttrs, {
              class: ["lc-modal__wrap", e.containerClass],
              name: e.transition
            }), {
              default: Te(() => [
                ($(), ke(zt(e.noFocusTrap ? "div" : j(_o)), {
                  options: e.noFocusTrap ? null : l
                }, {
                  default: Te(() => [
                    ve(f.$slots, "modal", Lt(Ot({ setRef: u })), () => [
                      Fe(j(ya), {
                        ref_key: "modalRef",
                        ref: r,
                        "body-class": "lc-modal__body",
                        class: ye([
                          "lc-modal__card",
                          `lc-modal__card--${e.spacing}`,
                          {
                            "lc-modal__card--full-size": e.fullSize
                          }
                        ]),
                        role: "dialog"
                      }, {
                        default: Te(() => [
                          f.$slots.header || i.value ? ($(), Z("header", {
                            key: 0,
                            class: ye(["lc-modal__card-header", {
                              "lc-modal__card-header--close-button": i.value || e.fullSize
                            }])
                          }, [
                            ne("div", ed, [
                              ve(f.$slots, "header")
                            ]),
                            ne("div", td, [
                              ve(f.$slots, "actions"),
                              i.value ? ($(), ke(j(kt), {
                                key: 0,
                                class: "lc-modal__card-header-close",
                                icon: "close",
                                size: "small",
                                variant: "tertiary",
                                onClickPassive: m[0] || (m[0] = (c) => v("close-button"))
                              })) : de("", !0)
                            ])
                          ], 2)) : de("", !0),
                          ve(f.$slots, "default")
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ])
                  ]),
                  _: 3
                }, 8, ["options"]))
              ]),
              _: 3
            }, 16, ["class", "name"])
          ], 2)
        ]),
        _: 3
      })
    ], 8, ["to"])) : de("", !0);
  }
}), eg = ["click-outside", "close-button", "escape"], tg = ["large", "medium", "small"], nd = 30, ad = 0.3, rl = (e) => {
  const t = e.match(/^([\d.]+)(px|dvh|vh|svh|lvh)$/);
  if (t) {
    const s = parseFloat(t[1]);
    return t[2] === "px" ? s : s / 100 * window.innerHeight;
  }
  const n = document.createElement("div");
  n.style.cssText = `height:${e};position:absolute;visibility:hidden`, document.body.appendChild(n);
  const r = n.getBoundingClientRect().height;
  return n.remove(), r;
}, rd = ({
  dragAreaRef: e,
  snapHeights: t,
  onClose: n,
  canClose: r
}) => {
  const s = ge(0), i = ge(0), a = ge(!1), o = ge(0), l = ge(0), h = ge(0), v = ge(0), u = W(
    () => Ge(t)[o.value] ?? Ge(t)[0]
  ), f = W(() => o.value < Ge(t).length - 1), m = () => {
    i.value = 0, s.value = 0, a.value = !1;
  }, c = () => {
    o.value = 0;
  }, p = (C, A) => (A > 0 ? C / A : 0) > ad || C > nd, k = () => {
    if (!a.value) return;
    const C = v.value - h.value, A = Date.now() - l.value, D = Math.abs(C), L = C > 0 ? "down" : "up", T = Ge(t);
    if (L === "up" && f.value && p(D, A)) {
      const U = rl(T[o.value]) + D;
      let K = o.value + 1, B = 1 / 0;
      for (let X = o.value + 1; X < T.length; X++) {
        const H = Math.abs(rl(T[X]) - U);
        H < B && (B = H, K = X);
      }
      o.value = K, m();
      return;
    }
    if (L === "down" && p(D, A) && r()) {
      a.value = !1, n();
      return;
    }
    m();
  }, g = (C) => {
    if (C.target.closest('button, a, [role="button"]')) return;
    C.currentTarget.setPointerCapture(C.pointerId), h.value = C.clientY, v.value = C.clientY, l.value = Date.now(), a.value = !0;
  }, b = (C) => {
    if (!a.value) return;
    v.value = C.clientY;
    const A = v.value - h.value;
    A < 0 && f.value ? (i.value = -A, s.value = 0) : (i.value = 0, s.value = Math.max(0, A));
  };
  return qt(e, "pointerdown", g), qt(e, "pointermove", b), qt(e, "pointerup", k), qt(e, "pointercancel", k), qt(e, "lostpointercapture", k), {
    currentSnapHeight: u,
    currentSnapIndex: o,
    dismissOffset: s,
    isDragging: a,
    resetDrag: m,
    resetSnapIndex: c,
    snapTransitionOffset: i
  };
}, id = { class: "lc-bottom-sheet-modal__header" }, ld = { class: "lc-bottom-sheet-modal__header-actions" }, od = { class: "lc-bottom-sheet" }, sd = ["aria-labelledby"], cd = { class: "lc-bottom-sheet__header-actions" }, Aa = 300, il = "lc-bottom-sheet__drag-area", ud = "(width < 496px)", ng = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcBottomSheet",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    closeTriggers: { default: () => ["swipe-down", "click-outside", "escape", "close-button"] },
    modalClass: {},
    modelValue: { type: Boolean, default: !1 },
    snapHeights: { default: () => ["50dvh"] },
    to: { default: () => je.lcModal.to }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = {
      allowOutsideClick: !0,
      fallbackFocus: () => document.querySelector(`.${il}`) ?? document.body,
      immediate: !0
    }, r = ["click-outside", "escape", "close-button"], s = t;
    let i;
    const o = `${$t()}-header`, l = ot("dragArea"), h = ge(!1), v = ge(!1), u = ge(!0), f = ec(ud), m = ho(() => document.documentElement), {
      currentSnapHeight: c,
      dismissOffset: p,
      isDragging: k,
      resetDrag: g,
      resetSnapIndex: b,
      snapTransitionOffset: C
    } = rd({
      canClose: () => P("swipe-down"),
      dragAreaRef: l,
      onClose: () => L(),
      snapHeights: W(() => e.snapHeights)
    }), A = W(
      () => e.closeTriggers.filter(
        (K) => r.includes(K)
      )
    ), D = W(() => {
      if (k.value) {
        const B = C.value !== 0;
        return {
          height: B ? `calc(${c.value} + ${C.value}px)` : c.value,
          transform: B ? "translateY(0)" : `translateY(${Math.max(0, p.value)}px)`,
          transition: "none"
        };
      }
      if (h.value)
        return {
          height: c.value,
          transform: "translateY(100%)",
          transition: `transform ${Aa}ms ease`
        };
      const K = u.value;
      return {
        height: c.value,
        transform: K ? "translateY(100%)" : "translateY(0)",
        transition: u.value ? "none" : `height ${Aa}ms ease, transform ${Aa}ms ease`
      };
    }), L = () => {
      h.value || (h.value = !0, i = setTimeout(() => {
        h.value = !1, g(), b(), s("update:modelValue", !1);
      }, Aa));
    }, T = () => {
      P("click-outside") && L();
    }, P = (K) => e.closeTriggers.includes(K), U = (K) => {
      const B = K.target;
      v.value = B.scrollTop > 0;
    };
    return Be(
      () => e.modelValue,
      async (K) => {
        if (!K) return m.value = !1;
        clearTimeout(i), h.value = !1, g(), v.value = !1, u.value = !0, m.value = !0, await Ya(), requestAnimationFrame(() => {
          u.value = !1;
        });
      },
      { immediate: !0 }
    ), vo("Escape", () => {
      P("escape") && L();
    }), Ln(() => {
      clearTimeout(i), m.value = !1;
    }), (K, B) => j(f) ? e.modelValue ? ($(), ke(ba, {
      key: 1,
      to: e.to
    }, [
      ne("div", od, [
        ne("div", {
          class: ye(["lc-bottom-sheet__overlay", { "lc-bottom-sheet__overlay--closing": h.value }]),
          role: "presentation",
          onClick: T
        }, null, 2),
        Fe(j(_o), { options: n }, {
          default: Te(() => [
            ne("div", {
              "aria-labelledby": K.$slots.title ? o : void 0,
              "aria-modal": "true",
              class: "lc-bottom-sheet__sheet",
              role: "dialog",
              style: Ct(D.value)
            }, [
              ne("div", {
                ref: "dragArea",
                class: ye([
                  il,
                  { "lc-bottom-sheet__drag-area--scrolled": v.value }
                ])
              }, [
                B[1] || (B[1] = ne("div", { class: "lc-bottom-sheet__handle" }, [
                  ne("div", { class: "lc-bottom-sheet__handle-pill" })
                ], -1)),
                K.$slots.title || P("close-button") ? ($(), Z("div", {
                  key: 0,
                  id: o,
                  class: "lc-bottom-sheet__header"
                }, [
                  ve(K.$slots, "title"),
                  ne("div", cd, [
                    ve(K.$slots, "actions"),
                    P("close-button") ? ($(), ke(j(kt), {
                      key: 0,
                      class: "lc-modal__card-header-close",
                      icon: "close",
                      size: "small",
                      variant: "tertiary",
                      onClick: L
                    })) : de("", !0)
                  ])
                ])) : de("", !0)
              ], 2),
              ne("div", {
                ref: "contentArea",
                class: "lc-bottom-sheet__content",
                onScroll: U
              }, [
                ve(K.$slots, "default")
              ], 544)
            ], 12, sd)
          ]),
          _: 3
        })
      ])
    ], 8, ["to"])) : de("", !0) : ($(), ke(j(Mo), Ae({ key: 0 }, { to: e.to, ignoreOutsideClickOn: e.ignoreOutsideClickOn }, {
      "background-class": `lc-bottom-sheet-modal lc-bottom-sheet-modal--${v.value ? "scrolled" : "default"}`,
      "is-visible": e.modelValue,
      "container-class": e.modalClass,
      "close-triggers": A.value,
      spacing: "small",
      onClose: B[0] || (B[0] = (X) => s("update:modelValue", !1))
    }), Xa({
      default: Te(() => [
        ne("div", {
          class: ye(["lc-bottom-sheet-modal__content", { "lc-bottom-sheet-modal__content--scrolled": v.value }]),
          onScroll: U
        }, [
          ve(K.$slots, "default")
        ], 34)
      ]),
      _: 2
    }, [
      K.$slots.title ? {
        name: "header",
        fn: Te(() => [
          ne("div", id, [
            ve(K.$slots, "title")
          ])
        ]),
        key: "0"
      } : void 0,
      K.$slots.actions ? {
        name: "actions",
        fn: Te(() => [
          ne("div", ld, [
            ve(K.$slots, "actions")
          ])
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["background-class", "is-visible", "container-class", "close-triggers"]));
  }
}), ag = ["swipe-down", "click-outside", "escape"];
function Oo(e = {}) {
  let t, n = [];
  const r = ["select", "slideFocus"];
  function s(h) {
    t = h;
    const {
      options: {
        axis: v
      },
      slideRects: u
    } = t.internalEngine();
    v !== "y" && (n = u.map((f) => f.height), r.forEach((f) => t.on(f, o)), o());
  }
  function i() {
    r.forEach((v) => t.off(v, o));
    const h = t.containerNode();
    h.style.height = "", h.getAttribute("style") || h.removeAttribute("style");
  }
  function a() {
    const {
      slideRegistry: h
    } = t.internalEngine(), v = h[t.selectedScrollSnap()];
    return v ? v.map((u) => n[u]).reduce((u, f) => Math.max(u, f), 0) : null;
  }
  function o() {
    a() !== null && (t.containerNode().style.height = `${a()}px`);
  }
  return {
    name: "autoHeight",
    options: e,
    init: s,
    destroy: i
  };
}
Oo.globalOptions = void 0;
const dd = {
  active: !0,
  breakpoints: {},
  snapped: "is-snapped",
  inView: "is-in-view",
  draggable: "is-draggable",
  dragging: "is-dragging",
  loop: "is-loop"
};
function Jn(e) {
  return (Array.isArray(e) ? e : [e]).filter(Boolean);
}
function Qn(e, t) {
  !e || !t.length || e.classList.remove(...t);
}
function La(e, t) {
  !e || !t.length || e.classList.add(...t);
}
function Ja(e = {}) {
  let t, n, r, s, i = [], a = [];
  const o = ["select"], l = ["pointerDown", "pointerUp"], h = ["slidesInView"], v = {
    snapped: [],
    inView: [],
    draggable: [],
    dragging: [],
    loop: []
  };
  function u(b, C) {
    n = b;
    const {
      mergeOptions: A,
      optionsAtMedia: D
    } = C, L = A(dd, Ja.globalOptions), T = A(L, e);
    t = D(T), r = n.rootNode(), s = n.slideNodes();
    const {
      watchDrag: P,
      loop: U
    } = n.internalEngine().options, K = !!P;
    t.loop && U && (v.loop = Jn(t.loop), La(r, v.loop)), t.draggable && K && (v.draggable = Jn(t.draggable), La(r, v.draggable)), t.dragging && (v.dragging = Jn(t.dragging), l.forEach((B) => n.on(B, m))), t.snapped && (v.snapped = Jn(t.snapped), o.forEach((B) => n.on(B, p)), p()), t.inView && (v.inView = Jn(t.inView), h.forEach((B) => n.on(B, k)), k());
  }
  function f() {
    l.forEach((b) => n.off(b, m)), o.forEach((b) => n.off(b, p)), h.forEach((b) => n.off(b, k)), Qn(r, v.loop), Qn(r, v.draggable), Qn(r, v.dragging), c([], i, v.snapped), c([], a, v.inView), Object.keys(v).forEach((b) => {
      const C = b;
      v[C] = [];
    });
  }
  function m(b, C) {
    (C === "pointerDown" ? La : Qn)(r, v.dragging);
  }
  function c(b = [], C = [], A) {
    const D = C.map((T) => s[T]), L = b.map((T) => s[T]);
    return D.forEach((T) => Qn(T, A)), L.forEach((T) => La(T, A)), b;
  }
  function p() {
    const {
      slideRegistry: b
    } = n.internalEngine(), C = b[n.selectedScrollSnap()];
    i = c(C, i, v.snapped);
  }
  function k() {
    const b = n.slidesInView();
    a = c(b, a, v.inView);
  }
  return {
    name: "classNames",
    options: e,
    init: u,
    destroy: f
  };
}
Ja.globalOptions = void 0;
function ll(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function yr(e) {
  return typeof e == "number" && !isNaN(e);
}
function Ro(e = {}) {
  let s, i = [], a, o = 0, l = 0, h = 0, v = !1, u, f;
  function m(_) {
    s = _;
    const E = s.selectedScrollSnap(), {
      scrollBody: R,
      containerRect: V,
      axis: q
    } = s.internalEngine(), O = q.measureSize(V);
    a = ll(O * 0.75, 200, 500), v = !1, i = s.scrollSnapList().map((Q, ae) => ae === E ? 1 : 0), u = R.settled, f = s.scrollProgress, R.settled = B, s.scrollProgress = X, s.on("select", b).on("slideFocus", p).on("pointerDown", g).on("pointerUp", k), A(), p();
  }
  function c() {
    const {
      scrollBody: _
    } = s.internalEngine();
    _.settled = u, s.scrollProgress = f, s.off("select", b).off("slideFocus", p).off("pointerDown", g).off("pointerUp", k), s.slideNodes().forEach((E) => {
      const R = E.style;
      R.opacity = "", R.transform = "", R.pointerEvents = "", E.getAttribute("style") || E.removeAttribute("style");
    });
  }
  function p() {
    const _ = s.selectedScrollSnap();
    L(_, 1);
  }
  function k() {
    v = !1;
  }
  function g() {
    v = !1, o = 0, l = 0;
  }
  function b() {
    const _ = s.internalEngine().scrollBody.duration();
    l = _ ? 0 : 1, v = !0, _ || p();
  }
  function C(_) {
    const {
      axis: E
    } = s.internalEngine();
    return `translate${E.scroll.toUpperCase()}(${E.direction(_)}px)`;
  }
  function A() {
    const {
      translate: _,
      slideLooper: E
    } = s.internalEngine();
    _.clear(), _.toggleActive(!1), E.loopPoints.forEach(({
      translate: R
    }) => {
      R.clear(), R.toggleActive(!1);
    });
  }
  function D(_) {
    const {
      scrollSnaps: E,
      location: R,
      target: V
    } = s.internalEngine();
    !yr(_) || i[_] < 0.5 || (R.set(E[_]), V.set(R));
  }
  function L(_, E) {
    s.scrollSnapList().forEach((V, q) => {
      const O = Math.abs(E), Q = i[q], ae = q === _, le = ae ? Q + O : Q - O, me = ll(le, 0, 1);
      i[q] = me;
      const $e = ae && v, xe = s.previousScrollSnap();
      $e && (i[xe] = 1 - me), ae && P(_, me), T(q);
    });
  }
  function T(_) {
    const E = s.internalEngine().slideRegistry[_], {
      scrollSnaps: R,
      containerRect: V
    } = s.internalEngine(), q = i[_];
    E.forEach((O) => {
      const Q = s.slideNodes()[O].style, ae = parseFloat(q.toFixed(2)), le = ae > 0, me = le ? R[_] : V.width + 2, $e = C(me);
      le && (Q.transform = $e), Q.opacity = ae.toString(), Q.pointerEvents = q > 0.5 ? "auto" : "none", le || (Q.transform = $e);
    });
  }
  function P(_, E) {
    const {
      index: R,
      dragHandler: V,
      scrollSnaps: q
    } = s.internalEngine(), O = V.pointerDown(), Q = 1 / (q.length - 1);
    let ae = _, le = O ? s.selectedScrollSnap() : s.previousScrollSnap();
    if (O && ae === le) {
      const xe = Math.sign(o) * -1;
      ae = le, le = R.clone().set(le).add(xe).get();
    }
    const me = le * Q, $e = (ae - le) * Q;
    h = me + $e * E;
  }
  function U() {
    const {
      dragHandler: _,
      index: E,
      scrollBody: R
    } = s.internalEngine(), V = s.selectedScrollSnap();
    if (!_.pointerDown()) return V;
    const q = Math.sign(R.velocity()), O = Math.sign(o), Q = E.clone().set(V).add(q * -1).get();
    return !q || !O ? null : O === q ? Q : V;
  }
  function K(_) {
    const {
      dragHandler: E,
      scrollBody: R
    } = _.internalEngine(), V = E.pointerDown(), q = R.velocity(), O = R.duration(), Q = U(), ae = !yr(Q);
    if (V) {
      if (!q) return;
      o += q, l = Math.abs(q / a), D(Q);
    }
    if (!V) {
      if (!O || ae) return;
      l += (1 - i[Q]) / O, l *= 0.68;
    }
    ae || L(Q, l);
  }
  function B() {
    const {
      target: _,
      location: E
    } = s.internalEngine(), R = _.get() - E.get(), V = Math.abs(R) >= 1, q = U(), O = !yr(q);
    return K(s), O || V ? !1 : i[q] > 0.999;
  }
  function X() {
    return h;
  }
  return {
    name: "fade",
    options: e,
    init: m,
    destroy: c
  };
}
Ro.globalOptions = void 0;
function fd(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ol(e) {
  return fd(e) || Array.isArray(e);
}
function hd() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function fi(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const s = JSON.stringify(Object.keys(e.breakpoints || {})), i = JSON.stringify(Object.keys(t.breakpoints || {}));
  return s !== i ? !1 : n.every((a) => {
    const o = e[a], l = t[a];
    return typeof o == "function" ? `${o}` == `${l}` : !ol(o) || !ol(l) ? o === l : fi(o, l);
  });
}
function sl(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function vd(e, t) {
  if (e.length !== t.length) return !1;
  const n = sl(e), r = sl(t);
  return n.every((s, i) => {
    const a = r[i];
    return fi(s, a);
  });
}
function hi(e) {
  return typeof e == "number";
}
function Wr(e) {
  return typeof e == "string";
}
function Qa(e) {
  return typeof e == "boolean";
}
function cl(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function rt(e) {
  return Math.abs(e);
}
function vi(e) {
  return Math.sign(e);
}
function la(e, t) {
  return rt(e - t);
}
function md(e, t) {
  if (e === 0 || t === 0 || rt(e) <= rt(t)) return 0;
  const n = la(rt(e), rt(t));
  return rt(n / e);
}
function gd(e) {
  return Math.round(e * 100) / 100;
}
function ua(e) {
  return da(e).map(Number);
}
function jt(e) {
  return e[wa(e)];
}
function wa(e) {
  return Math.max(0, e.length - 1);
}
function mi(e, t) {
  return t === wa(e);
}
function ul(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function da(e) {
  return Object.keys(e);
}
function Fo(e, t) {
  return [e, t].reduce((n, r) => (da(r).forEach((s) => {
    const i = n[s], a = r[s], o = cl(i) && cl(a);
    n[s] = o ? Fo(i, a) : a;
  }), n), {});
}
function Yr(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function bd(e, t) {
  const n = {
    start: r,
    center: s,
    end: i
  };
  function r() {
    return 0;
  }
  function s(l) {
    return i(l) / 2;
  }
  function i(l) {
    return t - l;
  }
  function a(l, h) {
    return Wr(e) ? n[e](l) : e(t, l, h);
  }
  return {
    measure: a
  };
}
function fa() {
  let e = [];
  function t(s, i, a, o = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in s)
      s.addEventListener(i, a, o), l = () => s.removeEventListener(i, a, o);
    else {
      const h = s;
      h.addListener(a), l = () => h.removeListener(a);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((s) => s());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function pd(e, t, n, r) {
  const s = fa(), i = 1e3 / 60;
  let a = null, o = 0, l = 0;
  function h() {
    s.add(e, "visibilitychange", () => {
      e.hidden && c();
    });
  }
  function v() {
    m(), s.clear();
  }
  function u(k) {
    if (!l) return;
    a || (a = k, n(), n());
    const g = k - a;
    for (a = k, o += g; o >= i; )
      n(), o -= i;
    const b = o / i;
    r(b), l && (l = t.requestAnimationFrame(u));
  }
  function f() {
    l || (l = t.requestAnimationFrame(u));
  }
  function m() {
    t.cancelAnimationFrame(l), a = null, o = 0, l = 0;
  }
  function c() {
    a = null, o = 0;
  }
  return {
    init: h,
    destroy: v,
    start: f,
    stop: m,
    update: n,
    render: r
  };
}
function yd(e, t) {
  const n = t === "rtl", r = e === "y", s = r ? "y" : "x", i = r ? "x" : "y", a = !r && n ? -1 : 1, o = v(), l = u();
  function h(c) {
    const {
      height: p,
      width: k
    } = c;
    return r ? p : k;
  }
  function v() {
    return r ? "top" : n ? "right" : "left";
  }
  function u() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(c) {
    return c * a;
  }
  return {
    scroll: s,
    cross: i,
    startEdge: o,
    endEdge: l,
    measureSize: h,
    direction: f
  };
}
function Cn(e = 0, t = 0) {
  const n = rt(e - t);
  function r(h) {
    return h < e;
  }
  function s(h) {
    return h > t;
  }
  function i(h) {
    return r(h) || s(h);
  }
  function a(h) {
    return i(h) ? r(h) ? e : t : h;
  }
  function o(h) {
    return n ? h - n * Math.ceil((h - t) / n) : h;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: a,
    reachedAny: i,
    reachedMax: s,
    reachedMin: r,
    removeOffset: o
  };
}
function No(e, t, n) {
  const {
    constrain: r
  } = Cn(0, e), s = e + 1;
  let i = a(t);
  function a(f) {
    return n ? rt((s + f) % s) : r(f);
  }
  function o() {
    return i;
  }
  function l(f) {
    return i = a(f), u;
  }
  function h(f) {
    return v().set(o() + f);
  }
  function v() {
    return No(e, o(), n);
  }
  const u = {
    get: o,
    set: l,
    add: h,
    clone: v
  };
  return u;
}
function wd(e, t, n, r, s, i, a, o, l, h, v, u, f, m, c, p, k, g, b) {
  const {
    cross: C,
    direction: A
  } = e, D = ["INPUT", "SELECT", "TEXTAREA"], L = {
    passive: !1
  }, T = fa(), P = fa(), U = Cn(50, 225).constrain(m.measure(20)), K = {
    mouse: 300,
    touch: 400
  }, B = {
    mouse: 500,
    touch: 600
  }, X = c ? 43 : 25;
  let H = !1, _ = 0, E = 0, R = !1, V = !1, q = !1, O = !1;
  function Q(se) {
    if (!b) return;
    function pe(He) {
      (Qa(b) || b(se, He)) && fe(He);
    }
    const Pe = t;
    T.add(Pe, "dragstart", (He) => He.preventDefault(), L).add(Pe, "touchmove", () => {
    }, L).add(Pe, "touchend", () => {
    }).add(Pe, "touchstart", pe).add(Pe, "mousedown", pe).add(Pe, "touchcancel", _e).add(Pe, "contextmenu", _e).add(Pe, "click", Me, !0);
  }
  function ae() {
    T.clear(), P.clear();
  }
  function le() {
    const se = O ? n : t;
    P.add(se, "touchmove", be, L).add(se, "touchend", _e).add(se, "mousemove", be, L).add(se, "mouseup", _e);
  }
  function me(se) {
    const pe = se.nodeName || "";
    return D.includes(pe);
  }
  function $e() {
    return (c ? B : K)[O ? "mouse" : "touch"];
  }
  function xe(se, pe) {
    const Pe = u.add(vi(se) * -1), He = v.byDistance(se, !c).distance;
    return c || rt(se) < U ? He : k && pe ? He * 0.5 : v.byIndex(Pe.get(), 0).distance;
  }
  function fe(se) {
    const pe = Yr(se, r);
    O = pe, q = c && pe && !se.buttons && H, H = la(s.get(), a.get()) >= 2, !(pe && se.button !== 0) && (me(se.target) || (R = !0, i.pointerDown(se), h.useFriction(0).useDuration(0), s.set(a), le(), _ = i.readPoint(se), E = i.readPoint(se, C), f.emit("pointerDown")));
  }
  function be(se) {
    if (!Yr(se, r) && se.touches.length >= 2) return _e(se);
    const Pe = i.readPoint(se), He = i.readPoint(se, C), Ue = la(Pe, _), ze = la(He, E);
    if (!V && !O && (!se.cancelable || (V = Ue > ze, !V)))
      return _e(se);
    const Ne = i.pointerMove(se);
    Ue > p && (q = !0), h.useFriction(0.3).useDuration(0.75), o.start(), s.add(A(Ne)), se.preventDefault();
  }
  function _e(se) {
    const Pe = v.byDistance(0, !1).index !== u.get(), He = i.pointerUp(se) * $e(), Ue = xe(A(He), Pe), ze = md(He, Ue), Ne = X - 10 * ze, Qe = g + ze / 50;
    V = !1, R = !1, P.clear(), h.useDuration(Ne).useFriction(Qe), l.distance(Ue, !c), O = !1, f.emit("pointerUp");
  }
  function Me(se) {
    q && (se.stopPropagation(), se.preventDefault(), q = !1);
  }
  function qe() {
    return R;
  }
  return {
    init: Q,
    destroy: ae,
    pointerDown: qe
  };
}
function xd(e, t) {
  let r, s;
  function i(u) {
    return u.timeStamp;
  }
  function a(u, f) {
    const c = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (Yr(u, t) ? u : u.touches[0])[c];
  }
  function o(u) {
    return r = u, s = u, a(u);
  }
  function l(u) {
    const f = a(u) - a(s), m = i(u) - i(r) > 170;
    return s = u, m && (r = u), f;
  }
  function h(u) {
    if (!r || !s) return 0;
    const f = a(s) - a(r), m = i(u) - i(r), c = i(u) - i(s) > 170, p = f / m;
    return m && !c && rt(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: o,
    pointerMove: l,
    pointerUp: h,
    readPoint: a
  };
}
function kd() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: s,
      offsetWidth: i,
      offsetHeight: a
    } = n;
    return {
      top: r,
      right: s + i,
      bottom: r + a,
      left: s,
      width: i,
      height: a
    };
  }
  return {
    measure: e
  };
}
function Sd(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function _d(e, t, n, r, s, i, a) {
  const o = [e].concat(r);
  let l, h, v = [], u = !1;
  function f(k) {
    return s.measureSize(a.measure(k));
  }
  function m(k) {
    if (!i) return;
    h = f(e), v = r.map(f);
    function g(b) {
      for (const C of b) {
        if (u) return;
        const A = C.target === e, D = r.indexOf(C.target), L = A ? h : v[D], T = f(A ? e : r[D]);
        if (rt(T - L) >= 0.5) {
          k.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((b) => {
      (Qa(i) || i(k, b)) && g(b);
    }), n.requestAnimationFrame(() => {
      o.forEach((b) => l.observe(b));
    });
  }
  function c() {
    u = !0, l && l.disconnect();
  }
  return {
    init: m,
    destroy: c
  };
}
function Cd(e, t, n, r, s, i) {
  let a = 0, o = 0, l = s, h = i, v = e.get(), u = 0;
  function f() {
    const L = r.get() - e.get(), T = !l;
    let P = 0;
    return T ? (a = 0, n.set(r), e.set(r), P = L) : (n.set(e), a += L / l, a *= h, v += a, e.add(a), P = v - u), o = vi(P), u = v, D;
  }
  function m() {
    const L = r.get() - t.get();
    return rt(L) < 1e-3;
  }
  function c() {
    return l;
  }
  function p() {
    return o;
  }
  function k() {
    return a;
  }
  function g() {
    return C(s);
  }
  function b() {
    return A(i);
  }
  function C(L) {
    return l = L, D;
  }
  function A(L) {
    return h = L, D;
  }
  const D = {
    direction: p,
    duration: c,
    velocity: k,
    seek: f,
    settled: m,
    useBaseFriction: b,
    useBaseDuration: g,
    useFriction: A,
    useDuration: C
  };
  return D;
}
function Ed(e, t, n, r, s) {
  const i = s.measure(10), a = s.measure(50), o = Cn(0.1, 0.99);
  let l = !1;
  function h() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function v(m) {
    if (!h()) return;
    const c = e.reachedMin(t.get()) ? "min" : "max", p = rt(e[c] - t.get()), k = n.get() - t.get(), g = o.constrain(p / a);
    n.subtract(k * g), !m && rt(k) < i && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function u(m) {
    l = !m;
  }
  return {
    shouldConstrain: h,
    constrain: v,
    toggleActive: u
  };
}
function Td(e, t, n, r, s) {
  const i = Cn(-t + e, 0), a = u(), o = v(), l = f();
  function h(c, p) {
    return la(c, p) <= 1;
  }
  function v() {
    const c = a[0], p = jt(a), k = a.lastIndexOf(c), g = a.indexOf(p) + 1;
    return Cn(k, g);
  }
  function u() {
    return n.map((c, p) => {
      const {
        min: k,
        max: g
      } = i, b = i.constrain(c), C = !p, A = mi(n, p);
      return C ? g : A || h(k, b) ? k : h(g, b) ? g : b;
    }).map((c) => parseFloat(c.toFixed(3)));
  }
  function f() {
    if (t <= e + s) return [i.max];
    if (r === "keepSnaps") return a;
    const {
      min: c,
      max: p
    } = o;
    return a.slice(c, p);
  }
  return {
    snapsContained: l,
    scrollContainLimit: o
  };
}
function Ad(e, t, n) {
  const r = t[0], s = n ? r - e : jt(t);
  return {
    limit: Cn(s, r)
  };
}
function Ld(e, t, n, r) {
  const i = t.min + 0.1, a = t.max + 0.1, {
    reachedMin: o,
    reachedMax: l
  } = Cn(i, a);
  function h(f) {
    return f === 1 ? l(n.get()) : f === -1 ? o(n.get()) : !1;
  }
  function v(f) {
    if (!h(f)) return;
    const m = e * (f * -1);
    r.forEach((c) => c.add(m));
  }
  return {
    loop: v
  };
}
function $d(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(i) {
    const a = i - t;
    return n ? a / -n : 0;
  }
  return {
    get: r
  };
}
function Id(e, t, n, r, s) {
  const {
    startEdge: i,
    endEdge: a
  } = e, {
    groupSlides: o
  } = s, l = u().map(t.measure), h = f(), v = m();
  function u() {
    return o(r).map((p) => jt(p)[a] - p[0][i]).map(rt);
  }
  function f() {
    return r.map((p) => n[i] - p[i]).map((p) => -rt(p));
  }
  function m() {
    return o(h).map((p) => p[0]).map((p, k) => p + l[k]);
  }
  return {
    snaps: h,
    snapsAligned: v
  };
}
function Dd(e, t, n, r, s, i) {
  const {
    groupSlides: a
  } = s, {
    min: o,
    max: l
  } = r, h = v();
  function v() {
    const f = a(i), m = !e || t === "keepSnaps";
    return n.length === 1 ? [i] : m ? f : f.slice(o, l).map((c, p, k) => {
      const g = !p, b = mi(k, p);
      if (g) {
        const C = jt(k[0]) + 1;
        return ul(C);
      }
      if (b) {
        const C = wa(i) - jt(k)[0] + 1;
        return ul(C, jt(k)[0]);
      }
      return c;
    });
  }
  return {
    slideRegistry: h
  };
}
function Md(e, t, n, r, s) {
  const {
    reachedAny: i,
    removeOffset: a,
    constrain: o
  } = r;
  function l(c) {
    return c.concat().sort((p, k) => rt(p) - rt(k))[0];
  }
  function h(c) {
    const p = e ? a(c) : o(c), k = t.map((b, C) => ({
      diff: v(b - p, 0),
      index: C
    })).sort((b, C) => rt(b.diff) - rt(C.diff)), {
      index: g
    } = k[0];
    return {
      index: g,
      distance: p
    };
  }
  function v(c, p) {
    const k = [c, c + n, c - n];
    if (!e) return c;
    if (!p) return l(k);
    const g = k.filter((b) => vi(b) === p);
    return g.length ? l(g) : jt(k) - n;
  }
  function u(c, p) {
    const k = t[c] - s.get(), g = v(k, p);
    return {
      index: c,
      distance: g
    };
  }
  function f(c, p) {
    const k = s.get() + c, {
      index: g,
      distance: b
    } = h(k), C = !e && i(k);
    if (!p || C) return {
      index: g,
      distance: c
    };
    const A = t[g] - b, D = c + v(A, 0);
    return {
      index: g,
      distance: D
    };
  }
  return {
    byDistance: f,
    byIndex: u,
    shortcut: v
  };
}
function Od(e, t, n, r, s, i, a) {
  function o(u) {
    const f = u.distance, m = u.index !== t.get();
    i.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), m && (n.set(t.get()), t.set(u.index), a.emit("select"));
  }
  function l(u, f) {
    const m = s.byDistance(u, f);
    o(m);
  }
  function h(u, f) {
    const m = t.clone().set(u), c = s.byIndex(m.get(), f);
    o(c);
  }
  return {
    distance: l,
    index: h
  };
}
function Rd(e, t, n, r, s, i, a, o) {
  const l = {
    passive: !0,
    capture: !0
  };
  let h = 0;
  function v(m) {
    if (!o) return;
    function c(p) {
      if ((/* @__PURE__ */ new Date()).getTime() - h > 10) return;
      a.emit("slideFocusStart"), e.scrollLeft = 0;
      const b = n.findIndex((C) => C.includes(p));
      hi(b) && (s.useDuration(0), r.index(b, 0), a.emit("slideFocus"));
    }
    i.add(document, "keydown", u, !1), t.forEach((p, k) => {
      i.add(p, "focus", (g) => {
        (Qa(o) || o(m, g)) && c(k);
      }, l);
    });
  }
  function u(m) {
    m.code === "Tab" && (h = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: v
  };
}
function na(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = a(l);
  }
  function s(l) {
    t += a(l);
  }
  function i(l) {
    t -= a(l);
  }
  function a(l) {
    return hi(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: s,
    subtract: i
  };
}
function Po(e, t) {
  const n = e.scroll === "x" ? a : o, r = t.style;
  let s = null, i = !1;
  function a(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function o(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function l(f) {
    if (i) return;
    const m = gd(e.direction(f));
    m !== s && (r.transform = n(m), s = m);
  }
  function h(f) {
    i = !f;
  }
  function v() {
    i || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: v,
    to: l,
    toggleActive: h
  };
}
function Fd(e, t, n, r, s, i, a, o, l) {
  const v = ua(s), u = ua(s).reverse(), f = g().concat(b());
  function m(T, P) {
    return T.reduce((U, K) => U - s[K], P);
  }
  function c(T, P) {
    return T.reduce((U, K) => m(U, P) > 0 ? U.concat([K]) : U, []);
  }
  function p(T) {
    return i.map((P, U) => ({
      start: P - r[U] + 0.5 + T,
      end: P + t - 0.5 + T
    }));
  }
  function k(T, P, U) {
    const K = p(P);
    return T.map((B) => {
      const X = U ? 0 : -n, H = U ? n : 0, _ = U ? "end" : "start", E = K[B][_];
      return {
        index: B,
        loopPoint: E,
        slideLocation: na(-1),
        translate: Po(e, l[B]),
        target: () => o.get() > E ? X : H
      };
    });
  }
  function g() {
    const T = a[0], P = c(u, T);
    return k(P, n, !1);
  }
  function b() {
    const T = t - a[0] - 1, P = c(v, T);
    return k(P, -n, !0);
  }
  function C() {
    return f.every(({
      index: T
    }) => {
      const P = v.filter((U) => U !== T);
      return m(P, t) <= 0.1;
    });
  }
  function A() {
    f.forEach((T) => {
      const {
        target: P,
        translate: U,
        slideLocation: K
      } = T, B = P();
      B !== K.get() && (U.to(B), K.set(B));
    });
  }
  function D() {
    f.forEach((T) => T.translate.clear());
  }
  return {
    canLoop: C,
    clear: D,
    loop: A,
    loopPoints: f
  };
}
function Nd(e, t, n) {
  let r, s = !1;
  function i(l) {
    if (!n) return;
    function h(v) {
      for (const u of v)
        if (u.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((v) => {
      s || (Qa(n) || n(l, v)) && h(v);
    }), r.observe(e, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), s = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function Pd(e, t, n, r) {
  const s = {};
  let i = null, a = null, o, l = !1;
  function h() {
    o = new IntersectionObserver((c) => {
      l || (c.forEach((p) => {
        const k = t.indexOf(p.target);
        s[k] = p;
      }), i = null, a = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((c) => o.observe(c));
  }
  function v() {
    o && o.disconnect(), l = !0;
  }
  function u(c) {
    return da(s).reduce((p, k) => {
      const g = parseInt(k), {
        isIntersecting: b
      } = s[g];
      return (c && b || !c && !b) && p.push(g), p;
    }, []);
  }
  function f(c = !0) {
    if (c && i) return i;
    if (!c && a) return a;
    const p = u(c);
    return c && (i = p), c || (a = p), p;
  }
  return {
    init: h,
    destroy: v,
    get: f
  };
}
function Bd(e, t, n, r, s, i) {
  const {
    measureSize: a,
    startEdge: o,
    endEdge: l
  } = e, h = n[0] && s, v = c(), u = p(), f = n.map(a), m = k();
  function c() {
    if (!h) return 0;
    const b = n[0];
    return rt(t[o] - b[o]);
  }
  function p() {
    if (!h) return 0;
    const b = i.getComputedStyle(jt(r));
    return parseFloat(b.getPropertyValue(`margin-${l}`));
  }
  function k() {
    return n.map((b, C, A) => {
      const D = !C, L = mi(A, C);
      return D ? f[C] + v : L ? f[C] + u : A[C + 1][o] - b[o];
    }).map(rt);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: m,
    startGap: v,
    endGap: u
  };
}
function zd(e, t, n, r, s, i, a, o, l) {
  const {
    startEdge: h,
    endEdge: v,
    direction: u
  } = e, f = hi(n);
  function m(g, b) {
    return ua(g).filter((C) => C % b === 0).map((C) => g.slice(C, C + b));
  }
  function c(g) {
    return g.length ? ua(g).reduce((b, C, A) => {
      const D = jt(b) || 0, L = D === 0, T = C === wa(g), P = s[h] - i[D][h], U = s[h] - i[C][v], K = !r && L ? u(a) : 0, B = !r && T ? u(o) : 0, X = rt(U - B - (P + K));
      return A && X > t + l && b.push(C), T && b.push(g.length), b;
    }, []).map((b, C, A) => {
      const D = Math.max(A[C - 1] || 0);
      return g.slice(D, b);
    }) : [];
  }
  function p(g) {
    return f ? m(g, n) : c(g);
  }
  return {
    groupSlides: p
  };
}
function Vd(e, t, n, r, s, i, a) {
  const {
    align: o,
    axis: l,
    direction: h,
    startIndex: v,
    loop: u,
    duration: f,
    dragFree: m,
    dragThreshold: c,
    inViewThreshold: p,
    slidesToScroll: k,
    skipSnaps: g,
    containScroll: b,
    watchResize: C,
    watchSlides: A,
    watchDrag: D,
    watchFocus: L
  } = i, T = 2, P = kd(), U = P.measure(t), K = n.map(P.measure), B = yd(l, h), X = B.measureSize(U), H = Sd(X), _ = bd(o, X), E = !u && !!b, R = u || !!b, {
    slideSizes: V,
    slideSizesWithGaps: q,
    startGap: O,
    endGap: Q
  } = Bd(B, U, K, n, R, s), ae = zd(B, X, k, u, U, K, O, Q, T), {
    snaps: le,
    snapsAligned: me
  } = Id(B, _, U, K, ae), $e = -jt(le) + jt(q), {
    snapsContained: xe,
    scrollContainLimit: fe
  } = Td(X, $e, me, b, T), be = E ? xe : me, {
    limit: _e
  } = Ad($e, be, u), Me = No(wa(be), v, u), qe = Me.clone(), ce = ua(n), se = ({
    dragHandler: S,
    scrollBody: w,
    scrollBounds: G,
    options: {
      loop: M
    }
  }) => {
    M || G.constrain(S.pointerDown()), w.seek();
  }, pe = ({
    scrollBody: S,
    translate: w,
    location: G,
    offsetLocation: M,
    previousLocation: ie,
    scrollLooper: I,
    slideLooper: J,
    dragHandler: y,
    animation: ue,
    eventHandler: Ee,
    scrollBounds: d,
    options: {
      loop: re
    }
  }, te) => {
    const x = S.settled(), N = !d.shouldConstrain(), ee = re ? x : x && N, Ie = ee && !y.pointerDown();
    Ie && ue.stop();
    const we = G.get() * te + ie.get() * (1 - te);
    M.set(we), re && (I.loop(S.direction()), J.loop()), w.to(M.get()), Ie && Ee.emit("settle"), ee || Ee.emit("scroll");
  }, Pe = pd(r, s, () => se(F), (S) => pe(F, S)), He = 0.68, Ue = be[Me.get()], ze = na(Ue), Ne = na(Ue), Qe = na(Ue), vt = na(Ue), mt = Cd(ze, Qe, Ne, vt, f, He), dt = Md(u, be, $e, _e, vt), St = Od(Pe, Me, qe, mt, dt, vt, a), Et = $d(_e), it = fa(), Nt = Pd(t, n, a, p), {
    slideRegistry: _t
  } = Dd(E, b, be, fe, ae, ce), at = Rd(e, n, _t, St, mt, it, a, L), F = {
    ownerDocument: r,
    ownerWindow: s,
    eventHandler: a,
    containerRect: U,
    slideRects: K,
    animation: Pe,
    axis: B,
    dragHandler: wd(B, e, r, s, vt, xd(B, s), ze, Pe, St, mt, dt, Me, a, H, m, c, g, He, D),
    eventStore: it,
    percentOfView: H,
    index: Me,
    indexPrevious: qe,
    limit: _e,
    location: ze,
    offsetLocation: Qe,
    previousLocation: Ne,
    options: i,
    resizeHandler: _d(t, a, s, n, B, C, P),
    scrollBody: mt,
    scrollBounds: Ed(_e, Qe, vt, mt, H),
    scrollLooper: Ld($e, _e, Qe, [ze, Qe, Ne, vt]),
    scrollProgress: Et,
    scrollSnapList: be.map(Et.get),
    scrollSnaps: be,
    scrollTarget: dt,
    scrollTo: St,
    slideLooper: Fd(B, X, $e, V, q, le, be, Qe, n),
    slideFocus: at,
    slidesHandler: Nd(t, a, A),
    slidesInView: Nt,
    slideIndexes: ce,
    slideRegistry: _t,
    slidesToScroll: ae,
    target: vt,
    translate: Po(B, t)
  };
  return F;
}
function Hd() {
  let e = {}, t;
  function n(h) {
    t = h;
  }
  function r(h) {
    return e[h] || [];
  }
  function s(h) {
    return r(h).forEach((v) => v(t, h)), l;
  }
  function i(h, v) {
    return e[h] = r(h).concat([v]), l;
  }
  function a(h, v) {
    return e[h] = r(h).filter((u) => u !== v), l;
  }
  function o() {
    e = {};
  }
  const l = {
    init: n,
    emit: s,
    off: a,
    on: i,
    clear: o
  };
  return l;
}
const Ud = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function qd(e) {
  function t(i, a) {
    return Fo(i, a || {});
  }
  function n(i) {
    const a = i.breakpoints || {}, o = da(a).filter((l) => e.matchMedia(l).matches).map((l) => a[l]).reduce((l, h) => t(l, h), {});
    return t(i, o);
  }
  function r(i) {
    return i.map((a) => da(a.breakpoints || {})).reduce((a, o) => a.concat(o), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function jd(e) {
  let t = [];
  function n(i, a) {
    return t = a.filter(({
      options: o
    }) => e.optionsAtMedia(o).active !== !1), t.forEach((o) => o.init(i, e)), a.reduce((o, l) => Object.assign(o, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((i) => i.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Ua(e, t, n) {
  const r = e.ownerDocument, s = r.defaultView, i = qd(s), a = jd(i), o = fa(), l = Hd(), {
    mergeOptions: h,
    optionsAtMedia: v,
    optionsMediaQueries: u
  } = i, {
    on: f,
    off: m,
    emit: c
  } = l, p = B;
  let k = !1, g, b = h(Ud, Ua.globalOptions), C = h(b), A = [], D, L, T;
  function P() {
    const {
      container: ce,
      slides: se
    } = C;
    L = (Wr(ce) ? e.querySelector(ce) : ce) || e.children[0];
    const Pe = Wr(se) ? L.querySelectorAll(se) : se;
    T = [].slice.call(Pe || L.children);
  }
  function U(ce) {
    const se = Vd(e, L, T, r, s, ce, l);
    if (ce.loop && !se.slideLooper.canLoop()) {
      const pe = Object.assign({}, ce, {
        loop: !1
      });
      return U(pe);
    }
    return se;
  }
  function K(ce, se) {
    k || (b = h(b, ce), C = v(b), A = se || A, P(), g = U(C), u([b, ...A.map(({
      options: pe
    }) => pe)]).forEach((pe) => o.add(pe, "change", B)), C.active && (g.translate.to(g.location.get()), g.animation.init(), g.slidesInView.init(), g.slideFocus.init(qe), g.eventHandler.init(qe), g.resizeHandler.init(qe), g.slidesHandler.init(qe), g.options.loop && g.slideLooper.loop(), L.offsetParent && T.length && g.dragHandler.init(qe), D = a.init(qe, A)));
  }
  function B(ce, se) {
    const pe = ae();
    X(), K(h({
      startIndex: pe
    }, ce), se), l.emit("reInit");
  }
  function X() {
    g.dragHandler.destroy(), g.eventStore.clear(), g.translate.clear(), g.slideLooper.clear(), g.resizeHandler.destroy(), g.slidesHandler.destroy(), g.slidesInView.destroy(), g.animation.destroy(), a.destroy(), o.clear();
  }
  function H() {
    k || (k = !0, o.clear(), X(), l.emit("destroy"), l.clear());
  }
  function _(ce, se, pe) {
    !C.active || k || (g.scrollBody.useBaseFriction().useDuration(se === !0 ? 0 : C.duration), g.scrollTo.index(ce, pe || 0));
  }
  function E(ce) {
    const se = g.index.add(1).get();
    _(se, ce, -1);
  }
  function R(ce) {
    const se = g.index.add(-1).get();
    _(se, ce, 1);
  }
  function V() {
    return g.index.add(1).get() !== ae();
  }
  function q() {
    return g.index.add(-1).get() !== ae();
  }
  function O() {
    return g.scrollSnapList;
  }
  function Q() {
    return g.scrollProgress.get(g.offsetLocation.get());
  }
  function ae() {
    return g.index.get();
  }
  function le() {
    return g.indexPrevious.get();
  }
  function me() {
    return g.slidesInView.get();
  }
  function $e() {
    return g.slidesInView.get(!1);
  }
  function xe() {
    return D;
  }
  function fe() {
    return g;
  }
  function be() {
    return e;
  }
  function _e() {
    return L;
  }
  function Me() {
    return T;
  }
  const qe = {
    canScrollNext: V,
    canScrollPrev: q,
    containerNode: _e,
    internalEngine: fe,
    destroy: H,
    off: m,
    on: f,
    emit: c,
    plugins: xe,
    previousScrollSnap: le,
    reInit: p,
    rootNode: be,
    scrollNext: E,
    scrollPrev: R,
    scrollProgress: Q,
    scrollSnapList: O,
    scrollTo: _,
    selectedScrollSnap: ae,
    slideNodes: Me,
    slidesInView: me,
    slidesNotInView: $e
  };
  return K(t, n), setTimeout(() => l.emit("init"), 0), qe;
}
Ua.globalOptions = void 0;
function er(e = {}, t = []) {
  const n = zi(e), r = zi(t);
  let s = n ? e.value : e, i = r ? t.value : t;
  const a = kn(), o = kn();
  function l() {
    o.value && o.value.reInit(s, i);
  }
  return pt(() => {
    !hd() || !a.value || (Ua.globalOptions = er.globalOptions, o.value = Ua(a.value, s, i));
  }), ai(() => {
    o.value && o.value.destroy();
  }), n && Be(e, (h) => {
    fi(s, h) || (s = h, l());
  }), r && Be(t, (h) => {
    vd(i, h) || (i = h, l());
  }), [a, o];
}
er.globalOptions = void 0;
const rg = ["default", "highlight"], ig = ["click", "keyboard"], Xr = /* @__PURE__ */ Symbol();
var Oa = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e))(Oa || {});
const Zd = ["tabindex"], Wd = {
  key: 0,
  class: "lc-carousel__arrows"
}, Yd = ["aria-controls", "aria-current", "aria-label", "onClick"], Xd = { class: "lc-carousel__dot-indicator" }, Gd = ["aria-label", "aria-pressed"], dl = 1.08, Kd = /* @__PURE__ */ Se({
  __name: "LcCarousel",
  props: {
    duration: { default: 25 },
    loop: { type: Boolean },
    skipSnaps: { type: Boolean },
    adaptiveHeight: { type: Boolean },
    arrows: { type: Boolean },
    autoPlay: { type: Boolean },
    defaultIndex: { default: 0 },
    disableSwipe: { type: Boolean },
    fade: { type: Boolean },
    id: {},
    keyExtractor: { type: Function },
    keyProp: {},
    moveTriggers: { default: () => [] },
    pagination: { type: Boolean },
    renderOnlyVisible: { type: Boolean },
    slides: {},
    variant: { default: "default" },
    visibleSlideBuffer: { default: 0 }
  },
  emits: ["ready", "changed"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = W(() => e.slides.length > 1), i = W(() => !e.disableSwipe && s.value), a = {
      align: "start",
      containScroll: "trimSnaps"
    }, o = {
      align: "center",
      containScroll: !1,
      loop: !1,
      skipSnaps: !0
    }, l = {
      duration: e.duration,
      inViewThreshold: 2 / 100,
      loop: e.loop,
      skipSnaps: e.skipSnaps,
      watchDrag: i.value,
      watchResize: ({ containerNode: M, emit: ie, reInit: I }, J) => {
        if (!e.adaptiveHeight) return !0;
        for (const y of J) {
          if (M() === y.target) return !0;
          requestAnimationFrame(() => {
            I(), ie("resize");
          });
          break;
        }
        return !1;
      },
      ...e.variant === "highlight" ? o : a
    }, h = je.lcCarousel.autoPlayDelayInSeconds * 1e3, v = (M = e.fade) => [
      ...e.adaptiveHeight ? [Oo()] : [],
      ...M ? [Ro()] : [],
      Ja({
        draggable: "",
        dragging: "lc-carousel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-carousel__slide--snapped"
      })
    ], [u, f] = er(
      {
        ...l,
        startIndex: e.defaultIndex
      },
      v()
    ), m = Wn(Xr, () => null, !0), c = mo(), p = ge(0), k = ge(0), g = ge(!i.value), b = ge(!1), C = ge(!1), A = ge(!1), D = ge(!1), L = ge(!1), T = ge(), P = ge(e.defaultIndex), U = ge(
      new Set(
        e.slides.slice(e.defaultIndex - e.visibleSlideBuffer, e.defaultIndex + e.visibleSlideBuffer).map((M, ie) => ie)
      )
    );
    let K = h, B, X, H, _, E, R;
    const V = W(() => je.lcCarousel), q = W(
      () => !!e.autoPlay && s.value && !D.value && !A.value && !b.value
    ), O = W(() => [
      "lc-carousel",
      `lc-carousel--variant-${e.variant}`,
      {
        "lc-carousel--adaptive-height": e.adaptiveHeight,
        "lc-carousel--arrows": !!e.arrows && s.value,
        "lc-carousel--auto-play": !!e.autoPlay && s.value,
        "lc-carousel--auto-play-paused": !!e.autoPlay && !q.value,
        "lc-carousel--draggable": !g.value,
        "lc-carousel--fade": e.fade,
        "lc-carousel--keyboard-enabled": St("keyboard"),
        "lc-carousel--swipe-hint": L.value
      }
    ]), Q = () => {
      i.value && (f.value?.reInit({
        ...l,
        watchDrag: !1
      }), g.value = !0);
    }, ae = () => {
      i.value && (f.value?.reInit({
        ...l,
        watchDrag: !0
      }), g.value = !1);
    }, le = (M, ie) => e.keyExtractor ? e.keyExtractor(M, ie) : e.keyProp && $u(e.keyProp, M) ? String(M[e.keyProp]) : String(ie), me = (M) => {
      const ie = {
        "aria-roledescription": "slide",
        role: "group"
      };
      return Et(M) ? ie : {
        ...ie,
        "aria-hidden": "true",
        inert: "true"
      };
    }, $e = ({ clientX: M }) => {
      if (!f.value || !St("click") || g.value) return;
      const I = f.value.slideNodes().map((J) => J.getBoundingClientRect());
      for (const [J, { left: y, right: ue }] of I.entries())
        if (!(M < y || M > ue)) {
          _t(J);
          break;
        }
    }, xe = () => {
      C.value = !0, w(), G(), He(), r("ready");
    }, fe = (M) => {
      if (!(!tn(M.key, Oa) || !St("keyboard") || g.value))
        switch (M.preventDefault(), M.stopPropagation(), M.key) {
          case Oa.ArrowLeft:
            F();
            break;
          case Oa.ArrowRight:
            at();
            break;
        }
    }, be = () => {
      m?.disable(), pe();
    }, _e = () => {
      m?.enable(), He();
    }, Me = () => {
      w(), G();
    }, qe = () => {
      const M = f.value?.selectedScrollSnap() ?? 0;
      P.value = M, r("changed", M);
    }, ce = () => {
      clearTimeout(X), X = void 0, B = void 0;
    }, se = () => {
      clearTimeout(X), B = Date.now(), X = setTimeout(() => Ue(1), K);
    }, pe = () => {
      !X || B === void 0 || (K = Math.max(0, K - (Date.now() - B)), ce());
    }, Pe = () => {
      !q.value || X || se();
    }, He = () => {
      if (K = h, p.value += 1, !q.value) {
        ce();
        return;
      }
      se();
    }, Ue = (M) => {
      const ie = (P.value + M + e.slides.length) % e.slides.length;
      ze(ie);
    }, ze = (M) => {
      f.value?.scrollTo(M, it(!0)), He();
    }, Ne = (M) => V.value.slideAriaLabel.replace("{slide}", String(M + 1)), Qe = () => {
      if (q.value) {
        D.value = !0;
        return;
      }
      D.value = !1, A.value = !1;
    }, vt = () => {
      b.value = document.visibilityState === "hidden", Nt();
    }, mt = [
      ["focusin", () => A.value = !0],
      ["focusout", () => A.value = !1],
      ["mouseenter", () => A.value = !0],
      ["mouseleave", () => A.value = !1]
    ], dt = () => {
      clearTimeout(E), E = setTimeout(() => f.value?.reInit(), 50);
    }, St = (M) => e.moveTriggers.includes(M), Et = (M) => U.value.has(M), it = (M) => !M || c.value === "reduce", Nt = () => {
      const M = T.value?.querySelector(".lc-carousel__dot-progress")?.getAnimations?.().at(0);
      if (M) {
        if (q.value) {
          M.play();
          return;
        }
        M.pause();
      }
    }, _t = (M, ie = !0) => {
      f.value?.scrollTo(M, it(ie));
    }, at = (M = !0) => {
      f.value?.scrollNext(it(M));
    }, F = (M = !0) => {
      f.value?.scrollPrev(it(M));
    }, S = async () => {
      L.value || (L.value = !0, await new Promise((M) => {
        R = setTimeout(() => {
          L.value = !1, M();
        }, 1800);
      }));
    }, w = () => {
      if (!f.value || e.variant !== "highlight") return;
      const { rootNode: M, slideNodes: ie } = f.value, I = ie(), y = M().getBoundingClientRect(), ue = y.left + y.width / 2;
      let Ee = I[0], d = 1 / 0;
      I.forEach((N) => {
        const ee = N.getBoundingClientRect(), Ie = ee.left + ee.width / 2, we = Math.abs(Ie - ue);
        we < d && (Ee = N, d = we);
      });
      const x = Ee.offsetWidth * (dl - 1) / 2;
      I.forEach((N, ee) => {
        if (N === Ee) {
          k.value = ee, N.style.transform = `scale(${dl.toString()}) translateX(0px)`, N.style.zIndex = "1";
          return;
        }
        const Ie = N.getBoundingClientRect(), Le = Ie.left + Ie.width / 2 < ue ? -1 : 1;
        N.style.transform = `scale(1) translateX(${(Le * x).toString()}px)`, N.style.zIndex = "0";
      });
    }, G = () => {
      if (!f.value) return;
      const M = f.value.slidesInView();
      if (!M.length) return;
      const ie = e.slides.length, I = /* @__PURE__ */ new Set();
      M.forEach((J) => {
        for (let y = -e.visibleSlideBuffer; y <= e.visibleSlideBuffer; y++) {
          const ue = (J + y + ie) % ie;
          I.add(ue);
        }
      }), U.value = I;
    };
    return pt(() => {
      document.addEventListener("visibilitychange", vt), f.value && (f.value.on("init", xe).on("pointerDown", be).on("pointerUp", _e).on("reInit", Me).on("resize", G).on("scroll", w).on("select", qe).on("slidesChanged", w).on("slidesInView", G), _ = f.value.rootNode(), mt.forEach(
        ([M, ie]) => _?.addEventListener(M, ie)
      ), e.adaptiveHeight && (H = new ResizeObserver(dt), f.value.slideNodes().forEach((M) => H?.observe(M))));
    }), Ln(() => {
      document.removeEventListener("visibilitychange", vt), mt.forEach(
        ([M, ie]) => _?.removeEventListener(M, ie)
      ), ce(), clearTimeout(R), clearTimeout(E), H?.disconnect();
    }), Be(
      [i, () => e.fade, () => e.loop, () => e.skipSnaps, () => e.variant],
      ([M, ie, I, J, y]) => {
        g.value = !M, f.value?.reInit(
          {
            ...l,
            loop: I,
            skipSnaps: J,
            watchDrag: M,
            ...y === "highlight" ? o : a
          },
          v(ie)
        );
      }
    ), Be(q, (M) => M ? Pe() : pe()), t({
      disable: Q,
      enable: ae,
      moveToIndex: _t,
      next: at,
      prev: F,
      showSwipeHint: S
    }), ri(Xr, {
      disable: Q,
      enable: ae
    }), (M, ie) => ($(), Z("div", {
      class: ye(O.value),
      style: Ct(
        e.autoPlay ? { "--lc-carousel-auto-play-delay": `${h}ms` } : void 0
      ),
      tabindex: St("keyboard") ? 0 : void 0,
      onClickPassive: $e,
      onKeydown: fe
    }, [
      ne("div", {
        ref_key: "emblaRef",
        ref: u,
        class: "lc-carousel__container"
      }, [
        ne("div", Ae({ id: e.id }, { class: "lc-carousel__wrap" }), [
          ($(!0), Z(Xe, null, ht(e.slides, (I, J) => ve(M.$slots, "slide", Ae({ ref_for: !0 }, { slide: I, index: J }, {
            key: le(I, J),
            attributes: me(J),
            isHighlighted: k.value === J,
            isVisible: Et(J)
          }))), 128))
        ], 16),
        e.arrows && s.value ? ($(), Z("nav", Wd, [
          Fe(j(kt), {
            "aria-controls": e.id,
            "aria-label": V.value.prevSlideAriaLabel,
            icon: "chevron-left",
            size: "small",
            variant: "filled",
            onClick: ie[0] || (ie[0] = (I) => Ue(-1))
          }, null, 8, ["aria-controls", "aria-label"]),
          Fe(j(kt), {
            "aria-controls": e.id,
            "aria-label": V.value.nextSlideAriaLabel,
            icon: "chevron-right",
            size: "small",
            variant: "filled",
            onClick: ie[1] || (ie[1] = (I) => Ue(1))
          }, null, 8, ["aria-controls", "aria-label"])
        ])) : de("", !0)
      ], 512),
      e.pagination && s.value ? ($(), Z("div", {
        key: 0,
        ref_key: "paginationElement",
        ref: T,
        class: "lc-carousel__pagination"
      }, [
        ($(!0), Z(Xe, null, ht(e.slides, (I, J) => ($(), Z("button", {
          key: le(I, J),
          "aria-controls": e.id,
          "aria-current": P.value === J ? "true" : void 0,
          "aria-label": Ne(J),
          class: ye(["lc-carousel__dot", { "lc-carousel__dot--active": P.value === J }]),
          type: "button",
          onClick: (y) => ze(J)
        }, [
          ne("span", Xd, [
            e.autoPlay && P.value === J ? ($(), Z("span", {
              key: p.value,
              class: "lc-carousel__dot-progress"
            })) : de("", !0)
          ])
        ], 10, Yd))), 128)),
        e.autoPlay ? ($(), Z("button", {
          key: 0,
          "aria-label": q.value ? V.value.pauseAriaLabel : V.value.playAriaLabel,
          "aria-pressed": q.value ? "false" : "true",
          class: "lc-carousel__auto-play-toggle",
          type: "button",
          onClick: Qe
        }, [
          Fe(j(Ke), {
            name: q.value ? "pause" : "play-filled",
            size: "small"
          }, null, 8, ["name"])
        ], 8, Gd)) : de("", !0)
      ], 512)) : de("", !0)
    ], 46, Zd));
  }
}), Jd = ["for"], Qd = { class: "lc-checkbox__control" }, ef = ["id", "data-click-name"], tf = ["id"], lg = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcCheckbox",
  props: {
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "checkbox" },
    noFeedback: { type: Boolean },
    value: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = $t(e.id), { vibrate: s } = go(), i = W(() => [
      "lc-checkbox",
      {
        "lc-checkbox--checked": e.value,
        "lc-checkbox--disabled": e.disabled,
        "lc-checkbox--error": !!e.errorMessage
      }
    ]), a = W({
      get: () => e.value,
      set: (o) => {
        n("update:value", o), s();
      }
    });
    return (o, l) => ($(), Z("div", {
      class: ye([i.value, o.$attrs.class])
    }, [
      ne("label", {
        class: "lc-checkbox__wrap",
        for: j(r)
      }, [
        ne("div", Qd, [
          Qt(ne("input", Ae({ id: j(r) }, {
            ...en(o.$attrs, ["class"]),
            disabled: e.disabled,
            name: e.name
          }, {
            "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
            class: "lc-checkbox__input",
            "data-click-listener": "blur,focus",
            "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_checkbox`,
            type: "checkbox",
            onKeydown: l[1] || (l[1] = ii((h) => a.value = !a.value, ["enter"]))
          }), null, 16, ef), [
            [co, a.value]
          ]),
          Fe(j(Ke), {
            class: "lc-checkbox__icon",
            name: "checkmark"
          })
        ]),
        e.label ? ($(), Z("span", {
          key: 0,
          id: `${j(r)}-label`,
          class: "lc-checkbox__label"
        }, Oe(e.label), 9, tf)) : de("", !0)
      ], 8, Jd),
      e.noFeedback ? de("", !0) : ($(), ke(j($n), Ae({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), nf = () => typeof window > "u";
function Bo(e, t) {
  const n = pa(), r = typeof e == "string" ? e : void 0, s = typeof e == "function" ? e : t;
  if (n)
    return r ? n.useState(r, s) : n.useState(s);
  const i = s ? Ge(s()) : void 0;
  return ge(i);
}
const gi = {
  drawingShort: {
    hour: "numeric",
    minute: "numeric",
    weekday: "short"
  }
}, zo = (e, t) => ou({
  end: new Date(t),
  start: new Date(e)
}), Vo = ({ date: e, format: t, locale: n, timeZone: r }) => new Intl.DateTimeFormat(n ?? "en-US", {
  ...gi[t],
  timeZone: r
}).format(new Date(e)), wr = (e) => typeof e != "number" ? "" : e <= 0 ? "00" : e < 10 ? `0${e}` : String(e), af = /* @__PURE__ */ Se({
  __name: "LcCountdown",
  props: {
    expiresAt: {},
    variant: { default: "default" }
  },
  emits: ["expired", "update"],
  setup(e, { emit: t }) {
    const n = {
      hours: 0,
      minutes: 0,
      seconds: 0
    }, r = t, s = nf(), i = Bo(() => /* @__PURE__ */ new Date()), a = ge(!1);
    let o;
    const l = W(() => {
      if (a.value) return n;
      const { hours: g, minutes: b, seconds: C } = zo(i.value, f.value);
      return {
        ...n,
        hours: g || 0,
        minutes: b || 0,
        seconds: C || 0
      };
    }), h = W(() => v.value ? f.value.toISOString() : void 0), v = W(() => oi(f.value)), u = W(() => {
      const { hours: g, minutes: b, seconds: C } = l.value, A = `${wr(b)}:${wr(C)}`;
      return e.variant === "without-hours" ? A : `${wr(g)}:${A}`;
    }), f = W(() => new Date(e.expiresAt)), m = () => {
      a.value = !0, r("expired"), clearInterval(o);
    }, c = () => {
      i.value = /* @__PURE__ */ new Date(), r("update");
    }, p = () => Eo(f.value), k = () => {
      o && clearInterval(o), o = setInterval(() => {
        p() ? m() : c();
      }, 1e3);
    };
    return ai(() => {
      clearInterval(o);
    }), Be(
      h,
      () => {
        s || (a.value = !1, k());
      },
      {
        immediate: !0
      }
    ), (g, b) => v.value ? ($(), Z("time", Ae({ key: 0 }, { datetime: h.value }, { class: "lc-countdown" }), Oe(u.value), 17)) : de("", !0);
  }
}), og = ["default", "without-hours"], rf = { class: "lc-data-list" }, sg = /* @__PURE__ */ Se({
  __name: "LcDataList",
  setup(e) {
    return (t, n) => ($(), Z("ul", rf, [
      ve(t.$slots, "default")
    ]));
  }
}), lf = { class: "lc-data-list-item" }, of = { class: "lc-data-list-item__content" }, sf = {
  key: 0,
  class: "lc-data-list-item__headline"
}, cf = {
  key: 0,
  class: "lc-data-list-item__text"
}, uf = { key: 0 }, df = {
  key: 0,
  class: "lc-data-list-item__underneath"
}, cg = /* @__PURE__ */ Se({
  __name: "LcDataListItem",
  props: {
    headline: {},
    text: {}
  },
  setup(e) {
    return (t, n) => ($(), Z("li", lf, [
      ne("div", of, [
        ne("section", null, [
          e.headline ? ($(), Z("span", sf, Oe(e.headline), 1)) : de("", !0),
          ve(t.$slots, "default", {}, () => [
            e.text ? ($(), Z("p", cf, Oe(e.text), 1)) : de("", !0)
          ])
        ]),
        t.$slots.suffix ? ($(), Z("aside", uf, [
          ve(t.$slots, "suffix")
        ])) : de("", !0)
      ]),
      t.$slots.underneath ? ($(), Z("div", df, [
        ve(t.$slots, "underneath")
      ])) : de("", !0)
    ]));
  }
});
var ff = Object.defineProperty, hf = (e, t, n) => t in e ? ff(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, oa = (e, t, n) => hf(e, typeof t != "symbol" ? t + "" : t, n);
const fl = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, hl = (e, t, n) => e.replaceAll(t, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), vl = (e, t, n) => {
  var r;
  return new Intl.NumberFormat(((r = n.number) == null ? void 0 : r.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, vf = (e, t = !0, n) => {
  var r, s, i, a;
  const o = ((r = n.number) == null ? void 0 : r.unsigned) !== !0 && e.startsWith("-") ? "-" : "", l = ((s = n.number) == null ? void 0 : s.fraction) ?? 0;
  let h = vl(0, l, n);
  const v = h.formatToParts(1000.12), u = ((i = v.find((k) => k.type === "group")) == null ? void 0 : i.value) ?? " ", f = ((a = v.find((k) => k.type === "decimal")) == null ? void 0 : a.value) ?? ".", m = hl(e, u, f);
  if (Number.isNaN(parseFloat(m))) return o;
  const c = m.split(".");
  if (c[1] != null && c[1].length >= 1) {
    const k = c[1].length <= l ? c[1].length : l;
    h = vl(k, l, n);
  }
  let p = h.format(parseFloat(m));
  return t ? l > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (p += f) : p = hl(p, u, f), o + p;
}, Ho = (e) => JSON.parse(e.replaceAll("'", '"')), mf = (e, t = {}) => {
  const n = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = gf(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = $a(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = $a(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = $a(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = bf(e.dataset.maskaTokens));
  const r = {};
  return e.dataset.maskaNumberLocale != null && (r.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (r.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (r.unsigned = $a(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(r).length > 0) && (n.number = r), n;
}, $a = (e) => e !== "" ? !!JSON.parse(e) : !0, gf = (e) => e.startsWith("[") && e.endsWith("]") ? Ho(e) : e, bf = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Ho(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const r = n.split(":");
    t[r[0]] = {
      pattern: Uo() ? new RegExp(r[1], "u") : new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), t;
}, Uo = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
class pf {
  constructor(t = {}) {
    oa(this, "opts", {}), oa(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...t };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...fl, ...n.tokens };
      for (const r of Object.values(n.tokens))
        typeof r.pattern == "string" && (r.pattern = Uo() ? new RegExp(r.pattern, "u") : new RegExp(r.pattern));
    } else
      n.tokens = fl;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((r, s) => r.length - s.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(String(t));
    if (this.opts.mask == null || n == null) return !1;
    const r = this.process(String(t), n).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : r >= n.length;
  }
  findMask(t) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(t);
    const r = this.process(t, n.slice(-1).pop() ?? "", !1);
    return n.find((s) => this.process(t, s, !1).length >= r.length) ?? "";
  }
  escapeMask(t) {
    const n = [], r = [];
    return t.split("").forEach((s, i) => {
      s === "!" && t[i - 1] !== "!" ? r.push(i - r.length) : n.push(s);
    }), { mask: n.join(""), escaped: r };
  }
  process(t, n, r = !0) {
    if (this.opts.number != null) return vf(t, r, this.opts);
    if (n == null) return t;
    const s = `v=${t},mr=${n},m=${r ? 1 : 0}`;
    if (this.memo.has(s)) return this.memo.get(s);
    const { mask: i, escaped: a } = this.escapeMask(n), o = [], l = this.opts.tokens != null ? this.opts.tokens : {}, h = this.isReversed() ? -1 : 1, v = this.isReversed() ? "unshift" : "push", u = this.isReversed() ? 0 : i.length - 1, f = this.isReversed() ? () => k > -1 && g > -1 : () => k < i.length && g < t.length, m = (C) => !this.isReversed() && C <= u || this.isReversed() && C >= u;
    let c, p = -1, k = this.isReversed() ? i.length - 1 : 0, g = this.isReversed() ? t.length - 1 : 0, b = !1;
    for (; f(); ) {
      const C = i.charAt(k), A = l[C], D = A?.transform != null ? A.transform(t.charAt(g)) : t.charAt(g);
      if (!a.includes(k) && A != null ? (D.match(A.pattern) != null ? (o[v](D), A.repeated ? (p === -1 ? p = k : k === u && k !== p && (k = p - h), u === p && (k -= h)) : A.multiple && (b = !0, k -= h), k += h) : A.multiple ? b && (k += h, g -= h, b = !1) : D === c ? c = void 0 : A.optional && (k += h, g -= h), g += h) : (r && !this.isEager() && o[v](C), D === C && !this.isEager() ? g += h : c = C, this.isEager() || (k += h)), this.isEager())
        for (; m(k) && (l[i.charAt(k)] == null || a.includes(k)); ) {
          if (r) {
            if (o[v](i.charAt(k)), t.charAt(g) === i.charAt(k)) {
              k += h, g += h;
              continue;
            }
          } else i.charAt(k) === t.charAt(g) && (g += h);
          k += h;
        }
    }
    return this.memo.set(s, o.join("")), this.memo.get(s);
  }
}
class yf {
  constructor(t, n = {}) {
    oa(this, "items", /* @__PURE__ */ new Map()), oa(this, "eventAbortController"), oa(this, "onInput", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && !r.isTrusted && !r.bubbles)
        return;
      const s = r.target, i = this.items.get(s);
      if (i === void 0) return;
      const a = "inputType" in r && r.inputType.startsWith("delete"), o = i.isEager(), l = a && o && i.unmasked(s.value) === "" ? "" : s.value;
      this.fixCursor(s, a, () => this.setValue(s, l));
    }), this.options = n, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    var n;
    t.value !== "" && t.value !== ((n = this.processInput(t)) == null ? void 0 : n.masked) && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const n = this.getOptions(this.options);
    for (const r of t) {
      if (!this.items.has(r)) {
        const { signal: i } = this.eventAbortController;
        r.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const s = new pf(mf(r, n));
      this.items.set(r, s), queueMicrotask(() => this.updateValue(r)), r.selectionStart === null && s.isEager() && console.warn("Maska: input of `%s` type is not supported", r.type);
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: n, preProcess: r, postProcess: s, ...i } = t;
    return i;
  }
  fixCursor(t, n, r) {
    var s, i;
    const a = t.selectionStart, o = t.value;
    if (r(), a === null || a === o.length && !n) return;
    const l = t.value, h = o.slice(0, a), v = l.slice(0, a), u = (s = this.processInput(t, h)) == null ? void 0 : s.unmasked, f = (i = this.processInput(t, v)) == null ? void 0 : i.unmasked;
    if (u === void 0 || f === void 0) return;
    let m = a;
    h !== v && (m += n ? l.length - o.length : u.length - f.length), t.setSelectionRange(m, m);
  }
  setValue(t, n) {
    const r = this.processInput(t, n);
    r !== void 0 && (t.value = r.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((s) => s(r)) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", { detail: r })), t.dispatchEvent(new CustomEvent("input", { detail: r.masked })));
  }
  processInput(t, n) {
    const r = this.items.get(t);
    if (r === void 0) return;
    let s = n ?? t.value;
    this.options.preProcess != null && (s = this.options.preProcess(s));
    let i = r.masked(s);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: r.unmasked(s),
      completed: r.completed(s)
    };
  }
}
const xr = /* @__PURE__ */ new WeakMap(), wf = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const n = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : n && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, xf = (e, t) => {
  var n;
  const r = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (r == null || r?.type === "file") return;
  let s = {};
  if (t.value != null && (s = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (a) => {
      const o = t.modifiers.unmasked ? a.unmasked : t.modifiers.completed ? a.completed : a.masked;
      wf(t, o);
    };
    s.onMaska = s.onMaska == null ? i : Array.isArray(s.onMaska) ? [...s.onMaska, i] : [s.onMaska, i];
  }
  xr.has(r) ? (n = xr.get(r)) == null || n.update(s) : xr.set(r, new yf(r, s));
}, kf = ["for"], Sf = ["id"], _f = { class: "lc-input__input-wrap" }, Cf = ["data-testid"], Ef = ["data-testid"], tr = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: { default: "input" },
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean, default: !0 },
    suffixClass: {},
    type: { default: "text" },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = { Z: { pattern: "[1-9]" } }, s = n, i = ot("input"), a = $t(e.id), o = ge(!1), l = W(() => [
      "lc-input",
      {
        "lc-input--disabled": e.disabled,
        "lc-input--error": !!e.errorMessage,
        "lc-input--has-label": !!e.label
      }
    ]), h = W(() => ({
      "aria-labelledby": e.label ? `${a}-label` : void 0,
      autocomplete: e.autocomplete,
      class: "lc-input__input",
      "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_input`,
      disabled: e.disabled,
      id: a,
      inputmode: e.inputmode,
      name: e.name,
      onFocusin: () => o.value = !0,
      onFocusout: () => o.value = !1,
      pattern: e.pattern,
      placeholder: e.placeholder,
      spellcheck: e.spellcheck,
      type: e.type
    })), v = W(() => [
      "lc-input__label",
      {
        "lc-input__label--floating": o.value || !!e.value || typeof e.value == "number"
      }
    ]), u = W(() => e.mask ? m(e.mask) ? { ...e.mask, tokens: { ...r, ...e.mask.tokens } } : { mask: e.mask, tokens: r } : {}), f = W({
      get: () => e.value,
      set: (c) => {
        s("update:value", c);
      }
    }), m = (c) => c.mask !== void 0;
    return pt(() => {
      e.autofocus && i.value?.focus(), e.value && s("update:value", e.value);
    }), t({ ref: i }), (c, p) => ($(), Z("div", {
      class: ye([l.value, c.$attrs.class])
    }, [
      ne("label", {
        class: "lc-input__wrap",
        for: j(a)
      }, [
        e.label ? ($(), Z("span", {
          key: 0,
          id: `${j(a)}-label`,
          class: ye(v.value)
        }, Oe(e.label), 11, Sf)) : de("", !0),
        ne("div", _f, [
          c.$slots.prefix ? ($(), Z("div", {
            key: 0,
            class: ye(["lc-input__prefix", e.prefixClass])
          }, [
            ve(c.$slots, "prefix")
          ], 2)) : de("", !0),
          e.mask ? Qt(($(), Z("input", Ae({
            key: 1,
            ref: "input"
          }, {
            ...en(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[0] || (p[0] = (k) => f.value = k),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-with-mask"
          }), null, 16, Cf)), [
            [Vi, f.value],
            [j(xf), u.value]
          ]) : Qt(($(), Z("input", Ae({
            key: 2,
            ref: "input"
          }, {
            ...en(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[1] || (p[1] = (k) => f.value = k),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-without-mask"
          }), null, 16, Ef)), [
            [Vi, f.value]
          ]),
          c.$slots.suffix ? ($(), Z("div", {
            key: 3,
            class: ye(["lc-input__suffix", e.suffixClass])
          }, [
            ve(c.$slots, "suffix")
          ], 2)) : de("", !0)
        ])
      ], 8, kf),
      e.noFeedback ? de("", !0) : ($(), ke(j($n), Ae({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), ug = [
  "decimal",
  "email",
  "none",
  "numeric",
  "search",
  "tel",
  "text",
  "url"
], dg = [
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url"
], fg = /* @__PURE__ */ Se({
  __name: "LcDateInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null], default: "##/##/####" },
    name: {},
    noFeedback: { type: Boolean },
    placeholder: { default: "MM/DD/YYYY" },
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {}
  },
  setup(e) {
    const t = ga(e, ["mask", "placeholder"]);
    return (n, r) => ($(), ke(j(tr), Ae({ ...n.$attrs, ...t, mask: e.mask, placeholder: e.placeholder }, {
      class: "lc-date-input",
      inputmode: "numeric",
      pattern: "[0-9]*"
    }), null, 16));
  }
}), Tf = { class: "lc-description-list" }, hg = /* @__PURE__ */ Se({
  __name: "LcDescriptionList",
  setup(e) {
    return (t, n) => ($(), Z("dl", Tf, [
      ve(t.$slots, "default")
    ]));
  }
}), qo = /* @__PURE__ */ Symbol();
var ln = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Backspace = "Backspace", e.Dead = "Dead", e.Delete = "Delete", e.Eight = "8", e.Five = "5", e.Four = "4", e.Nine = "9", e.One = "1", e.Seven = "7", e.Six = "6", e.Three = "3", e.Two = "2", e.Zero = "0", e))(ln || {});
const vg = /* @__PURE__ */ Se({
  __name: "LcDigitInput",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    type: {},
    index: { default: 0 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = ga(e, ["index"]), i = ot("input"), a = Wn(qo, () => null, !0), o = W(() => Ge(a?.config)), l = W(() => s.disabled || !!Ge(a?.disabled)), h = W(() => l.value ? "*" : "#"), v = W({
      get: () => l.value ? "X" : f.value,
      set: (c) => {
        if (l.value || c === "X") return;
        const p = typeof c == "number" ? c : null;
        r("update:value", p), a?.updateValue(e.index, p);
      }
    }), u = W(() => a ? `${Ge(a.name)}_input_${e.index}` : s.name), f = W(() => a ? Ge(a.value)?.[e.index] : s.value), m = (c) => {
      if (tn(c.key, ln))
        switch (c.key !== ln.Dead && c.preventDefault(), c.key) {
          case ln.ArrowLeft:
            a?.focusPrevious(e.index);
            break;
          case ln.ArrowRight:
            a?.focusNext(e.index);
            break;
          case ln.Backspace:
          case ln.Delete:
            v.value = null;
            break;
          case ln.Dead: {
            const p = c.target;
            p?.blur(), setTimeout(() => p?.focus(), 1);
            break;
          }
          default: {
            const p = parseInt(c.key);
            v.value = p, a?.focusNext(e.index);
          }
        }
    };
    return t({
      disabled: l,
      index: e.index,
      inputRef: i
    }), (c, p) => ($(), ke(j(tr), Ae({ ref: "input" }, { ...c.$attrs, ...s, ...o.value, disabled: l.value, mask: h.value, name: u.value }, {
      autocomplete: "off",
      class: "lc-digit-input",
      inputmode: "numeric",
      pattern: "[0-9]*",
      tabindex: l.value ? -1 : 0,
      value: v.value,
      onKeydown: m
    }), null, 16, ["tabindex", "value"]));
  }
}), Af = ["id"], Lf = ["id"], $f = ["aria-labelledby"], mg = /* @__PURE__ */ Se({
  __name: "LcDigitInputGroup",
  props: {
    disabled: { type: Boolean },
    errorMessage: {},
    feedbackMessageClass: {},
    helpMessage: {},
    id: {},
    legendClass: {},
    name: { default: "digit-input-group" },
    noFeedback: { type: Boolean },
    value: {},
    wrapperClass: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = ge([]), i = $t(e.id), a = (f, m) => {
      const c = [...e.value ?? []];
      c[f] = m, r("update:value", c);
    }, o = () => {
      const f = s.value.findIndex((m) => !m.disabled);
      s.value[f]?.inputRef?.ref?.focus();
    }, l = (f) => {
      if (f < 0 || f >= s.value.length) return;
      const m = s.value[f];
      m.disabled || m.inputRef?.ref?.focus();
    }, h = (f, m) => {
      if (a(f, m), m !== null) {
        v(f);
        return;
      }
      if (f <= 0 || typeof e.value?.[f] == "number") return;
      const p = s.value.slice(0, f).reverse().find(({ disabled: k }) => !k)?.index;
      typeof p == "number" && (l(p), a(p, null));
    }, v = (f, m = !0) => {
      const c = m ? f + 1 : f - 1;
      if (c < 0 || c >= s.value.length) return;
      const p = s.value[c];
      if (p.disabled) {
        v(c, m);
        return;
      }
      p.inputRef?.ref?.focus();
    }, u = (f) => {
      const m = f;
      m?.inputRef?.ref && (s.value[m.index] = m);
    };
    return pt(o), t({ focusFirstEnabledInput: o, focusInputByIndex: l }), ri(qo, {
      config: uo(
        W(() => ({
          errorMessage: e.errorMessage,
          noFeedback: !0
        }))
      ),
      disabled: () => e.disabled,
      focusNext: (f) => v(f),
      focusPrevious: (f) => v(f, !1),
      name: () => e.name,
      updateValue: h,
      value: () => e.value
    }), (f, m) => ($(), Z("fieldset", Ae(f.$attrs, {
      id: j(i),
      class: "lc-digit-input-group"
    }), [
      f.$slots.legend ? ($(), Z("legend", {
        key: 0,
        id: `${j(i)}-label`,
        class: ye(["lc-digit-input-group__label", e.legendClass])
      }, [
        ve(f.$slots, "legend")
      ], 10, Lf)) : de("", !0),
      ne("div", {
        "aria-labelledby": f.$slots.legend ? `${j(i)}-label` : void 0,
        class: ye(["lc-digit-input-group__wrap", e.wrapperClass]),
        role: "group"
      }, [
        ve(f.$slots, "default", Lt(Ot({ setRef: u })))
      ], 10, $f),
      e.noFeedback ? de("", !0) : ($(), ke(j($n), Ae({ key: 1 }, { disabled: e.disabled }, {
        class: e.feedbackMessageClass,
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["class", "content", "variant"]))
    ], 16, Af));
  }
}), If = ["id"], Df = ["aria-expanded"], Mf = /* @__PURE__ */ Se({
  __name: "LcExpandable",
  props: /* @__PURE__ */ Sn({
    animated: { type: Boolean },
    contentClass: {},
    disabled: { type: Boolean },
    headerClass: {},
    id: {},
    modelValue: { type: Boolean }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Sn(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = $t(e.id), n = `${t}-region`, r = Wa(e, "modelValue"), s = W(() => [
      "lc-expandable",
      {
        "lc-expandable--animated": e.animated,
        "lc-expandable--disabled": e.disabled,
        "lc-expandable--expanded": r.value
      }
    ]), i = W(() => ["lc-expandable__content", e.contentClass]), a = () => {
      r.value = !r.value;
    };
    return (o, l) => ($(), Z("article", Ae(o.$attrs, {
      id: j(t),
      class: s.value
    }), [
      ne("button", Ae({ "aria-controls": n }, { disabled: e.disabled }, {
        "aria-expanded": r.value,
        class: ["lc-expandable__header", e.headerClass],
        type: "button",
        onClickPassive: a
      }), [
        ve(o.$slots, "header"),
        e.disabled ? de("", !0) : ($(), ke(j(Ke), {
          key: 0,
          class: "lc-expandable__header-icon",
          name: "chevron-down"
        }))
      ], 16, Df),
      e.animated ? ($(), ke(j(Io), {
        key: 0,
        animated: "",
        class: "lc-expandable__collapse",
        when: r.value,
        onCollapse: l[0] || (l[0] = (h) => o.$emit("collapse")),
        onCollapsed: l[1] || (l[1] = (h) => o.$emit("collapsed")),
        onExpand: l[2] || (l[2] = (h) => o.$emit("expand")),
        onExpanded: l[3] || (l[3] = (h) => o.$emit("expanded"))
      }, {
        default: Te(() => [
          ne("section", {
            id: n,
            class: ye(i.value),
            role: "region"
          }, [
            ve(o.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 8, ["when"])) : Qt(($(), Z("section", {
        key: 1,
        id: n,
        class: ye(i.value),
        role: "region"
      }, [
        ve(o.$slots, "default")
      ], 2)), [
        [li, r.value]
      ])
    ], 16, If));
  }
}), Of = { class: "lc-expandable-list" }, gg = /* @__PURE__ */ Se({
  __name: "LcExpandableList",
  setup(e) {
    return (t, n) => ($(), Z("div", Of, [
      ve(t.$slots, "default")
    ]));
  }
}), Rf = () => {
  const e = ge(!1);
  return pt(() => {
    e.value = !0;
  }), Ln(() => {
    e.value = !1;
  }), e;
}, Ff = {
  key: 0,
  class: "lc-fly-out__illustration"
}, Nf = { class: "lc-fly-out__message" }, bg = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcFlyOut",
  props: {
    buttonAriaLabel: { default: () => je.lcFlyOut.buttonAriaLabel },
    isVisible: { type: Boolean },
    message: {},
    to: { default: () => je.lcFlyOut.to },
    visibleInSeconds: { default: () => je.lcFlyOut.visibleInSeconds }
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const n = t, r = Rf(), s = W(() => e.visibleInSeconds * 1e3), { start: i, stop: a } = ta(
      () => {
        n("update:isVisible", !1);
      },
      s,
      { immediate: !1 }
    );
    return Ln(a), Be(
      () => e.isVisible,
      (o) => {
        o ? i() : a();
      },
      { immediate: !0 }
    ), (o, l) => j(r) ? ($(), ke(ba, {
      key: 0,
      class: "lc-fly-out",
      to: e.to
    }, [
      Fe(j(ca), { name: "slide-down-lg" }, {
        default: Te(() => [
          e.isVisible ? ($(), Z("div", Ae({ key: 0 }, o.$attrs, { class: "lc-fly-out__container" }), [
            Fe(j(Lu), {
              class: "lc-fly-out__timer",
              "duration-in-ms": s.value
            }, {
              default: Te(() => [
                Fe(j(kt), {
                  "aria-label": e.buttonAriaLabel,
                  icon: "close",
                  variant: "tertiary",
                  onClick: l[0] || (l[0] = (h) => o.$emit("update:isVisible", !1))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["duration-in-ms"]),
            o.$slots.default ? ($(), Z("div", Ff, [
              ve(o.$slots, "default")
            ])) : de("", !0),
            ne("p", Nf, Oe(e.message), 1)
          ], 16)) : de("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"])) : de("", !0);
  }
});
const ha = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function ml(e) {
  return Number(e) >= 0;
}
function Pf(e) {
  return typeof e == "object" && e !== null;
}
function Bf(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function gl(e) {
  if (!Pf(e) || Bf(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function jo(e, t) {
  return Object.keys(t).forEach((n) => {
    if (gl(t[n]) && gl(e[n])) {
      e[n] || (e[n] = {}), jo(e[n], t[n]);
      return;
    }
    e[n] = t[n];
  }), e;
}
function zf(e, t = { abortEarly: !1 }) {
  return {
    __type: "VVTypedSchema",
    async parse(r) {
      var s;
      try {
        return {
          value: await e.validate(r, Object.assign({}, t)),
          errors: []
        };
      } catch (i) {
        const a = i;
        if (a.name !== "ValidationError")
          throw i;
        if (!(!((s = a.inner) === null || s === void 0) && s.length) && a.errors.length)
          return { errors: [{ path: a.path, errors: a.errors }] };
        const o = a.inner.reduce((l, h) => {
          const v = h.path || "";
          return l[v] || (l[v] = { errors: [], path: v }), l[v].errors.push(...h.errors), l;
        }, {});
        return { errors: Object.values(o) };
      }
    },
    cast(r) {
      try {
        return e.cast(r);
      } catch {
        const i = e.getDefault();
        return ha(i) && ha(r) ? jo(i, r) : r;
      }
    },
    describe(r) {
      try {
        if (!r)
          return bl(e.spec);
        const s = Vf(r, e);
        return s ? bl(s) : {
          required: !1,
          exists: !1
        };
      } catch {
        return process.env.NODE_ENV !== "production" && console.warn(`Failed to describe path ${r} on the schema, returning a default description.`), {
          required: !1,
          exists: !1
        };
      }
    }
  };
}
function bl(e) {
  return {
    required: !e.optional,
    exists: !0
  };
}
function Vf(e, t) {
  if (!pl(t))
    return null;
  if (ic(e)) {
    const s = t.fields[lc(e)];
    return s?.spec || null;
  }
  const n = (e || "").split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = t;
  for (let s = 0; s < n.length; s++) {
    const i = n[s];
    if (pl(r) && i in r.fields ? r = r.fields[i] : Hf(r) && ml(i) ? r = r.spec.types[Number(i)] : ml(i) && Uf(r) && (r = r.innerType), s === n.length - 1)
      return r.spec;
  }
  return null;
}
function Hf(e) {
  return ha(e) && e.type === "tuple";
}
function pl(e) {
  return ha(e) && e.type === "object";
}
function Uf(e) {
  return ha(e) && e.type === "array";
}
const pg = /* @__PURE__ */ Se({
  __name: "LcForm",
  props: {
    initialValues: {},
    onSubmit: { type: Function },
    resetOnSubmit: { type: Boolean },
    validateOnMount: { type: Boolean },
    validationSchema: {}
  },
  setup(e, { expose: t }) {
    const n = e, {
      isFieldValid: r,
      isSubmitting: s,
      meta: i,
      resetField: a,
      resetForm: o,
      setErrors: l,
      setValues: h,
      validate: v,
      values: u
    } = oc({
      initialValues: n.initialValues,
      validateOnMount: n.validateOnMount,
      validationSchema: n.validationSchema ? zf(n.validationSchema) : void 0
    }), f = async (m) => {
      m.preventDefault();
      try {
        s.value = !0;
        const { valid: c, values: p } = await v();
        c && n.onSubmit && await n.onSubmit(p), c && n.resetOnSubmit && o();
      } finally {
        s.value = !1;
      }
    };
    return t({
      isFieldValid: r,
      isSubmitting: s,
      meta: i,
      resetField: a,
      resetForm: o,
      setErrors: l,
      setValues: h,
      validate: v,
      values: u
    }), (m, c) => ($(), Z("form", {
      class: "lc-form",
      novalidate: "",
      onSubmit: f
    }, [
      ve(m.$slots, "default", Lt(Ot({ isSubmitting: j(s), meta: j(i), values: j(u) })))
    ], 32));
  }
}), yg = [
  "aggressive",
  "blur",
  "eager",
  "lazy",
  "passive"
];
var Zo = /* @__PURE__ */ ((e) => (e.InputEnd = "lottocom_form_input_end", e))(Zo || {});
const Pt = {
  Blur: "onBlur",
  Change: "onChange",
  Update: "onUpdate:value"
}, qf = { class: "lc-form-field" }, wg = /* @__PURE__ */ Se({
  __name: "LcFormField",
  props: {
    mode: { default: "aggressive" },
    name: {}
  },
  setup(e, { expose: t }) {
    const n = {
      aggressive: () => [Pt.Blur, Pt.Update],
      blur: ({ errorMessage: f }) => f.value ? [Pt.Update] : [Pt.Blur],
      eager: ({ errorMessage: f }) => f.value ? [Pt.Update] : [Pt.Change],
      lazy: () => [Pt.Change],
      passive: () => []
    }, {
      errorMessage: r,
      handleBlur: s,
      handleChange: i,
      meta: a,
      value: o
    } = sc(() => e.name, {}, { validateOnValueUpdate: !1 }), l = {
      [Pt.Blur]: (f) => u(f, !0),
      [Pt.Change]: (f) => i(f, !0),
      [Pt.Update]: (f) => i(f, !0)
    }, h = W(() => ({
      errorMessage: r.value,
      name: e.name,
      value: o.value,
      ...v.value
    })), v = W(() => {
      const f = {
        [Pt.Blur]: (m) => u(m, !1),
        [Pt.Update]: (m) => i(m, !1)
      };
      return n[e.mode]({
        errorMessage: r,
        meta: a
      }).forEach((m) => {
        f[m] = l[m];
      }), f;
    }), u = async (f, m) => {
      if (s(f, m), await Ya(), !f) return;
      const c = new CustomEvent(Zo.InputEnd, {
        detail: {
          _value: f
        }
      });
      window.dispatchEvent(c);
    };
    return t({ field: h }), (f, m) => ($(), Z("div", qf, [
      ve(f.$slots, "default", Lt(Ot({ field: h.value })))
    ]));
  }
}), jf = ["id"], Zf = { ref: "wrapper" }, Wf = { class: "lc-header__wrap" }, Yf = { class: "lc-header__left-button-wrap" }, Xf = { class: "lc-header__headline-wrap" }, Gf = {
  key: 0,
  class: "lc-header__fly-out-toggle-wrap"
}, Kf = ["id", "aria-labelledby"], Jf = { class: "lc-header__fly-out-content-container" }, xg = /* @__PURE__ */ Se({
  __name: "LcHeader",
  props: {
    href: {},
    target: {},
    to: {},
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    closeFlyOutOnOutsideClick: { type: Boolean, default: !0 },
    flyOutContentClass: {},
    flyOutToggleAriaLabel: { default: () => je.lcHeader.flyOutToggleAriaLabel },
    flyOutToggleClass: {},
    headlineClass: {},
    id: {},
    leftButtonAriaLabel: { default: () => je.lcHeader.leftButtonAriaLabel },
    leftButtonIcon: { default: "arrow-left" },
    withFlyOut: { type: Boolean }
  },
  emits: ["left-button-click"],
  setup(e) {
    const t = ot("wrapper"), n = $t(e.id), r = ge(!1), s = W(() => [
      "lc-header",
      {
        "lc-header--active": r.value,
        "lc-header--with-fly-out": e.withFlyOut
      }
    ]), i = () => {
      r.value = !r.value;
    };
    return Ga(
      t,
      () => {
        !e.closeFlyOutOnOutsideClick || !r.value || (r.value = !1);
      },
      { ignore: [...Ge(e.ignoreOutsideClickOn)] }
    ), (a, o) => ($(), Z("header", {
      id: j(n),
      class: ye(s.value)
    }, [
      ne("div", Zf, [
        ne("div", Wf, [
          ne("div", Yf, [
            Fe(j(kt), Ae({ href: e.href, target: e.target, to: e.to }, {
              "aria-label": e.leftButtonAriaLabel,
              icon: e.leftButtonIcon,
              size: "small",
              variant: "tertiary",
              onClick: o[0] || (o[0] = (l) => a.$emit("left-button-click"))
            }), null, 16, ["aria-label", "icon"])
          ]),
          ne("div", Xf, [
            ne("h1", {
              class: ye(["lc-header__headline", e.headlineClass])
            }, [
              ve(a.$slots, "headline")
            ], 2)
          ]),
          ve(a.$slots, "right", {}, () => [
            e.withFlyOut ? ($(), Z("div", Gf, [
              Fe(j(kt), {
                id: `${j(n)}-toggle`,
                "aria-controls": `${j(n)}-region`,
                "aria-expanded": r.value,
                "aria-label": e.flyOutToggleAriaLabel,
                class: ye(["lc-header__fly-out-toggle", e.flyOutToggleClass]),
                icon: "chevron-down",
                "icon-position": "right",
                "no-padding": "",
                size: "small",
                variant: "tertiary",
                onClickPassive: i
              }, {
                default: Te(() => [
                  ve(a.$slots, "fly-out-toggle")
                ]),
                _: 3
              }, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "class"])
            ])) : de("", !0)
          ])
        ]),
        e.withFlyOut && r.value ? ($(), Z("div", {
          key: 0,
          id: `${j(n)}-region`,
          "aria-labelledby": `${j(n)}-toggle`,
          class: "lc-header__fly-out",
          role: "region"
        }, [
          ne("div", Jf, [
            ne("div", {
              class: ye(["lc-header__fly-out-content", e.flyOutContentClass])
            }, [
              ve(a.$slots, "fly-out-content")
            ], 2)
          ])
        ], 8, Kf)) : de("", !0)
      ], 512),
      ve(a.$slots, "default")
    ], 10, jf));
  }
}), Qf = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyBall",
  props: {
    content: {},
    opacity: { default: 1 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = W(() => ["lc-high-frequency-ball", `lc-high-frequency-ball--size-${e.size}`]);
    return (n, r) => ($(), Z("div", {
      class: ye(t.value),
      style: Ct({
        "--ball-opacity": e.opacity
      })
    }, Oe(e.content), 7));
  }
}), e0 = { class: "lc-high-frequency-ball-background" }, Wo = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyBallBackground",
  props: {
    ballConfig: {},
    gradientClass: {}
  },
  setup(e) {
    return (t, n) => ($(), Z("div", e0, [
      ($(!0), Z(Xe, null, ht(e.ballConfig, (r, s) => ($(), ke(Qf, {
        key: s,
        class: "lc-high-frequency-ball-background__ball",
        content: r.content,
        opacity: r.opacity,
        size: r.size,
        style: Ct({
          "--ball-position-top": r.top,
          "--ball-position-left": r.left
        })
      }, null, 8, ["content", "opacity", "size", "style"]))), 128)),
      ne("div", {
        class: ye(["lc-high-frequency-ball-background__gradient", e.gradientClass])
      }, null, 2)
    ]));
  }
}), t0 = {
  key: 0,
  class: "lc-lottery-jackpot__placeholder"
}, n0 = { class: "lc-lottery-jackpot__value" }, a0 = { class: "lc-lottery-jackpot__currency" }, r0 = {
  key: 0,
  class: "lc-lottery-jackpot__numeral"
}, yl = 10 ** 9, wl = 10 ** 6, i0 = "mil millones", l0 = "mil M", Yo = /* @__PURE__ */ Se({
  __name: "LcLotteryJackpot",
  props: {
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    noShadow: { type: Boolean },
    placeholder: {},
    size: { default: "medium" },
    value: {}
  },
  setup(e) {
    const t = yl * 100, n = wl * 100, r = W(() => {
      let a;
      const o = e.value >= t, l = e.value >= n;
      switch (!0) {
        case o:
          a = Math.floor(e.value / yl) / 100;
          break;
        case l:
          a = Math.floor(e.value / wl) / 100;
          break;
        default:
          a = e.value / 100;
          break;
      }
      const [h, v] = a.toFixed(2).split("."), u = v.replace(/0+$/, ""), f = l || o;
      let m = u;
      !f && u.length >= 1 ? m = v : f && h.length >= 3 ? m = "" : f && u.length > 1 && (m = u.slice(0, 1));
      const c = m.length > 0 ? [h, m].join(".") : h, p = m.length;
      return new Intl.NumberFormat(e.locale, {
        maximumFractionDigits: p,
        minimumFractionDigits: p
      }).format(Number(c));
    }), s = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: a }) => a === "currency")?.value ?? e.currency
    ), i = W(() => {
      if (e.value < n) return null;
      const a = new Intl.NumberFormat(e.locale, {
        compactDisplay: "long",
        maximumFractionDigits: 12,
        minimumFractionDigits: 2,
        notation: "compact"
      }).format(e.value / 100).split(" ").slice(1).join(" ");
      return a === i0 ? l0 : a;
    });
    return (a, o) => ($(), Z("div", {
      class: ye([
        "lc-lottery-jackpot",
        `lc-lottery-jackpot--size-${e.size}`,
        { "lc-lottery-jackpot--no-shadow": e.noShadow }
      ])
    }, [
      e.placeholder ? ($(), Z("span", t0, Oe(e.placeholder), 1)) : ($(), Z(Xe, { key: 1 }, [
        ne("span", n0, [
          ne("span", a0, Oe(s.value), 1),
          ne("span", null, Oe(r.value), 1)
        ]),
        i.value ? ($(), Z("span", r0, Oe(i.value), 1)) : de("", !0)
      ], 64))
    ], 2));
  }
}), kg = ["large", "medium", "small"], Xo = () => typeof window < "u", o0 = { class: "lc-info-button__modal" }, s0 = { class: "lc-info-button__modal-header" }, c0 = { class: "lc-info-button__modal-headline" }, u0 = { class: "lc-info-button__modal-text" }, Go = /* @__PURE__ */ Se({
  __name: "LcInfoButton",
  props: {
    to: {},
    closeButtonAriaLabel: { default: () => je.lcInfoButton.closeButtonAriaLabel },
    disabled: { type: Boolean, default: !1 },
    headline: {},
    openButtonAriaLabel: { default: () => je.lcInfoButton.openButtonAriaLabel },
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = Xo(), n = ge(!1), r = () => {
      n.value = !1;
    }, s = () => {
      e.disabled || (n.value = !0);
    };
    return (i, a) => ($(), Z("div", {
      class: ye(["lc-info-button", `lc-info-button--variant-${e.variant}`])
    }, [
      Fe(j(kt), Ae({ disabled: e.disabled }, {
        "aria-label": e.openButtonAriaLabel,
        class: "lc-info-button__button-open",
        icon: "info",
        size: "small",
        variant: "tertiary",
        onClickPassive: s
      }), null, 16, ["aria-label"]),
      j(t) && n.value ? ($(), ke(j(Mo), Ae({ key: 0 }, { to: e.to, isVisible: n.value }, {
        "close-triggers": ["escape", "click-outside"],
        spacing: "small",
        onClosePassive: r
      }), {
        default: Te(() => [
          ne("div", o0, [
            ne("header", s0, [
              ne("span", c0, Oe(e.headline), 1),
              Fe(j(kt), {
                "aria-label": e.closeButtonAriaLabel,
                icon: "close",
                size: "small",
                variant: "tertiary",
                onClick: r
              }, null, 8, ["aria-label"])
            ]),
            ve(i.$slots, "default", {}, () => [
              ne("p", u0, Oe(e.text), 1)
            ])
          ])
        ]),
        _: 3
      }, 16)) : de("", !0)
    ], 2));
  }
}), Sg = ["default", "prominent"], d0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='11.9999'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M19.4149%2015.1688C18.8733%2019.0325%2016.1778%2021.4239%2011.7967%2021.4239C7.80659%2021.4239%204.34435%2017.7274%205.29956%2014.3591C6.14178%2011.3891%208.79864%2011.1375%209.58553%207.65315C11.2998%209.28806%2010.8823%2010.6768%2010.5907%2012.0319C10.34%2013.1974%2010.7651%2014.5391%2011.7967%2014.5391C13.0342%2014.5391%2013.5051%2013.1541%2013.0342%2011.7364C12.2699%209.43549%2010.4881%206.2479%2012.2267%203.90869C13.3913%206.00993%2014.7039%206.89025%2016.4607%208.40282C18.7036%2010.3339%2019.7843%2012.5328%2019.4149%2015.1688Z'%20fill='%23000860'/%3e%3cpath%20d='M7.99905%203.70487C9.59553%207.89517%205.86485%209.98417%205.86485%209.98417C5.07622%206.82574%206.57056%206.64536%207.99905%203.70487Z'%20fill='%23000860'/%3e%3c/svg%3e", f0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='56'%20height='55'%20fill='none'%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='%2300C572'%20d='M24.064%204.19A1%201%200%200%201%2025.427%204L27.1%205.192a1%201%200%200%200%201.185-.016l1.638-1.24a1%201%200%200%201%201.368.153l1.323%201.572a1%201%200%200%200%201.151.279l1.895-.794a1%201%200%200%201%201.288.49l.89%201.85a1%201%200%200%200%201.046.557l2.033-.297a1%201%200%200%201%201.125.794l.402%202.014a1%201%200%200%200%20.875.799l2.042.218a1%201%200%200%201%20.893%201.048l-.112%202.052a1%201%200%200%200%20.649.99l1.924.72a1%201%200%200%201%20.604%201.237l-.618%201.96a1%201%200%200%200%20.381%201.12l1.685%201.176a1%201%200%200%201%20.277%201.349l-1.086%201.744a1%201%200%200%200%20.091%201.18l1.34%201.558a1%201%200%200%201-.067%201.375l-1.485%201.419a1%201%200%200%200-.206%201.166l.91%201.842a1%201%200%200%201-.407%201.315l-1.791%201.005a1%201%200%200%200-.49%201.079l.424%202.01a1%201%200%200%201-.721%201.173l-1.986.528a1%201%200%200%200-.742.923l-.089%202.052a1%201%200%200%201-.99.957l-2.055.017a1%201%200%200%200-.948.71l-.597%201.965a1%201%200%200%201-1.197.68l-1.994-.493a1%201%200%200%200-1.095.45l-1.067%201.756a1%201%200%200%201-1.33.361l-1.808-.974a1%201%200%200%200-1.172.165l-1.47%201.435a1%201%200%200%201-1.377.02l-1.51-1.394a1%201%200%200%200-1.177-.132l-1.78%201.024a1%201%200%200%201-1.339-.324l-1.115-1.725a1%201%200%200%200-1.108-.42l-1.98.55a1%201%200%200%201-1.215-.647l-.651-1.949a1%201%200%200%200-.968-.682l-2.054.04a1%201%200%200%201-1.017-.929l-.146-2.05a1%201%200%200%200-.768-.901l-2-.472a1%201%200%200%201-.753-1.153l.367-2.02a1%201%200%200%200-.519-1.065l-1.819-.955a1%201%200%200%201-.444-1.303l.86-1.866a1%201%200%200%200-.239-1.16L4.738%2029.73a1%201%200%200%201-.105-1.373l1.296-1.593a1%201%200%200%200%20.058-1.183l-1.135-1.713a1%201%200%200%201%20.24-1.356l1.651-1.222a1%201%200%200%200%20.35-1.131l-.672-1.942a1%201%200%200%201%20.569-1.254l1.903-.772a1%201%200%200%200%20.62-1.009l-.168-2.047a1%201%200%200%201%20.863-1.073l2.036-.275a1%201%200%200%200%20.852-.823l.345-2.025a1%201%200%200%201%201.103-.825l2.04.24a1%201%200%200%200%201.03-.585l.838-1.875a1%201%200%200%201%201.274-.525l1.916.74a1%201%200%200%200%201.143-.31z'/%3e%3cpath%20fill='%23fff'%20d='M12.886%2035.433a.42.42%200%200%201-.32-.075.41.41%200%200%201-.16-.286l-1.538-10.943a.41.41%200%200%201%20.075-.32.41.41%200%200%201%20.286-.16l1.532-.215q.254-.036.387.066.135.101.178.163l5.481%206.389-.97-6.902a.41.41%200%200%201%20.075-.32.4.4%200%200%201%20.27-.158l1.717-.242a.41.41%200%200%201%20.32.076q.135.101.16.286l1.538%2010.943a.45.45%200%200%201-.075.32.41.41%200%200%201-.287.16l-1.549.217q-.252.036-.386-.065-.12-.12-.178-.164l-5.434-6.172.94%206.683a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.176-1.57a.42.42%200%200%201-.32-.076.41.41%200%200%201-.16-.286l-1.538-10.943a.42.42%200%200%201%20.076-.32.41.41%200%200%201%20.286-.16l7.626-1.072a.41.41%200%200%201%20.32.076q.135.101.16.286l.19%201.347a.4.4%200%200%201-.078.303.42.42%200%200%201-.287.16l-5.454.767.372%202.643%205.084-.715a.42.42%200%200%201%20.32.075q.133.102.16.287l.175%201.246a.4.4%200%200%201-.078.302.42.42%200%200%201-.287.16l-5.084.715.384%202.727%205.589-.785a.42.42%200%200%201%20.32.075q.133.102.16.287l.187%201.33a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.278-1.586a.64.64%200%200%201-.459-.09.66.66%200%200%201-.237-.344l-3.436-10.521a.15.15%200%200%201-.026-.065l-.007-.05a.33.33%200%200%201%20.067-.25.32.32%200%200%201%20.236-.154l1.768-.248q.438-.061.538.285l2.263%206.943.742-4.619q.03-.142.128-.31.096-.167.366-.206l1.06-.149q.27-.038.409.097a.8.8%200%200%201%20.192.265l2%204.217.247-7.28q0-.36.456-.424l1.767-.248a.32.32%200%200%201%20.27.082.33.33%200%200%201%20.133.222l.008.05a.15.15%200%200%201-.008.07l-.403%2011.06a.62.62%200%200%201-.15.4q-.13.172-.399.21l-1.364.192q-.27.038-.44-.076a.9.9%200%200%201-.227-.277l-2.535-4.966-1.05%205.47a.8.8%200%200%201-.16.331q-.117.154-.402.194z'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='a'%20width='54.296'%20height='56.295'%20x='.852'%20y='.102'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='2'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20values='0%200%200%200%200%200%200%200%200%200.0313726%200%200%200%200%200.376471%200%200%200%200.06%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11660_18282'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_11660_18282'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", h0 = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12.0001'%20cy='12.9417'%20r='11'%20fill='white'/%3e%3ccircle%20cx='12'%20cy='12.9417'%20r='9.21486'%20transform='rotate(-11.3509%2012%2012.9417)'%20fill='%23000860'/%3e%3cpath%20d='M10.5288%205.61047C9.30234%205.85667%208.15728%206.40664%207.19846%207.21001C6.23963%208.01338%205.49769%209.04448%205.04059%2010.2089L12.0003%2012.941L10.5288%205.61047Z'%20fill='white'/%3e%3c/svg%3e", v0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M11.7802%2013.8032L14.3303%2012.5401L14.5266%2012.7531C16.3077%2014.6859%2017.2575%2017.2414%2017.1712%2019.8683C17.1679%2019.9693%2017.1041%2020.0585%2017.0095%2020.0942L13.4144%2021.4522C13.2796%2021.5031%2013.1355%2021.4035%2013.1355%2021.2594L13.1356%2020.3255C13.1356%2018.0815%2012.6742%2015.8615%2011.7802%2013.8032Z'%20fill='%23000860'/%3e%3cpath%20d='M11.0112%209.27934C11.0323%209.19513%2011.1291%209.15558%2011.2031%209.20086L17.6251%2012.5888C17.715%2012.6438%2017.7043%2012.7778%2017.6066%2012.8177L9.86212%2016.2293C9.76448%2016.2693%209.66293%2016.1812%209.6886%2016.0789L11.0112%209.27934Z'%20fill='%23000860'/%3e%3cpath%20d='M5.25467%200.422462C5.25301%200.280381%205.41499%200.19807%205.52878%200.283175L8.27821%202.33962C8.3234%202.37342%208.38232%202.38282%208.43577%202.36475L11.6885%201.26567C11.8231%201.22018%2011.9515%201.3488%2011.9057%201.48331L10.7995%204.73366C10.7813%204.78707%2010.7906%204.84601%2010.8243%204.89127L12.8748%207.64518C12.9596%207.75915%2012.8769%207.92095%2012.7349%207.91898L9.30178%207.87136C9.24536%207.87057%209.19217%207.8976%209.15954%207.94364L7.17404%2010.7447C7.09187%2010.8607%206.91245%2010.832%206.87042%2010.6963L5.85482%207.41653C5.83813%207.36263%205.79599%207.32039%205.74213%207.30359L2.46457%206.28085C2.32893%206.23852%202.3007%206.05904%202.41681%205.97712L5.22222%203.99773C5.26833%203.9652%205.29547%203.91207%205.29481%203.85565L5.25467%200.422462Z'%20fill='%23000860'/%3e%3c/svg%3e", m0 = {
  key: 0,
  fill: "none",
  height: "32",
  viewBox: "0 0 21 32",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, g0 = ["src"], b0 = {
  key: 2,
  class: "lc-teaser-badge__text"
}, p0 = ["src"], y0 = 8, rn = 10, w0 = 20, x0 = /* @__PURE__ */ Se({
  __name: "LcTeaserBadge",
  props: {
    infoHeadline: {},
    infoText: {},
    title: {},
    variant: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-teaser-badge",
      `lc-teaser-badge--variant-${e.variant}`,
      {
        "lc-teaser-badge--multiple-lines": n.value
      }
    ]), n = W(() => s.value.length > 1), r = W(() => {
      switch (e.variant) {
        case "fire":
          return d0;
        case "pie":
          return h0;
        case "star":
          return v0;
        default:
          return null;
      }
    }), s = W(() => {
      if (!e.title) return [];
      const i = e.title.substring(0, w0);
      if (i.length <= y0) return [i];
      const o = i.split(" ").filter(Boolean);
      if (o.length === 1)
        return [
          i.slice(0, rn),
          i.slice(rn)
        ];
      let l = "";
      const h = [];
      return o.forEach((v) => {
        if (l.length + v.length + (l.length ? 1 : 0) <= rn) {
          l.length > 0 && (l += " "), l += v;
          return;
        }
        if (v.length > rn) {
          if (l.length > 0) {
            let u = 0;
            l.length < rn && (l += " ", u = rn - l.length, l += v.slice(0, u)), h.push(l), h.push(v.slice(u)), l = "";
            return;
          }
          h.push(v.slice(0, rn)), l = v.slice(rn);
          return;
        }
        h.push(l), l = v;
      }), l.length > 0 && h.push(l), h.length > 2 ? [h[0], h.slice(1).join(" ")] : h;
    });
    return (i, a) => ($(), Z("div", {
      class: ye(t.value)
    }, [
      e.variant === "price-tag" ? ($(), Z("svg", m0, [...a[0] || (a[0] = [
        ne("path", {
          d: "M20.4593 2C20.4593 0.895431 19.5638 0 18.4593 0H16.9403C16.602 0 16.2693 0.0858105 15.9732 0.249404L1.49209 8.24989C0.854856 8.60195 0.459259 9.27247 0.459259 10.0005V21.9995C0.459259 22.7275 0.854856 23.398 1.49209 23.7501L15.9732 31.7506C16.2693 31.9142 16.602 32 16.9403 32H18.4593C19.5638 32 20.4593 31.1046 20.4593 30V2Z",
          fill: "currentColor"
        }, null, -1)
      ])])) : de("", !0),
      r.value ? ($(), Z("img", {
        key: 1,
        alt: "",
        height: "24",
        src: r.value,
        width: "24"
      }, null, 8, g0)) : de("", !0),
      e.variant !== "new" ? ($(), Z("span", b0, Oe(s.value.join(`
`)), 1)) : ($(), Z("img", {
        key: 3,
        alt: "New",
        height: "48",
        src: j(f0),
        width: "48"
      }, null, 8, p0)),
      e.variant !== "new" && e.variant !== "floating" && e.infoHeadline && e.infoText ? ($(), ke(j(Go), {
        key: 4,
        headline: e.infoHeadline,
        "open-button-aria-label": `${j(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : de("", !0)
    ], 2));
  }
}), _g = ["fire", "lightning", "money", "star"], Cg = [
  "fire",
  "floating",
  "new",
  "pie",
  "price-tag",
  "star",
  "text"
], Eg = ["bottom-m", "bottom-xl", "top-m", "top-xl"], Ko = ["badge", "default", "hero"];
var Jo = /* @__PURE__ */ ((e) => (e.Blue = "#a8e2ff", e.Green = "#84f9c1", e.YellowBright = "#ffec8d", e.YellowDark = "#f2c219", e))(Jo || {});
const k0 = { class: "lc-teaser-hero-badge__text-wrap" }, S0 = /* @__PURE__ */ Se({
  __name: "LcTeaserHeroBadge",
  props: {
    color: { default: () => Jo.YellowBright },
    infoHeadline: {},
    infoText: {},
    subtitle: {},
    title: {},
    variant: {}
  },
  setup(e) {
    return (t, n) => ($(), Z("div", {
      class: ye(["lc-teaser-hero-badge", `lc-teaser-hero-badge--variant-${e.variant}`]),
      style: Ct({
        "--teaser-badge-color": e.color
      })
    }, [
      ne("div", k0, [
        ne("span", null, Oe(e.title), 1),
        ne("span", null, Oe(e.subtitle), 1)
      ]),
      e.infoHeadline && e.infoText ? ($(), ke(j(Go), {
        key: 0,
        headline: e.infoHeadline,
        "open-button-aria-label": `${j(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : de("", !0)
    ], 6));
  }
}), _0 = (e) => !!e.title && !!e.subtitle, C0 = { class: "lc-teaser__background" }, nr = /* @__PURE__ */ Se({
  __name: "LcTeaser",
  props: {
    bodyClass: {},
    footerClass: {},
    headerClass: {},
    headerTo: {},
    onHeaderClick: { type: Function },
    backgroundPattern: {},
    badge: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = An(), n = W(() => [
      ["lc-teaser", `lc-teaser--variant-${e.variant}`],
      {
        [`lc-teaser--background-pattern-${String(e.backgroundPattern)}`]: e.variant === "hero" && !!e.backgroundPattern,
        [`lc-teaser--variant-badge-${String(e.badge?.variant)}`]: !!e.badge,
        "lc-teaser--has-background": !!t.background
      }
    ]);
    return (r, s) => ($(), ke(j(ya), Ae({ headerTo: e.headerTo }, {
      "body-class": ["lc-teaser__body", e.bodyClass],
      class: n.value,
      "footer-class": ["lc-teaser__footer", e.footerClass],
      "header-class": ["lc-teaser__header", e.headerClass],
      radius: "large",
      onHeaderClick: e.onHeaderClick
    }), Xa({
      default: Te(() => [
        ve(r.$slots, "default"),
        e.badge ? ($(), Z(Xe, { key: 0 }, [
          j(_0)(e.badge) ? ($(), ke(S0, Lt(Ae({ key: 0 }, e.badge)), null, 16)) : ($(), ke(x0, Lt(Ae({ key: 1 }, e.badge)), null, 16))
        ], 64)) : de("", !0)
      ]),
      _: 2
    }, [
      r.$slots.background ? {
        name: "background",
        fn: Te(() => [
          ne("div", C0, [
            ve(r.$slots, "background")
          ])
        ]),
        key: "0"
      } : void 0,
      r.$slots.header ? {
        name: "header",
        fn: Te(() => [
          ve(r.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      r.$slots.footer ? {
        name: "footer",
        fn: Te(() => [
          ve(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["body-class", "class", "footer-class", "header-class", "onHeaderClick"]));
  }
}), E0 = { class: "lc-high-frequency-teaser__background" }, T0 = { class: "lc-high-frequency-teaser__jackpot-section" }, A0 = {
  key: 0,
  class: "lc-high-frequency-teaser__jackpot-headline"
}, L0 = { class: "lc-high-frequency-teaser__button-container" }, $0 = { class: "lc-high-frequency-teaser__button-wrap" }, I0 = { class: "lc-high-frequency-teaser__hint-container" }, D0 = {
  key: 0,
  class: "lc-high-frequency-teaser__hint-text"
}, Tg = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyTeaser",
  props: {
    backgroundPattern: {},
    badge: {},
    headline: {},
    jackpot: {},
    locale: {},
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" },
    ballConfig: {},
    hint: {}
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    An();
    const t = W(() => [
      "lc-high-frequency-teaser",
      `lc-high-frequency-teaser--variant-${e.variant}`
    ]), n = W(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (r, s) => ($(), ke(j(nr), Ae({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-high-frequency-teaser__body",
      class: t.value,
      "footer-class": "lc-high-frequency-teaser__footer",
      "header-to": e.primaryButtonProps.to,
      onHeaderClick: e.onTeaserClick
    }), {
      background: Te(() => [
        ne("div", E0, [
          Fe(j(Wo), Lt(Ot({ ballConfig: e.ballConfig })), null, 16)
        ])
      ]),
      header: Te(() => [
        ve(r.$slots, "lottery-logo")
      ]),
      default: Te(() => [
        ne("section", T0, [
          ($(), ke(zt(n.value), {
            class: "lc-high-frequency-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Te(() => [
              e.headline ? ($(), Z("strong", A0, Oe(e.headline), 1)) : de("", !0),
              Fe(j(Yo), Ae(e.jackpot, {
                "no-shadow": "",
                size: "small"
              }), null, 16)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ne("section", L0, [
          ne("div", $0, [
            ve(r.$slots, "primary-button", {}, () => [
              Fe(j(kt), Ae(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-high-frequency-teaser__button",
                "no-padding": "",
                onClick: s[0] || (s[0] = (i) => r.$emit("primary-button-click"))
              }), {
                default: Te(() => [
                  xt(Oe(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])
            ])
          ])
        ]),
        ne("section", I0, [
          e.hint ? ($(), Z("p", D0, [
            ve(r.$slots, "hint", {}, () => [
              xt(Oe(e.hint), 1)
            ])
          ])) : de("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class", "header-to", "onHeaderClick"]));
  }
}), M0 = {
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, O0 = ["stroke"], R0 = ["stroke"], xl = "lc-high-frequency-teaser-watch-arrows-gradient-1", kl = "lc-high-frequency-teaser-watch-arrows-gradient-2", F0 = /* @__PURE__ */ Se({
  __name: "ArrowsIcon",
  setup(e) {
    return (t, n) => ($(), Z("svg", M0, [
      ne("path", {
        d: "M6.29812 18.431C7.41552 14.3207 9.97378 10.7492 13.5059 8.36858C17.0381 5.98793 21.3086 4.95686 25.5378 5.46358C29.7671 5.9703 33.6731 7.98101 36.5429 11.1287C39.4127 14.2764 41.0549 18.3511 41.1696 22.6091",
        stroke: `url(#${xl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, O0),
      n[2] || (n[2] = ne("path", {
        d: "M38.1073 20.6755L41.1265 22.9697C41.2144 23.0366 41.3399 23.0195 41.4067 22.9315L43.7009 19.9123",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ne("path", {
        d: "M40.5545 28.3175C39.3918 32.4153 36.7942 35.9583 33.236 38.2998C29.6778 40.6413 25.3962 41.6251 21.1727 41.0717C16.9493 40.5183 13.0657 38.4646 10.2309 35.2854C7.39604 32.1062 5.79899 28.0136 5.73126 23.7546",
        stroke: `url(#${kl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, R0),
      n[3] || (n[3] = ne("path", {
        d: "M8.73274 25.8842L5.71355 23.5899C5.6256 23.5231 5.50013 23.5402 5.4333 23.6282L3.1391 26.6474",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ne("defs", null, [
        ne("linearGradient", {
          id: xl,
          x1: "35.7167",
          y1: "6.28729",
          x2: "7.80661",
          y2: "13.8312",
          gradientUnits: "userSpaceOnUse"
        }, [...n[0] || (n[0] = [
          ne("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])]),
        ne("linearGradient", {
          id: kl,
          x1: "11.0036",
          y1: "40.1356",
          x2: "38.9953",
          y2: "32.9005",
          gradientUnits: "userSpaceOnUse"
        }, [...n[1] || (n[1] = [
          ne("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), N0 = {}, P0 = {
  viewBox: "0 0 45 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function B0(e, t) {
  return $(), Z("svg", P0, [...t[0] || (t[0] = [
    zs('<path class="star star-1" fill-rule="evenodd" clip-rule="evenodd" d="M5.25845 10.7151C4.91385 10.5772 4.91385 10.0894 5.25845 9.95156C6.48681 9.46014 7.46014 8.48681 7.95157 7.25845C8.08943 6.91385 8.57723 6.91385 8.7151 7.25845C9.20653 8.48681 10.1799 9.46014 11.4082 9.95156C11.7528 10.0894 11.7528 10.5772 11.4082 10.7151C10.1799 11.2065 9.20653 12.1798 8.7151 13.4082C8.57723 13.7528 8.08943 13.7528 7.95157 13.4082C7.46014 12.1798 6.48681 11.2065 5.25845 10.7151Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-2" fill-rule="evenodd" clip-rule="evenodd" d="M0.155071 19.2291C-0.0516903 19.1463 -0.0516903 18.8537 0.155071 18.7709C0.892087 18.4761 1.47608 17.8921 1.77094 17.1551C1.85366 16.9483 2.14634 16.9483 2.22906 17.1551C2.52392 17.8921 3.10791 18.4761 3.84493 18.7709C4.05169 18.8537 4.05169 19.1463 3.84493 19.2291C3.10791 19.5239 2.52392 20.1079 2.22906 20.8449C2.14634 21.0517 1.85366 21.0517 1.77094 20.8449C1.47608 20.1079 0.892087 19.5239 0.155071 19.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-3" fill-rule="evenodd" clip-rule="evenodd" d="M41.1551 18.2291C40.9483 18.1463 40.9483 17.8537 41.1551 17.7709C41.8921 17.4761 42.4761 16.8921 42.7709 16.1551C42.8537 15.9483 43.1463 15.9483 43.2291 16.1551C43.5239 16.8921 44.1079 17.4761 44.8449 17.7709C45.0517 17.8537 45.0517 18.1463 44.8449 18.2291C44.1079 18.5239 43.5239 19.1079 43.2291 19.8449C43.1463 20.0517 42.8537 20.0517 42.7709 19.8449C42.4761 19.1079 41.8921 18.5239 41.1551 18.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-4" fill-rule="evenodd" clip-rule="evenodd" d="M32.2068 21.9721C31.9311 21.8618 31.9311 21.4715 32.2068 21.3613C33.1894 20.9681 33.9681 20.1894 34.3613 19.2068C34.4715 18.9311 34.8618 18.9311 34.9721 19.2068C35.3652 20.1894 36.1439 20.9681 37.1266 21.3613C37.4023 21.4715 37.4023 21.8618 37.1266 21.9721C36.1439 22.3652 35.3652 23.1439 34.9721 24.1266C34.8618 24.4022 34.4715 24.4022 34.3613 24.1266C33.9681 23.1439 33.1894 22.3652 32.2068 21.9721Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-5" fill-rule="evenodd" clip-rule="evenodd" d="M31.2068 2.97208C30.9311 2.86179 30.9311 2.47154 31.2068 2.36125C32.1894 1.96811 32.9681 1.18945 33.3613 0.206761C33.4715 -0.0689204 33.8618 -0.0689204 33.9721 0.206761C34.3652 1.18945 35.1439 1.96811 36.1266 2.36125C36.4023 2.47154 36.4023 2.86179 36.1266 2.97208C35.1439 3.36522 34.3652 4.14388 33.9721 5.12657C33.8618 5.40225 33.4715 5.40225 33.3613 5.12657C32.9681 4.14388 32.1894 3.36522 31.2068 2.97208Z" fill="currentColor" data-v-0c679bcf></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2651 4.74748C19.6333 4.10999 20.4491 3.89126 21.0867 4.2592L32.6479 10.935C33.2856 11.3032 33.5044 12.1189 33.1362 12.7566C32.7679 13.3941 31.9522 13.6129 31.3146 13.2449L31.144 13.1459L30.5047 14.2553C29.6757 15.6906 28.226 16.6584 26.5828 16.8751L24.0815 17.2045L25.0464 19.5352C25.6807 21.067 25.5666 22.8078 24.7378 24.2436L24.101 25.3464L24.2469 25.4311C24.8843 25.7994 25.102 26.6151 24.7339 27.2527C24.3657 27.89 23.5511 28.1087 22.9135 27.741L11.351 21.0652C10.7137 20.6969 10.496 19.8811 10.8641 19.2436C11.2324 18.6065 12.0469 18.3886 12.6844 18.7566L12.8354 18.8438L13.4734 17.7397C14.3024 16.3041 15.7518 15.3352 17.3953 15.1186L19.8966 14.7878L18.9318 12.4571C18.2977 10.9256 18.4117 9.18694 19.2404 7.75138L19.8797 6.64201L19.7534 6.56909C19.1157 6.20089 18.8969 5.38518 19.2651 4.74748ZM17.7443 17.7618C16.9225 17.87 16.1965 18.3552 15.782 19.073L15.1492 20.1694L21.7951 24.0066L22.4292 22.9102C22.8434 22.1925 22.901 21.3218 22.5841 20.5561L21.2365 17.3009L17.7443 17.7618ZM21.549 9.08472C21.135 9.80227 21.0773 10.6721 21.394 11.4376L22.7417 14.6928L26.2339 14.2319C27.0556 14.1236 27.7816 13.6396 28.1961 12.922L28.8289 11.8243L22.1831 7.98706L21.549 9.08472Z" fill="currentColor" data-v-0c679bcf></path>', 6)
  ])]);
}
const z0 = /* @__PURE__ */ di(N0, [["render", B0], ["__scopeId", "data-v-0c679bcf"]]), V0 = {
  width: "48",
  height: "54",
  viewBox: "16 6 48 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, H0 = ["fill"], Sl = "lc-high-frequency-teaser-watch-play-button-gradient", U0 = /* @__PURE__ */ Se({
  __name: "PlayButtonIcon",
  setup(e) {
    return (t, n) => ($(), Z("svg", V0, [
      n[1] || (n[1] = ne("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        transform: "translate(2.4, 2.4)",
        fill: "var(--play-button-icon-shadow-color, #D3A700)"
      }, null, -1)),
      ne("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        fill: `url(#${Sl})`
      }, null, 8, H0),
      ne("defs", null, [
        ne("radialGradient", {
          id: Sl,
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(30.339 18.8727) rotate(103.105) scale(31.1141 42.8816)"
        }, [...n[0] || (n[0] = [
          ne("stop", { "stop-color": "var(--play-button-icon-color-start, #FFF5C9)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--play-button-icon-color-end, #FBCD0C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), ea = {
  SPIN_DELAY: 50,
  PAUSE_DELAY: 2550,
  LABEL_DELAY: 3350,
  IDLE_DELAY: 13350,
  IDLE_SPIN_INTERVAL: 1e4
}, q0 = { class: "lc-high-frequency-teaser-watch__background-wrapper" }, j0 = { class: "lc-high-frequency-teaser-watch__header-wrapper" }, Z0 = { class: "lc-high-frequency-teaser-watch__game-badge" }, W0 = { class: "lc-high-frequency-teaser-watch__game-label" }, Y0 = { class: "lc-high-frequency-teaser-watch__game-number" }, X0 = { class: "lc-high-frequency-teaser-watch__game-icon" }, G0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__pause-icon"
}, K0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__icon-area"
}, J0 = { class: "lc-high-frequency-teaser-watch__timer-value" }, Q0 = { class: "lc-high-frequency-teaser-watch__timer-unit" }, eh = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__new-game-label"
}, th = { class: "lc-high-frequency-teaser-watch__main" }, nh = { class: "lc-high-frequency-teaser-watch__title" }, Ag = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyTeaserWatch",
  props: {
    ballConfig: {},
    gameLabel: {},
    gameNumber: {},
    timerValueLabel: {},
    timerUnitLabel: {},
    isOperational: { type: Boolean, default: !0 },
    title: {},
    to: {}
  },
  setup(e) {
    const t = ge("idle"), n = ge(e.gameNumber), r = ge(!1), s = ge(0), i = W(() => e.to ? Yn(e.to) : "div"), a = W(() => String(n.value).split("")), o = W(() => t.value === "spinning"), l = W(() => t.value === "idle" || o.value), h = W(() => ({
      "lc-high-frequency-teaser-watch__timer-icon--spinning": o.value
    })), v = W(() => ({
      "lc-high-frequency-teaser-watch__timer-text--hidden": o.value
    })), u = W(() => ({
      "lc-high-frequency-teaser-watch__arrows--idle-spin": s.value > 0 && t.value === "idle",
      "lc-high-frequency-teaser-watch__arrows--spinning": o.value
    })), f = W(() => ({
      "lc-high-frequency-teaser-watch__play-button--heartbeat": r.value
    })), { pause: m, resume: c } = tc(
      () => {
        t.value === "idle" && e.isOperational && s.value++;
      },
      ea.IDLE_SPIN_INTERVAL,
      { immediate: e.isOperational }
    ), { start: p, stop: k } = ta(
      () => {
        t.value = "spinning";
      },
      ea.SPIN_DELAY,
      { immediate: !1 }
    ), { start: g, stop: b } = ta(
      () => t.value = "paused",
      ea.PAUSE_DELAY,
      { immediate: !1 }
    ), C = ge(e.gameNumber), { start: A, stop: D } = ta(
      () => {
        t.value = "label", n.value = C.value, r.value = !1, requestAnimationFrame(() => {
          r.value = !0;
        });
      },
      ea.LABEL_DELAY,
      { immediate: !1 }
    ), { start: L, stop: T } = ta(
      () => {
        t.value = "idle", r.value = !1, c();
      },
      ea.IDLE_DELAY,
      { immediate: !1 }
    ), P = () => {
      k(), b(), D(), T();
    };
    return Be(
      () => e.isOperational,
      (U) => {
        U ? c() : (P(), m(), t.value = "idle", r.value = !1);
      }
    ), Be(
      () => e.gameNumber,
      (U, K) => {
        if (U === K || !e.isOperational) {
          n.value = U;
          return;
        }
        P(), m(), C.value = U, t.value = "idle", p(), g(), A(), L();
      }
    ), (U, K) => ($(), ke(zt(i.value), Lt(Ot({ to: e.to })), {
      default: Te(() => [
        Fe(j(nr), {
          class: "lc-high-frequency-teaser-watch",
          "body-class": "lc-high-frequency-teaser-watch__body",
          "footer-class": "lc-high-frequency-teaser-watch__footer"
        }, {
          background: Te(() => [
            ne("div", q0, [
              Fe(j(Wo), Ae({
                class: "lc-high-frequency-teaser-watch__background",
                "gradient-class": "lc-high-frequency-teaser-watch__gradient"
              }, { ballConfig: e.ballConfig }), null, 16)
            ])
          ]),
          header: Te(() => [
            ne("div", j0, [
              ne("div", Z0, [
                ne("span", W0, Oe(e.gameLabel), 1),
                ne("span", Y0, [
                  ($(!0), Z(Xe, null, ht(a.value, (B, X) => ($(), Z("span", {
                    key: `pos-${X}`,
                    class: "lc-high-frequency-teaser-watch__digit-slot"
                  }, [
                    Fe(Vs, { name: "lc-high-frequency-teaser-watch-digit" }, {
                      default: Te(() => [
                        ($(), Z("span", {
                          key: B,
                          class: "lc-high-frequency-teaser-watch__digit",
                          style: Ct({ transitionDelay: `${X * 35}ms` })
                        }, Oe(B), 5))
                      ]),
                      _: 2
                    }, 1024)
                  ]))), 128))
                ])
              ]),
              ne("div", X0, [
                Fe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                  default: Te(() => [
                    e.isOperational ? de("", !0) : ($(), Z("div", G0, [
                      Fe(z0)
                    ]))
                  ]),
                  _: 1
                }),
                e.isOperational ? ($(), Z("div", K0, [
                  Fe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                    default: Te(() => [
                      l.value ? ($(), Z("div", {
                        key: 0,
                        class: ye(["lc-high-frequency-teaser-watch__timer-icon", h.value])
                      }, [
                        ne("span", {
                          class: ye(["lc-high-frequency-teaser-watch__timer-text", v.value])
                        }, [
                          ne("span", J0, Oe(e.timerValueLabel), 1),
                          ne("span", Q0, Oe(e.timerUnitLabel), 1)
                        ], 2),
                        ($(), Z("div", {
                          key: `arrows-${s.value}`,
                          class: ye(["lc-high-frequency-teaser-watch__arrows", u.value])
                        }, [
                          Fe(F0)
                        ], 2))
                      ], 2)) : de("", !0)
                    ]),
                    _: 1
                  }),
                  Fe(wn, { name: "lc-high-frequency-teaser-watch-label" }, {
                    default: Te(() => [
                      t.value === "label" ? ($(), Z("div", eh, [
                        ve(U.$slots, "new-game-label")
                      ])) : de("", !0)
                    ]),
                    _: 3
                  })
                ])) : de("", !0)
              ])
            ])
          ]),
          footer: Te(() => [
            ve(U.$slots, "message")
          ]),
          default: Te(() => [
            ne("div", th, [
              ne("div", {
                class: ye(["lc-high-frequency-teaser-watch__play-button", f.value])
              }, [
                Fe(U0)
              ], 2),
              ne("span", nh, Oe(e.title), 1)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
});
var Pn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ah = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ia = 0; Ia < Pn.length; Ia++)
  ah[Pn.charCodeAt(Ia)] = Ia;
var rh = function(e) {
  var t = new Uint8Array(e), n, r = t.length, s = "";
  for (n = 0; n < r; n += 3)
    s += Pn[t[n] >> 2], s += Pn[(t[n] & 3) << 4 | t[n + 1] >> 4], s += Pn[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], s += Pn[t[n + 2] & 63];
  return r % 3 === 2 ? s = s.substring(0, s.length - 1) + "=" : r % 3 === 1 && (s = s.substring(0, s.length - 2) + "=="), s;
}, ih = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], aa = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], s = ih.indexOf(r);
    t = t * 83 + s;
  }
  return t;
}, kr = (e) => {
  let t = e / 255;
  return t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}, Sr = (e) => {
  let t = Math.max(0, Math.min(1, e));
  return t <= 31308e-7 ? Math.trunc(t * 12.92 * 255 + 0.5) : Math.trunc((1.055 * Math.pow(t, 0.4166666666666667) - 0.055) * 255 + 0.5);
}, lh = (e) => e < 0 ? -1 : 1, _r = (e, t) => lh(e) * Math.pow(Math.abs(e), t), _l = class extends Error {
  constructor(t) {
    super(t), this.name = "ValidationError", this.message = t;
  }
}, oh = (e) => {
  if (!e || e.length < 6) throw new _l("The blurhash string must be at least 6 characters");
  let t = aa(e[0]), n = Math.floor(t / 9) + 1, r = t % 9 + 1;
  if (e.length !== 4 + 2 * r * n) throw new _l(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * r * n}`);
}, sh = (e) => {
  let t = e >> 16, n = e >> 8 & 255, r = e & 255;
  return [kr(t), kr(n), kr(r)];
}, ch = (e, t) => {
  let n = Math.floor(e / 361), r = Math.floor(e / 19) % 19, s = e % 19;
  return [_r((n - 9) / 9, 2) * t, _r((r - 9) / 9, 2) * t, _r((s - 9) / 9, 2) * t];
}, uh = (e, t, n, r) => {
  oh(e), r = r | 1;
  let s = aa(e[0]), i = Math.floor(s / 9) + 1, a = s % 9 + 1, o = (aa(e[1]) + 1) / 166, l = new Array(a * i);
  for (let u = 0; u < l.length; u++) if (u === 0) {
    let f = aa(e.substring(2, 6));
    l[u] = sh(f);
  } else {
    let f = aa(e.substring(4 + u * 2, 6 + u * 2));
    l[u] = ch(f, o * r);
  }
  let h = t * 4, v = new Uint8ClampedArray(h * n);
  for (let u = 0; u < n; u++) for (let f = 0; f < t; f++) {
    let m = 0, c = 0, p = 0;
    for (let C = 0; C < i; C++) for (let A = 0; A < a; A++) {
      let D = Math.cos(Math.PI * f * A / t) * Math.cos(Math.PI * u * C / n), L = l[A + C * a];
      m += L[0] * D, c += L[1] * D, p += L[2] * D;
    }
    let k = Sr(m), g = Sr(c), b = Sr(p);
    v[4 * f + 0 + u * h] = k, v[4 * f + 1 + u * h] = g, v[4 * f + 2 + u * h] = b, v[4 * f + 3 + u * h] = 255;
  }
  return v;
}, dh = uh;
function fh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function hh(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Cr = { exports: {} }, Er = {}, Cl;
function un() {
  return Cl || (Cl = 1, (function(e) {
    var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function n(i, a) {
      return Object.prototype.hasOwnProperty.call(i, a);
    }
    e.assign = function(i) {
      for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
        var o = a.shift();
        if (o) {
          if (typeof o != "object")
            throw new TypeError(o + "must be non-object");
          for (var l in o)
            n(o, l) && (i[l] = o[l]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, a) {
      return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
    };
    var r = {
      arraySet: function(i, a, o, l, h) {
        if (a.subarray && i.subarray) {
          i.set(a.subarray(o, o + l), h);
          return;
        }
        for (var v = 0; v < l; v++)
          i[h + v] = a[o + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var a, o, l, h, v, u;
        for (l = 0, a = 0, o = i.length; a < o; a++)
          l += i[a].length;
        for (u = new Uint8Array(l), h = 0, a = 0, o = i.length; a < o; a++)
          v = i[a], u.set(v, h), h += v.length;
        return u;
      }
    }, s = {
      arraySet: function(i, a, o, l, h) {
        for (var v = 0; v < l; v++)
          i[h + v] = a[o + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, s));
    }, e.setTyped(t);
  })(Er)), Er;
}
var Rn = {}, Ht = {}, mn = {}, El;
function vh() {
  if (El) return mn;
  El = 1;
  var e = un(), t = 4, n = 0, r = 1, s = 2;
  function i(w) {
    for (var G = w.length; --G >= 0; )
      w[G] = 0;
  }
  var a = 0, o = 1, l = 2, h = 3, v = 258, u = 29, f = 256, m = f + 1 + u, c = 30, p = 19, k = 2 * m + 1, g = 15, b = 16, C = 7, A = 256, D = 16, L = 17, T = 18, P = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), U = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), K = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), B = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], X = 512, H = new Array((m + 2) * 2);
  i(H);
  var _ = new Array(c * 2);
  i(_);
  var E = new Array(X);
  i(E);
  var R = new Array(v - h + 1);
  i(R);
  var V = new Array(u);
  i(V);
  var q = new Array(c);
  i(q);
  function O(w, G, M, ie, I) {
    this.static_tree = w, this.extra_bits = G, this.extra_base = M, this.elems = ie, this.max_length = I, this.has_stree = w && w.length;
  }
  var Q, ae, le;
  function me(w, G) {
    this.dyn_tree = w, this.max_code = 0, this.stat_desc = G;
  }
  function $e(w) {
    return w < 256 ? E[w] : E[256 + (w >>> 7)];
  }
  function xe(w, G) {
    w.pending_buf[w.pending++] = G & 255, w.pending_buf[w.pending++] = G >>> 8 & 255;
  }
  function fe(w, G, M) {
    w.bi_valid > b - M ? (w.bi_buf |= G << w.bi_valid & 65535, xe(w, w.bi_buf), w.bi_buf = G >> b - w.bi_valid, w.bi_valid += M - b) : (w.bi_buf |= G << w.bi_valid & 65535, w.bi_valid += M);
  }
  function be(w, G, M) {
    fe(
      w,
      M[G * 2],
      M[G * 2 + 1]
      /*.Len*/
    );
  }
  function _e(w, G) {
    var M = 0;
    do
      M |= w & 1, w >>>= 1, M <<= 1;
    while (--G > 0);
    return M >>> 1;
  }
  function Me(w) {
    w.bi_valid === 16 ? (xe(w, w.bi_buf), w.bi_buf = 0, w.bi_valid = 0) : w.bi_valid >= 8 && (w.pending_buf[w.pending++] = w.bi_buf & 255, w.bi_buf >>= 8, w.bi_valid -= 8);
  }
  function qe(w, G) {
    var M = G.dyn_tree, ie = G.max_code, I = G.stat_desc.static_tree, J = G.stat_desc.has_stree, y = G.stat_desc.extra_bits, ue = G.stat_desc.extra_base, Ee = G.stat_desc.max_length, d, re, te, x, N, ee, Ie = 0;
    for (x = 0; x <= g; x++)
      w.bl_count[x] = 0;
    for (M[w.heap[w.heap_max] * 2 + 1] = 0, d = w.heap_max + 1; d < k; d++)
      re = w.heap[d], x = M[M[re * 2 + 1] * 2 + 1] + 1, x > Ee && (x = Ee, Ie++), M[re * 2 + 1] = x, !(re > ie) && (w.bl_count[x]++, N = 0, re >= ue && (N = y[re - ue]), ee = M[re * 2], w.opt_len += ee * (x + N), J && (w.static_len += ee * (I[re * 2 + 1] + N)));
    if (Ie !== 0) {
      do {
        for (x = Ee - 1; w.bl_count[x] === 0; )
          x--;
        w.bl_count[x]--, w.bl_count[x + 1] += 2, w.bl_count[Ee]--, Ie -= 2;
      } while (Ie > 0);
      for (x = Ee; x !== 0; x--)
        for (re = w.bl_count[x]; re !== 0; )
          te = w.heap[--d], !(te > ie) && (M[te * 2 + 1] !== x && (w.opt_len += (x - M[te * 2 + 1]) * M[te * 2], M[te * 2 + 1] = x), re--);
    }
  }
  function ce(w, G, M) {
    var ie = new Array(g + 1), I = 0, J, y;
    for (J = 1; J <= g; J++)
      ie[J] = I = I + M[J - 1] << 1;
    for (y = 0; y <= G; y++) {
      var ue = w[y * 2 + 1];
      ue !== 0 && (w[y * 2] = _e(ie[ue]++, ue));
    }
  }
  function se() {
    var w, G, M, ie, I, J = new Array(g + 1);
    for (M = 0, ie = 0; ie < u - 1; ie++)
      for (V[ie] = M, w = 0; w < 1 << P[ie]; w++)
        R[M++] = ie;
    for (R[M - 1] = ie, I = 0, ie = 0; ie < 16; ie++)
      for (q[ie] = I, w = 0; w < 1 << U[ie]; w++)
        E[I++] = ie;
    for (I >>= 7; ie < c; ie++)
      for (q[ie] = I << 7, w = 0; w < 1 << U[ie] - 7; w++)
        E[256 + I++] = ie;
    for (G = 0; G <= g; G++)
      J[G] = 0;
    for (w = 0; w <= 143; )
      H[w * 2 + 1] = 8, w++, J[8]++;
    for (; w <= 255; )
      H[w * 2 + 1] = 9, w++, J[9]++;
    for (; w <= 279; )
      H[w * 2 + 1] = 7, w++, J[7]++;
    for (; w <= 287; )
      H[w * 2 + 1] = 8, w++, J[8]++;
    for (ce(H, m + 1, J), w = 0; w < c; w++)
      _[w * 2 + 1] = 5, _[w * 2] = _e(w, 5);
    Q = new O(H, P, f + 1, m, g), ae = new O(_, U, 0, c, g), le = new O(new Array(0), K, 0, p, C);
  }
  function pe(w) {
    var G;
    for (G = 0; G < m; G++)
      w.dyn_ltree[G * 2] = 0;
    for (G = 0; G < c; G++)
      w.dyn_dtree[G * 2] = 0;
    for (G = 0; G < p; G++)
      w.bl_tree[G * 2] = 0;
    w.dyn_ltree[A * 2] = 1, w.opt_len = w.static_len = 0, w.last_lit = w.matches = 0;
  }
  function Pe(w) {
    w.bi_valid > 8 ? xe(w, w.bi_buf) : w.bi_valid > 0 && (w.pending_buf[w.pending++] = w.bi_buf), w.bi_buf = 0, w.bi_valid = 0;
  }
  function He(w, G, M, ie) {
    Pe(w), xe(w, M), xe(w, ~M), e.arraySet(w.pending_buf, w.window, G, M, w.pending), w.pending += M;
  }
  function Ue(w, G, M, ie) {
    var I = G * 2, J = M * 2;
    return w[I] < w[J] || w[I] === w[J] && ie[G] <= ie[M];
  }
  function ze(w, G, M) {
    for (var ie = w.heap[M], I = M << 1; I <= w.heap_len && (I < w.heap_len && Ue(G, w.heap[I + 1], w.heap[I], w.depth) && I++, !Ue(G, ie, w.heap[I], w.depth)); )
      w.heap[M] = w.heap[I], M = I, I <<= 1;
    w.heap[M] = ie;
  }
  function Ne(w, G, M) {
    var ie, I, J = 0, y, ue;
    if (w.last_lit !== 0)
      do
        ie = w.pending_buf[w.d_buf + J * 2] << 8 | w.pending_buf[w.d_buf + J * 2 + 1], I = w.pending_buf[w.l_buf + J], J++, ie === 0 ? be(w, I, G) : (y = R[I], be(w, y + f + 1, G), ue = P[y], ue !== 0 && (I -= V[y], fe(w, I, ue)), ie--, y = $e(ie), be(w, y, M), ue = U[y], ue !== 0 && (ie -= q[y], fe(w, ie, ue)));
      while (J < w.last_lit);
    be(w, A, G);
  }
  function Qe(w, G) {
    var M = G.dyn_tree, ie = G.stat_desc.static_tree, I = G.stat_desc.has_stree, J = G.stat_desc.elems, y, ue, Ee = -1, d;
    for (w.heap_len = 0, w.heap_max = k, y = 0; y < J; y++)
      M[y * 2] !== 0 ? (w.heap[++w.heap_len] = Ee = y, w.depth[y] = 0) : M[y * 2 + 1] = 0;
    for (; w.heap_len < 2; )
      d = w.heap[++w.heap_len] = Ee < 2 ? ++Ee : 0, M[d * 2] = 1, w.depth[d] = 0, w.opt_len--, I && (w.static_len -= ie[d * 2 + 1]);
    for (G.max_code = Ee, y = w.heap_len >> 1; y >= 1; y--)
      ze(w, M, y);
    d = J;
    do
      y = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[
        1
        /*SMALLEST*/
      ] = w.heap[w.heap_len--], ze(
        w,
        M,
        1
        /*SMALLEST*/
      ), ue = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[--w.heap_max] = y, w.heap[--w.heap_max] = ue, M[d * 2] = M[y * 2] + M[ue * 2], w.depth[d] = (w.depth[y] >= w.depth[ue] ? w.depth[y] : w.depth[ue]) + 1, M[y * 2 + 1] = M[ue * 2 + 1] = d, w.heap[
        1
        /*SMALLEST*/
      ] = d++, ze(
        w,
        M,
        1
        /*SMALLEST*/
      );
    while (w.heap_len >= 2);
    w.heap[--w.heap_max] = w.heap[
      1
      /*SMALLEST*/
    ], qe(w, G), ce(M, Ee, w.bl_count);
  }
  function vt(w, G, M) {
    var ie, I = -1, J, y = G[1], ue = 0, Ee = 7, d = 4;
    for (y === 0 && (Ee = 138, d = 3), G[(M + 1) * 2 + 1] = 65535, ie = 0; ie <= M; ie++)
      J = y, y = G[(ie + 1) * 2 + 1], !(++ue < Ee && J === y) && (ue < d ? w.bl_tree[J * 2] += ue : J !== 0 ? (J !== I && w.bl_tree[J * 2]++, w.bl_tree[D * 2]++) : ue <= 10 ? w.bl_tree[L * 2]++ : w.bl_tree[T * 2]++, ue = 0, I = J, y === 0 ? (Ee = 138, d = 3) : J === y ? (Ee = 6, d = 3) : (Ee = 7, d = 4));
  }
  function mt(w, G, M) {
    var ie, I = -1, J, y = G[1], ue = 0, Ee = 7, d = 4;
    for (y === 0 && (Ee = 138, d = 3), ie = 0; ie <= M; ie++)
      if (J = y, y = G[(ie + 1) * 2 + 1], !(++ue < Ee && J === y)) {
        if (ue < d)
          do
            be(w, J, w.bl_tree);
          while (--ue !== 0);
        else J !== 0 ? (J !== I && (be(w, J, w.bl_tree), ue--), be(w, D, w.bl_tree), fe(w, ue - 3, 2)) : ue <= 10 ? (be(w, L, w.bl_tree), fe(w, ue - 3, 3)) : (be(w, T, w.bl_tree), fe(w, ue - 11, 7));
        ue = 0, I = J, y === 0 ? (Ee = 138, d = 3) : J === y ? (Ee = 6, d = 3) : (Ee = 7, d = 4);
      }
  }
  function dt(w) {
    var G;
    for (vt(w, w.dyn_ltree, w.l_desc.max_code), vt(w, w.dyn_dtree, w.d_desc.max_code), Qe(w, w.bl_desc), G = p - 1; G >= 3 && w.bl_tree[B[G] * 2 + 1] === 0; G--)
      ;
    return w.opt_len += 3 * (G + 1) + 5 + 5 + 4, G;
  }
  function St(w, G, M, ie) {
    var I;
    for (fe(w, G - 257, 5), fe(w, M - 1, 5), fe(w, ie - 4, 4), I = 0; I < ie; I++)
      fe(w, w.bl_tree[B[I] * 2 + 1], 3);
    mt(w, w.dyn_ltree, G - 1), mt(w, w.dyn_dtree, M - 1);
  }
  function Et(w) {
    var G = 4093624447, M;
    for (M = 0; M <= 31; M++, G >>>= 1)
      if (G & 1 && w.dyn_ltree[M * 2] !== 0)
        return n;
    if (w.dyn_ltree[18] !== 0 || w.dyn_ltree[20] !== 0 || w.dyn_ltree[26] !== 0)
      return r;
    for (M = 32; M < f; M++)
      if (w.dyn_ltree[M * 2] !== 0)
        return r;
    return n;
  }
  var it = !1;
  function Nt(w) {
    it || (se(), it = !0), w.l_desc = new me(w.dyn_ltree, Q), w.d_desc = new me(w.dyn_dtree, ae), w.bl_desc = new me(w.bl_tree, le), w.bi_buf = 0, w.bi_valid = 0, pe(w);
  }
  function _t(w, G, M, ie) {
    fe(w, (a << 1) + (ie ? 1 : 0), 3), He(w, G, M);
  }
  function at(w) {
    fe(w, o << 1, 3), be(w, A, H), Me(w);
  }
  function F(w, G, M, ie) {
    var I, J, y = 0;
    w.level > 0 ? (w.strm.data_type === s && (w.strm.data_type = Et(w)), Qe(w, w.l_desc), Qe(w, w.d_desc), y = dt(w), I = w.opt_len + 3 + 7 >>> 3, J = w.static_len + 3 + 7 >>> 3, J <= I && (I = J)) : I = J = M + 5, M + 4 <= I && G !== -1 ? _t(w, G, M, ie) : w.strategy === t || J === I ? (fe(w, (o << 1) + (ie ? 1 : 0), 3), Ne(w, H, _)) : (fe(w, (l << 1) + (ie ? 1 : 0), 3), St(w, w.l_desc.max_code + 1, w.d_desc.max_code + 1, y + 1), Ne(w, w.dyn_ltree, w.dyn_dtree)), pe(w), ie && Pe(w);
  }
  function S(w, G, M) {
    return w.pending_buf[w.d_buf + w.last_lit * 2] = G >>> 8 & 255, w.pending_buf[w.d_buf + w.last_lit * 2 + 1] = G & 255, w.pending_buf[w.l_buf + w.last_lit] = M & 255, w.last_lit++, G === 0 ? w.dyn_ltree[M * 2]++ : (w.matches++, G--, w.dyn_ltree[(R[M] + f + 1) * 2]++, w.dyn_dtree[$e(G) * 2]++), w.last_lit === w.lit_bufsize - 1;
  }
  return mn._tr_init = Nt, mn._tr_stored_block = _t, mn._tr_flush_block = F, mn._tr_tally = S, mn._tr_align = at, mn;
}
var Tr, Tl;
function Qo() {
  if (Tl) return Tr;
  Tl = 1;
  function e(t, n, r, s) {
    for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, o = 0; r !== 0; ) {
      o = r > 2e3 ? 2e3 : r, r -= o;
      do
        i = i + n[s++] | 0, a = a + i | 0;
      while (--o);
      i %= 65521, a %= 65521;
    }
    return i | a << 16 | 0;
  }
  return Tr = e, Tr;
}
var Ar, Al;
function es() {
  if (Al) return Ar;
  Al = 1;
  function e() {
    for (var r, s = [], i = 0; i < 256; i++) {
      r = i;
      for (var a = 0; a < 8; a++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      s[i] = r;
    }
    return s;
  }
  var t = e();
  function n(r, s, i, a) {
    var o = t, l = a + i;
    r ^= -1;
    for (var h = a; h < l; h++)
      r = r >>> 8 ^ o[(r ^ s[h]) & 255];
    return r ^ -1;
  }
  return Ar = n, Ar;
}
var Lr, Ll;
function bi() {
  return Ll || (Ll = 1, Lr = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), Lr;
}
var $l;
function mh() {
  if ($l) return Ht;
  $l = 1;
  var e = un(), t = vh(), n = Qo(), r = es(), s = bi(), i = 0, a = 1, o = 3, l = 4, h = 5, v = 0, u = 1, f = -2, m = -3, c = -5, p = -1, k = 1, g = 2, b = 3, C = 4, A = 0, D = 2, L = 8, T = 9, P = 15, U = 8, K = 29, B = 256, X = B + 1 + K, H = 30, _ = 19, E = 2 * X + 1, R = 15, V = 3, q = 258, O = q + V + 1, Q = 32, ae = 42, le = 69, me = 73, $e = 91, xe = 103, fe = 113, be = 666, _e = 1, Me = 2, qe = 3, ce = 4, se = 3;
  function pe(d, re) {
    return d.msg = s[re], re;
  }
  function Pe(d) {
    return (d << 1) - (d > 4 ? 9 : 0);
  }
  function He(d) {
    for (var re = d.length; --re >= 0; )
      d[re] = 0;
  }
  function Ue(d) {
    var re = d.state, te = re.pending;
    te > d.avail_out && (te = d.avail_out), te !== 0 && (e.arraySet(d.output, re.pending_buf, re.pending_out, te, d.next_out), d.next_out += te, re.pending_out += te, d.total_out += te, d.avail_out -= te, re.pending -= te, re.pending === 0 && (re.pending_out = 0));
  }
  function ze(d, re) {
    t._tr_flush_block(d, d.block_start >= 0 ? d.block_start : -1, d.strstart - d.block_start, re), d.block_start = d.strstart, Ue(d.strm);
  }
  function Ne(d, re) {
    d.pending_buf[d.pending++] = re;
  }
  function Qe(d, re) {
    d.pending_buf[d.pending++] = re >>> 8 & 255, d.pending_buf[d.pending++] = re & 255;
  }
  function vt(d, re, te, x) {
    var N = d.avail_in;
    return N > x && (N = x), N === 0 ? 0 : (d.avail_in -= N, e.arraySet(re, d.input, d.next_in, N, te), d.state.wrap === 1 ? d.adler = n(d.adler, re, N, te) : d.state.wrap === 2 && (d.adler = r(d.adler, re, N, te)), d.next_in += N, d.total_in += N, N);
  }
  function mt(d, re) {
    var te = d.max_chain_length, x = d.strstart, N, ee, Ie = d.prev_length, we = d.nice_match, Le = d.strstart > d.w_size - O ? d.strstart - (d.w_size - O) : 0, Ze = d.window, gt = d.w_mask, et = d.prev, We = d.strstart + q, st = Ze[x + Ie - 1], yt = Ze[x + Ie];
    d.prev_length >= d.good_match && (te >>= 2), we > d.lookahead && (we = d.lookahead);
    do
      if (N = re, !(Ze[N + Ie] !== yt || Ze[N + Ie - 1] !== st || Ze[N] !== Ze[x] || Ze[++N] !== Ze[x + 1])) {
        x += 2, N++;
        do
          ;
        while (Ze[++x] === Ze[++N] && Ze[++x] === Ze[++N] && Ze[++x] === Ze[++N] && Ze[++x] === Ze[++N] && Ze[++x] === Ze[++N] && Ze[++x] === Ze[++N] && Ze[++x] === Ze[++N] && Ze[++x] === Ze[++N] && x < We);
        if (ee = q - (We - x), x = We - q, ee > Ie) {
          if (d.match_start = re, Ie = ee, ee >= we)
            break;
          st = Ze[x + Ie - 1], yt = Ze[x + Ie];
        }
      }
    while ((re = et[re & gt]) > Le && --te !== 0);
    return Ie <= d.lookahead ? Ie : d.lookahead;
  }
  function dt(d) {
    var re = d.w_size, te, x, N, ee, Ie;
    do {
      if (ee = d.window_size - d.lookahead - d.strstart, d.strstart >= re + (re - O)) {
        e.arraySet(d.window, d.window, re, re, 0), d.match_start -= re, d.strstart -= re, d.block_start -= re, x = d.hash_size, te = x;
        do
          N = d.head[--te], d.head[te] = N >= re ? N - re : 0;
        while (--x);
        x = re, te = x;
        do
          N = d.prev[--te], d.prev[te] = N >= re ? N - re : 0;
        while (--x);
        ee += re;
      }
      if (d.strm.avail_in === 0)
        break;
      if (x = vt(d.strm, d.window, d.strstart + d.lookahead, ee), d.lookahead += x, d.lookahead + d.insert >= V)
        for (Ie = d.strstart - d.insert, d.ins_h = d.window[Ie], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[Ie + 1]) & d.hash_mask; d.insert && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[Ie + V - 1]) & d.hash_mask, d.prev[Ie & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = Ie, Ie++, d.insert--, !(d.lookahead + d.insert < V)); )
          ;
    } while (d.lookahead < O && d.strm.avail_in !== 0);
  }
  function St(d, re) {
    var te = 65535;
    for (te > d.pending_buf_size - 5 && (te = d.pending_buf_size - 5); ; ) {
      if (d.lookahead <= 1) {
        if (dt(d), d.lookahead === 0 && re === i)
          return _e;
        if (d.lookahead === 0)
          break;
      }
      d.strstart += d.lookahead, d.lookahead = 0;
      var x = d.block_start + te;
      if ((d.strstart === 0 || d.strstart >= x) && (d.lookahead = d.strstart - x, d.strstart = x, ze(d, !1), d.strm.avail_out === 0) || d.strstart - d.block_start >= d.w_size - O && (ze(d, !1), d.strm.avail_out === 0))
        return _e;
    }
    return d.insert = 0, re === l ? (ze(d, !0), d.strm.avail_out === 0 ? qe : ce) : (d.strstart > d.block_start && (ze(d, !1), d.strm.avail_out === 0), _e);
  }
  function Et(d, re) {
    for (var te, x; ; ) {
      if (d.lookahead < O) {
        if (dt(d), d.lookahead < O && re === i)
          return _e;
        if (d.lookahead === 0)
          break;
      }
      if (te = 0, d.lookahead >= V && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + V - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), te !== 0 && d.strstart - te <= d.w_size - O && (d.match_length = mt(d, te)), d.match_length >= V)
        if (x = t._tr_tally(d, d.strstart - d.match_start, d.match_length - V), d.lookahead -= d.match_length, d.match_length <= d.max_lazy_match && d.lookahead >= V) {
          d.match_length--;
          do
            d.strstart++, d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + V - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart;
          while (--d.match_length !== 0);
          d.strstart++;
        } else
          d.strstart += d.match_length, d.match_length = 0, d.ins_h = d.window[d.strstart], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + 1]) & d.hash_mask;
      else
        x = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++;
      if (x && (ze(d, !1), d.strm.avail_out === 0))
        return _e;
    }
    return d.insert = d.strstart < V - 1 ? d.strstart : V - 1, re === l ? (ze(d, !0), d.strm.avail_out === 0 ? qe : ce) : d.last_lit && (ze(d, !1), d.strm.avail_out === 0) ? _e : Me;
  }
  function it(d, re) {
    for (var te, x, N; ; ) {
      if (d.lookahead < O) {
        if (dt(d), d.lookahead < O && re === i)
          return _e;
        if (d.lookahead === 0)
          break;
      }
      if (te = 0, d.lookahead >= V && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + V - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), d.prev_length = d.match_length, d.prev_match = d.match_start, d.match_length = V - 1, te !== 0 && d.prev_length < d.max_lazy_match && d.strstart - te <= d.w_size - O && (d.match_length = mt(d, te), d.match_length <= 5 && (d.strategy === k || d.match_length === V && d.strstart - d.match_start > 4096) && (d.match_length = V - 1)), d.prev_length >= V && d.match_length <= d.prev_length) {
        N = d.strstart + d.lookahead - V, x = t._tr_tally(d, d.strstart - 1 - d.prev_match, d.prev_length - V), d.lookahead -= d.prev_length - 1, d.prev_length -= 2;
        do
          ++d.strstart <= N && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + V - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart);
        while (--d.prev_length !== 0);
        if (d.match_available = 0, d.match_length = V - 1, d.strstart++, x && (ze(d, !1), d.strm.avail_out === 0))
          return _e;
      } else if (d.match_available) {
        if (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), x && ze(d, !1), d.strstart++, d.lookahead--, d.strm.avail_out === 0)
          return _e;
      } else
        d.match_available = 1, d.strstart++, d.lookahead--;
    }
    return d.match_available && (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), d.match_available = 0), d.insert = d.strstart < V - 1 ? d.strstart : V - 1, re === l ? (ze(d, !0), d.strm.avail_out === 0 ? qe : ce) : d.last_lit && (ze(d, !1), d.strm.avail_out === 0) ? _e : Me;
  }
  function Nt(d, re) {
    for (var te, x, N, ee, Ie = d.window; ; ) {
      if (d.lookahead <= q) {
        if (dt(d), d.lookahead <= q && re === i)
          return _e;
        if (d.lookahead === 0)
          break;
      }
      if (d.match_length = 0, d.lookahead >= V && d.strstart > 0 && (N = d.strstart - 1, x = Ie[N], x === Ie[++N] && x === Ie[++N] && x === Ie[++N])) {
        ee = d.strstart + q;
        do
          ;
        while (x === Ie[++N] && x === Ie[++N] && x === Ie[++N] && x === Ie[++N] && x === Ie[++N] && x === Ie[++N] && x === Ie[++N] && x === Ie[++N] && N < ee);
        d.match_length = q - (ee - N), d.match_length > d.lookahead && (d.match_length = d.lookahead);
      }
      if (d.match_length >= V ? (te = t._tr_tally(d, 1, d.match_length - V), d.lookahead -= d.match_length, d.strstart += d.match_length, d.match_length = 0) : (te = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++), te && (ze(d, !1), d.strm.avail_out === 0))
        return _e;
    }
    return d.insert = 0, re === l ? (ze(d, !0), d.strm.avail_out === 0 ? qe : ce) : d.last_lit && (ze(d, !1), d.strm.avail_out === 0) ? _e : Me;
  }
  function _t(d, re) {
    for (var te; ; ) {
      if (d.lookahead === 0 && (dt(d), d.lookahead === 0)) {
        if (re === i)
          return _e;
        break;
      }
      if (d.match_length = 0, te = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++, te && (ze(d, !1), d.strm.avail_out === 0))
        return _e;
    }
    return d.insert = 0, re === l ? (ze(d, !0), d.strm.avail_out === 0 ? qe : ce) : d.last_lit && (ze(d, !1), d.strm.avail_out === 0) ? _e : Me;
  }
  function at(d, re, te, x, N) {
    this.good_length = d, this.max_lazy = re, this.nice_length = te, this.max_chain = x, this.func = N;
  }
  var F;
  F = [
    /*      good lazy nice chain */
    new at(0, 0, 0, 0, St),
    /* 0 store only */
    new at(4, 4, 8, 4, Et),
    /* 1 max speed, no lazy matches */
    new at(4, 5, 16, 8, Et),
    /* 2 */
    new at(4, 6, 32, 32, Et),
    /* 3 */
    new at(4, 4, 16, 16, it),
    /* 4 lazy matches */
    new at(8, 16, 32, 32, it),
    /* 5 */
    new at(8, 16, 128, 128, it),
    /* 6 */
    new at(8, 32, 128, 256, it),
    /* 7 */
    new at(32, 128, 258, 1024, it),
    /* 8 */
    new at(32, 258, 258, 4096, it)
    /* 9 max compression */
  ];
  function S(d) {
    d.window_size = 2 * d.w_size, He(d.head), d.max_lazy_match = F[d.level].max_lazy, d.good_match = F[d.level].good_length, d.nice_match = F[d.level].nice_length, d.max_chain_length = F[d.level].max_chain, d.strstart = 0, d.block_start = 0, d.lookahead = 0, d.insert = 0, d.match_length = d.prev_length = V - 1, d.match_available = 0, d.ins_h = 0;
  }
  function w() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = L, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(E * 2), this.dyn_dtree = new e.Buf16((2 * H + 1) * 2), this.bl_tree = new e.Buf16((2 * _ + 1) * 2), He(this.dyn_ltree), He(this.dyn_dtree), He(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(R + 1), this.heap = new e.Buf16(2 * X + 1), He(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * X + 1), He(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function G(d) {
    var re;
    return !d || !d.state ? pe(d, f) : (d.total_in = d.total_out = 0, d.data_type = D, re = d.state, re.pending = 0, re.pending_out = 0, re.wrap < 0 && (re.wrap = -re.wrap), re.status = re.wrap ? ae : fe, d.adler = re.wrap === 2 ? 0 : 1, re.last_flush = i, t._tr_init(re), v);
  }
  function M(d) {
    var re = G(d);
    return re === v && S(d.state), re;
  }
  function ie(d, re) {
    return !d || !d.state || d.state.wrap !== 2 ? f : (d.state.gzhead = re, v);
  }
  function I(d, re, te, x, N, ee) {
    if (!d)
      return f;
    var Ie = 1;
    if (re === p && (re = 6), x < 0 ? (Ie = 0, x = -x) : x > 15 && (Ie = 2, x -= 16), N < 1 || N > T || te !== L || x < 8 || x > 15 || re < 0 || re > 9 || ee < 0 || ee > C)
      return pe(d, f);
    x === 8 && (x = 9);
    var we = new w();
    return d.state = we, we.strm = d, we.wrap = Ie, we.gzhead = null, we.w_bits = x, we.w_size = 1 << we.w_bits, we.w_mask = we.w_size - 1, we.hash_bits = N + 7, we.hash_size = 1 << we.hash_bits, we.hash_mask = we.hash_size - 1, we.hash_shift = ~~((we.hash_bits + V - 1) / V), we.window = new e.Buf8(we.w_size * 2), we.head = new e.Buf16(we.hash_size), we.prev = new e.Buf16(we.w_size), we.lit_bufsize = 1 << N + 6, we.pending_buf_size = we.lit_bufsize * 4, we.pending_buf = new e.Buf8(we.pending_buf_size), we.d_buf = 1 * we.lit_bufsize, we.l_buf = 3 * we.lit_bufsize, we.level = re, we.strategy = ee, we.method = te, M(d);
  }
  function J(d, re) {
    return I(d, re, L, P, U, A);
  }
  function y(d, re) {
    var te, x, N, ee;
    if (!d || !d.state || re > h || re < 0)
      return d ? pe(d, f) : f;
    if (x = d.state, !d.output || !d.input && d.avail_in !== 0 || x.status === be && re !== l)
      return pe(d, d.avail_out === 0 ? c : f);
    if (x.strm = d, te = x.last_flush, x.last_flush = re, x.status === ae)
      if (x.wrap === 2)
        d.adler = 0, Ne(x, 31), Ne(x, 139), Ne(x, 8), x.gzhead ? (Ne(
          x,
          (x.gzhead.text ? 1 : 0) + (x.gzhead.hcrc ? 2 : 0) + (x.gzhead.extra ? 4 : 0) + (x.gzhead.name ? 8 : 0) + (x.gzhead.comment ? 16 : 0)
        ), Ne(x, x.gzhead.time & 255), Ne(x, x.gzhead.time >> 8 & 255), Ne(x, x.gzhead.time >> 16 & 255), Ne(x, x.gzhead.time >> 24 & 255), Ne(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Ne(x, x.gzhead.os & 255), x.gzhead.extra && x.gzhead.extra.length && (Ne(x, x.gzhead.extra.length & 255), Ne(x, x.gzhead.extra.length >> 8 & 255)), x.gzhead.hcrc && (d.adler = r(d.adler, x.pending_buf, x.pending, 0)), x.gzindex = 0, x.status = le) : (Ne(x, 0), Ne(x, 0), Ne(x, 0), Ne(x, 0), Ne(x, 0), Ne(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Ne(x, se), x.status = fe);
      else {
        var Ie = L + (x.w_bits - 8 << 4) << 8, we = -1;
        x.strategy >= g || x.level < 2 ? we = 0 : x.level < 6 ? we = 1 : x.level === 6 ? we = 2 : we = 3, Ie |= we << 6, x.strstart !== 0 && (Ie |= Q), Ie += 31 - Ie % 31, x.status = fe, Qe(x, Ie), x.strstart !== 0 && (Qe(x, d.adler >>> 16), Qe(x, d.adler & 65535)), d.adler = 1;
      }
    if (x.status === le)
      if (x.gzhead.extra) {
        for (N = x.pending; x.gzindex < (x.gzhead.extra.length & 65535) && !(x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), Ue(d), N = x.pending, x.pending === x.pending_buf_size)); )
          Ne(x, x.gzhead.extra[x.gzindex] & 255), x.gzindex++;
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), x.gzindex === x.gzhead.extra.length && (x.gzindex = 0, x.status = me);
      } else
        x.status = me;
    if (x.status === me)
      if (x.gzhead.name) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), Ue(d), N = x.pending, x.pending === x.pending_buf_size)) {
            ee = 1;
            break;
          }
          x.gzindex < x.gzhead.name.length ? ee = x.gzhead.name.charCodeAt(x.gzindex++) & 255 : ee = 0, Ne(x, ee);
        } while (ee !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), ee === 0 && (x.gzindex = 0, x.status = $e);
      } else
        x.status = $e;
    if (x.status === $e)
      if (x.gzhead.comment) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), Ue(d), N = x.pending, x.pending === x.pending_buf_size)) {
            ee = 1;
            break;
          }
          x.gzindex < x.gzhead.comment.length ? ee = x.gzhead.comment.charCodeAt(x.gzindex++) & 255 : ee = 0, Ne(x, ee);
        } while (ee !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), ee === 0 && (x.status = xe);
      } else
        x.status = xe;
    if (x.status === xe && (x.gzhead.hcrc ? (x.pending + 2 > x.pending_buf_size && Ue(d), x.pending + 2 <= x.pending_buf_size && (Ne(x, d.adler & 255), Ne(x, d.adler >> 8 & 255), d.adler = 0, x.status = fe)) : x.status = fe), x.pending !== 0) {
      if (Ue(d), d.avail_out === 0)
        return x.last_flush = -1, v;
    } else if (d.avail_in === 0 && Pe(re) <= Pe(te) && re !== l)
      return pe(d, c);
    if (x.status === be && d.avail_in !== 0)
      return pe(d, c);
    if (d.avail_in !== 0 || x.lookahead !== 0 || re !== i && x.status !== be) {
      var Le = x.strategy === g ? _t(x, re) : x.strategy === b ? Nt(x, re) : F[x.level].func(x, re);
      if ((Le === qe || Le === ce) && (x.status = be), Le === _e || Le === qe)
        return d.avail_out === 0 && (x.last_flush = -1), v;
      if (Le === Me && (re === a ? t._tr_align(x) : re !== h && (t._tr_stored_block(x, 0, 0, !1), re === o && (He(x.head), x.lookahead === 0 && (x.strstart = 0, x.block_start = 0, x.insert = 0))), Ue(d), d.avail_out === 0))
        return x.last_flush = -1, v;
    }
    return re !== l ? v : x.wrap <= 0 ? u : (x.wrap === 2 ? (Ne(x, d.adler & 255), Ne(x, d.adler >> 8 & 255), Ne(x, d.adler >> 16 & 255), Ne(x, d.adler >> 24 & 255), Ne(x, d.total_in & 255), Ne(x, d.total_in >> 8 & 255), Ne(x, d.total_in >> 16 & 255), Ne(x, d.total_in >> 24 & 255)) : (Qe(x, d.adler >>> 16), Qe(x, d.adler & 65535)), Ue(d), x.wrap > 0 && (x.wrap = -x.wrap), x.pending !== 0 ? v : u);
  }
  function ue(d) {
    var re;
    return !d || !d.state ? f : (re = d.state.status, re !== ae && re !== le && re !== me && re !== $e && re !== xe && re !== fe && re !== be ? pe(d, f) : (d.state = null, re === fe ? pe(d, m) : v));
  }
  function Ee(d, re) {
    var te = re.length, x, N, ee, Ie, we, Le, Ze, gt;
    if (!d || !d.state || (x = d.state, Ie = x.wrap, Ie === 2 || Ie === 1 && x.status !== ae || x.lookahead))
      return f;
    for (Ie === 1 && (d.adler = n(d.adler, re, te, 0)), x.wrap = 0, te >= x.w_size && (Ie === 0 && (He(x.head), x.strstart = 0, x.block_start = 0, x.insert = 0), gt = new e.Buf8(x.w_size), e.arraySet(gt, re, te - x.w_size, x.w_size, 0), re = gt, te = x.w_size), we = d.avail_in, Le = d.next_in, Ze = d.input, d.avail_in = te, d.next_in = 0, d.input = re, dt(x); x.lookahead >= V; ) {
      N = x.strstart, ee = x.lookahead - (V - 1);
      do
        x.ins_h = (x.ins_h << x.hash_shift ^ x.window[N + V - 1]) & x.hash_mask, x.prev[N & x.w_mask] = x.head[x.ins_h], x.head[x.ins_h] = N, N++;
      while (--ee);
      x.strstart = N, x.lookahead = V - 1, dt(x);
    }
    return x.strstart += x.lookahead, x.block_start = x.strstart, x.insert = x.lookahead, x.lookahead = 0, x.match_length = x.prev_length = V - 1, x.match_available = 0, d.next_in = Le, d.input = Ze, d.avail_in = we, x.wrap = Ie, v;
  }
  return Ht.deflateInit = J, Ht.deflateInit2 = I, Ht.deflateReset = M, Ht.deflateResetKeep = G, Ht.deflateSetHeader = ie, Ht.deflate = y, Ht.deflateEnd = ue, Ht.deflateSetDictionary = Ee, Ht.deflateInfo = "pako deflate (from Nodeca project)", Ht;
}
var gn = {}, Il;
function ts() {
  if (Il) return gn;
  Il = 1;
  var e = un(), t = !0, n = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    t = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    n = !1;
  }
  for (var r = new e.Buf8(256), s = 0; s < 256; s++)
    r[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;
  r[254] = r[254] = 1, gn.string2buf = function(a) {
    var o, l, h, v, u, f = a.length, m = 0;
    for (v = 0; v < f; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), m += l < 128 ? 1 : l < 2048 ? 2 : l < 65536 ? 3 : 4;
    for (o = new e.Buf8(m), u = 0, v = 0; u < m; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), l < 128 ? o[u++] = l : l < 2048 ? (o[u++] = 192 | l >>> 6, o[u++] = 128 | l & 63) : l < 65536 ? (o[u++] = 224 | l >>> 12, o[u++] = 128 | l >>> 6 & 63, o[u++] = 128 | l & 63) : (o[u++] = 240 | l >>> 18, o[u++] = 128 | l >>> 12 & 63, o[u++] = 128 | l >>> 6 & 63, o[u++] = 128 | l & 63);
    return o;
  };
  function i(a, o) {
    if (o < 65534 && (a.subarray && n || !a.subarray && t))
      return String.fromCharCode.apply(null, e.shrinkBuf(a, o));
    for (var l = "", h = 0; h < o; h++)
      l += String.fromCharCode(a[h]);
    return l;
  }
  return gn.buf2binstring = function(a) {
    return i(a, a.length);
  }, gn.binstring2buf = function(a) {
    for (var o = new e.Buf8(a.length), l = 0, h = o.length; l < h; l++)
      o[l] = a.charCodeAt(l);
    return o;
  }, gn.buf2string = function(a, o) {
    var l, h, v, u, f = o || a.length, m = new Array(f * 2);
    for (h = 0, l = 0; l < f; ) {
      if (v = a[l++], v < 128) {
        m[h++] = v;
        continue;
      }
      if (u = r[v], u > 4) {
        m[h++] = 65533, l += u - 1;
        continue;
      }
      for (v &= u === 2 ? 31 : u === 3 ? 15 : 7; u > 1 && l < f; )
        v = v << 6 | a[l++] & 63, u--;
      if (u > 1) {
        m[h++] = 65533;
        continue;
      }
      v < 65536 ? m[h++] = v : (v -= 65536, m[h++] = 55296 | v >> 10 & 1023, m[h++] = 56320 | v & 1023);
    }
    return i(m, h);
  }, gn.utf8border = function(a, o) {
    var l;
    for (o = o || a.length, o > a.length && (o = a.length), l = o - 1; l >= 0 && (a[l] & 192) === 128; )
      l--;
    return l < 0 || l === 0 ? o : l + r[a[l]] > o ? l : o;
  }, gn;
}
var $r, Dl;
function ns() {
  if (Dl) return $r;
  Dl = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return $r = e, $r;
}
var Ml;
function gh() {
  if (Ml) return Rn;
  Ml = 1;
  var e = mh(), t = un(), n = ts(), r = bi(), s = ns(), i = Object.prototype.toString, a = 0, o = 4, l = 0, h = 1, v = 2, u = -1, f = 0, m = 8;
  function c(b) {
    if (!(this instanceof c)) return new c(b);
    this.options = t.assign({
      level: u,
      method: m,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: f,
      to: ""
    }, b || {});
    var C = this.options;
    C.raw && C.windowBits > 0 ? C.windowBits = -C.windowBits : C.gzip && C.windowBits > 0 && C.windowBits < 16 && (C.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
    var A = e.deflateInit2(
      this.strm,
      C.level,
      C.method,
      C.windowBits,
      C.memLevel,
      C.strategy
    );
    if (A !== l)
      throw new Error(r[A]);
    if (C.header && e.deflateSetHeader(this.strm, C.header), C.dictionary) {
      var D;
      if (typeof C.dictionary == "string" ? D = n.string2buf(C.dictionary) : i.call(C.dictionary) === "[object ArrayBuffer]" ? D = new Uint8Array(C.dictionary) : D = C.dictionary, A = e.deflateSetDictionary(this.strm, D), A !== l)
        throw new Error(r[A]);
      this._dict_set = !0;
    }
  }
  c.prototype.push = function(b, C) {
    var A = this.strm, D = this.options.chunkSize, L, T;
    if (this.ended)
      return !1;
    T = C === ~~C ? C : C === !0 ? o : a, typeof b == "string" ? A.input = n.string2buf(b) : i.call(b) === "[object ArrayBuffer]" ? A.input = new Uint8Array(b) : A.input = b, A.next_in = 0, A.avail_in = A.input.length;
    do {
      if (A.avail_out === 0 && (A.output = new t.Buf8(D), A.next_out = 0, A.avail_out = D), L = e.deflate(A, T), L !== h && L !== l)
        return this.onEnd(L), this.ended = !0, !1;
      (A.avail_out === 0 || A.avail_in === 0 && (T === o || T === v)) && (this.options.to === "string" ? this.onData(n.buf2binstring(t.shrinkBuf(A.output, A.next_out))) : this.onData(t.shrinkBuf(A.output, A.next_out)));
    } while ((A.avail_in > 0 || A.avail_out === 0) && L !== h);
    return T === o ? (L = e.deflateEnd(this.strm), this.onEnd(L), this.ended = !0, L === l) : (T === v && (this.onEnd(l), A.avail_out = 0), !0);
  }, c.prototype.onData = function(b) {
    this.chunks.push(b);
  }, c.prototype.onEnd = function(b) {
    b === l && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = b, this.msg = this.strm.msg;
  };
  function p(b, C) {
    var A = new c(C);
    if (A.push(b, !0), A.err)
      throw A.msg || r[A.err];
    return A.result;
  }
  function k(b, C) {
    return C = C || {}, C.raw = !0, p(b, C);
  }
  function g(b, C) {
    return C = C || {}, C.gzip = !0, p(b, C);
  }
  return Rn.Deflate = c, Rn.deflate = p, Rn.deflateRaw = k, Rn.gzip = g, Rn;
}
var Fn = {}, Bt = {}, Ir, Ol;
function bh() {
  if (Ol) return Ir;
  Ol = 1;
  var e = 30, t = 12;
  return Ir = function(r, s) {
    var i, a, o, l, h, v, u, f, m, c, p, k, g, b, C, A, D, L, T, P, U, K, B, X, H;
    i = r.state, a = r.next_in, X = r.input, o = a + (r.avail_in - 5), l = r.next_out, H = r.output, h = l - (s - r.avail_out), v = l + (r.avail_out - 257), u = i.dmax, f = i.wsize, m = i.whave, c = i.wnext, p = i.window, k = i.hold, g = i.bits, b = i.lencode, C = i.distcode, A = (1 << i.lenbits) - 1, D = (1 << i.distbits) - 1;
    e:
      do {
        g < 15 && (k += X[a++] << g, g += 8, k += X[a++] << g, g += 8), L = b[k & A];
        t:
          for (; ; ) {
            if (T = L >>> 24, k >>>= T, g -= T, T = L >>> 16 & 255, T === 0)
              H[l++] = L & 65535;
            else if (T & 16) {
              P = L & 65535, T &= 15, T && (g < T && (k += X[a++] << g, g += 8), P += k & (1 << T) - 1, k >>>= T, g -= T), g < 15 && (k += X[a++] << g, g += 8, k += X[a++] << g, g += 8), L = C[k & D];
              n:
                for (; ; ) {
                  if (T = L >>> 24, k >>>= T, g -= T, T = L >>> 16 & 255, T & 16) {
                    if (U = L & 65535, T &= 15, g < T && (k += X[a++] << g, g += 8, g < T && (k += X[a++] << g, g += 8)), U += k & (1 << T) - 1, U > u) {
                      r.msg = "invalid distance too far back", i.mode = e;
                      break e;
                    }
                    if (k >>>= T, g -= T, T = l - h, U > T) {
                      if (T = U - T, T > m && i.sane) {
                        r.msg = "invalid distance too far back", i.mode = e;
                        break e;
                      }
                      if (K = 0, B = p, c === 0) {
                        if (K += f - T, T < P) {
                          P -= T;
                          do
                            H[l++] = p[K++];
                          while (--T);
                          K = l - U, B = H;
                        }
                      } else if (c < T) {
                        if (K += f + c - T, T -= c, T < P) {
                          P -= T;
                          do
                            H[l++] = p[K++];
                          while (--T);
                          if (K = 0, c < P) {
                            T = c, P -= T;
                            do
                              H[l++] = p[K++];
                            while (--T);
                            K = l - U, B = H;
                          }
                        }
                      } else if (K += c - T, T < P) {
                        P -= T;
                        do
                          H[l++] = p[K++];
                        while (--T);
                        K = l - U, B = H;
                      }
                      for (; P > 2; )
                        H[l++] = B[K++], H[l++] = B[K++], H[l++] = B[K++], P -= 3;
                      P && (H[l++] = B[K++], P > 1 && (H[l++] = B[K++]));
                    } else {
                      K = l - U;
                      do
                        H[l++] = H[K++], H[l++] = H[K++], H[l++] = H[K++], P -= 3;
                      while (P > 2);
                      P && (H[l++] = H[K++], P > 1 && (H[l++] = H[K++]));
                    }
                  } else if ((T & 64) === 0) {
                    L = C[(L & 65535) + (k & (1 << T) - 1)];
                    continue n;
                  } else {
                    r.msg = "invalid distance code", i.mode = e;
                    break e;
                  }
                  break;
                }
            } else if ((T & 64) === 0) {
              L = b[(L & 65535) + (k & (1 << T) - 1)];
              continue t;
            } else if (T & 32) {
              i.mode = t;
              break e;
            } else {
              r.msg = "invalid literal/length code", i.mode = e;
              break e;
            }
            break;
          }
      } while (a < o && l < v);
    P = g >> 3, a -= P, g -= P << 3, k &= (1 << g) - 1, r.next_in = a, r.next_out = l, r.avail_in = a < o ? 5 + (o - a) : 5 - (a - o), r.avail_out = l < v ? 257 + (v - l) : 257 - (l - v), i.hold = k, i.bits = g;
  }, Ir;
}
var Dr, Rl;
function ph() {
  if (Rl) return Dr;
  Rl = 1;
  var e = un(), t = 15, n = 852, r = 592, s = 0, i = 1, a = 2, o = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], l = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], h = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], v = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return Dr = function(f, m, c, p, k, g, b, C) {
    var A = C.bits, D = 0, L = 0, T = 0, P = 0, U = 0, K = 0, B = 0, X = 0, H = 0, _ = 0, E, R, V, q, O, Q = null, ae = 0, le, me = new e.Buf16(t + 1), $e = new e.Buf16(t + 1), xe = null, fe = 0, be, _e, Me;
    for (D = 0; D <= t; D++)
      me[D] = 0;
    for (L = 0; L < p; L++)
      me[m[c + L]]++;
    for (U = A, P = t; P >= 1 && me[P] === 0; P--)
      ;
    if (U > P && (U = P), P === 0)
      return k[g++] = 1 << 24 | 64 << 16 | 0, k[g++] = 1 << 24 | 64 << 16 | 0, C.bits = 1, 0;
    for (T = 1; T < P && me[T] === 0; T++)
      ;
    for (U < T && (U = T), X = 1, D = 1; D <= t; D++)
      if (X <<= 1, X -= me[D], X < 0)
        return -1;
    if (X > 0 && (f === s || P !== 1))
      return -1;
    for ($e[1] = 0, D = 1; D < t; D++)
      $e[D + 1] = $e[D] + me[D];
    for (L = 0; L < p; L++)
      m[c + L] !== 0 && (b[$e[m[c + L]]++] = L);
    if (f === s ? (Q = xe = b, le = 19) : f === i ? (Q = o, ae -= 257, xe = l, fe -= 257, le = 256) : (Q = h, xe = v, le = -1), _ = 0, L = 0, D = T, O = g, K = U, B = 0, V = -1, H = 1 << U, q = H - 1, f === i && H > n || f === a && H > r)
      return 1;
    for (; ; ) {
      be = D - B, b[L] < le ? (_e = 0, Me = b[L]) : b[L] > le ? (_e = xe[fe + b[L]], Me = Q[ae + b[L]]) : (_e = 96, Me = 0), E = 1 << D - B, R = 1 << K, T = R;
      do
        R -= E, k[O + (_ >> B) + R] = be << 24 | _e << 16 | Me | 0;
      while (R !== 0);
      for (E = 1 << D - 1; _ & E; )
        E >>= 1;
      if (E !== 0 ? (_ &= E - 1, _ += E) : _ = 0, L++, --me[D] === 0) {
        if (D === P)
          break;
        D = m[c + b[L]];
      }
      if (D > U && (_ & q) !== V) {
        for (B === 0 && (B = U), O += T, K = D - B, X = 1 << K; K + B < P && (X -= me[K + B], !(X <= 0)); )
          K++, X <<= 1;
        if (H += 1 << K, f === i && H > n || f === a && H > r)
          return 1;
        V = _ & q, k[V] = U << 24 | K << 16 | O - g | 0;
      }
    }
    return _ !== 0 && (k[O + _] = D - B << 24 | 64 << 16 | 0), C.bits = U, 0;
  }, Dr;
}
var Fl;
function yh() {
  if (Fl) return Bt;
  Fl = 1;
  var e = un(), t = Qo(), n = es(), r = bh(), s = ph(), i = 0, a = 1, o = 2, l = 4, h = 5, v = 6, u = 0, f = 1, m = 2, c = -2, p = -3, k = -4, g = -5, b = 8, C = 1, A = 2, D = 3, L = 4, T = 5, P = 6, U = 7, K = 8, B = 9, X = 10, H = 11, _ = 12, E = 13, R = 14, V = 15, q = 16, O = 17, Q = 18, ae = 19, le = 20, me = 21, $e = 22, xe = 23, fe = 24, be = 25, _e = 26, Me = 27, qe = 28, ce = 29, se = 30, pe = 31, Pe = 32, He = 852, Ue = 592, ze = 15, Ne = ze;
  function Qe(I) {
    return (I >>> 24 & 255) + (I >>> 8 & 65280) + ((I & 65280) << 8) + ((I & 255) << 24);
  }
  function vt() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function mt(I) {
    var J;
    return !I || !I.state ? c : (J = I.state, I.total_in = I.total_out = J.total = 0, I.msg = "", J.wrap && (I.adler = J.wrap & 1), J.mode = C, J.last = 0, J.havedict = 0, J.dmax = 32768, J.head = null, J.hold = 0, J.bits = 0, J.lencode = J.lendyn = new e.Buf32(He), J.distcode = J.distdyn = new e.Buf32(Ue), J.sane = 1, J.back = -1, u);
  }
  function dt(I) {
    var J;
    return !I || !I.state ? c : (J = I.state, J.wsize = 0, J.whave = 0, J.wnext = 0, mt(I));
  }
  function St(I, J) {
    var y, ue;
    return !I || !I.state || (ue = I.state, J < 0 ? (y = 0, J = -J) : (y = (J >> 4) + 1, J < 48 && (J &= 15)), J && (J < 8 || J > 15)) ? c : (ue.window !== null && ue.wbits !== J && (ue.window = null), ue.wrap = y, ue.wbits = J, dt(I));
  }
  function Et(I, J) {
    var y, ue;
    return I ? (ue = new vt(), I.state = ue, ue.window = null, y = St(I, J), y !== u && (I.state = null), y) : c;
  }
  function it(I) {
    return Et(I, Ne);
  }
  var Nt = !0, _t, at;
  function F(I) {
    if (Nt) {
      var J;
      for (_t = new e.Buf32(512), at = new e.Buf32(32), J = 0; J < 144; )
        I.lens[J++] = 8;
      for (; J < 256; )
        I.lens[J++] = 9;
      for (; J < 280; )
        I.lens[J++] = 7;
      for (; J < 288; )
        I.lens[J++] = 8;
      for (s(a, I.lens, 0, 288, _t, 0, I.work, { bits: 9 }), J = 0; J < 32; )
        I.lens[J++] = 5;
      s(o, I.lens, 0, 32, at, 0, I.work, { bits: 5 }), Nt = !1;
    }
    I.lencode = _t, I.lenbits = 9, I.distcode = at, I.distbits = 5;
  }
  function S(I, J, y, ue) {
    var Ee, d = I.state;
    return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new e.Buf8(d.wsize)), ue >= d.wsize ? (e.arraySet(d.window, J, y - d.wsize, d.wsize, 0), d.wnext = 0, d.whave = d.wsize) : (Ee = d.wsize - d.wnext, Ee > ue && (Ee = ue), e.arraySet(d.window, J, y - ue, Ee, d.wnext), ue -= Ee, ue ? (e.arraySet(d.window, J, y - ue, ue, 0), d.wnext = ue, d.whave = d.wsize) : (d.wnext += Ee, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += Ee))), 0;
  }
  function w(I, J) {
    var y, ue, Ee, d, re, te, x, N, ee, Ie, we, Le, Ze, gt, et = 0, We, st, yt, Tt, fn, an, tt, It, bt = new e.Buf8(4), Vt, Ft, xa = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!I || !I.state || !I.output || !I.input && I.avail_in !== 0)
      return c;
    y = I.state, y.mode === _ && (y.mode = E), re = I.next_out, Ee = I.output, x = I.avail_out, d = I.next_in, ue = I.input, te = I.avail_in, N = y.hold, ee = y.bits, Ie = te, we = x, It = u;
    e:
      for (; ; )
        switch (y.mode) {
          case C:
            if (y.wrap === 0) {
              y.mode = E;
              break;
            }
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            if (y.wrap & 2 && N === 35615) {
              y.check = 0, bt[0] = N & 255, bt[1] = N >>> 8 & 255, y.check = n(y.check, bt, 2, 0), N = 0, ee = 0, y.mode = A;
              break;
            }
            if (y.flags = 0, y.head && (y.head.done = !1), !(y.wrap & 1) || /* check if zlib header allowed */
            (((N & 255) << 8) + (N >> 8)) % 31) {
              I.msg = "incorrect header check", y.mode = se;
              break;
            }
            if ((N & 15) !== b) {
              I.msg = "unknown compression method", y.mode = se;
              break;
            }
            if (N >>>= 4, ee -= 4, tt = (N & 15) + 8, y.wbits === 0)
              y.wbits = tt;
            else if (tt > y.wbits) {
              I.msg = "invalid window size", y.mode = se;
              break;
            }
            y.dmax = 1 << tt, I.adler = y.check = 1, y.mode = N & 512 ? X : _, N = 0, ee = 0;
            break;
          case A:
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            if (y.flags = N, (y.flags & 255) !== b) {
              I.msg = "unknown compression method", y.mode = se;
              break;
            }
            if (y.flags & 57344) {
              I.msg = "unknown header flags set", y.mode = se;
              break;
            }
            y.head && (y.head.text = N >> 8 & 1), y.flags & 512 && (bt[0] = N & 255, bt[1] = N >>> 8 & 255, y.check = n(y.check, bt, 2, 0)), N = 0, ee = 0, y.mode = D;
          /* falls through */
          case D:
            for (; ee < 32; ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            y.head && (y.head.time = N), y.flags & 512 && (bt[0] = N & 255, bt[1] = N >>> 8 & 255, bt[2] = N >>> 16 & 255, bt[3] = N >>> 24 & 255, y.check = n(y.check, bt, 4, 0)), N = 0, ee = 0, y.mode = L;
          /* falls through */
          case L:
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            y.head && (y.head.xflags = N & 255, y.head.os = N >> 8), y.flags & 512 && (bt[0] = N & 255, bt[1] = N >>> 8 & 255, y.check = n(y.check, bt, 2, 0)), N = 0, ee = 0, y.mode = T;
          /* falls through */
          case T:
            if (y.flags & 1024) {
              for (; ee < 16; ) {
                if (te === 0)
                  break e;
                te--, N += ue[d++] << ee, ee += 8;
              }
              y.length = N, y.head && (y.head.extra_len = N), y.flags & 512 && (bt[0] = N & 255, bt[1] = N >>> 8 & 255, y.check = n(y.check, bt, 2, 0)), N = 0, ee = 0;
            } else y.head && (y.head.extra = null);
            y.mode = P;
          /* falls through */
          case P:
            if (y.flags & 1024 && (Le = y.length, Le > te && (Le = te), Le && (y.head && (tt = y.head.extra_len - y.length, y.head.extra || (y.head.extra = new Array(y.head.extra_len)), e.arraySet(
              y.head.extra,
              ue,
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              Le,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              tt
            )), y.flags & 512 && (y.check = n(y.check, ue, Le, d)), te -= Le, d += Le, y.length -= Le), y.length))
              break e;
            y.length = 0, y.mode = U;
          /* falls through */
          case U:
            if (y.flags & 2048) {
              if (te === 0)
                break e;
              Le = 0;
              do
                tt = ue[d + Le++], y.head && tt && y.length < 65536 && (y.head.name += String.fromCharCode(tt));
              while (tt && Le < te);
              if (y.flags & 512 && (y.check = n(y.check, ue, Le, d)), te -= Le, d += Le, tt)
                break e;
            } else y.head && (y.head.name = null);
            y.length = 0, y.mode = K;
          /* falls through */
          case K:
            if (y.flags & 4096) {
              if (te === 0)
                break e;
              Le = 0;
              do
                tt = ue[d + Le++], y.head && tt && y.length < 65536 && (y.head.comment += String.fromCharCode(tt));
              while (tt && Le < te);
              if (y.flags & 512 && (y.check = n(y.check, ue, Le, d)), te -= Le, d += Le, tt)
                break e;
            } else y.head && (y.head.comment = null);
            y.mode = B;
          /* falls through */
          case B:
            if (y.flags & 512) {
              for (; ee < 16; ) {
                if (te === 0)
                  break e;
                te--, N += ue[d++] << ee, ee += 8;
              }
              if (N !== (y.check & 65535)) {
                I.msg = "header crc mismatch", y.mode = se;
                break;
              }
              N = 0, ee = 0;
            }
            y.head && (y.head.hcrc = y.flags >> 9 & 1, y.head.done = !0), I.adler = y.check = 0, y.mode = _;
            break;
          case X:
            for (; ee < 32; ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            I.adler = y.check = Qe(N), N = 0, ee = 0, y.mode = H;
          /* falls through */
          case H:
            if (y.havedict === 0)
              return I.next_out = re, I.avail_out = x, I.next_in = d, I.avail_in = te, y.hold = N, y.bits = ee, m;
            I.adler = y.check = 1, y.mode = _;
          /* falls through */
          case _:
            if (J === h || J === v)
              break e;
          /* falls through */
          case E:
            if (y.last) {
              N >>>= ee & 7, ee -= ee & 7, y.mode = Me;
              break;
            }
            for (; ee < 3; ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            switch (y.last = N & 1, N >>>= 1, ee -= 1, N & 3) {
              case 0:
                y.mode = R;
                break;
              case 1:
                if (F(y), y.mode = le, J === v) {
                  N >>>= 2, ee -= 2;
                  break e;
                }
                break;
              case 2:
                y.mode = O;
                break;
              case 3:
                I.msg = "invalid block type", y.mode = se;
            }
            N >>>= 2, ee -= 2;
            break;
          case R:
            for (N >>>= ee & 7, ee -= ee & 7; ee < 32; ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            if ((N & 65535) !== (N >>> 16 ^ 65535)) {
              I.msg = "invalid stored block lengths", y.mode = se;
              break;
            }
            if (y.length = N & 65535, N = 0, ee = 0, y.mode = V, J === v)
              break e;
          /* falls through */
          case V:
            y.mode = q;
          /* falls through */
          case q:
            if (Le = y.length, Le) {
              if (Le > te && (Le = te), Le > x && (Le = x), Le === 0)
                break e;
              e.arraySet(Ee, ue, d, Le, re), te -= Le, d += Le, x -= Le, re += Le, y.length -= Le;
              break;
            }
            y.mode = _;
            break;
          case O:
            for (; ee < 14; ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            if (y.nlen = (N & 31) + 257, N >>>= 5, ee -= 5, y.ndist = (N & 31) + 1, N >>>= 5, ee -= 5, y.ncode = (N & 15) + 4, N >>>= 4, ee -= 4, y.nlen > 286 || y.ndist > 30) {
              I.msg = "too many length or distance symbols", y.mode = se;
              break;
            }
            y.have = 0, y.mode = Q;
          /* falls through */
          case Q:
            for (; y.have < y.ncode; ) {
              for (; ee < 3; ) {
                if (te === 0)
                  break e;
                te--, N += ue[d++] << ee, ee += 8;
              }
              y.lens[xa[y.have++]] = N & 7, N >>>= 3, ee -= 3;
            }
            for (; y.have < 19; )
              y.lens[xa[y.have++]] = 0;
            if (y.lencode = y.lendyn, y.lenbits = 7, Vt = { bits: y.lenbits }, It = s(i, y.lens, 0, 19, y.lencode, 0, y.work, Vt), y.lenbits = Vt.bits, It) {
              I.msg = "invalid code lengths set", y.mode = se;
              break;
            }
            y.have = 0, y.mode = ae;
          /* falls through */
          case ae:
            for (; y.have < y.nlen + y.ndist; ) {
              for (; et = y.lencode[N & (1 << y.lenbits) - 1], We = et >>> 24, st = et >>> 16 & 255, yt = et & 65535, !(We <= ee); ) {
                if (te === 0)
                  break e;
                te--, N += ue[d++] << ee, ee += 8;
              }
              if (yt < 16)
                N >>>= We, ee -= We, y.lens[y.have++] = yt;
              else {
                if (yt === 16) {
                  for (Ft = We + 2; ee < Ft; ) {
                    if (te === 0)
                      break e;
                    te--, N += ue[d++] << ee, ee += 8;
                  }
                  if (N >>>= We, ee -= We, y.have === 0) {
                    I.msg = "invalid bit length repeat", y.mode = se;
                    break;
                  }
                  tt = y.lens[y.have - 1], Le = 3 + (N & 3), N >>>= 2, ee -= 2;
                } else if (yt === 17) {
                  for (Ft = We + 3; ee < Ft; ) {
                    if (te === 0)
                      break e;
                    te--, N += ue[d++] << ee, ee += 8;
                  }
                  N >>>= We, ee -= We, tt = 0, Le = 3 + (N & 7), N >>>= 3, ee -= 3;
                } else {
                  for (Ft = We + 7; ee < Ft; ) {
                    if (te === 0)
                      break e;
                    te--, N += ue[d++] << ee, ee += 8;
                  }
                  N >>>= We, ee -= We, tt = 0, Le = 11 + (N & 127), N >>>= 7, ee -= 7;
                }
                if (y.have + Le > y.nlen + y.ndist) {
                  I.msg = "invalid bit length repeat", y.mode = se;
                  break;
                }
                for (; Le--; )
                  y.lens[y.have++] = tt;
              }
            }
            if (y.mode === se)
              break;
            if (y.lens[256] === 0) {
              I.msg = "invalid code -- missing end-of-block", y.mode = se;
              break;
            }
            if (y.lenbits = 9, Vt = { bits: y.lenbits }, It = s(a, y.lens, 0, y.nlen, y.lencode, 0, y.work, Vt), y.lenbits = Vt.bits, It) {
              I.msg = "invalid literal/lengths set", y.mode = se;
              break;
            }
            if (y.distbits = 6, y.distcode = y.distdyn, Vt = { bits: y.distbits }, It = s(o, y.lens, y.nlen, y.ndist, y.distcode, 0, y.work, Vt), y.distbits = Vt.bits, It) {
              I.msg = "invalid distances set", y.mode = se;
              break;
            }
            if (y.mode = le, J === v)
              break e;
          /* falls through */
          case le:
            y.mode = me;
          /* falls through */
          case me:
            if (te >= 6 && x >= 258) {
              I.next_out = re, I.avail_out = x, I.next_in = d, I.avail_in = te, y.hold = N, y.bits = ee, r(I, we), re = I.next_out, Ee = I.output, x = I.avail_out, d = I.next_in, ue = I.input, te = I.avail_in, N = y.hold, ee = y.bits, y.mode === _ && (y.back = -1);
              break;
            }
            for (y.back = 0; et = y.lencode[N & (1 << y.lenbits) - 1], We = et >>> 24, st = et >>> 16 & 255, yt = et & 65535, !(We <= ee); ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            if (st && (st & 240) === 0) {
              for (Tt = We, fn = st, an = yt; et = y.lencode[an + ((N & (1 << Tt + fn) - 1) >> Tt)], We = et >>> 24, st = et >>> 16 & 255, yt = et & 65535, !(Tt + We <= ee); ) {
                if (te === 0)
                  break e;
                te--, N += ue[d++] << ee, ee += 8;
              }
              N >>>= Tt, ee -= Tt, y.back += Tt;
            }
            if (N >>>= We, ee -= We, y.back += We, y.length = yt, st === 0) {
              y.mode = _e;
              break;
            }
            if (st & 32) {
              y.back = -1, y.mode = _;
              break;
            }
            if (st & 64) {
              I.msg = "invalid literal/length code", y.mode = se;
              break;
            }
            y.extra = st & 15, y.mode = $e;
          /* falls through */
          case $e:
            if (y.extra) {
              for (Ft = y.extra; ee < Ft; ) {
                if (te === 0)
                  break e;
                te--, N += ue[d++] << ee, ee += 8;
              }
              y.length += N & (1 << y.extra) - 1, N >>>= y.extra, ee -= y.extra, y.back += y.extra;
            }
            y.was = y.length, y.mode = xe;
          /* falls through */
          case xe:
            for (; et = y.distcode[N & (1 << y.distbits) - 1], We = et >>> 24, st = et >>> 16 & 255, yt = et & 65535, !(We <= ee); ) {
              if (te === 0)
                break e;
              te--, N += ue[d++] << ee, ee += 8;
            }
            if ((st & 240) === 0) {
              for (Tt = We, fn = st, an = yt; et = y.distcode[an + ((N & (1 << Tt + fn) - 1) >> Tt)], We = et >>> 24, st = et >>> 16 & 255, yt = et & 65535, !(Tt + We <= ee); ) {
                if (te === 0)
                  break e;
                te--, N += ue[d++] << ee, ee += 8;
              }
              N >>>= Tt, ee -= Tt, y.back += Tt;
            }
            if (N >>>= We, ee -= We, y.back += We, st & 64) {
              I.msg = "invalid distance code", y.mode = se;
              break;
            }
            y.offset = yt, y.extra = st & 15, y.mode = fe;
          /* falls through */
          case fe:
            if (y.extra) {
              for (Ft = y.extra; ee < Ft; ) {
                if (te === 0)
                  break e;
                te--, N += ue[d++] << ee, ee += 8;
              }
              y.offset += N & (1 << y.extra) - 1, N >>>= y.extra, ee -= y.extra, y.back += y.extra;
            }
            if (y.offset > y.dmax) {
              I.msg = "invalid distance too far back", y.mode = se;
              break;
            }
            y.mode = be;
          /* falls through */
          case be:
            if (x === 0)
              break e;
            if (Le = we - x, y.offset > Le) {
              if (Le = y.offset - Le, Le > y.whave && y.sane) {
                I.msg = "invalid distance too far back", y.mode = se;
                break;
              }
              Le > y.wnext ? (Le -= y.wnext, Ze = y.wsize - Le) : Ze = y.wnext - Le, Le > y.length && (Le = y.length), gt = y.window;
            } else
              gt = Ee, Ze = re - y.offset, Le = y.length;
            Le > x && (Le = x), x -= Le, y.length -= Le;
            do
              Ee[re++] = gt[Ze++];
            while (--Le);
            y.length === 0 && (y.mode = me);
            break;
          case _e:
            if (x === 0)
              break e;
            Ee[re++] = y.length, x--, y.mode = me;
            break;
          case Me:
            if (y.wrap) {
              for (; ee < 32; ) {
                if (te === 0)
                  break e;
                te--, N |= ue[d++] << ee, ee += 8;
              }
              if (we -= x, I.total_out += we, y.total += we, we && (I.adler = y.check = /*UPDATE(state.check, put - _out, _out);*/
              y.flags ? n(y.check, Ee, we, re - we) : t(y.check, Ee, we, re - we)), we = x, (y.flags ? N : Qe(N)) !== y.check) {
                I.msg = "incorrect data check", y.mode = se;
                break;
              }
              N = 0, ee = 0;
            }
            y.mode = qe;
          /* falls through */
          case qe:
            if (y.wrap && y.flags) {
              for (; ee < 32; ) {
                if (te === 0)
                  break e;
                te--, N += ue[d++] << ee, ee += 8;
              }
              if (N !== (y.total & 4294967295)) {
                I.msg = "incorrect length check", y.mode = se;
                break;
              }
              N = 0, ee = 0;
            }
            y.mode = ce;
          /* falls through */
          case ce:
            It = f;
            break e;
          case se:
            It = p;
            break e;
          case pe:
            return k;
          case Pe:
          /* falls through */
          default:
            return c;
        }
    return I.next_out = re, I.avail_out = x, I.next_in = d, I.avail_in = te, y.hold = N, y.bits = ee, (y.wsize || we !== I.avail_out && y.mode < se && (y.mode < Me || J !== l)) && S(I, I.output, I.next_out, we - I.avail_out), Ie -= I.avail_in, we -= I.avail_out, I.total_in += Ie, I.total_out += we, y.total += we, y.wrap && we && (I.adler = y.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    y.flags ? n(y.check, Ee, we, I.next_out - we) : t(y.check, Ee, we, I.next_out - we)), I.data_type = y.bits + (y.last ? 64 : 0) + (y.mode === _ ? 128 : 0) + (y.mode === le || y.mode === V ? 256 : 0), (Ie === 0 && we === 0 || J === l) && It === u && (It = g), It;
  }
  function G(I) {
    if (!I || !I.state)
      return c;
    var J = I.state;
    return J.window && (J.window = null), I.state = null, u;
  }
  function M(I, J) {
    var y;
    return !I || !I.state || (y = I.state, (y.wrap & 2) === 0) ? c : (y.head = J, J.done = !1, u);
  }
  function ie(I, J) {
    var y = J.length, ue, Ee, d;
    return !I || !I.state || (ue = I.state, ue.wrap !== 0 && ue.mode !== H) ? c : ue.mode === H && (Ee = 1, Ee = t(Ee, J, y, 0), Ee !== ue.check) ? p : (d = S(I, J, y, y), d ? (ue.mode = pe, k) : (ue.havedict = 1, u));
  }
  return Bt.inflateReset = dt, Bt.inflateReset2 = St, Bt.inflateResetKeep = mt, Bt.inflateInit = it, Bt.inflateInit2 = Et, Bt.inflate = w, Bt.inflateEnd = G, Bt.inflateGetHeader = M, Bt.inflateSetDictionary = ie, Bt.inflateInfo = "pako inflate (from Nodeca project)", Bt;
}
var Mr, Nl;
function as() {
  return Nl || (Nl = 1, Mr = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), Mr;
}
var Or, Pl;
function wh() {
  if (Pl) return Or;
  Pl = 1;
  function e() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return Or = e, Or;
}
var Bl;
function xh() {
  if (Bl) return Fn;
  Bl = 1;
  var e = yh(), t = un(), n = ts(), r = as(), s = bi(), i = ns(), a = wh(), o = Object.prototype.toString;
  function l(u) {
    if (!(this instanceof l)) return new l(u);
    this.options = t.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, u || {});
    var f = this.options;
    f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), f.windowBits >= 0 && f.windowBits < 16 && !(u && u.windowBits) && (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && (f.windowBits & 15) === 0 && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
    var m = e.inflateInit2(
      this.strm,
      f.windowBits
    );
    if (m !== r.Z_OK)
      throw new Error(s[m]);
    if (this.header = new a(), e.inflateGetHeader(this.strm, this.header), f.dictionary && (typeof f.dictionary == "string" ? f.dictionary = n.string2buf(f.dictionary) : o.call(f.dictionary) === "[object ArrayBuffer]" && (f.dictionary = new Uint8Array(f.dictionary)), f.raw && (m = e.inflateSetDictionary(this.strm, f.dictionary), m !== r.Z_OK)))
      throw new Error(s[m]);
  }
  l.prototype.push = function(u, f) {
    var m = this.strm, c = this.options.chunkSize, p = this.options.dictionary, k, g, b, C, A, D = !1;
    if (this.ended)
      return !1;
    g = f === ~~f ? f : f === !0 ? r.Z_FINISH : r.Z_NO_FLUSH, typeof u == "string" ? m.input = n.binstring2buf(u) : o.call(u) === "[object ArrayBuffer]" ? m.input = new Uint8Array(u) : m.input = u, m.next_in = 0, m.avail_in = m.input.length;
    do {
      if (m.avail_out === 0 && (m.output = new t.Buf8(c), m.next_out = 0, m.avail_out = c), k = e.inflate(m, r.Z_NO_FLUSH), k === r.Z_NEED_DICT && p && (k = e.inflateSetDictionary(this.strm, p)), k === r.Z_BUF_ERROR && D === !0 && (k = r.Z_OK, D = !1), k !== r.Z_STREAM_END && k !== r.Z_OK)
        return this.onEnd(k), this.ended = !0, !1;
      m.next_out && (m.avail_out === 0 || k === r.Z_STREAM_END || m.avail_in === 0 && (g === r.Z_FINISH || g === r.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (b = n.utf8border(m.output, m.next_out), C = m.next_out - b, A = n.buf2string(m.output, b), m.next_out = C, m.avail_out = c - C, C && t.arraySet(m.output, m.output, b, C, 0), this.onData(A)) : this.onData(t.shrinkBuf(m.output, m.next_out))), m.avail_in === 0 && m.avail_out === 0 && (D = !0);
    } while ((m.avail_in > 0 || m.avail_out === 0) && k !== r.Z_STREAM_END);
    return k === r.Z_STREAM_END && (g = r.Z_FINISH), g === r.Z_FINISH ? (k = e.inflateEnd(this.strm), this.onEnd(k), this.ended = !0, k === r.Z_OK) : (g === r.Z_SYNC_FLUSH && (this.onEnd(r.Z_OK), m.avail_out = 0), !0);
  }, l.prototype.onData = function(u) {
    this.chunks.push(u);
  }, l.prototype.onEnd = function(u) {
    u === r.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = u, this.msg = this.strm.msg;
  };
  function h(u, f) {
    var m = new l(f);
    if (m.push(u, !0), m.err)
      throw m.msg || s[m.err];
    return m.result;
  }
  function v(u, f) {
    return f = f || {}, f.raw = !0, h(u, f);
  }
  return Fn.Inflate = l, Fn.inflate = h, Fn.inflateRaw = v, Fn.ungzip = h, Fn;
}
var Rr, zl;
function kh() {
  if (zl) return Rr;
  zl = 1;
  var e = un().assign, t = gh(), n = xh(), r = as(), s = {};
  return e(s, t, n, r), Rr = s, Rr;
}
var Vl;
function Sh() {
  return Vl || (Vl = 1, (function(e) {
    (function() {
      var t = {}, n;
      e.exports = t, typeof hh == "function" ? n = kh() : n = window.pako, (function(r, s) {
        r.toRGBA8 = function(i) {
          var a = i.width, o = i.height;
          if (i.tabs.acTL == null) return [r.toRGBA8.decodeImage(i.data, a, o, i).buffer];
          var l = [];
          i.frames[0].data == null && (i.frames[0].data = i.data);
          for (var h, v = new Uint8Array(a * o * 4), u = 0; u < i.frames.length; u++) {
            var f = i.frames[u], m = f.rect.x, c = f.rect.y, p = f.rect.width, k = f.rect.height, g = r.toRGBA8.decodeImage(f.data, p, k, i);
            if (u == 0 ? h = g : f.blend == 0 ? r._copyTile(g, p, k, h, a, o, m, c, 0) : f.blend == 1 && r._copyTile(g, p, k, h, a, o, m, c, 1), l.push(h.buffer), h = h.slice(0), f.dispose != 0) {
              if (f.dispose == 1) r._copyTile(v, p, k, h, a, o, m, c, 0);
              else if (f.dispose == 2) {
                for (var b = u - 1; i.frames[b].dispose == 2; ) b--;
                h = new Uint8Array(l[b]).slice(0);
              }
            }
          }
          return l;
        }, r.toRGBA8.decodeImage = function(i, a, o, l) {
          var h = a * o, v = r.decode._getBPP(l), u = Math.ceil(a * v / 8), f = new Uint8Array(h * 4), m = new Uint32Array(f.buffer), c = l.ctype, p = l.depth, k = r._bin.readUshort;
          if (c == 6) {
            var g = h << 2;
            if (p == 8) for (var b = 0; b < g; b++)
              f[b] = i[b];
            if (p == 16) for (var b = 0; b < g; b++)
              f[b] = i[b << 1];
          } else if (c == 2) {
            var C = l.tabs.tRNS, A = -1, D = -1, L = -1;
            if (C && (A = C[0], D = C[1], L = C[2]), p == 8) for (var b = 0; b < h; b++) {
              var T = b << 2, P = b * 3;
              f[T] = i[P], f[T + 1] = i[P + 1], f[T + 2] = i[P + 2], f[T + 3] = 255, A != -1 && i[P] == A && i[P + 1] == D && i[P + 2] == L && (f[T + 3] = 0);
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var T = b << 2, P = b * 6;
              f[T] = i[P], f[T + 1] = i[P + 2], f[T + 2] = i[P + 4], f[T + 3] = 255, A != -1 && k(i, P) == A && k(i, P + 2) == D && k(i, P + 4) == L && (f[T + 3] = 0);
            }
          } else if (c == 3) {
            var U = l.tabs.PLTE, K = l.tabs.tRNS, B = K ? K.length : 0;
            if (p == 1) for (var X = 0; X < o; X++)
              for (var H = X * u, _ = X * a, b = 0; b < a; b++) {
                var T = _ + b << 2, E = i[H + (b >> 3)] >> 7 - ((b & 7) << 0) & 1, R = 3 * E;
                f[T] = U[R], f[T + 1] = U[R + 1], f[T + 2] = U[R + 2], f[T + 3] = E < B ? K[E] : 255;
              }
            if (p == 2) for (var X = 0; X < o; X++)
              for (var H = X * u, _ = X * a, b = 0; b < a; b++) {
                var T = _ + b << 2, E = i[H + (b >> 2)] >> 6 - ((b & 3) << 1) & 3, R = 3 * E;
                f[T] = U[R], f[T + 1] = U[R + 1], f[T + 2] = U[R + 2], f[T + 3] = E < B ? K[E] : 255;
              }
            if (p == 4) for (var X = 0; X < o; X++)
              for (var H = X * u, _ = X * a, b = 0; b < a; b++) {
                var T = _ + b << 2, E = i[H + (b >> 1)] >> 4 - ((b & 1) << 2) & 15, R = 3 * E;
                f[T] = U[R], f[T + 1] = U[R + 1], f[T + 2] = U[R + 2], f[T + 3] = E < B ? K[E] : 255;
              }
            if (p == 8) for (var b = 0; b < h; b++) {
              var T = b << 2, E = i[b], R = 3 * E;
              f[T] = U[R], f[T + 1] = U[R + 1], f[T + 2] = U[R + 2], f[T + 3] = E < B ? K[E] : 255;
            }
          } else if (c == 4) {
            if (p == 8) for (var b = 0; b < h; b++) {
              var T = b << 2, V = b << 1, q = i[V];
              f[T] = q, f[T + 1] = q, f[T + 2] = q, f[T + 3] = i[V + 1];
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var T = b << 2, V = b << 2, q = i[V];
              f[T] = q, f[T + 1] = q, f[T + 2] = q, f[T + 3] = i[V + 2];
            }
          } else if (c == 0) {
            var A = l.tabs.tRNS ? l.tabs.tRNS : -1;
            if (p == 1) for (var b = 0; b < h; b++) {
              var q = 255 * (i[b >> 3] >> 7 - (b & 7) & 1), O = q == A * 255 ? 0 : 255;
              m[b] = O << 24 | q << 16 | q << 8 | q;
            }
            if (p == 2) for (var b = 0; b < h; b++) {
              var q = 85 * (i[b >> 2] >> 6 - ((b & 3) << 1) & 3), O = q == A * 85 ? 0 : 255;
              m[b] = O << 24 | q << 16 | q << 8 | q;
            }
            if (p == 4) for (var b = 0; b < h; b++) {
              var q = 17 * (i[b >> 1] >> 4 - ((b & 1) << 2) & 15), O = q == A * 17 ? 0 : 255;
              m[b] = O << 24 | q << 16 | q << 8 | q;
            }
            if (p == 8) for (var b = 0; b < h; b++) {
              var q = i[b], O = q == A ? 0 : 255;
              m[b] = O << 24 | q << 16 | q << 8 | q;
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var q = i[b << 1], O = k(i, b << 1) == A ? 0 : 255;
              m[b] = O << 24 | q << 16 | q << 8 | q;
            }
          }
          return f;
        }, r.decode = function(i) {
          for (var a = new Uint8Array(i), o = 8, l = r._bin, h = l.readUshort, v = l.readUint, u = { tabs: {}, frames: [] }, f = new Uint8Array(a.length), m = 0, c, p = 0, k = [137, 80, 78, 71, 13, 10, 26, 10], g = 0; g < 8; g++) if (a[g] != k[g]) throw "The input is not a PNG file!";
          for (; o < a.length; ) {
            var b = l.readUint(a, o);
            o += 4;
            var C = l.readASCII(a, o, 4);
            if (o += 4, C == "IHDR")
              r.decode._IHDR(a, o, u);
            else if (C == "IDAT") {
              for (var g = 0; g < b; g++) f[m + g] = a[o + g];
              m += b;
            } else if (C == "acTL")
              u.tabs[C] = { num_frames: v(a, o), num_plays: v(a, o + 4) }, c = new Uint8Array(a.length);
            else if (C == "fcTL") {
              if (p != 0) {
                var A = u.frames[u.frames.length - 1];
                A.data = r.decode._decompress(u, c.slice(0, p), A.rect.width, A.rect.height), p = 0;
              }
              var D = { x: v(a, o + 12), y: v(a, o + 16), width: v(a, o + 4), height: v(a, o + 8) }, L = h(a, o + 22);
              L = h(a, o + 20) / (L == 0 ? 100 : L);
              var T = { rect: D, delay: Math.round(L * 1e3), dispose: a[o + 24], blend: a[o + 25] };
              u.frames.push(T);
            } else if (C == "fdAT") {
              for (var g = 0; g < b - 4; g++) c[p + g] = a[o + g + 4];
              p += b - 4;
            } else if (C == "pHYs")
              u.tabs[C] = [l.readUint(a, o), l.readUint(a, o + 4), a[o + 8]];
            else if (C == "cHRM") {
              u.tabs[C] = [];
              for (var g = 0; g < 8; g++) u.tabs[C].push(l.readUint(a, o + g * 4));
            } else if (C == "tEXt") {
              u.tabs[C] == null && (u.tabs[C] = {});
              var P = l.nextZero(a, o), U = l.readASCII(a, o, P - o), K = l.readASCII(a, P + 1, o + b - P - 1);
              u.tabs[C][U] = K;
            } else if (C == "iTXt") {
              u.tabs[C] == null && (u.tabs[C] = {});
              var P = 0, B = o;
              P = l.nextZero(a, B);
              var U = l.readASCII(a, B, P - B);
              B = P + 1, a[B], a[B + 1], B += 2, P = l.nextZero(a, B), l.readASCII(a, B, P - B), B = P + 1, P = l.nextZero(a, B), l.readUTF8(a, B, P - B), B = P + 1;
              var K = l.readUTF8(a, B, b - (B - o));
              u.tabs[C][U] = K;
            } else if (C == "PLTE")
              u.tabs[C] = l.readBytes(a, o, b);
            else if (C == "hIST") {
              var X = u.tabs.PLTE.length / 3;
              u.tabs[C] = [];
              for (var g = 0; g < X; g++) u.tabs[C].push(h(a, o + g * 2));
            } else if (C == "tRNS")
              u.ctype == 3 ? u.tabs[C] = l.readBytes(a, o, b) : u.ctype == 0 ? u.tabs[C] = h(a, o) : u.ctype == 2 && (u.tabs[C] = [h(a, o), h(a, o + 2), h(a, o + 4)]);
            else if (C == "gAMA") u.tabs[C] = l.readUint(a, o) / 1e5;
            else if (C == "sRGB") u.tabs[C] = a[o];
            else if (C == "bKGD")
              u.ctype == 0 || u.ctype == 4 ? u.tabs[C] = [h(a, o)] : u.ctype == 2 || u.ctype == 6 ? u.tabs[C] = [h(a, o), h(a, o + 2), h(a, o + 4)] : u.ctype == 3 && (u.tabs[C] = a[o]);
            else if (C == "IEND") {
              if (p != 0) {
                var A = u.frames[u.frames.length - 1];
                A.data = r.decode._decompress(u, c.slice(0, p), A.rect.width, A.rect.height), p = 0;
              }
              u.data = r.decode._decompress(u, f, u.width, u.height);
              break;
            }
            o += b, l.readUint(a, o), o += 4;
          }
          return delete u.compress, delete u.interlace, delete u.filter, u;
        }, r.decode._decompress = function(i, a, o, l) {
          return i.compress == 0 && (a = r.decode._inflate(a)), i.interlace == 0 ? a = r.decode._filterZero(a, i, 0, o, l) : i.interlace == 1 && (a = r.decode._readInterlace(a, i)), a;
        }, r.decode._inflate = function(i) {
          return s.inflate(i);
        }, r.decode._readInterlace = function(i, a) {
          for (var o = a.width, l = a.height, h = r.decode._getBPP(a), v = h >> 3, u = Math.ceil(o * h / 8), f = new Uint8Array(l * u), m = 0, c = [0, 0, 4, 0, 2, 0, 1], p = [0, 4, 0, 2, 0, 1, 0], k = [8, 8, 8, 4, 4, 2, 2], g = [8, 8, 4, 4, 2, 2, 1], b = 0; b < 7; ) {
            for (var C = k[b], A = g[b], D = 0, L = 0, T = c[b]; T < l; )
              T += C, L++;
            for (var P = p[b]; P < o; )
              P += A, D++;
            var U = Math.ceil(D * h / 8);
            r.decode._filterZero(i, a, m, D, L);
            for (var K = 0, B = c[b]; B < l; ) {
              for (var X = p[b], H = m + K * U << 3; X < o; ) {
                if (h == 1) {
                  var _ = i[H >> 3];
                  _ = _ >> 7 - (H & 7) & 1, f[B * u + (X >> 3)] |= _ << 7 - ((X & 3) << 0);
                }
                if (h == 2) {
                  var _ = i[H >> 3];
                  _ = _ >> 6 - (H & 7) & 3, f[B * u + (X >> 2)] |= _ << 6 - ((X & 3) << 1);
                }
                if (h == 4) {
                  var _ = i[H >> 3];
                  _ = _ >> 4 - (H & 7) & 15, f[B * u + (X >> 1)] |= _ << 4 - ((X & 1) << 2);
                }
                if (h >= 8)
                  for (var E = B * u + X * v, R = 0; R < v; R++) f[E + R] = i[(H >> 3) + R];
                H += h, X += A;
              }
              K++, B += C;
            }
            D * L != 0 && (m += L * (1 + U)), b = b + 1;
          }
          return f;
        }, r.decode._getBPP = function(i) {
          var a = [1, null, 3, 1, 2, null, 4][i.ctype];
          return a * i.depth;
        }, r.decode._filterZero = function(i, a, o, l, h) {
          var v = r.decode._getBPP(a), u = Math.ceil(l * v / 8), f = r.decode._paeth;
          v = Math.ceil(v / 8);
          for (var m = 0; m < h; m++) {
            var c = o + m * u, p = c + m + 1, k = i[p - 1];
            if (k == 0) for (var g = 0; g < u; g++) i[c + g] = i[p + g];
            else if (k == 1) {
              for (var g = 0; g < v; g++) i[c + g] = i[p + g];
              for (var g = v; g < u; g++) i[c + g] = i[p + g] + i[c + g - v] & 255;
            } else if (m == 0) {
              for (var g = 0; g < v; g++) i[c + g] = i[p + g];
              if (k == 2) for (var g = v; g < u; g++) i[c + g] = i[p + g] & 255;
              if (k == 3) for (var g = v; g < u; g++) i[c + g] = i[p + g] + (i[c + g - v] >> 1) & 255;
              if (k == 4) for (var g = v; g < u; g++) i[c + g] = i[p + g] + f(i[c + g - v], 0, 0) & 255;
            } else {
              if (k == 2)
                for (var g = 0; g < u; g++) i[c + g] = i[p + g] + i[c + g - u] & 255;
              if (k == 3) {
                for (var g = 0; g < v; g++) i[c + g] = i[p + g] + (i[c + g - u] >> 1) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[p + g] + (i[c + g - u] + i[c + g - v] >> 1) & 255;
              }
              if (k == 4) {
                for (var g = 0; g < v; g++) i[c + g] = i[p + g] + f(0, i[c + g - u], 0) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[p + g] + f(i[c + g - v], i[c + g - u], i[c + g - v - u]) & 255;
              }
            }
          }
          return i;
        }, r.decode._paeth = function(i, a, o) {
          var l = i + a - o, h = Math.abs(l - i), v = Math.abs(l - a), u = Math.abs(l - o);
          return h <= v && h <= u ? i : v <= u ? a : o;
        }, r.decode._IHDR = function(i, a, o) {
          var l = r._bin;
          o.width = l.readUint(i, a), a += 4, o.height = l.readUint(i, a), a += 4, o.depth = i[a], a++, o.ctype = i[a], a++, o.compress = i[a], a++, o.filter = i[a], a++, o.interlace = i[a], a++;
        }, r._bin = {
          nextZero: function(i, a) {
            for (; i[a] != 0; ) a++;
            return a;
          },
          readUshort: function(i, a) {
            return i[a] << 8 | i[a + 1];
          },
          writeUshort: function(i, a, o) {
            i[a] = o >> 8 & 255, i[a + 1] = o & 255;
          },
          readUint: function(i, a) {
            return i[a] * (256 * 256 * 256) + (i[a + 1] << 16 | i[a + 2] << 8 | i[a + 3]);
          },
          writeUint: function(i, a, o) {
            i[a] = o >> 24 & 255, i[a + 1] = o >> 16 & 255, i[a + 2] = o >> 8 & 255, i[a + 3] = o & 255;
          },
          readASCII: function(i, a, o) {
            for (var l = "", h = 0; h < o; h++) l += String.fromCharCode(i[a + h]);
            return l;
          },
          writeASCII: function(i, a, o) {
            for (var l = 0; l < o.length; l++) i[a + l] = o.charCodeAt(l);
          },
          readBytes: function(i, a, o) {
            for (var l = [], h = 0; h < o; h++) l.push(i[a + h]);
            return l;
          },
          pad: function(i) {
            return i.length < 2 ? "0" + i : i;
          },
          readUTF8: function(i, a, o) {
            for (var l = "", h, v = 0; v < o; v++) l += "%" + r._bin.pad(i[a + v].toString(16));
            try {
              h = decodeURIComponent(l);
            } catch {
              return r._bin.readASCII(i, a, o);
            }
            return h;
          }
        }, r._copyTile = function(i, a, o, l, h, v, u, f, m) {
          for (var c = Math.min(a, h), p = Math.min(o, v), k = 0, g = 0, b = 0; b < p; b++)
            for (var C = 0; C < c; C++)
              if (u >= 0 && f >= 0 ? (k = b * a + C << 2, g = (f + b) * h + u + C << 2) : (k = (-f + b) * a - u + C << 2, g = b * h + C << 2), m == 0)
                l[g] = i[k], l[g + 1] = i[k + 1], l[g + 2] = i[k + 2], l[g + 3] = i[k + 3];
              else if (m == 1) {
                var A = i[k + 3] * 0.00392156862745098, D = i[k] * A, L = i[k + 1] * A, T = i[k + 2] * A, P = l[g + 3] * (1 / 255), U = l[g] * P, K = l[g + 1] * P, B = l[g + 2] * P, X = 1 - A, H = A + P * X, _ = H == 0 ? 0 : 1 / H;
                l[g + 3] = 255 * H, l[g + 0] = (D + U * X) * _, l[g + 1] = (L + K * X) * _, l[g + 2] = (T + B * X) * _;
              } else if (m == 2) {
                var A = i[k + 3], D = i[k], L = i[k + 1], T = i[k + 2], P = l[g + 3], U = l[g], K = l[g + 1], B = l[g + 2];
                A == P && D == U && L == K && T == B ? (l[g] = 0, l[g + 1] = 0, l[g + 2] = 0, l[g + 3] = 0) : (l[g] = D, l[g + 1] = L, l[g + 2] = T, l[g + 3] = A);
              } else if (m == 3) {
                var A = i[k + 3], D = i[k], L = i[k + 1], T = i[k + 2], P = l[g + 3], U = l[g], K = l[g + 1], B = l[g + 2];
                if (A == P && D == U && L == K && T == B) continue;
                if (A < 220 && P > 20) return !1;
              }
          return !0;
        }, r.encode = function(i, a, o, l, h, v) {
          l == null && (l = 0), v == null && (v = !1);
          for (var u = new Uint8Array(i[0].byteLength * i.length + 100), f = [137, 80, 78, 71, 13, 10, 26, 10], m = 0; m < 8; m++) u[m] = f[m];
          var c = 8, p = r._bin, k = r.crc.crc, g = p.writeUint, b = p.writeUshort, C = p.writeASCII, A = r.encode.compressPNG(i, a, o, l, v);
          g(u, c, 13), c += 4, C(u, c, "IHDR"), c += 4, g(u, c, a), c += 4, g(u, c, o), c += 4, u[c] = A.depth, c++, u[c] = A.ctype, c++, u[c] = 0, c++, u[c] = 0, c++, u[c] = 0, c++, g(u, c, k(u, c - 17, 17)), c += 4, g(u, c, 1), c += 4, C(u, c, "sRGB"), c += 4, u[c] = 1, c++, g(u, c, k(u, c - 5, 5)), c += 4;
          var D = i.length > 1;
          if (D && (g(u, c, 8), c += 4, C(u, c, "acTL"), c += 4, g(u, c, i.length), c += 4, g(u, c, 0), c += 4, g(u, c, k(u, c - 12, 12)), c += 4), A.ctype == 3) {
            var L = A.plte.length;
            g(u, c, L * 3), c += 4, C(u, c, "PLTE"), c += 4;
            for (var m = 0; m < L; m++) {
              var T = m * 3, P = A.plte[m], U = P & 255, K = P >> 8 & 255, B = P >> 16 & 255;
              u[c + T + 0] = U, u[c + T + 1] = K, u[c + T + 2] = B;
            }
            if (c += L * 3, g(u, c, k(u, c - L * 3 - 4, L * 3 + 4)), c += 4, A.gotAlpha) {
              g(u, c, L), c += 4, C(u, c, "tRNS"), c += 4;
              for (var m = 0; m < L; m++) u[c + m] = A.plte[m] >> 24 & 255;
              c += L, g(u, c, k(u, c - L - 4, L + 4)), c += 4;
            }
          }
          for (var X = 0, H = 0; H < A.frames.length; H++) {
            var _ = A.frames[H];
            D && (g(u, c, 26), c += 4, C(u, c, "fcTL"), c += 4, g(u, c, X++), c += 4, g(u, c, _.rect.width), c += 4, g(u, c, _.rect.height), c += 4, g(u, c, _.rect.x), c += 4, g(u, c, _.rect.y), c += 4, b(u, c, h[H]), c += 2, b(u, c, 1e3), c += 2, u[c] = _.dispose, c++, u[c] = _.blend, c++, g(u, c, k(u, c - 30, 30)), c += 4);
            var E = _.cimg, L = E.length;
            g(u, c, L + (H == 0 ? 0 : 4)), c += 4;
            var R = c;
            C(u, c, H == 0 ? "IDAT" : "fdAT"), c += 4, H != 0 && (g(u, c, X++), c += 4);
            for (var m = 0; m < L; m++) u[c + m] = E[m];
            c += L, g(u, c, k(u, R, c - R)), c += 4;
          }
          return g(u, c, 0), c += 4, C(u, c, "IEND"), c += 4, g(u, c, k(u, c - 4, 4)), c += 4, u.buffer.slice(0, c);
        }, r.encode.compressPNG = function(i, a, o, l, h) {
          for (var v = r.encode.compress(i, a, o, l, !1, h), u = 0; u < i.length; u++) {
            var f = v.frames[u];
            f.rect.width;
            var m = f.rect.height, c = f.bpl, p = f.bpp, k = new Uint8Array(m * c + m);
            f.cimg = r.encode._filterZero(f.img, m, p, c, k);
          }
          return v;
        }, r.encode.compress = function(i, a, o, l, h, v) {
          v == null && (v = !1);
          for (var u = 6, f = 8, m = 4, c = 255, p = 0; p < i.length; p++)
            for (var k = new Uint8Array(i[p]), g = k.length, b = 0; b < g; b += 4) c &= k[b + 3];
          var C = c != 255, A = {}, D = [];
          if (i.length != 0 && (A[0] = 0, D.push(0), l != 0 && l--), l != 0) {
            var L = r.quantize(i, l, h);
            i = L.bufs;
            for (var b = 0; b < L.plte.length; b++) {
              var T = L.plte[b].est.rgba;
              A[T] == null && (A[T] = D.length, D.push(T));
            }
          } else
            for (var p = 0; p < i.length; p++)
              for (var P = new Uint32Array(i[p]), g = P.length, b = 0; b < g; b++) {
                var T = P[b];
                if ((b < a || T != P[b - 1] && T != P[b - a]) && A[T] == null && (A[T] = D.length, D.push(T), D.length >= 300))
                  break;
              }
          var U = C ? h : !1, K = D.length;
          K <= 256 && v == !1 && (K <= 2 ? f = 1 : K <= 4 ? f = 2 : K <= 16 ? f = 4 : f = 8, h && (f = 8), C = !0);
          for (var B = [], p = 0; p < i.length; p++) {
            var X = new Uint8Array(i[p]), H = new Uint32Array(X.buffer), _ = 0, E = 0, R = a, V = o, q = 0;
            if (p != 0 && !U) {
              for (var O = h || p == 1 || B[B.length - 2].dispose == 2 ? 1 : 2, Q = 0, ae = 1e9, le = 0; le < O; le++) {
                for (var ce = new Uint8Array(i[p - 1 - le]), me = new Uint32Array(i[p - 1 - le]), $e = a, xe = o, fe = -1, be = -1, _e = 0; _e < o; _e++) for (var Me = 0; Me < a; Me++) {
                  var b = _e * a + Me;
                  H[b] != me[b] && (Me < $e && ($e = Me), Me > fe && (fe = Me), _e < xe && (xe = _e), _e > be && (be = _e));
                }
                var qe = fe == -1 ? 1 : (fe - $e + 1) * (be - xe + 1);
                qe < ae && (ae = qe, Q = le, fe == -1 ? (_ = E = 0, R = V = 1) : (_ = $e, E = xe, R = fe - $e + 1, V = be - xe + 1));
              }
              var ce = new Uint8Array(i[p - 1 - Q]);
              Q == 1 && (B[B.length - 1].dispose = 2);
              var se = new Uint8Array(R * V * 4);
              new Uint32Array(se.buffer), r._copyTile(ce, a, o, se, R, V, -_, -E, 0), r._copyTile(X, a, o, se, R, V, -_, -E, 3) ? (r._copyTile(X, a, o, se, R, V, -_, -E, 2), q = 1) : (r._copyTile(X, a, o, se, R, V, -_, -E, 0), q = 0), X = se, H = new Uint32Array(X.buffer);
            }
            var pe = 4 * R;
            if (K <= 256 && v == !1) {
              pe = Math.ceil(f * R / 8);
              for (var se = new Uint8Array(pe * V), _e = 0; _e < V; _e++) {
                var b = _e * pe, Pe = _e * R;
                if (f == 8) for (var Me = 0; Me < R; Me++) se[b + Me] = A[H[Pe + Me]];
                else if (f == 4) for (var Me = 0; Me < R; Me++) se[b + (Me >> 1)] |= A[H[Pe + Me]] << 4 - (Me & 1) * 4;
                else if (f == 2) for (var Me = 0; Me < R; Me++) se[b + (Me >> 2)] |= A[H[Pe + Me]] << 6 - (Me & 3) * 2;
                else if (f == 1) for (var Me = 0; Me < R; Me++) se[b + (Me >> 3)] |= A[H[Pe + Me]] << 7 - (Me & 7) * 1;
              }
              X = se, u = 3, m = 1;
            } else if (C == !1 && i.length == 1) {
              for (var se = new Uint8Array(R * V * 3), He = R * V, b = 0; b < He; b++) {
                var Ue = b * 3, ze = b * 4;
                se[Ue] = X[ze], se[Ue + 1] = X[ze + 1], se[Ue + 2] = X[ze + 2];
              }
              X = se, u = 2, m = 3, pe = 3 * R;
            }
            B.push({ rect: { x: _, y: E, width: R, height: V }, img: X, bpl: pe, bpp: m, blend: q, dispose: U ? 1 : 0 });
          }
          return { ctype: u, depth: f, plte: D, gotAlpha: C, frames: B };
        }, r.encode._filterZero = function(i, a, o, l, h) {
          for (var v = [], u = 0; u < 5; u++)
            if (!(a * l > 5e5 && (u == 2 || u == 3 || u == 4))) {
              for (var f = 0; f < a; f++) r.encode._filterLine(h, i, f, l, o, u);
              if (v.push(s.deflate(h)), o == 1) break;
            }
          for (var m, c = 1e9, p = 0; p < v.length; p++) v[p].length < c && (m = p, c = v[p].length);
          return v[m];
        }, r.encode._filterLine = function(i, a, o, l, h, v) {
          var u = o * l, f = u + o, m = r.decode._paeth;
          if (i[f] = v, f++, v == 0) for (var c = 0; c < l; c++) i[f + c] = a[u + c];
          else if (v == 1) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            for (var c = h; c < l; c++) i[f + c] = a[u + c] - a[u + c - h] + 256 & 255;
          } else if (o == 0) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            if (v == 2) for (var c = h; c < l; c++) i[f + c] = a[u + c];
            if (v == 3) for (var c = h; c < l; c++) i[f + c] = a[u + c] - (a[u + c - h] >> 1) + 256 & 255;
            if (v == 4) for (var c = h; c < l; c++) i[f + c] = a[u + c] - m(a[u + c - h], 0, 0) + 256 & 255;
          } else {
            if (v == 2)
              for (var c = 0; c < l; c++) i[f + c] = a[u + c] + 256 - a[u + c - l] & 255;
            if (v == 3) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - (a[u + c - l] >> 1) & 255;
              for (var c = h; c < l; c++) i[f + c] = a[u + c] + 256 - (a[u + c - l] + a[u + c - h] >> 1) & 255;
            }
            if (v == 4) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - m(0, a[u + c - l], 0) & 255;
              for (var c = h; c < l; c++) i[f + c] = a[u + c] + 256 - m(a[u + c - h], a[u + c - l], a[u + c - h - l]) & 255;
            }
          }
        }, r.crc = {
          table: (function() {
            for (var i = new Uint32Array(256), a = 0; a < 256; a++) {
              for (var o = a, l = 0; l < 8; l++)
                o & 1 ? o = 3988292384 ^ o >>> 1 : o = o >>> 1;
              i[a] = o;
            }
            return i;
          })(),
          update: function(i, a, o, l) {
            for (var h = 0; h < l; h++) i = r.crc.table[(i ^ a[o + h]) & 255] ^ i >>> 8;
            return i;
          },
          crc: function(i, a, o) {
            return r.crc.update(4294967295, i, a, o) ^ 4294967295;
          }
        }, r.quantize = function(i, a, o) {
          for (var l = [], h = 0, v = 0; v < i.length; v++)
            l.push(r.encode.alphaMul(new Uint8Array(i[v]), o)), h += i[v].byteLength;
          for (var u = new Uint8Array(h), f = new Uint32Array(u.buffer), m = 0, v = 0; v < l.length; v++) {
            for (var c = l[v], p = c.length, k = 0; k < p; k++) u[m + k] = c[k];
            m += p;
          }
          var g = { i0: 0, i1: u.length, bst: null, est: null, tdst: 0, left: null, right: null };
          g.bst = r.quantize.stats(u, g.i0, g.i1), g.est = r.quantize.estats(g.bst);
          for (var b = [g]; b.length < a; ) {
            for (var C = 0, A = 0, v = 0; v < b.length; v++) b[v].est.L > C && (C = b[v].est.L, A = v);
            if (C < 1e-3) break;
            var D = b[A], L = r.quantize.splitPixels(u, f, D.i0, D.i1, D.est.e, D.est.eMq255), T = { i0: D.i0, i1: L, bst: null, est: null, tdst: 0, left: null, right: null };
            T.bst = r.quantize.stats(u, T.i0, T.i1), T.est = r.quantize.estats(T.bst);
            var P = { i0: L, i1: D.i1, bst: null, est: null, tdst: 0, left: null, right: null };
            P.bst = { R: [], m: [], N: D.bst.N - T.bst.N };
            for (var v = 0; v < 16; v++) P.bst.R[v] = D.bst.R[v] - T.bst.R[v];
            for (var v = 0; v < 4; v++) P.bst.m[v] = D.bst.m[v] - T.bst.m[v];
            P.est = r.quantize.estats(P.bst), D.left = T, D.right = P, b[A] = T, b.push(P);
          }
          b.sort(function(O, Q) {
            return Q.bst.N - O.bst.N;
          });
          for (var U = 0; U < l.length; U++) {
            for (var K = r.quantize.planeDst, B = new Uint8Array(l[U].buffer), X = new Uint32Array(l[U].buffer), H = B.length, v = 0; v < H; v += 4) {
              for (var _ = B[v] * 0.00392156862745098, E = B[v + 1] * (1 / 255), R = B[v + 2] * (1 / 255), V = B[v + 3] * (1 / 255), q = g; q.left; ) q = K(q.est, _, E, R, V) <= 0 ? q.left : q.right;
              X[v >> 2] = q.est.rgba;
            }
            l[U] = X.buffer;
          }
          return { bufs: l, plte: b };
        }, r.quantize.getNearest = function(i, a, o, l, h) {
          if (i.left == null)
            return i.tdst = r.quantize.dist(i.est.q, a, o, l, h), i;
          var v = r.quantize.planeDst(i.est, a, o, l, h), u = i.left, f = i.right;
          v > 0 && (u = i.right, f = i.left);
          var m = r.quantize.getNearest(u, a, o, l, h);
          if (m.tdst <= v * v) return m;
          var c = r.quantize.getNearest(f, a, o, l, h);
          return c.tdst < m.tdst ? c : m;
        }, r.quantize.planeDst = function(i, a, o, l, h) {
          var v = i.e;
          return v[0] * a + v[1] * o + v[2] * l + v[3] * h - i.eMq;
        }, r.quantize.dist = function(i, a, o, l, h) {
          var v = a - i[0], u = o - i[1], f = l - i[2], m = h - i[3];
          return v * v + u * u + f * f + m * m;
        }, r.quantize.splitPixels = function(i, a, o, l, h, v) {
          var u = r.quantize.vecDot;
          for (l -= 4; o < l; ) {
            for (; u(i, o, h) <= v; ) o += 4;
            for (; u(i, l, h) > v; ) l -= 4;
            if (o >= l) break;
            var f = a[o >> 2];
            a[o >> 2] = a[l >> 2], a[l >> 2] = f, o += 4, l -= 4;
          }
          for (; u(i, o, h) > v; ) o -= 4;
          return o + 4;
        }, r.quantize.vecDot = function(i, a, o) {
          return i[a] * o[0] + i[a + 1] * o[1] + i[a + 2] * o[2] + i[a + 3] * o[3];
        }, r.quantize.stats = function(i, a, o) {
          for (var l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], h = [0, 0, 0, 0], v = o - a >> 2, u = a; u < o; u += 4) {
            var f = i[u] * 0.00392156862745098, m = i[u + 1] * (1 / 255), c = i[u + 2] * (1 / 255), p = i[u + 3] * (1 / 255);
            h[0] += f, h[1] += m, h[2] += c, h[3] += p, l[0] += f * f, l[1] += f * m, l[2] += f * c, l[3] += f * p, l[5] += m * m, l[6] += m * c, l[7] += m * p, l[10] += c * c, l[11] += c * p, l[15] += p * p;
          }
          return l[4] = l[1], l[8] = l[2], l[12] = l[3], l[9] = l[6], l[13] = l[7], l[14] = l[11], { R: l, m: h, N: v };
        }, r.quantize.estats = function(i) {
          var a = i.R, o = i.m, l = i.N, h = o[0], v = o[1], u = o[2], f = o[3], m = l == 0 ? 0 : 1 / l, c = [
            a[0] - h * h * m,
            a[1] - h * v * m,
            a[2] - h * u * m,
            a[3] - h * f * m,
            a[4] - v * h * m,
            a[5] - v * v * m,
            a[6] - v * u * m,
            a[7] - v * f * m,
            a[8] - u * h * m,
            a[9] - u * v * m,
            a[10] - u * u * m,
            a[11] - u * f * m,
            a[12] - f * h * m,
            a[13] - f * v * m,
            a[14] - f * u * m,
            a[15] - f * f * m
          ], p = c, k = r.M4, g = [0.5, 0.5, 0.5, 0.5], b = 0, C = 0;
          if (l != 0)
            for (var A = 0; A < 10 && (g = k.multVec(p, g), C = Math.sqrt(k.dot(g, g)), g = k.sml(1 / C, g), !(Math.abs(C - b) < 1e-9)); A++)
              b = C;
          var D = [h * m, v * m, u * m, f * m], L = k.dot(k.sml(255, D), g), T = D[3] < 1e-3 ? 0 : 1 / D[3];
          return {
            Cov: c,
            q: D,
            e: g,
            L: b,
            eMq255: L,
            eMq: k.dot(g, D),
            rgba: (Math.round(255 * D[3]) << 24 | Math.round(255 * D[2] * T) << 16 | Math.round(255 * D[1] * T) << 8 | Math.round(255 * D[0] * T) << 0) >>> 0
          };
        }, r.M4 = {
          multVec: function(i, a) {
            return [
              i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3],
              i[4] * a[0] + i[5] * a[1] + i[6] * a[2] + i[7] * a[3],
              i[8] * a[0] + i[9] * a[1] + i[10] * a[2] + i[11] * a[3],
              i[12] * a[0] + i[13] * a[1] + i[14] * a[2] + i[15] * a[3]
            ];
          },
          dot: function(i, a) {
            return i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3];
          },
          sml: function(i, a) {
            return [i * a[0], i * a[1], i * a[2], i * a[3]];
          }
        }, r.encode.alphaMul = function(i, a) {
          for (var o = new Uint8Array(i.length), l = i.length >> 2, h = 0; h < l; h++) {
            var v = h << 2, u = i[v + 3];
            a && (u = u < 128 ? 0 : 255);
            var f = u * (1 / 255);
            o[v + 0] = i[v + 0] * f, o[v + 1] = i[v + 1] * f, o[v + 2] = i[v + 2] * f, o[v + 3] = u;
          }
          return o;
        };
      })(t, n);
    })();
  })(Cr)), Cr.exports;
}
var _h = Sh();
const Ch = /* @__PURE__ */ fh(_h), Eh = () => pa() ? Na("NuxtImg") : "img", Th = ["alt", "src"], $g = /* @__PURE__ */ Se({
  __name: "LcImage",
  props: {
    alt: {},
    aspectRatio: {},
    blurHash: {},
    densities: {},
    fetchpriority: { default: "low" },
    height: {},
    loading: { type: Boolean },
    preload: { type: Boolean },
    src: {},
    width: {}
  },
  emits: ["error", "load"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = ot("wrapper"), i = Eh(), a = ge(!0), o = W(
      () => typeof e.aspectRatio == "number" ? e.aspectRatio : (Math.round(e.width) / Math.round(e.height)).toFixed(2)
    ), l = W(() => s.value?.clientHeight ?? 0), h = W(() => s.value?.clientWidth ?? 0), v = W(() => e.loading || a.value), u = W(() => {
      if (!e.blurHash) return;
      const m = dh(e.blurHash, 32, 32), c = new Uint8Array(m), p = Ch.encode([c.buffer], 32, 32, 256);
      return "data:image/png;base64," + rh(p);
    }), f = () => {
      a.value = !1, r("load");
    };
    return t({
      clientHeight: l,
      clientWidth: h
    }), (m, c) => ($(), Z("div", {
      ref: "wrapper",
      class: "lc-image",
      style: Ct({ "--image-aspect-ratio": o.value })
    }, [
      ($(), ke(zt(j(i)), Ae({ key: "image" }, {
        alt: e.alt,
        densities: e.densities,
        fetchpriority: e.fetchpriority,
        height: e.height,
        preload: e.preload,
        src: e.src,
        width: e.width
      }, {
        class: "lc-image__image",
        loading: e.fetchpriority === "high" ? void 0 : "lazy",
        onError: c[0] || (c[0] = (p) => m.$emit("error")),
        onLoad: f
      }), null, 16, ["loading"])),
      u.value ? ($(), ke(wn, {
        key: 0,
        name: "lc-image__transition"
      }, {
        default: Te(() => [
          Qt(ne("img", Ae({ key: "placeholder" }, { height: e.height, width: e.width }, {
            alt: e.alt,
            class: "lc-image__placeholder",
            src: u.value
          }), null, 16, Th), [
            [li, v.value]
          ])
        ]),
        _: 1
      })) : de("", !0)
    ], 4));
  }
}), Ah = {
  key: 1,
  class: "lc-info-text__content"
}, Lh = {
  key: 0,
  class: "lc-info-text__text"
}, Ig = /* @__PURE__ */ Se({
  __name: "LcInfoText",
  props: {
    headline: {},
    icon: { default: "info" },
    iconAlignment: { default: "top" },
    iconSize: { default: "medium" },
    size: { default: "medium" },
    text: {}
  },
  setup(e) {
    const t = An(), n = W(() => [
      "lc-info-text",
      {
        [`lc-info-text--icon-align-${e.iconAlignment}`]: !0,
        [`lc-info-text--size-${e.size}`]: !0
      }
    ]), r = W(() => [
      "lc-info-text__headline",
      {
        "lc-info-text__headline--with-margin": !!e.text || !!t.default
      }
    ]);
    return (s, i) => ($(), Z("article", {
      class: ye(n.value)
    }, [
      Fe(j(Ke), {
        name: e.icon,
        size: e.iconSize
      }, null, 8, ["name", "size"]),
      ne("section", null, [
        e.headline ? ($(), Z("span", {
          key: 0,
          class: ye(r.value)
        }, Oe(e.headline), 3)) : de("", !0),
        e.text || s.$slots.default ? ($(), Z("div", Ah, [
          ve(s.$slots, "default", {}, () => [
            e.text ? ($(), Z("p", Lh, Oe(e.text), 1)) : de("", !0)
          ])
        ])) : de("", !0)
      ])
    ], 2));
  }
}), Dg = ["center", "top"], Mg = ["medium", "small"], $h = { class: "lc-link-list" }, Og = /* @__PURE__ */ Se({
  __name: "LcLinkList",
  setup(e) {
    return (t, n) => ($(), Z("ul", $h, [
      ve(t.$slots, "default")
    ]));
  }
}), Ih = { key: 0 }, Dh = { class: "lc-link-list-item__headline" }, Mh = {
  key: 0,
  class: "lc-link-list-item__text"
}, Rg = /* @__PURE__ */ Se({
  __name: "LcLinkListItem",
  props: {
    href: {},
    target: {},
    to: {},
    headline: {},
    icon: {},
    text: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-link-list-item",
      {
        "lc-link-list-item--headline-only": !e.text
      }
    ]);
    return (n, r) => ($(), Z("li", {
      class: ye(t.value)
    }, [
      Fe(j(ci), Ae({ href: e.href, target: e.target, to: e.to }, { class: "lc-link-list-item__link" }), {
        default: Te(() => [
          n.$slots.default ? ($(), Z("div", Ih, [
            ve(n.$slots, "default")
          ])) : ($(), Z(Xe, { key: 1 }, [
            e.icon ? ($(), ke(j(Ke), {
              key: 0,
              name: e.icon
            }, null, 8, ["name"])) : de("", !0),
            ne("div", null, [
              ne("span", Dh, Oe(e.headline), 1),
              e.text ? ($(), Z("p", Mh, Oe(e.text), 1)) : de("", !0)
            ])
          ], 64))
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), Oh = "data:image/svg+xml,%3csvg%20id='eSvZIJXzBLn1'%20width='16'%20height='16'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2016%2016'%20shape-rendering='geometricPrecision'%20text-rendering='geometricPrecision'%3e%3cstyle%3e%3c![CDATA[%23eSvZIJXzBLn2_to%20{animation:%20eSvZIJXzBLn2_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_to__to%20{%200%25%20{transform:%20translate(7.980026px,1.350002px)}%2024%25%20{transform:%20translate(7.980026px,1.350002px)}%2025%25%20{transform:%20translate(7.980026px,2.07px)}%2028%25%20{transform:%20translate(7.980026px,1px)}%2032%25%20{transform:%20translate(9.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20translate(5.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20translate(8.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20translate(6.980026px,1px)}%2044%25%20{transform:%20translate(7.999896px,1.175001px)}%2048%25%20{transform:%20translate(7.980026px,1.350002px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2052%25%20{transform:%20translate(7.980026px,1.35px)}%20100%25%20{transform:%20translate(7.980026px,1.35px)}}%20%23eSvZIJXzBLn2_tr%20{animation:%20eSvZIJXzBLn2_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2028%25%20{transform:%20rotate(0deg)}%2032%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20rotate(-8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20rotate(-8deg)}%2044%25%20{transform:%20rotate(0deg)}%20100%25%20{transform:%20rotate(0deg)}}%20%23eSvZIJXzBLn3_to%20{animation:%20eSvZIJXzBLn3_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn3_tr%20{animation:%20eSvZIJXzBLn3_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn6_to%20{animation:%20eSvZIJXzBLn6_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn6_tr%20{animation:%20eSvZIJXzBLn6_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%206%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn9_to%20{animation:%20eSvZIJXzBLn9_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn9_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000025px,9.6px);animation-timing-function:%20cubic-bezier(0.42,0,1,1)}%2044%25%20{transform:%20translate(8.000025px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}]]%3e%3c/style%3e%3cg%20id='eSvZIJXzBLn2_to'%20transform='translate(7.980026,1.350002)'%3e%3cg%20id='eSvZIJXzBLn2_tr'%20transform='rotate(0)'%3e%3cpath%20d='M6.06888,2.13247c.8-.2,1.4-.26667,1.93333-.26667s1.13333.06667,1.86667.26667c.33332.13333.73332-.13333.80002-.46667.1333-.33333-.1334-.733329-.4667-.799996-.77705-.253981-1.07173-.333333-2.19999-.333333-.73333,0-1.40328.079352-2.26667.333333-.33333.066667-.53333.399996-.46666.799996.06666.33334.46666.53334.8.46667Z'%20transform='translate(-7.980026,-1.350002)'%20fill='%23394e8e'/%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn3_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn3_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='4.09313'%20rx='0.638'%20ry='0.638'%20transform='translate(7.36206%205.73901)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn6_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn6_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='3.48663'%20rx='0.638'%20ry='0.638'%20transform='matrix(0-1%201%200%205.14111%209.83799)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn9_to'%20transform='translate(8.000025,9.2)'%3e%3cpath%20d='M8.00005,14.2C10.7615,14.2,13,11.9614,13,9.2s-2.2385-5-4.99995-5-5,2.23858-5,5s2.23858,5,5,5Zm0,1.2C11.4242,15.4,14.2,12.6242,14.2,9.2s-2.7758-6.2-6.19995-6.2-6.2,2.77583-6.2,6.2s2.77583,6.2,6.2,6.2Z'%20transform='translate(-8.000025,-9.2)'%20clip-rule='evenodd'%20fill='%23394e8e'%20fill-rule='evenodd'/%3e%3c/g%3e%3c/svg%3e", Rh = { class: "lc-lottery-cutoff-time__headline" }, Fh = ["src"], Nh = { class: "lc-lottery-cutoff-time__time-to-cutoff" }, Ph = { class: "lc-lottery-cutoff-time__time-is-almost-up" }, Bh = {
  key: 0,
  class: "lc-lottery-cutoff-time__divider"
}, zh = { class: "lc-lottery-cutoff-time__countdown-wrapper" }, Hl = /* @__PURE__ */ Se({
  __name: "LcLotteryCutoffTime",
  props: {
    countdownVariant: { default: "default" },
    cutoffTime: {},
    locale: { default: () => je.general.locale },
    nextCutoffTime: {},
    singleLine: { type: Boolean },
    startAnimationTime: { default: 90 },
    textCutoffTime: { default: () => je.lcLotteryCutoffTime.textCutoffTime },
    textTimeIsAlmostUp: { default: () => je.lcLotteryCutoffTime.textTimeIsAlmostUp },
    textTimeToCutoff: { default: () => je.lcLotteryCutoffTime.textTimeToCutoff },
    variant: { default: "default" }
  },
  emits: ["cutoff-time-reached"],
  setup(e, { emit: t }) {
    const n = t, r = ge(), s = Bo(() => /* @__PURE__ */ new Date()), i = W(() => [
      "lc-lottery-cutoff-time",
      `lc-lottery-cutoff-time--variant-${e.variant}`,
      {
        "lc-lottery-cutoff-time--animated": h.value,
        "lc-lottery-cutoff-time--single-line": e.singleLine
      }
    ]), a = W(() => new Date(e.cutoffTime)), o = W(
      () => Vo({
        date: v.value,
        format: "drawingShort",
        locale: e.locale
      })
    ), l = W(() => u("days") === 0), h = W(() => {
      const m = u("minutes");
      return l.value && m ? m < e.startAnimationTime : !1;
    }), v = W({
      get: () => r.value ?? new Date(e.cutoffTime),
      set: (m) => {
        r.value = m;
      }
    }), u = (m) => {
      if (!oi(a.value)) return null;
      const { days: c = 0, hours: p = 0, minutes: k = 0 } = zo(s.value, a.value);
      switch (m) {
        case "days":
          return c;
        case "minutes":
          return c * 24 + p * 60 + k;
      }
    }, f = () => {
      n("cutoff-time-reached"), Eo(a.value) && e.nextCutoffTime && (v.value = new Date(e.nextCutoffTime));
    };
    return (m, c) => ($(), Z("div", {
      class: ye(i.value)
    }, [
      ne("span", Rh, [
        h.value ? ($(), Z("img", {
          key: 0,
          alt: "",
          height: "16",
          src: j(Oh),
          width: "16"
        }, null, 8, Fh)) : ($(), ke(j(Ke), {
          key: 1,
          name: l.value ? "alarm" : "time",
          size: "small"
        }, null, 8, ["name"])),
        ve(m.$slots, "title", {}, () => [
          ne("span", Nh, Oe(l.value ? e.textTimeToCutoff : e.textCutoffTime), 1),
          ne("span", Ph, Oe(e.textTimeIsAlmostUp), 1)
        ])
      ]),
      e.variant === "default" && e.singleLine ? ($(), Z("span", Bh, " : ")) : de("", !0),
      ne("div", zh, [
        l.value ? ($(), ke(j(af), {
          key: 0,
          class: "lc-lottery-cutoff-time__countdown",
          "expires-at": v.value,
          variant: e.countdownVariant,
          onExpired: f,
          onUpdate: c[0] || (c[0] = (p) => s.value = /* @__PURE__ */ new Date())
        }, null, 8, ["expires-at", "variant"])) : ($(), ke(j(Lo), Ae({
          key: 1,
          class: "lc-lottery-cutoff-time__date-time"
        }, { locale: e.locale, ...j(gi).drawingShort }, { datetime: v.value }), {
          default: Te(() => [
            xt(Oe(o.value), 1)
          ]),
          _: 1
        }, 16, ["datetime"]))
      ])
    ], 2));
  }
}), Fg = ["default", "expressive"], Vh = {
  key: 0,
  class: "lc-lottery-numbers__icon-wrap"
}, Hh = {
  key: 0,
  class: "lc-lottery-numbers__field-divider"
}, Uh = "extra", qh = /* @__PURE__ */ Se({
  __name: "LcLotteryNumbers",
  props: {
    fields: {},
    listClass: {},
    numberClass: { type: Function },
    rows: {},
    size: { default: "medium" },
    spacing: { default: "medium" }
  },
  setup(e) {
    const t = W(() => [
      "lc-lottery-numbers",
      `lc-lottery-numbers--size-${e.size}`,
      `lc-lottery-numbers--spacing-${e.spacing}`,
      {
        "lc-lottery-numbers--multiple-rows": e.rows
      }
    ]), n = W(() => s.value.flat().length), r = W(() => e.rows ? Math.ceil(n.value / e.rows) : n.value), s = W(
      () => e.fields.map(
        ({ name: i, numbers: a }) => a.map(({ icon: o, ignored: l, matching: h, value: v }) => ({
          empty: !o && !l && (v === void 0 || v === ""),
          icon: o,
          ignored: l,
          matching: h,
          name: i.toLowerCase().replace("_", "-"),
          number: v
        }))
      ).filter((i) => !!i.length)
    );
    return (i, a) => ($(), Z("article", {
      class: ye(t.value),
      style: Ct({ "--items-per-row": r.value })
    }, [
      ne("ol", {
        class: ye(["lc-lottery-numbers__list", e.listClass])
      }, [
        ($(!0), Z(Xe, null, ht(s.value, (o, l) => ($(), Z(Xe, { key: l }, [
          ($(!0), Z(Xe, null, ht(o, ({ empty: h, icon: v, ignored: u, matching: f, name: m, number: c }, p) => ($(), Z(Xe, {
            key: `${l}-${p}`
          }, [
            ne("li", {
              class: "lc-lottery-numbers__list-item",
              style: Ct({
                "--number-bg": `var(--lottery-numbers-${m}-bg)`,
                "--number-border": `var(--lottery-numbers-${m}-border)`,
                "--number-color": `var(--lottery-numbers-${m}-color)`,
                "--number-font-size": `var(--lottery-numbers-${m}-font-size)`,
                "--number-font-weight": `var(--lottery-numbers-${m}-font-weight)`
              })
            }, [
              ve(i.$slots, `highlight-${m}`),
              ne("div", {
                class: ye(["lc-lottery-numbers__number", [
                  {
                    "lc-lottery-numbers__number--empty": h,
                    "lc-lottery-numbers__number--empty-extra": h && m === Uh,
                    "lc-lottery-numbers__number--ignored": u
                  },
                  e.numberClass ? e.numberClass(c, m) : ""
                ]])
              }, [
                f ? ($(), Z("div", Vh, [
                  Fe(j(Ke), {
                    class: "lc-lottery-numbers__icon",
                    name: "checkmark-small"
                  })
                ])) : de("", !0),
                ve(i.$slots, `number-${m}`, Ae({ ref_for: !0 }, { icon: v, number: c }), () => [
                  v ? ($(), ke(j(Ke), {
                    key: 0,
                    name: v
                  }, null, 8, ["name"])) : ($(), Z(Xe, { key: 1 }, [
                    xt(Oe(u ? "X" : c), 1)
                  ], 64))
                ])
              ], 2)
            ], 4),
            l < s.value.length - 1 && p === o.length - 1 && i.$slots["field-divider"] ? ($(), Z("li", Hh, [
              ve(i.$slots, "field-divider")
            ])) : de("", !0)
          ], 64))), 128))
        ], 64))), 128))
      ], 2)
    ], 6));
  }
}), Ng = ["large", "medium", "small"], Pg = ["medium", "small"], Bg = [
  "custom-cell",
  "default",
  "high-frequency",
  "round"
];
var Zt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Home = "Home", e))(Zt || {});
const jh = ["id"], Zh = { class: "lc-lottery-number-selector__label" }, Wh = ["for"], Yh = ["id", "checked", "disabled", "tabindex", "onChange", "onFocusin", "onKeydown"], zg = /* @__PURE__ */ Se({
  __name: "LcLotteryNumberSelector",
  props: {
    allNumbersToggled: { type: Boolean },
    disabled: { type: Boolean },
    fixedColumns: {},
    id: {},
    label: {},
    max: {},
    min: { default: 1 },
    selectableNumbers: {},
    selectableMax: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["complete", "update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Xo(), s = ot("numberInputs"), i = $t(e.id), a = ge(e.fixedColumns ?? 0), o = ge(0), l = W(() => A(o.value)), h = W(
      () => u.value ? c.value : f.value
    ), v = W(() => L(o.value)), u = W(() => e.value.length >= e.selectableMax), f = W(() => {
      const O = Array.from({ length: b.value }, () => []);
      return m.value.map((Q, ae) => {
        O[L(ae)].push(ae);
      }), _(O);
    }), m = W(() => {
      if (e.selectableNumbers?.length)
        return [...e.selectableNumbers];
      if (e.max === void 0)
        throw Error('LcLotteryNumberSelector: provide "max" or "selectableNumbers".');
      if (e.min < 0)
        throw Error('LcLotteryNumberSelector: "min" must be >= 0.');
      if (e.min >= e.max)
        throw Error('LcLotteryNumberSelector: "max" must be greater than "min".');
      return Array.from({ length: e.max - e.min + 1 }, (O, Q) => e.min + Q);
    }), c = W(
      () => f.value.map(
        (O) => O.map(
          (Q) => p.value.includes(Q) ? Q : -1
        )
      )
    ), p = W(() => e.value.map((O) => m.value.indexOf(O))), k = W(() => Math.min(g.value, a.value)), g = W(() => m.value.length), b = W(() => Math.ceil(g.value / k.value)), C = (O) => {
      const Q = h.value.length, ae = h.value[0].length;
      let le = v.value, me = l.value;
      do
        switch (O) {
          case "down":
            le = (le + 1) % Q, le === 0 && (me = (me + 1) % ae);
            break;
          case "left":
            me = (me - 1 + ae) % ae, me === ae - 1 && (le = (le - 1 + Q) % Q);
            break;
          case "right":
            me = (me + 1) % ae, me === 0 && (le = (le + 1) % Q);
            break;
          case "up":
            le = (le - 1 + Q) % Q, le === Q - 1 && (me = (me - 1 + ae) % ae);
            break;
        }
      while (h.value[le][me] === -1);
      return h.value[le][me];
    }, A = (O) => O % k.value, D = (O) => ({
      "lc-lottery-number-selector__number": !0,
      "lc-lottery-number-selector__number--all-checked": e.allNumbersToggled,
      "lc-lottery-number-selector__number--checked": E(O),
      "lc-lottery-number-selector__number--disabled": R(O)
    }), L = (O) => Math.floor(O / k.value), T = () => {
      if (u.value) {
        const ae = f.value[v.value].filter(
          (le) => le > o.value && p.value.includes(le)
        ).reverse();
        if (!ae.length) return;
        o.value = ae[0];
        return;
      }
      const O = f.value[v.value];
      o.value = O.at(-1) ?? 0;
    }, P = () => {
      if (u.value) {
        const ae = f.value[v.value].filter(
          (le) => le < o.value && p.value.includes(le)
        );
        if (!ae.length) return;
        o.value = ae[0];
        return;
      }
      const O = f.value[v.value];
      o.value = O[0];
    }, U = () => {
      o.value = u.value ? p.value[0] : 0;
    }, K = () => {
      const O = p.value.at(-1) ?? 0;
      o.value = u.value ? O : g.value - 1;
    }, B = (O) => {
      tn(O.key, Zt) && (O.preventDefault(), O.stopPropagation(), O.ctrlKey ? X(O.key) : H(O.key));
    }, X = (O) => {
      switch (O) {
        case Zt.End:
          K();
          break;
        case Zt.Home:
          U();
          break;
      }
    }, H = (O) => {
      switch (O) {
        case Zt.ArrowDown:
          o.value = C("down");
          break;
        case Zt.ArrowLeft:
          o.value = C("left");
          break;
        case Zt.ArrowRight:
          o.value = C("right");
          break;
        case Zt.ArrowUp:
          o.value = C("up");
          break;
        case Zt.End:
          T();
          break;
        case Zt.Home:
          P();
          break;
      }
    }, _ = (O) => {
      const Q = Math.max(...O.map((ae) => ae.length));
      return O.map((ae) => {
        const le = [...ae];
        for (; le.length < Q; )
          le.push(-1);
        return le;
      });
    }, E = (O) => e.value.includes(O), R = (O) => e.disabled || !E(O) && u.value || e.allNumbersToggled, V = (O) => {
      const Q = [...e.value], ae = Q.indexOf(O);
      ae > -1 ? Q.splice(ae, 1) : u.value || (Q.push(O), Q.sort((le, me) => m.value.indexOf(le) - m.value.indexOf(me))), n("update:value", Q);
    };
    Be(
      () => e.allNumbersToggled,
      () => {
        const O = e.allNumbersToggled ? m.value : [];
        n("update:value", O);
      }
    ), Be(o, (O) => {
      s.value?.[O].focus();
    }), Be(u, (O) => {
      O && n("complete");
    });
    const q = nc(() => {
      if (e.fixedColumns && e.fixedColumns >= 0) {
        a.value = e.fixedColumns;
        return;
      }
      const O = s.value;
      if (!r || !O?.length) return;
      const Q = O[0].getBoundingClientRect().top;
      let ae = 0;
      for (const le of O) {
        if (le.getBoundingClientRect().top !== Q) break;
        ae++;
      }
      a.value = ae;
    }, 100);
    return Be(() => e.fixedColumns, q), pt(q), qt(window, "resize", q), (O, Q) => ($(), Z("fieldset", Ae(O.$attrs, {
      id: j(i),
      class: [
        "lc-lottery-number-selector",
        `lc-lottery-number-selector--${e.variant}`,
        {
          "lc-lottery-number-selector--fixed-columns": e.fixedColumns && e.fixedColumns >= 0
        }
      ],
      style: {
        "--fixed-columns": e.fixedColumns,
        "--hfg-number-background": "var(--lottery-numbers-extra-bg)",
        "--number-bg": "var(--lottery-numbers-extra-bg)",
        "--round-number-bg": `var(--lottery-number-rounded-${e.id}-bg)`,
        "--round-number-color": `var(--lottery-number-rounded-${e.id}-color)`
      }
    }), [
      ne("legend", Zh, Oe(e.label), 1),
      ($(!0), Z(Xe, null, ht(m.value, (ae, le) => ($(), Z("label", {
        key: ae,
        class: ye(D(ae)),
        for: `gridcell-${A(le)}-${L(le)}-${j(i)}`
      }, [
        ne("input", {
          id: `gridcell-${A(le)}-${L(le)}-${j(i)}`,
          ref_for: !0,
          ref: "numberInputs",
          checked: E(ae),
          class: "lc-lottery-number-selector__input",
          disabled: R(ae),
          tabindex: o.value === le || E(ae) ? 0 : -1,
          type: "checkbox",
          onChange: () => V(ae),
          onFocusin: (me) => o.value = le,
          onKeydown: [
            B,
            ii(() => V(ae), ["enter"])
          ]
        }, null, 40, Yh),
        ve(O.$slots, "cell", Ae({ ref_for: !0 }, {
          checked: E(ae),
          disabled: R(ae),
          number: ae
        }), () => [
          xt(Oe(ae), 1)
        ])
      ], 10, Wh))), 128))
    ], 16, jh));
  }
}), Xh = { class: "w-full" }, Gh = {
  key: 0,
  class: "lc-lottery-teaser__jackpot-text"
}, Kh = {
  key: 1,
  class: "lc-lottery-teaser__jackpot-text"
}, Jh = { class: "lc-lottery-teaser__button-container" }, Qh = { class: "lc-lottery-teaser__button-wrap" }, ev = {
  key: 0,
  class: "lc-lottery-teaser__button-wrap"
}, tv = {
  key: 0,
  class: "lc-lottery-teaser__draw-date"
}, nv = { class: "lc-lottery-teaser__draw-date-headline" }, Vg = /* @__PURE__ */ Se({
  __name: "LcLotteryTeaser",
  props: {
    cutoffTime: {},
    nextCutoffTime: {},
    backgroundPattern: {},
    badge: {},
    comingSoon: { type: Boolean },
    drawDate: {},
    drawDateHeadline: {},
    headline: {},
    jackpot: {},
    locale: { default: () => je.general.locale },
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" }
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    const t = An(), n = W(() => [
      "lc-lottery-teaser",
      `lc-lottery-teaser--variant-${e.variant}`,
      {
        "lc-lottery-teaser--two-buttons": s.value
      }
    ]), r = W(
      () => Vo({
        date: e.drawDate,
        format: "drawingShort",
        locale: e.locale
      })
    ), s = W(
      () => e.variant !== "expressive" && !!(e.secondaryButtonProps?.text || t["secondary-button"])
    ), i = W(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (a, o) => ($(), ke(j(nr), Ae({ badge: e.badge, backgroundPattern: e.backgroundPattern }, {
      "body-class": "lc-lottery-teaser__body",
      class: n.value,
      "footer-class": "lc-lottery-teaser__footer",
      "header-class": "lc-lottery-teaser__header",
      "header-to": e.primaryButtonProps.to,
      style: {
        "--teaser-frame-color": "var(--lottery-teaser-frame-color)"
      },
      variant: e.variant === "expressive" ? "default" : e.variant,
      onHeaderClick: e.onTeaserClick
    }), Xa({
      header: Te(() => [
        ve(a.$slots, "lottery-logo")
      ]),
      default: Te(() => [
        e.variant === "expressive" ? ($(), ke(j(Hl), Ae({ key: 0 }, { cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
          class: "lc-lottery-teaser__cutoff-time",
          variant: "expressive",
          onCutoffTimeReached: o[0] || (o[0] = (l) => a.$emit("outdated"))
        }), null, 16)) : de("", !0),
        ne("section", Xh, [
          ($(), ke(zt(i.value), {
            class: "lc-lottery-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Te(() => [
              e.headline ? ($(), Z("strong", Gh, Oe(e.headline), 1)) : de("", !0),
              Fe(j(Yo), Ae(e.jackpot, { size: "small" }), null, 16),
              e.subline ? ($(), Z("strong", Kh, Oe(e.subline), 1)) : de("", !0)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ne("section", Jh, [
          ne("div", Qh, [
            ve(a.$slots, "primary-button", {}, () => [
              Fe(j(kt), Ae(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                variant: s.value ? "primary-ghost" : "primary",
                onClick: o[1] || (o[1] = (l) => a.$emit("primary-button-click"))
              }), {
                default: Te(() => [
                  xt(Oe(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label", "variant"])
            ])
          ]),
          s.value ? ($(), Z("div", ev, [
            ve(a.$slots, "secondary-button", {}, () => [
              e.secondaryButtonProps ? ($(), ke(j(kt), Ae({ key: 0 }, e.secondaryButtonProps, {
                "aria-label": e.secondaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                onClick: o[2] || (o[2] = (l) => a.$emit("secondary-button-click"))
              }), {
                default: Te(() => [
                  xt(Oe(e.secondaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])) : de("", !0)
            ])
          ])) : de("", !0)
        ])
      ]),
      _: 2
    }, [
      e.variant !== "expressive" ? {
        name: "footer",
        fn: Te(() => [
          ["default", "badge"].includes(e.variant) ? ($(), Z("div", tv, [
            ne("div", nv, [
              Fe(j(Ke), {
                name: "calendar",
                size: "small"
              }),
              ne("span", null, Oe(e.drawDateHeadline), 1)
            ]),
            Fe(j(Lo), Ae({ locale: e.locale, ...j(gi).drawingShort }, { datetime: e.drawDate }), {
              default: Te(() => [
                xt(Oe(r.value), 1)
              ]),
              _: 1
            }, 16, ["datetime"])
          ])) : de("", !0),
          Fe(j(Hl), Ae({ cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
            "single-line": e.variant === "hero",
            variant: e.variant === "hero" ? "expressive" : "default",
            onCutoffTimeReached: o[3] || (o[3] = (l) => a.$emit("outdated"))
          }), null, 16, ["single-line", "variant"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class", "header-to", "variant", "onHeaderClick"]));
  }
}), Hg = [...Ko, "expressive"], av = { class: "lc-masked-value-display" }, Ug = /* @__PURE__ */ Se({
  __name: "LcMaskedValueDisplay",
  props: {
    masksPerPart: { default: 4 },
    parts: { default: 1 }
  },
  setup(e) {
    return (t, n) => ($(), Z("span", av, [
      ($(!0), Z(Xe, null, ht(e.parts, (r) => ($(), Z("span", {
        key: r,
        class: "lc-masked-value-display__part"
      }, [
        ($(!0), Z(Xe, null, ht(e.masksPerPart, (s) => ($(), Z("span", {
          key: s,
          class: "lc-masked-value-display__mask"
        }))), 128))
      ]))), 128)),
      ve(t.$slots, "default")
    ]));
  }
}), Gr = Math.min, Bn = Math.max, qa = Math.round, Da = Math.floor, Jt = (e) => ({
  x: e,
  y: e
}), rv = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function pi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function jn(e) {
  return e.split("-")[0];
}
function ar(e) {
  return e.split("-")[1];
}
function iv(e) {
  return e === "x" ? "y" : "x";
}
function rs(e) {
  return e === "y" ? "height" : "width";
}
function yn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function is(e) {
  return iv(yn(e));
}
function lv(e, t, n) {
  n === void 0 && (n = !1);
  const r = ar(e), s = is(e), i = rs(s);
  let a = s === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = ja(a)), [a, ja(a)];
}
function ov(e) {
  const t = ja(e);
  return [Kr(e), t, Kr(t)];
}
function Kr(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Ul = ["left", "right"], ql = ["right", "left"], sv = ["top", "bottom"], cv = ["bottom", "top"];
function uv(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? ql : Ul : t ? Ul : ql;
    case "left":
    case "right":
      return t ? sv : cv;
    default:
      return [];
  }
}
function dv(e, t, n, r) {
  const s = ar(e);
  let i = uv(jn(e), n === "start", r);
  return s && (i = i.map((a) => a + "-" + s), t && (i = i.concat(i.map(Kr)))), i;
}
function ja(e) {
  const t = jn(e);
  return rv[t] + e.slice(t.length);
}
function fv(e) {
  var t, n, r, s;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (s = e.left) != null ? s : 0
  };
}
function hv(e) {
  return typeof e != "number" ? fv(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Za(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: s
  } = e;
  return {
    width: r,
    height: s,
    top: n,
    left: t,
    right: t + r,
    bottom: n + s,
    x: t,
    y: n
  };
}
function jl(e, t, n) {
  let {
    reference: r,
    floating: s
  } = e;
  const i = yn(t), a = is(t), o = rs(a), l = jn(t), h = i === "y", v = r.x + r.width / 2 - s.width / 2, u = r.y + r.height / 2 - s.height / 2, f = r[o] / 2 - s[o] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: v,
        y: r.y - s.height
      };
      break;
    case "bottom":
      m = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: r.x - s.width,
        y: u
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const c = ar(t);
  return c && (m[a] += f * (c === "end" ? 1 : -1) * (n && h ? -1 : 1)), m;
}
async function vv(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: s,
    platform: i,
    rects: a,
    elements: o,
    strategy: l
  } = e, {
    boundary: h = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = pi(t, e), c = hv(m), k = o[f ? u === "floating" ? "reference" : "floating" : u], g = Za(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(k))) == null || n ? k : k.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
    boundary: h,
    rootBoundary: v,
    strategy: l
  })), b = u === "floating" ? {
    x: r,
    y: s,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), A = await (i.isElement == null ? void 0 : i.isElement(C)) && await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  }, D = Za(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: b,
    offsetParent: C,
    strategy: l
  }) : b);
  return {
    top: (g.top - D.top + c.top) / A.y,
    bottom: (D.bottom - g.bottom + c.bottom) / A.y,
    left: (g.left - D.left + c.left) / A.x,
    right: (D.right - g.right + c.right) / A.x
  };
}
const mv = 50, gv = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: i = [],
    platform: a
  } = n, o = a.detectOverflow ? a : {
    ...a,
    detectOverflow: vv
  }, l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let h = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: v,
    y: u
  } = jl(h, r, l), f = r, m = 0;
  const c = {};
  for (let p = 0; p < i.length; p++) {
    const k = i[p];
    if (!k)
      continue;
    const {
      name: g,
      fn: b
    } = k, {
      x: C,
      y: A,
      data: D,
      reset: L
    } = await b({
      x: v,
      y: u,
      initialPlacement: r,
      placement: f,
      strategy: s,
      middlewareData: c,
      rects: h,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    v = C ?? v, u = A ?? u, c[g] = {
      ...c[g],
      ...D
    }, L && m < mv && (m++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (h = L.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : L.rects), {
      x: v,
      y: u
    } = jl(h, f, l)), p = -1);
  }
  return {
    x: v,
    y: u,
    placement: f,
    strategy: s,
    middlewareData: c
  };
}, bv = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        middlewareData: i,
        rects: a,
        initialPlacement: o,
        platform: l,
        elements: h
      } = t, {
        mainAxis: v = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: c = "none",
        flipAlignment: p = !0,
        ...k
      } = pi(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = jn(s), b = yn(o), C = jn(o) === o, A = await (l.isRTL == null ? void 0 : l.isRTL(h.floating)), D = f || (C || !p ? [ja(o)] : ov(o)), L = c !== "none";
      !f && L && D.push(...dv(o, p, c, A));
      const T = [o, ...D], P = await l.detectOverflow(t, k), U = [];
      let K = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (v && U.push(P[g]), u) {
        const _ = lv(s, a, A);
        U.push(P[_[0]], P[_[1]]);
      }
      if (K = [...K, {
        placement: s,
        overflows: U
      }], !U.every((_) => _ <= 0)) {
        var B, X;
        const _ = (((B = i.flip) == null ? void 0 : B.index) || 0) + 1, E = T[_];
        if (E && (!(u === "alignment" ? b !== yn(E) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        K.every((q) => yn(q.placement) === b ? q.overflows[0] > 0 : !0)))
          return {
            data: {
              index: _,
              overflows: K
            },
            reset: {
              placement: E
            }
          };
        let R = (X = K.filter((V) => V.overflows[0] <= 0).sort((V, q) => V.overflows[1] - q.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!R)
          switch (m) {
            case "bestFit": {
              var H;
              const V = (H = K.filter((q) => {
                if (L) {
                  const O = yn(q.placement);
                  return O === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  O === "y";
                }
                return !0;
              }).map((q) => [q.placement, q.overflows.filter((O) => O > 0).reduce((O, Q) => O + Q, 0)]).sort((q, O) => q[1] - O[1])[0]) == null ? void 0 : H[0];
              V && (R = V);
              break;
            }
            case "initialPlacement":
              R = o;
              break;
          }
        if (s !== R)
          return {
            reset: {
              placement: R
            }
          };
      }
      return {};
    }
  };
}, pv = /* @__PURE__ */ new Set(["left", "top"]);
async function yv(e, t) {
  const {
    placement: n,
    platform: r,
    elements: s
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)), a = jn(n), o = ar(n), l = yn(n) === "y", h = pv.has(a) ? -1 : 1, v = i && l ? -1 : 1, u = pi(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: c
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return o && typeof c == "number" && (m = o === "end" ? c * -1 : c), l ? {
    x: m * v,
    y: f * h
  } : {
    x: f * h,
    y: m * v
  };
}
const wv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: s,
        y: i,
        placement: a,
        middlewareData: o
      } = t, l = await yv(t, e);
      return a === ((n = o.offset) == null ? void 0 : n.placement) && (r = o.arrow) != null && r.alignmentOffset ? {} : {
        x: s + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
};
function rr() {
  return typeof window < "u";
}
function In(e) {
  return yi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Mt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function nn(e) {
  var t;
  return (t = (yi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function yi(e) {
  return rr() ? e instanceof Node || e instanceof Mt(e).Node : !1;
}
function Yt(e) {
  return rr() ? e instanceof Element || e instanceof Mt(e).Element : !1;
}
function dn(e) {
  return rr() ? e instanceof HTMLElement || e instanceof Mt(e).HTMLElement : !1;
}
function Zl(e) {
  return !rr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Mt(e).ShadowRoot;
}
function ir(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: s
  } = Xt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && s !== "inline" && s !== "contents";
}
function xv(e) {
  return /^(table|td|th)$/.test(In(e));
}
function lr(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const kv = /transform|translate|scale|rotate|perspective|filter/, Sv = /paint|layout|strict|content/, bn = (e) => !!e && e !== "none";
let Fr;
function wi(e) {
  const t = Yt(e) ? Xt(e) : e;
  return bn(t.transform) || bn(t.translate) || bn(t.scale) || bn(t.rotate) || bn(t.perspective) || !xi() && (bn(t.backdropFilter) || bn(t.filter)) || kv.test(t.willChange || "") || Sv.test(t.contain || "");
}
function _v(e) {
  let t = En(e);
  for (; dn(t) && !va(t); ) {
    if (wi(t))
      return t;
    if (lr(t))
      return null;
    t = En(t);
  }
  return null;
}
function xi() {
  return Fr == null && (Fr = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Fr;
}
function va(e) {
  return /^(html|body|#document)$/.test(In(e));
}
function Xt(e) {
  return Mt(e).getComputedStyle(e);
}
function or(e) {
  return Yt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function En(e) {
  if (In(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Zl(e) && e.host || // Fallback.
    nn(e)
  );
  return Zl(t) ? t.host : t;
}
function ls(e) {
  const t = En(e);
  return va(t) ? (e.ownerDocument || e).body : dn(t) && ir(t) ? t : ls(t);
}
function ma(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = ls(e), i = s === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Mt(s);
  if (i) {
    const o = Jr(a);
    return t.concat(a, a.visualViewport || [], ir(s) ? s : [], o && n ? ma(o) : []);
  } else
    return t.concat(s, ma(s, [], n));
}
function Jr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function os(e) {
  const t = Xt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const s = dn(e), i = s ? e.offsetWidth : n, a = s ? e.offsetHeight : r, o = qa(n) !== i || qa(r) !== a;
  return o && (n = i, r = a), {
    width: n,
    height: r,
    $: o
  };
}
function ki(e) {
  return Yt(e) ? e : e.contextElement;
}
function zn(e) {
  const t = ki(e);
  if (!dn(t))
    return Jt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: s,
    $: i
  } = os(t);
  let a = (i ? qa(n.width) : n.width) / r, o = (i ? qa(n.height) : n.height) / s;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const Cv = /* @__PURE__ */ Jt(0);
function ss(e) {
  const t = Mt(e);
  return !xi() || !t.visualViewport ? Cv : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Ev(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === Mt(e);
}
function Tn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), i = ki(e);
  let a = Jt(1);
  t && (r ? Yt(r) && (a = zn(r)) : a = zn(e));
  const o = Ev(i, n, r) ? ss(i) : Jt(0);
  let l = (s.left + o.x) / a.x, h = (s.top + o.y) / a.y, v = s.width / a.x, u = s.height / a.y;
  if (i && r) {
    const f = Mt(i), m = Yt(r) ? Mt(r) : r;
    let c = f, p = Jr(c);
    for (; p && m !== c; ) {
      const k = zn(p), g = p.getBoundingClientRect(), b = Xt(p), C = g.left + (p.clientLeft + parseFloat(b.paddingLeft)) * k.x, A = g.top + (p.clientTop + parseFloat(b.paddingTop)) * k.y;
      l *= k.x, h *= k.y, v *= k.x, u *= k.y, l += C, h += A, c = Mt(p), p = Jr(c);
    }
  }
  return Za({
    width: v,
    height: u,
    x: l,
    y: h
  });
}
function sr(e, t) {
  const n = or(e).scrollLeft;
  return t ? t.left + n : Tn(nn(e)).left + n;
}
function cs(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - sr(e, n), s = n.top + t.scrollTop;
  return {
    x: r,
    y: s
  };
}
function Tv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: s
  } = e;
  const i = s === "fixed", a = nn(r), o = t ? lr(t.floating) : !1;
  if (r === a || o && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Jt(1);
  const v = Jt(0), u = dn(r);
  if ((u || !i) && ((In(r) !== "body" || ir(a)) && (l = or(r)), u)) {
    const m = Tn(r);
    h = zn(r), v.x = m.x + r.clientLeft, v.y = m.y + r.clientTop;
  }
  const f = a && !u && !i ? cs(a, l) : Jt(0);
  return {
    width: n.width * h.x,
    height: n.height * h.y,
    x: n.x * h.x - l.scrollLeft * h.x + v.x + f.x,
    y: n.y * h.y - l.scrollTop * h.y + v.y + f.y
  };
}
function Av(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function Lv(e) {
  const t = or(e), n = e.ownerDocument.body, r = Bn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), s = Bn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + sr(e);
  const a = -t.scrollTop;
  return Xt(n).direction === "rtl" && (i += Bn(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: a
  };
}
const $v = 25;
function Iv(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", s = Mt(e), i = nn(e), a = s.visualViewport;
  let o = i.clientWidth, l = i.clientHeight, h = 0, v = 0;
  if (a) {
    const f = !xi() || t === "fixed";
    r ? f || (h = -a.offsetLeft, v = -a.offsetTop) : (o = a.width, l = a.height, f && (h = a.offsetLeft, v = a.offsetTop));
  }
  if (sr(i) <= 0) {
    const f = i.ownerDocument, m = f.body, c = getComputedStyle(m), p = f.compatMode === "CSS1Compat" && parseFloat(c.marginLeft) + parseFloat(c.marginRight) || 0, k = Math.abs(i.clientWidth - m.clientWidth - p), g = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? k / 2 : k;
    g <= $v && (o -= g);
  }
  return {
    width: o,
    height: l,
    x: h,
    y: v
  };
}
function Dv(e, t) {
  const n = Tn(e, !0, t === "fixed"), r = n.top + e.clientTop, s = n.left + e.clientLeft, i = zn(e), a = e.clientWidth * i.x, o = e.clientHeight * i.y, l = s * i.x, h = r * i.y;
  return {
    width: a,
    height: o,
    x: l,
    y: h
  };
}
function Wl(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = Iv(e, n, t);
  else if (t === "document")
    r = Lv(nn(e));
  else if (Yt(t))
    r = Dv(t, n);
  else {
    const s = ss(e);
    r = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return Za(r);
}
function Mv(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ma(e, [], !1).filter((o) => Yt(o) && In(o) !== "body"), s = null;
  const i = Xt(e).position === "fixed";
  let a = i ? En(e) : e;
  for (; Yt(a) && !va(a); ) {
    const o = Xt(a), l = wi(a), h = s ? s.position : i ? "fixed" : "";
    !l && (h === "fixed" || h === "absolute" && o.position === "static") ? r = r.filter((u) => u !== a) : s = o, a = En(a);
  }
  return t.set(e, r), r;
}
function Ov(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: s
  } = e;
  const a = [...n === "clippingAncestors" ? lr(t) ? [] : Mv(t, this._c) : [].concat(n), r], o = Wl(t, a[0], s);
  let l = o.top, h = o.right, v = o.bottom, u = o.left;
  for (let f = 1; f < a.length; f++) {
    const m = Wl(t, a[f], s);
    l = Bn(m.top, l), h = Gr(m.right, h), v = Gr(m.bottom, v), u = Bn(m.left, u);
  }
  return {
    width: h - u,
    height: v - l,
    x: u,
    y: l
  };
}
function Rv(e) {
  const {
    width: t,
    height: n
  } = os(e);
  return {
    width: t,
    height: n
  };
}
function Fv(e, t, n) {
  const r = dn(t), s = nn(t), i = n === "fixed", a = Tn(e, !0, i, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Jt(0);
  if ((r || !i) && ((In(t) !== "body" || ir(s)) && (o = or(t)), r)) {
    const f = Tn(t, !0, i, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  }
  !r && s && (l.x = sr(s));
  const h = s && !r && !i ? cs(s, o) : Jt(0), v = a.left + o.scrollLeft - l.x - h.x, u = a.top + o.scrollTop - l.y - h.y;
  return {
    x: v,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Nr(e) {
  return Xt(e).position === "static";
}
function Yl(e, t) {
  if (!dn(e) || Xt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return nn(e) === n && (n = n.ownerDocument.body), n;
}
function us(e, t) {
  const n = Mt(e);
  if (lr(e))
    return n;
  if (!dn(e)) {
    let s = En(e);
    for (; s && !va(s); ) {
      if (Yt(s) && !Nr(s))
        return s;
      s = En(s);
    }
    return n;
  }
  let r = Yl(e, t);
  for (; r && xv(r) && Nr(r); )
    r = Yl(r, t);
  return r && va(r) && Nr(r) && !wi(r) ? n : r || _v(e) || n;
}
const Nv = async function(e) {
  const t = this.getOffsetParent || us, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Fv(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Pv(e) {
  return Xt(e).direction === "rtl";
}
const Bv = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Tv,
  getDocumentElement: nn,
  getClippingRect: Ov,
  getOffsetParent: us,
  getElementRects: Nv,
  getClientRects: Av,
  getDimensions: Rv,
  getScale: zn,
  isElement: Yt,
  isRTL: Pv
};
function ds(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function zv(e, t, n) {
  let r = null, s;
  const i = nn(e);
  function a() {
    var v;
    clearTimeout(s), (v = r) == null || v.disconnect(), r = null;
  }
  function o(v, u) {
    v === void 0 && (v = !1), u === void 0 && (u = 1), a();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: c,
      width: p,
      height: k
    } = f;
    if (v || t(), !p || !k)
      return;
    const g = Da(c), b = Da(i.clientWidth - (m + p)), C = Da(i.clientHeight - (c + k)), A = Da(m), L = {
      rootMargin: -g + "px " + -b + "px " + -C + "px " + -A + "px",
      threshold: Bn(0, Gr(1, u)) || 1
    };
    let T = !0;
    function P(U) {
      const K = U[0].intersectionRatio;
      if (!ds(f, e.getBoundingClientRect()))
        return o();
      if (K !== u) {
        if (!T)
          return o();
        K ? o(!1, K) : s = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      T = !1;
    }
    try {
      r = new IntersectionObserver(P, {
        ...L,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(P, L);
    }
    r.observe(e);
  }
  const l = Mt(e), h = () => o(n);
  return l.addEventListener("resize", h), o(!0), () => {
    l.removeEventListener("resize", h), a();
  };
}
function fs(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, h = ki(e), v = s || i ? [...h ? ma(h) : [], ...t ? ma(t) : []] : [];
  v.forEach((g) => {
    s && g.addEventListener("scroll", n), i && g.addEventListener("resize", n);
  });
  const u = h && o ? zv(h, n, i) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === h && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var C;
      (C = m) == null || C.observe(t);
    })), n();
  }), h && !l && m.observe(h), t && m.observe(t));
  let c, p = l ? Tn(e) : null;
  l && k();
  function k() {
    const g = Tn(e);
    p && !ds(p, g) && n(), p = g, c = requestAnimationFrame(k);
  }
  return n(), () => {
    var g;
    v.forEach((b) => {
      s && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), u?.(), (g = m) == null || g.disconnect(), m = null, l && cancelAnimationFrame(c);
  };
}
const hs = wv, vs = bv, Vv = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), s = n ?? {}, i = {
    ...Bv,
    ...s.platform,
    _c: r
  };
  return gv(e, t, {
    ...s,
    platform: i
  });
};
function Hv(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Xl(e) {
  if (Hv(e)) {
    const t = e.$el;
    return yi(t) && In(t) === "#comment" ? null : t;
  }
  return e;
}
function ms(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Gl(e, t) {
  const n = ms(e);
  return Math.round(t * n) / n;
}
function gs(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, s = W(() => {
    var T;
    return (T = Ge(n.open)) != null ? T : !0;
  }), i = W(() => Ge(n.middleware)), a = W(() => {
    var T;
    return (T = Ge(n.placement)) != null ? T : "bottom";
  }), o = W(() => {
    var T;
    return (T = Ge(n.strategy)) != null ? T : "absolute";
  }), l = W(() => {
    var T;
    return (T = Ge(n.transform)) != null ? T : !0;
  }), h = W(() => Xl(e.value)), v = W(() => Xl(t.value)), u = ge(0), f = ge(0), m = ge(o.value), c = ge(a.value), p = kn({}), k = ge(!1), g = W(() => {
    const T = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!v.value)
      return T;
    const P = Gl(v.value, u.value), U = Gl(v.value, f.value);
    return l.value ? {
      ...T,
      transform: "translate(" + P + "px, " + U + "px)",
      ...ms(v.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: P + "px",
      top: U + "px"
    };
  });
  let b;
  function C() {
    if (h.value == null || v.value == null)
      return;
    const T = s.value;
    Vv(h.value, v.value, {
      middleware: i.value,
      placement: a.value,
      strategy: o.value
    }).then((P) => {
      u.value = P.x, f.value = P.y, m.value = P.strategy, c.value = P.placement, p.value = P.middlewareData, k.value = T !== !1;
    });
  }
  function A() {
    typeof b == "function" && (b(), b = void 0);
  }
  function D() {
    if (A(), r === void 0) {
      C();
      return;
    }
    if (h.value != null && v.value != null) {
      b = r(h.value, v.value, C);
      return;
    }
  }
  function L() {
    s.value || (k.value = !1);
  }
  return Be([i, a, o, s], C, {
    flush: "sync"
  }), Be([h, v], D, {
    flush: "sync"
  }), Be(s, L, {
    flush: "sync"
  }), Hs() && Us(A), {
    x: Mn(u),
    y: Mn(f),
    strategy: Mn(m),
    placement: Mn(c),
    middlewareData: Mn(p),
    isPositioned: Mn(k),
    floatingStyles: g,
    update: C
  };
}
const Ra = ge(!1);
let Vn, Hn, Un, Qr = 0;
const Si = () => (pt(() => {
  Qr += 1, Uv();
}), Ln(() => {
  Qr -= 1, qv();
}), Ra), Uv = () => {
  typeof window > "u" || (Vn || (Vn = () => Ra.value = !0, window.addEventListener("keydown", Vn, !0)), Hn || (Hn = () => Ra.value = !1, window.addEventListener("mousedown", Hn, !0)), Un || (Un = () => Ra.value = !1, window.addEventListener("pointerdown", Un, !0)));
}, qv = () => {
  typeof window > "u" || Qr || (Vn && (window.removeEventListener("keydown", Vn, !0), Vn = null), Hn && (window.removeEventListener("mousedown", Hn, !0), Hn = null), Un && (window.removeEventListener("pointerdown", Un, !0), Un = null));
}, bs = {
  fn: (e) => ({ x: e.x < 0 ? e.rects.reference.x : e.x }),
  name: "positionHelper"
}, qg = [
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end"
];
var Ut = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Escape = "Escape", e.Home = "Home", e.Space = " ", e.Tab = "Tab", e))(Ut || {});
const jv = {
  ref: "container",
  class: "lc-menu-button"
}, Zv = ["id", "aria-activedescendant"], Wv = ["id", "aria-selected", "onClick"], jg = /* @__PURE__ */ Se({
  __name: "LcMenuButton",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    icon: { default: "more-horizontal" },
    id: {},
    options: {},
    placement: { default: "bottom-end" },
    value: {},
    zIndex: { default: 99 }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = ot("button"), i = ot("menu"), a = ge(null), o = ge(!1), { floatingStyles: l } = gs(s, i, {
      middleware: [
        hs({
          alignmentAxis: 4
        }),
        vs(),
        bs
      ],
      placement: () => e.placement,
      whileElementsMounted: fs
    }), h = $t(e.id), v = Si(), u = W(() => {
      if (!(!o.value || !At(a.value)))
        return `${h}-menuitem-${a.value}`;
    }), f = W(
      () => e.options.findIndex((b) => "value" in b && b.value === e.value)
    ), m = () => {
      o.value && (a.value = null, o.value = !1);
    }, c = () => {
      if (o.value) {
        m();
        return;
      }
      g();
    }, p = (b) => {
      if (m(), b?.onClick) {
        b.onClick();
        return;
      }
      r("update:value", b.value);
    }, k = (b) => {
      if (!tn(b.key, Ut)) return;
      b.key !== Ut.Tab && (b.preventDefault(), b.stopPropagation());
      const C = e.options.length - 1;
      switch (b.key) {
        case Ut.ArrowDown:
          if (o.value && At(a.value)) {
            a.value = Math.min(C, a.value + 1);
            break;
          }
          a.value = 0, g();
          break;
        case Ut.ArrowUp:
          if (o.value && At(a.value)) {
            a.value = Math.max(0, a.value - 1);
            break;
          }
          a.value = C, g();
          break;
        case Ut.End:
          if (!o.value) return;
          a.value = C;
          break;
        case Ut.Enter:
        case Ut.Space:
          if (o.value && At(a.value)) {
            p(e.options[a.value]);
            break;
          }
          a.value = 0, g();
          break;
        case Ut.Escape:
        case Ut.Tab:
          m();
          break;
        case Ut.Home:
          if (!o.value) return;
          a.value = 0;
          break;
      }
    }, g = () => {
      o.value || (o.value = !0, e.value && (a.value = f.value));
    };
    return Ga(i, m, {
      ignore: [s, ...Ge(e.ignoreOutsideClickOn)]
    }), t({ menuRef: i }), pt(() => {
      e.value && (a.value = f.value);
    }), (b, C) => ($(), Z("div", jv, [
      Fe(j(kt), Ae({
        id: j(h),
        ref: "button"
      }, { icon: e.icon }, {
        "aria-controls": `${j(h)}-menu`,
        "aria-expanded": o.value,
        "aria-haspopup": "menu",
        size: "small",
        variant: "tertiary",
        onClickPassive: c,
        onKeydown: k
      }), null, 16, ["id", "aria-controls", "aria-expanded"]),
      ($(), ke(ba, { to: "body" }, [
        o.value ? ($(), ke(j(ya), {
          key: 0,
          ref: "menu",
          "body-class": "lc-menu-button__menu-wrap-body",
          class: "lc-menu-button__menu-wrap",
          style: Ct({ ...j(l), zIndex: e.zIndex })
        }, {
          default: Te(() => [
            ne("ul", {
              id: `${j(h)}-menu`,
              "aria-activedescendant": u.value,
              class: "lc-menu-button__menu",
              role: "menu"
            }, [
              ($(!0), Z(Xe, null, ht(e.options, (A, D) => ($(), Z("li", {
                key: `${A.label}-${"value" in A ? A.value : "action"}`,
                class: ye(["lc-menu-button__menu-item", {
                  "lc-menu-button__menu-item--focused": a.value === D && j(v),
                  "lc-menu-button__menu-item--selected": "value" in A && A.value === e.value
                }])
              }, [
                ne("button", {
                  id: `${j(h)}-menuitem-${D}`,
                  "aria-selected": "value" in A && A.value === e.value,
                  class: "lc-menu-button__menu-item-button",
                  role: "menuitem",
                  tabindex: "-1",
                  type: "button",
                  onClick: (L) => p(A)
                }, [
                  Fe(j(Ke), {
                    name: A.icon
                  }, null, 8, ["name"]),
                  ne("span", null, Oe(A.label), 1),
                  "value" in A && A.value === e.value ? ($(), ke(j(Ke), {
                    key: 0,
                    class: "lc-menu-button__menu-item-checkmark",
                    name: "checkmark"
                  })) : de("", !0)
                ], 8, Wv)
              ], 2))), 128))
            ], 8, Zv)
          ]),
          _: 1
        }, 8, ["style"])) : de("", !0)
      ]))
    ], 512));
  }
}), Yv = { class: "lc-message-box__headline" }, Xv = {
  key: 0,
  class: "lc-message-box__text"
}, Zg = /* @__PURE__ */ Se({
  __name: "LcMessageBox",
  props: /* @__PURE__ */ Sn({
    id: {},
    modelValue: { type: Boolean },
    headline: {},
    size: { default: "medium" },
    text: {},
    variant: { default: "default" }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = {
      default: "info",
      info: "info",
      warning: "alert-circle"
    }, n = Wa(e, "modelValue"), r = W(() => [
      "lc-message-box",
      `lc-message-box--size-${e.size}`,
      `lc-message-box--variant-${e.variant}`
    ]);
    return (s, i) => ($(), ke(j(Mf), {
      modelValue: n.value,
      "onUpdate:modelValue": i[0] || (i[0] = (a) => n.value = a),
      class: ye(r.value),
      "content-class": "lc-message-box__content",
      "header-class": "lc-message-box__header"
    }, {
      header: Te(() => [
        ne("span", Yv, [
          Fe(j(Ke), {
            name: t[e.variant]
          }, null, 8, ["name"]),
          ne("span", null, Oe(e.headline), 1)
        ])
      ]),
      default: Te(() => [
        ve(s.$slots, "default", {}, () => [
          e.text ? ($(), Z("p", Xv, Oe(e.text), 1)) : de("", !0)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "class"]));
  }
}), Wg = ["medium", "small"], Yg = ["default", "info", "warning"];
var sn;
(function(e) {
  e.symbol = "symbol", e.narrowSymbol = "narrowSymbol", e.code = "code", e.name = "name", e.hidden = "hidden";
})(sn || (sn = {}));
var on;
(function(e) {
  e.precision = "precision", e.thousands = "thousands", e.tenThousands = "tenThousands", e.millions = "millions", e.billions = "billions";
})(on || (on = {}));
const Fa = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), ps = (e) => e.replace(/^0+(0$|[^0])/, "$1"), Pr = (e, t) => (e.match(new RegExp(Fa(t), "g")) || []).length, Gv = (e, t) => e.substring(0, e.indexOf(t)), ys = [
  ",",
  ".",
  "٫",
  "。"
], Kl = "(0|[1-9]\\d*)";
class Kv {
  constructor(t) {
    var n, r, s, i, a, o;
    const { currency: l, currencyDisplay: h, locale: v, precision: u, accountingSign: f, useGrouping: m } = t;
    this.locale = v, this.options = {
      currency: l,
      useGrouping: m,
      style: "currency",
      currencySign: f ? "accounting" : void 0,
      currencyDisplay: h !== sn.hidden ? h : void 0
    };
    const c = new Intl.NumberFormat(v, this.options), p = c.formatToParts(123456);
    this.currency = (n = p.find(({ type: b }) => b === "currency")) === null || n === void 0 ? void 0 : n.value, this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((b) => b.toLocaleString(v)), this.decimalSymbol = (r = p.find(({ type: b }) => b === "decimal")) === null || r === void 0 ? void 0 : r.value, this.groupingSymbol = (s = p.find(({ type: b }) => b === "group")) === null || s === void 0 ? void 0 : s.value, this.minusSign = (i = c.formatToParts(-1).find(({ type: b }) => b === "minusSign")) === null || i === void 0 ? void 0 : i.value, this.decimalSymbol === void 0 ? this.minimumFractionDigits = this.maximumFractionDigits = 0 : typeof u == "number" ? this.minimumFractionDigits = this.maximumFractionDigits = u : (this.minimumFractionDigits = (a = u?.min) !== null && a !== void 0 ? a : c.resolvedOptions().minimumFractionDigits, this.maximumFractionDigits = (o = u?.max) !== null && o !== void 0 ? o : c.resolvedOptions().maximumFractionDigits);
    const k = (b) => Gv(b, this.digits[1]), g = (b) => b.substring(b.lastIndexOf(this.decimalSymbol ? this.digits[0] : this.digits[1]) + 1);
    this.prefix = k(c.format(1)), this.suffix = g(c.format(1)), this.negativePrefix = k(c.format(-1)), this.negativeSuffix = g(c.format(-1));
  }
  parse(t) {
    if (t) {
      const n = this.isNegative(t);
      t = this.normalizeDigits(t), t = this.stripCurrency(t, n), t = this.stripSignLiterals(t);
      const r = this.decimalSymbol ? `(?:${Fa(this.decimalSymbol)}(\\d*))?` : "", s = this.stripGroupingSeparator(t).match(new RegExp(`^${Kl}${r}$`));
      if (s && this.isValidIntegerFormat(this.decimalSymbol ? t.split(this.decimalSymbol)[0] : t, Number(s[1])))
        return +`${n ? "-" : ""}${this.onlyDigits(s[1])}.${this.onlyDigits(s[2] || "")}`;
    }
    return null;
  }
  isValidIntegerFormat(t, n) {
    const r = { ...this.options, minimumFractionDigits: 0 };
    return [
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !0 })), !1),
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !1 })), !1)
    ].includes(t);
  }
  format(t, n = {
    minimumFractionDigits: this.minimumFractionDigits,
    maximumFractionDigits: this.maximumFractionDigits
  }) {
    return t != null ? t.toLocaleString(this.locale, { ...this.options, ...n }) : "";
  }
  toFraction(t) {
    return `${this.digits[0]}${this.decimalSymbol}${this.onlyLocaleDigits(t.substring(1)).substring(0, this.maximumFractionDigits)}`;
  }
  isFractionIncomplete(t) {
    return !!this.normalizeDigits(this.stripGroupingSeparator(t)).match(new RegExp(`^${Kl}${Fa(this.decimalSymbol)}$`));
  }
  isNegative(t) {
    return t.startsWith(this.negativePrefix) || this.minusSign === void 0 && (t.startsWith("(") || t.startsWith("-")) || this.minusSign !== void 0 && t.replace("-", this.minusSign).startsWith(this.minusSign);
  }
  insertCurrency(t, n) {
    return `${n ? this.negativePrefix : this.prefix}${t}${n ? this.negativeSuffix : this.suffix}`;
  }
  stripGroupingSeparator(t) {
    return this.groupingSymbol !== void 0 ? t.replace(new RegExp(Fa(this.groupingSymbol), "g"), "") : t;
  }
  stripSignLiterals(t) {
    return this.minusSign !== void 0 ? t.replace("-", this.minusSign).replace(this.minusSign, "") : t.replace(/[-()]/g, "");
  }
  stripCurrency(t, n) {
    return t.replace(n ? this.negativePrefix : this.prefix, "").replace(n ? this.negativeSuffix : this.suffix, "");
  }
  normalizeDecimalSeparator(t, n) {
    return ys.forEach((r) => {
      t = t.substring(0, n) + t.substring(n).replace(r, this.decimalSymbol);
    }), t;
  }
  normalizeDigits(t) {
    return this.digits[0] !== "0" && this.digits.forEach((n, r) => {
      t = t.replace(new RegExp(n, "g"), String(r));
    }), t;
  }
  onlyDigits(t) {
    return this.normalizeDigits(t).replace(/\D+/g, "");
  }
  onlyLocaleDigits(t) {
    return t.replace(new RegExp(`[^${this.digits.join("")}]*`, "g"), "");
  }
}
class ws {
  constructor(t) {
    this.currencyFormat = t;
  }
}
class Jv extends ws {
  conformToMask(t, n = "") {
    const r = this.currencyFormat.isNegative(t), s = (c) => c === "" && r && !(this.currencyFormat.minusSign === void 0 ? n === this.currencyFormat.negativePrefix + this.currencyFormat.negativeSuffix : n === this.currencyFormat.negativePrefix), i = (c) => {
      if (s(c))
        return "";
      if (this.currencyFormat.maximumFractionDigits > 0) {
        if (this.currencyFormat.isFractionIncomplete(c))
          return c;
        if (c.startsWith(this.currencyFormat.decimalSymbol))
          return this.currencyFormat.toFraction(c);
      }
      return null;
    };
    let a = t;
    a = this.currencyFormat.stripCurrency(a, r), a = this.currencyFormat.stripSignLiterals(a);
    const o = i(a);
    if (o != null)
      return this.currencyFormat.insertCurrency(o, r);
    const [l, ...h] = a.split(this.currencyFormat.decimalSymbol), v = ps(this.currencyFormat.onlyDigits(l)), u = this.currencyFormat.onlyDigits(h.join("")).substring(0, this.currencyFormat.maximumFractionDigits), f = h.length > 0 && u.length === 0, m = v === "" && r && (this.currencyFormat.minusSign === void 0 ? n === t.slice(0, -2) + this.currencyFormat.negativeSuffix : n === t.slice(0, -1));
    return f || m || s(v) ? n : v.match(/\d+/) ? {
      numberValue: +`${r ? "-" : ""}${v}.${u}`,
      fractionDigits: u
    } : "";
  }
}
class Qv extends ws {
  conformToMask(t, n = "") {
    if (t === "" || t === this.currencyFormat.decimalSymbol || this.currencyFormat.parse(n) === 0 && this.currencyFormat.stripCurrency(n, !0).slice(0, -1) === this.currencyFormat.stripCurrency(t, !0))
      return "";
    const r = this.currencyFormat.isNegative(t), s = this.currencyFormat.stripSignLiterals(t) === "" ? -0 : +`${r ? "-" : ""}${ps(this.currencyFormat.onlyDigits(t))}` / Math.pow(10, this.currencyFormat.maximumFractionDigits);
    return {
      numberValue: s,
      fractionDigits: s.toFixed(this.currencyFormat.maximumFractionDigits).slice(-this.currencyFormat.maximumFractionDigits)
    };
  }
}
const em = {
  locale: void 0,
  currency: void 0,
  currencyDisplay: void 0,
  hideGroupingSeparatorOnFocus: !0,
  hideCurrencySymbolOnFocus: !0,
  hideNegligibleDecimalDigitsOnFocus: !0,
  precision: void 0,
  autoDecimalDigits: !1,
  valueRange: void 0,
  useGrouping: void 0,
  valueScaling: void 0
};
class tm {
  constructor(t) {
    this.el = t.el, this.onInput = t.onInput, this.onChange = t.onChange, this.addEventListener(), this.init(t.options);
  }
  setOptions(t) {
    this.init(t), this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.onChange(this.getValue());
  }
  getValue() {
    return { number: this.valueScaling && this.numberValue != null ? this.toInteger(this.numberValue, this.valueScaling) : this.numberValue, formatted: this.formattedValue };
  }
  setValue(t) {
    const n = this.valueScaling !== void 0 && t != null ? this.toFloat(t, this.valueScaling) : t;
    n !== this.numberValue && (this.format(this.currencyFormat.format(this.validateValueRange(n))), this.onChange(this.getValue()));
  }
  init(t) {
    this.options = {
      ...em,
      ...t
    }, this.options.autoDecimalDigits && (this.options.hideNegligibleDecimalDigitsOnFocus = !1), this.el.getAttribute("inputmode") || this.el.setAttribute("inputmode", this.options.autoDecimalDigits ? "numeric" : "decimal"), this.currencyFormat = new Kv(this.options), this.numberMask = this.options.autoDecimalDigits ? new Qv(this.currencyFormat) : new Jv(this.currencyFormat);
    const n = {
      [on.precision]: this.currencyFormat.maximumFractionDigits,
      [on.thousands]: 3,
      [on.tenThousands]: 4,
      [on.millions]: 6,
      [on.billions]: 9
    };
    this.valueScaling = this.options.valueScaling ? n[this.options.valueScaling] : void 0, this.valueScalingFractionDigits = this.valueScaling !== void 0 && this.options.valueScaling !== on.precision ? this.valueScaling + this.currencyFormat.maximumFractionDigits : this.currencyFormat.maximumFractionDigits, this.minValue = this.getMinValue(), this.maxValue = this.getMaxValue();
  }
  getMinValue() {
    var t, n;
    let r = this.toFloat(-Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.min) !== void 0 && (r = Math.max((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.min, this.toFloat(-Number.MAX_SAFE_INTEGER))), r;
  }
  getMaxValue() {
    var t, n;
    let r = this.toFloat(Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.max) !== void 0 && (r = Math.min((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.max, this.toFloat(Number.MAX_SAFE_INTEGER))), r;
  }
  toFloat(t, n) {
    return t / Math.pow(10, n ?? this.valueScalingFractionDigits);
  }
  toInteger(t, n) {
    return Number(t.toFixed(n ?? this.valueScalingFractionDigits).split(".").join(""));
  }
  validateValueRange(t) {
    return t != null ? Math.min(Math.max(t, this.minValue), this.maxValue) : t;
  }
  format(t, n = !1) {
    if (t != null) {
      this.decimalSymbolInsertedAt !== void 0 && (t = this.currencyFormat.normalizeDecimalSeparator(t, this.decimalSymbolInsertedAt), this.decimalSymbolInsertedAt = void 0);
      const r = this.numberMask.conformToMask(t, this.formattedValue);
      let s;
      if (typeof r == "object") {
        const { numberValue: i, fractionDigits: a } = r;
        let { maximumFractionDigits: o, minimumFractionDigits: l } = this.currencyFormat;
        this.focus ? l = n ? a.replace(/0+$/, "").length : Math.min(o, a.length) : Number.isInteger(i) && !this.options.autoDecimalDigits && (this.options.precision === void 0 || l === 0) && (l = o = 0), s = this.toInteger(Math.abs(i)) > Number.MAX_SAFE_INTEGER ? this.formattedValue : this.currencyFormat.format(i, {
          useGrouping: this.options.useGrouping !== !1 && !(this.focus && this.options.hideGroupingSeparatorOnFocus),
          minimumFractionDigits: l,
          maximumFractionDigits: o
        });
      } else
        s = r;
      this.maxValue <= 0 && !this.currencyFormat.isNegative(s) && this.currencyFormat.parse(s) !== 0 && (s = s.replace(this.currencyFormat.prefix, this.currencyFormat.negativePrefix)), this.minValue >= 0 && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.prefix)), (this.options.currencyDisplay === sn.hidden || this.focus && this.options.hideCurrencySymbolOnFocus) && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.minusSign !== void 0 ? this.currencyFormat.minusSign : "(").replace(this.currencyFormat.negativeSuffix, this.currencyFormat.minusSign !== void 0 ? "" : ")").replace(this.currencyFormat.prefix, "").replace(this.currencyFormat.suffix, "")), this.el.value = s, this.numberValue = this.currencyFormat.parse(s);
    } else
      this.el.value = "", this.numberValue = null;
    this.formattedValue = this.el.value, this.onInput(this.getValue());
  }
  addEventListener() {
    this.el.addEventListener("input", (t) => {
      const { value: n, selectionStart: r } = this.el, s = t;
      if (r && s.data && ys.includes(s.data) && (this.decimalSymbolInsertedAt = r - 1), this.format(n), this.focus && r != null) {
        const i = () => {
          const { prefix: a, suffix: o, decimalSymbol: l, maximumFractionDigits: h, groupingSymbol: v } = this.currencyFormat;
          let u = n.length - r;
          const f = this.formattedValue.length;
          if (this.currencyFormat.minusSign === void 0 && (n.startsWith("(") || n.startsWith("-")) && !n.endsWith(")"))
            return f - this.currencyFormat.negativeSuffix.length > 1 ? this.formattedValue.substring(r).length : 1;
          if (this.formattedValue.substring(r, 1) === v && Pr(this.formattedValue, v) === Pr(n, v) + 1)
            return f - u - 1;
          if (f < u)
            return r;
          if (l !== void 0 && n.indexOf(l) !== -1) {
            const m = n.indexOf(l) + 1;
            if (Math.abs(f - n.length) > 1 && r <= m)
              return this.formattedValue.indexOf(l) + 1;
            !this.options.autoDecimalDigits && r > m && this.currencyFormat.onlyDigits(n.substring(m)).length - 1 === h && (u -= 1);
          }
          return this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden ? f - u : Math.max(f - Math.max(u, o.length), a.length);
        };
        this.setCaretPosition(i());
      }
    }), this.el.addEventListener("focus", () => {
      this.focus = !0, this.numberValueOnFocus = this.numberValue, setTimeout(() => {
        const { value: t, selectionStart: n, selectionEnd: r } = this.el;
        if (this.format(t, this.options.hideNegligibleDecimalDigitsOnFocus), n != null && r != null && Math.abs(n - r) > 0)
          this.setCaretPosition(0, this.el.value.length);
        else if (n != null) {
          const s = this.getCaretPositionOnFocus(t, n);
          this.setCaretPosition(s);
        }
      });
    }), this.el.addEventListener("blur", () => {
      this.focus = !1, this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.numberValueOnFocus !== this.numberValue && this.onChange(this.getValue());
    });
  }
  getCaretPositionOnFocus(t, n) {
    if (this.numberValue == null)
      return n;
    const { prefix: r, negativePrefix: s, suffix: i, negativeSuffix: a, groupingSymbol: o, currency: l } = this.currencyFormat, h = this.numberValue < 0, v = h ? s : r, u = v.length;
    if (this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden) {
      if (h) {
        if (n <= 1)
          return 1;
        if (t.endsWith(")") && n > t.indexOf(")"))
          return this.formattedValue.length - 1;
      }
    } else {
      const m = h ? a.length : i.length;
      if (n >= t.length - m)
        return this.formattedValue.length - m;
      if (n < u)
        return u;
    }
    let f = n;
    return this.options.hideCurrencySymbolOnFocus && this.options.currencyDisplay !== sn.hidden && n >= u && l !== void 0 && v.includes(l) && (f -= u, h && (f += 1)), this.options.hideGroupingSeparatorOnFocus && o !== void 0 && (f -= Pr(t.substring(0, n), o)), f;
  }
  setCaretPosition(t, n = t) {
    this.el.setSelectionRange(t, n);
  }
}
const nm = (e) => e?.matches("input") ? e : e?.querySelector("input");
function am(e, t) {
  var n, r, s, i;
  let a;
  const o = ge(null), l = ge(null), h = ge(null), v = ni();
  v?.emit || ((r = (n = v?.proxy) === null || n === void 0 ? void 0 : n.$emit) === null || r === void 0 || r.bind(v?.proxy));
  const u = v?.props || ((s = v?.proxy) === null || s === void 0 ? void 0 : s.$props), f = qs.startsWith("3");
  f && ((i = v?.attrs.modelModifiers) === null || i === void 0 || i.lazy);
  const m = W(() => u?.[f ? "modelValue" : "value"]);
  return Be(o, (c) => {
    var p;
    if (c) {
      const k = nm((p = c?.$el) !== null && p !== void 0 ? p : c);
      k ? (a = new tm({
        el: k,
        options: e,
        onInput: (g) => {
          h.value = g.number, l.value = g.formatted;
        },
        onChange: (g) => {
        }
      }), a.setValue(m.value)) : console.error('No input element found. Please make sure that the "inputRef" template ref is properly assigned.');
    } else
      a = null;
  }), {
    inputRef: o,
    numberValue: h,
    formattedValue: l,
    setValue: (c) => a?.setValue(c),
    setOptions: (c) => a?.setOptions(c)
  };
}
const Jl = 2, Xg = /* @__PURE__ */ Se({
  __name: "LcMoneyInput",
  props: {
    autocomplete: { default: "off" },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: { default: "0.00" },
    prefixClass: {},
    suffixClass: {},
    valueRange: { default: () => ({
      max: 1e6,
      min: 0
    }) },
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ga(e, ["autocomplete", "currency", "locale", "placeholder", "value", "valueRange"]), { formattedValue: s, inputRef: i, numberValue: a, setValue: o } = am(
      {
        currency: e.currency,
        currencyDisplay: sn.hidden,
        locale: e.locale,
        precision: Jl,
        valueRange: e.valueRange
      }
    ), l = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: u }) => u === "currency")?.value ?? e.currency
    ), h = W(
      () => At(a.value) ? parseFloat((a.value * 100).toFixed()) : null
    ), v = (u) => {
      o(At(u) ? parseFloat((u / 100).toFixed(Jl)) : null);
    };
    return pt(async () => {
      At(e.value) && (await Ya(), v(e.value));
    }), Be(h, (u) => {
      n("update:value", u);
    }), Be(
      () => e.value,
      (u) => {
        u !== h.value && v(u);
      }
    ), (u, f) => ($(), ke(j(tr), Ae({
      ref_key: "inputRef",
      ref: i
    }, { ...u.$attrs, ...r, autocomplete: e.autocomplete, placeholder: e.placeholder, value: e.value }, {
      class: "lc-money-input",
      spellcheck: !1,
      value: j(s)
    }), Xa({
      prefix: Te(() => [
        xt(Oe(l.value), 1)
      ]),
      _: 2
    }, [
      u.$slots.suffix ? {
        name: "suffix",
        fn: Te(() => [
          ve(u.$slots, "suffix")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["value"]));
  }
}), rm = ["aria-checked", "aria-label"], Gg = /* @__PURE__ */ Se({
  __name: "LcPasswordInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {},
    toggleAriaLabel: { default: () => je.lcPasswordInput.toggleAriaLabel }
  },
  setup(e) {
    const t = ga(e, ["toggleAriaLabel"]), n = ge("password"), r = W(() => s.value ? "eye-off" : "eye"), s = W(() => n.value === "text"), i = () => {
      n.value = s.value ? "password" : "text";
    };
    return (a, o) => ($(), ke(j(tr), Ae({ ...a.$attrs, ...t }, {
      class: "lc-password-input",
      spellcheck: !1,
      type: n.value
    }), {
      suffix: Te(() => [
        ne("button", {
          "aria-checked": s.value,
          "aria-label": e.toggleAriaLabel,
          class: "lc-password-input__toggle",
          role: "switch",
          type: "button",
          onClickPassive: i
        }, [
          Fe(j(Ke), { name: r.value }, null, 8, ["name"])
        ], 40, rm),
        ve(a.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), Kg = ["password", "text"], im = ["aria-valuenow"], Jg = /* @__PURE__ */ Se({
  __name: "LcProgressIndicator",
  props: {
    icon: {},
    progress: { default: 0 },
    size: { default: "medium" },
    variant: { default: "info" }
  },
  setup(e) {
    const t = W(() => e.size === "medium" ? 36 : 24);
    return (n, r) => ($(), Z("div", {
      "aria-live": "polite",
      "aria-valuenow": e.progress,
      class: ye([
        "lc-progress-indicator",
        `lc-progress-indicator--size-${e.size}`,
        `lc-progress-indicator--variant-${e.variant}`
      ]),
      role: "progressbar"
    }, [
      Fe(j(Do), Ae({ progress: e.progress, radius: t.value }, { "progress-class": "lc-progress-indicator__progress" }), null, 16),
      Fe(wn, {
        mode: "out-in",
        name: "lc-progress-indicator__transition"
      }, {
        default: Te(() => [
          ($(), ke(j(Ke), {
            key: e.icon,
            class: "lc-progress-indicator__icon",
            name: e.icon,
            size: e.size === "medium" ? "large" : "medium"
          }, null, 8, ["name", "size"]))
        ]),
        _: 1
      })
    ], 10, im));
  }
}), Qg = ["medium", "small"], e2 = ["info", "success"], _i = /* @__PURE__ */ Symbol(), lm = ["for"], om = { class: "lc-radio__control" }, sm = ["id", "aria-labelledby", "data-click-name", "name"], cm = ["id"], um = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcRadio",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = t, r = Wn(_i), s = $t(e.id), i = W(() => [
      "lc-radio",
      {
        "lc-radio--checked": a.value,
        "lc-radio--disabled": !!Ge(r?.disabled) || e.disabled,
        "lc-radio--error": !!Ge(r?.hasError)
      }
    ]), a = W(() => e.value === Ge(r?.value) || e.checked), o = W({
      get: () => a.value,
      set: () => {
        if (r) {
          r.updateValue(e.value);
          return;
        }
        n("change");
      }
    }), l = W(() => {
      if (Ge(r?.value))
        return a.value ? 0 : -1;
    }), h = W(() => Ge(r?.name) ?? e.name);
    return (v, u) => ($(), Z("label", {
      class: ye([i.value, v.$attrs.class]),
      for: j(s)
    }, [
      ne("div", om, [
        Qt(ne("input", Ae({ id: j(s) }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          tabindex: l.value
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => o.value = f),
          "aria-labelledby": e.label ? `${j(s)}-label` : void 0,
          class: "lc-radio__input",
          "data-click-name": e.dataClickName || `${h.value?.toLowerCase()}_radio`,
          name: h.value,
          type: "radio"
        }), null, 16, sm), [
          [js, o.value]
        ])
      ]),
      e.label ? ($(), Z("span", {
        key: 0,
        id: `${j(s)}-label`,
        class: ye(["lc-radio__label", e.labelClass])
      }, Oe(e.label), 11, cm)) : de("", !0)
    ], 10, lm));
  }
}), dm = { class: "lc-radio-card__main" }, t2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcRadioCard",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] },
    bodyClass: {}
  },
  setup(e) {
    const t = ot("radio"), n = Wn(_i), r = W(() => [
      "lc-radio-card",
      {
        "lc-radio-card--disabled": i.value
      }
    ]), s = W(() => e.value === Ge(n?.value) || e.checked), i = W(() => e.disabled || Ge(n?.disabled)), a = () => {
      if (i.value) return;
      n?.updateValue(e.value);
      const o = t.value?.$el?.querySelector("input");
      if (!o) return;
      const l = new Event("focusin", { bubbles: !0 }), h = new Event("focusout", { bubbles: !0 });
      o.dispatchEvent(l), o.dispatchEvent(h);
    };
    return (o, l) => ($(), ke(j(ya), {
      "body-class": ["lc-radio-card__body", e.bodyClass],
      class: ye([r.value, o.$attrs.class]),
      onClick: a
    }, {
      default: Te(() => [
        ne("div", dm, [
          Fe(j(um), Ae({ ref: "radio" }, {
            ...en(o.$attrs, ["class"]),
            ...o.$props
          }), null, 16),
          ve(o.$slots, "default", {
            checked: s.value,
            disabled: i.value
          })
        ]),
        Qt(ne("div", {
          class: "lc-radio-card__underneath",
          onClick: l[0] || (l[0] = sa(() => {
          }, ["stop"]))
        }, [
          ve(o.$slots, "underneath", { disabled: i.value })
        ], 512), [
          [li, s.value && o.$slots.underneath]
        ]),
        ve(o.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["body-class", "class"]));
  }
}), fm = ["id", "aria-labelledby"], hm = ["id"], n2 = /* @__PURE__ */ Se({
  __name: "LcRadioGroup",
  props: {
    contentWrapClass: {},
    defaultValue: { type: [Boolean, Number, String] },
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    layout: { default: "horizontal" },
    name: { default: "radio-group" },
    noFeedback: { type: Boolean },
    value: { type: [Boolean, null, Number, String], default: null }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = $t(e.id), s = W(() => [
      "lc-radio-group",
      `lc-radio-group--${e.layout}`,
      {
        "lc-radio-group--disabled": e.disabled,
        "lc-radio-group--error": i.value
      }
    ]), i = W(() => !!e.errorMessage);
    return pt(() => {
      e.defaultValue && n("update:value", e.defaultValue);
    }), ri(_i, {
      disabled: () => e.disabled,
      hasError: uo(i),
      name: () => e.name,
      updateValue: (a) => {
        n("update:value", a);
      },
      value: () => e.value
    }), (a, o) => ($(), Z("fieldset", Ae({
      ...a.$attrs,
      disabled: e.disabled,
      name: e.name
    }, {
      id: j(r),
      "aria-labelledby": e.label ? `${j(r)}-label` : void 0,
      class: s.value,
      role: "radiogroup"
    }), [
      e.label ? ($(), Z("legend", {
        key: 0,
        id: `${j(r)}-label`,
        class: "lc-radio-group__label"
      }, Oe(e.label), 9, hm)) : de("", !0),
      ne("div", {
        class: ye(["lc-radio-group__wrap", e.contentWrapClass])
      }, [
        ve(a.$slots, "default")
      ], 2),
      e.noFeedback ? de("", !0) : ($(), ke(j($n), Ae({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 16, fm));
  }
}), a2 = ["horizontal", "vertical"], vm = { class: "lc-rating" }, r2 = /* @__PURE__ */ Se({
  __name: "LcRating",
  props: {
    max: { default: 5 },
    rating: { default: 0 }
  },
  setup(e) {
    return (t, n) => ($(), Z("div", vm, [
      ($(!0), Z(Xe, null, ht(new Array(e.max), (r, s) => ($(), Z("svg", {
        key: s,
        class: ye(["lc-rating__star", s < e.rating ? "lc-rating__star--active" : "lc-rating__star--inactive"]),
        fill: "none",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...n[0] || (n[0] = [
        ne("path", { d: "M7.639.68c.148-.299.574-.299.722 0l2.16 4.377c.059.119.172.201.303.22l4.831.702c.33.048.462.454.223.686l-3.496 3.407c-.095.092-.138.226-.116.356l.825 4.811c.056.329-.289.579-.584.424l-4.321-2.271c-.117-.062-.257-.062-.374 0l-4.321 2.271c-.295.155-.64-.095-.584-.424l.825-4.811c.022-.131-.021-.264-.116-.356L.122 6.665c-.239-.233-.107-.638.223-.686l4.831-.702c.131-.019.244-.101.303-.22L7.639.68z" }, null, -1),
        ne("path", {
          d: "M.262 6.522l-.14.143.14-.143c-.12-.117-.054-.321.112-.345l4.831-.702a.6.6 0 0 0 .454-.33L7.819.768c.074-.15.289-.15.363 0l2.16 4.377c.088.178.257.301.454.33l4.831.702c.166.024.232.228.112.345l-3.496 3.407c-.142.138-.207.338-.173.533l.825 4.811c.028.165-.145.291-.294.213l-4.321-2.271a.6.6 0 0 0-.561 0l-4.321 2.271.093.177-.093-.177c-.148.078-.322-.048-.294-.213l.825-4.811a.6.6 0 0 0-.173-.533L.262 6.522z",
          "stroke-width": ".4"
        }, null, -1)
      ])], 2))), 128))
    ]));
  }
}), mm = /* @__PURE__ */ Se({
  __name: "LcSkeleton",
  props: {
    height: { default: "1rem" },
    opacity: { default: 0.4 },
    radius: { default: "large" },
    width: { default: "100%" }
  },
  setup(e) {
    return (t, n) => ($(), Z("div", {
      "aria-hidden": "true",
      class: ye(["lc-skeleton", `lc-skeleton--radius-${e.radius}`]),
      style: Ct({
        "--skeleton-height": e.height,
        "--skeleton-radius": e.radius,
        "--skeleton-width": e.width,
        "--skeleton-opacity": e.opacity
      })
    }, null, 6));
  }
}), i2 = ["full", "half", "large", "medium", "none", "small"], gm = { class: "lc-remote-list__content" }, bm = {
  key: 0,
  class: "lc-remote-list__cta-wrap"
}, l2 = /* @__PURE__ */ Se({
  __name: "LcRemoteList",
  props: {
    buttonText: {},
    count: {},
    hideSeparator: { type: Boolean },
    loading: { type: Boolean },
    numberOfSkeletons: { default: 3 },
    skeletonHeight: { default: "10.75rem" },
    total: {}
  },
  emits: ["fetch-more"],
  setup(e, { emit: t }) {
    const n = t, r = W(() => [
      "lc-remote-list",
      {
        "lc-remote-list--separator": !e.hideSeparator
      }
    ]), s = W(() => e.count < e.total), i = () => {
      s.value && n("fetch-more");
    };
    return (a, o) => ($(), Z("section", {
      class: ye(r.value)
    }, [
      ne("ul", gm, [
        ve(a.$slots, "default"),
        e.loading ? ve(a.$slots, "loading", {}, () => [
          ($(!0), Z(Xe, null, ht(e.numberOfSkeletons, (l) => ($(), ke(j(mm), {
            key: l,
            height: e.skeletonHeight,
            radius: "medium"
          }, null, 8, ["height"]))), 128))
        ], void 0, 0) : de("", !0)
      ]),
      !e.loading && s.value ? ($(), Z("div", bm, [
        ve(a.$slots, "load-more", Lt(Ot({ fetchMore: i })), () => [
          Fe(j(kt), {
            class: "lc-remote-list__cta",
            size: "medium",
            variant: "secondary",
            onClickPassive: i
          }, {
            default: Te(() => [
              xt(Oe(e.buttonText), 1)
            ]),
            _: 1
          })
        ]),
        e.hideSeparator ? de("", !0) : ($(), ke(j(ui), { key: 0 }))
      ])) : de("", !0)
    ], 2));
  }
}), pm = { class: "lc-scratchcard-teaser__button-wrap" }, o2 = /* @__PURE__ */ Se({
  __name: "LcScratchcardTeaser",
  props: {
    href: {},
    target: {},
    to: {},
    backgroundPattern: {},
    badge: {},
    buttonAriaLabel: {},
    buttonText: {},
    variant: { default: "default" }
  },
  emits: ["primary-button-click"],
  setup(e) {
    return (t, n) => ($(), ke(j(nr), Ae({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-scratchcard-teaser__body",
      class: ["lc-scratchcard-teaser", `lc-scratchcard-teaser--variant-${e.variant}`],
      style: {
        "--teaser-frame-color": "var(--scratchcard-teaser-frame-color)"
      }
    }), {
      default: Te(() => [
        Fe(j(ci), Ae({ href: e.href, target: e.target, to: e.to }, {
          class: "lc-scratchcard-teaser__link",
          tabindex: "-1"
        }), {
          default: Te(() => [
            ve(t.$slots, "image")
          ]),
          _: 3
        }, 16),
        ne("div", pm, [
          Fe(j(kt), Ae({ "aria-label": e.buttonAriaLabel }, { href: e.href, target: e.target, to: e.to }, {
            class: "lc-scratchcard-teaser__button",
            "no-padding": "",
            onClick: n[0] || (n[0] = (r) => t.$emit("primary-button-click"))
          }), {
            default: Te(() => [
              xt(Oe(e.buttonText), 1)
            ]),
            _: 1
          }, 16, ["aria-label"])
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), s2 = [...Ko];
var Gt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.Enter = "Enter", e.Escape = "Escape", e.Space = " ", e.Tab = "Tab", e))(Gt || {});
const ym = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-labelledby", "data-click-name", "disabled", "role"], wm = ["id"], xm = { class: "lc-select__input" }, km = ["id", "aria-activedescendant", "aria-labelledby"], Sm = ["id", "aria-selected", "onClickPassive"], c2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcSelect",
  props: {
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "select" },
    noFeedback: { type: Boolean },
    noTeleport: { type: Boolean },
    notNullable: { type: Boolean },
    onBlur: {},
    options: {},
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ot("button"), s = ot("container"), i = ot("menu"), a = ot("options"), o = ge(null), l = ge(!1), h = ti({
      focusin: !1,
      focusout: !1
    }), { floatingStyles: v } = gs(r, i, {
      middleware: [vs(), bs, hs(2)],
      whileElementsMounted: fs
    }), { width: u } = Hr(s), f = $t(e.id), m = Si(), c = W(() => {
      if (!(!l.value || !At(o.value)))
        return `${f}-option-${o.value}`;
    }), p = W(() => [
      "lc-select",
      {
        "lc-select--disabled": e.disabled,
        "lc-select--error": !!e.errorMessage,
        "lc-select--expanded": l.value,
        "lc-select--fixed-value": b.value,
        "lc-select--has-label": !b.value && !!e.label
      }
    ]), k = W(
      () => b.value || e.value ? e.options[g.value].label : ""
    ), g = W(() => e.options.findIndex((E) => E.value === e.value)), b = W(() => e.notNullable && e.options.length === 1 && !!e.value), C = W(() => [
      "lc-select__label",
      {
        "lc-select__label--floating": !!e.value
      }
    ]), A = W(() => [
      "lc-select__menu",
      {
        "lc-select__menu--scrollable": e.options.length > 6
      }
    ]), D = W(() => ({
      ...v.value,
      minWidth: `${u.value}px`
    })), L = () => {
      l.value && (o.value = null, l.value = !1, e.onBlur?.(), T("focusout"));
    }, T = (E) => {
      const R = r.value;
      if (!R) return;
      h[E] = !0;
      const V = new Event(E, { bubbles: !0 });
      R.dispatchEvent(V);
    }, P = async () => {
      l.value || await H();
    }, U = (E) => {
      const R = E.type;
      if (!X(R)) return;
      h[R] ? h[R] = !1 : E.stopPropagation();
    }, K = async (E) => {
      if (!tn(E.key, Gt)) return;
      E.key !== Gt.Tab && (E.preventDefault(), E.stopPropagation());
      const R = e.options.length - 1;
      switch (E.key) {
        case Gt.ArrowDown:
          if (l.value && At(o.value)) {
            o.value = Math.min(R, o.value + 1), _();
            break;
          }
          o.value = 0, await H();
          break;
        case Gt.ArrowUp:
          if (l.value && At(o.value)) {
            o.value = Math.max(0, o.value - 1), _();
            break;
          }
          o.value = R, await H();
          break;
        case Gt.Enter:
        case Gt.Space:
          if (l.value && At(o.value)) {
            B(e.options[o.value].value);
            break;
          }
          await H();
          break;
        case Gt.Escape:
          L();
          break;
        case Gt.Tab:
          if (!l.value || !At(o.value)) break;
          B(e.options[o.value].value);
          break;
      }
    }, B = (E) => {
      const R = e.value === E ? null : E;
      e.notNullable && R === null || (n("update:value", R), L());
    }, X = (E) => E === "focusin" || E === "focusout", H = async () => {
      l.value || (l.value = !0, e.value && (o.value = g.value), T("focusin"), await Ya(), _());
    }, _ = () => {
      if (!At(o.value)) return;
      a.value?.[o.value]?.scrollIntoView({ block: "center" });
    };
    return Ga(i, L, {
      ignore: [r, ...Ge(e.ignoreOutsideClickOn)]
    }), pt(() => {
      e.autofocus && r.value?.focus(), e.value && (o.value = g.value);
    }), (E, R) => ($(), Z("div", {
      ref: "container",
      class: ye([p.value, E.$attrs.class])
    }, [
      ne("button", Ae({
        id: j(f),
        ref: "button"
      }, en(E.$attrs, ["class"]), {
        "aria-controls": b.value ? void 0 : `${j(f)}-listbox`,
        "aria-expanded": b.value ? void 0 : l.value,
        "aria-haspopup": b.value ? void 0 : "listbox",
        "aria-labelledby": e.label ? `${j(f)}-label` : void 0,
        class: "lc-select__wrap",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_select`,
        disabled: b.value || e.disabled,
        role: b.value ? void 0 : "combobox",
        type: "button",
        onClickPassive: P,
        onFocusin: U,
        onFocusout: U,
        onKeydown: K
      }), [
        !b.value && e.label ? ($(), Z("span", {
          key: 0,
          id: `${j(f)}-label`,
          class: ye(C.value)
        }, Oe(e.label), 11, wm)) : de("", !0),
        ne("div", xm, Oe(k.value), 1),
        b.value ? de("", !0) : ($(), ke(j(Ke), {
          key: 1,
          class: "lc-select__icon",
          name: "chevron-down"
        }))
      ], 16, ym),
      b.value ? de("", !0) : ($(), ke(j(ku), {
        key: 0,
        to: e.noTeleport ? void 0 : "body"
      }, {
        default: Te(() => [
          l.value ? ($(), Z("div", {
            key: 0,
            ref: "menu",
            class: ye(A.value),
            style: Ct(D.value)
          }, [
            ne("ul", {
              id: `${j(f)}-listbox`,
              "aria-activedescendant": c.value,
              "aria-labelledby": e.label ? `${j(f)}-label` : void 0,
              class: "lc-select__menu-list",
              role: "listbox"
            }, [
              ($(!0), Z(Xe, null, ht(e.options, (V, q) => ($(), Z("li", {
                key: `${V.label}-${V.value}`,
                class: ye(["lc-select__menu-item", {
                  "lc-select__menu-item--focused": o.value === q && j(m),
                  "lc-select__menu-item--selected": V.value === e.value
                }])
              }, [
                ne("button", {
                  id: `${j(f)}-option-${q}`,
                  ref_for: !0,
                  ref: "options",
                  "aria-selected": V.value === e.value,
                  class: "lc-select__menu-item-button",
                  role: "option",
                  tabindex: "-1",
                  type: "button",
                  onClickPassive: (O) => B(V.value)
                }, [
                  ne("span", null, Oe(V.label), 1),
                  V.value === e.value ? ($(), ke(j(Ke), {
                    key: 0,
                    class: "lc-select__menu-item-checkmark",
                    name: "checkmark"
                  })) : de("", !0)
                ], 40, Sm)
              ], 2))), 128))
            ], 8, km)
          ], 6)) : de("", !0)
        ]),
        _: 1
      }, 8, ["to"])),
      e.noFeedback ? de("", !0) : ($(), ke(j($n), Ae({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), u2 = ["default", "discreet"];
var Wt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Home = "Home", e.Space = " ", e))(Wt || {});
const _m = ["id", "aria-activedescendant"], d2 = /* @__PURE__ */ Se({
  __name: "LcSelectList",
  props: {
    horizontal: { type: Boolean },
    id: {},
    multiple: { type: Boolean },
    optionComponent: {},
    options: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ot("list"), s = ge(null), i = $t(e.id), a = Si(), o = W(() => {
      if (At(s.value))
        return `${i}-option-${s.value}`;
    }), l = W(() => !r.value || !At(s.value) ? null : r.value.querySelectorAll('[role="option"]')[s.value]), h = W(() => [
      "lc-select-list",
      `lc-select-list--variant-${e.variant}`,
      {
        "lc-select-list--focus-hidden": e.options.length <= 1,
        "lc-select-list--horizontal": e.horizontal
      }
    ]), v = W(
      () => e.options.findIndex((A) => A.value === (Array.isArray(e.value) ? e.value[0] : e.value))
    ), u = (A) => e.optionComponent ? g(A) ? "span" : e.optionComponent : k(A) ? g(A) ? "span" : Yn(A.to) : "button", f = () => {
      a.value && (s.value = Math.max(0, v.value));
    }, m = () => {
      a.value && (s.value = null);
    }, c = (A) => {
      if (!tn(A.key, Wt) || !At(s.value))
        return;
      A.preventDefault(), A.stopPropagation();
      const D = e.options.length - 1;
      switch (A.key) {
        case Wt.ArrowDown:
        case Wt.ArrowRight:
          s.value = Math.min(D, s.value + 1);
          break;
        case Wt.ArrowLeft:
        case Wt.ArrowUp:
          s.value = Math.max(0, s.value - 1);
          break;
        case Wt.End:
          s.value = D;
          break;
        case Wt.Enter:
        case Wt.Space:
          l.value?.dispatchEvent(new MouseEvent("click"));
          break;
        case Wt.Home:
          s.value = 0;
          break;
      }
    }, p = (A) => {
      let D;
      if (e.multiple) {
        const L = Array.isArray(e.value) ? e.value : [];
        D = L.includes(A) ? L.filter((T) => T !== A) : C([...L, A]);
      } else
        D = e.value === A ? void 0 : A;
      n("update:value", D);
    }, k = ({ href: A, to: D }) => !!(A || D), g = (A) => Array.isArray(e.value) ? e.value.includes(A.value) : e.value === A.value, b = () => {
      l.value?.scrollIntoView(
        e.horizontal ? { block: "nearest", inline: "center" } : { block: "center", inline: "nearest" }
      );
    }, C = (A) => {
      const D = new Map(e.options.map((L, T) => [L.value, T]));
      return [...A].sort(
        (L, T) => (D.get(L) ?? 1 / 0) - (D.get(T) ?? 1 / 0)
      );
    };
    return pt(() => {
      if (e.value) {
        if (e.multiple && !Array.isArray(e.value))
          throw Error('LcSelectList: "value" must be an array when "multiple" is true.');
        if (!e.multiple && Array.isArray(e.value))
          throw Error('LcSelectList: "value" must not be an array when "multiple" is false.');
      }
    }), Be(s, (A) => {
      A !== null && b();
    }), (A, D) => ($(), Z("div", {
      class: ye(h.value)
    }, [
      ne("ul", {
        id: j(i),
        ref: "list",
        "aria-activedescendant": o.value,
        class: "lc-select-list__list",
        role: "listbox",
        tabindex: "0",
        onFocusin: f,
        onFocusout: m,
        onKeydown: c
      }, [
        ($(!0), Z(Xe, null, ht(e.options, (L, T) => ($(), Z("li", {
          key: `${L.label}-${L.value}`,
          class: ye(["lc-select-list__item", {
            "lc-select-list__item--focused": s.value === T && j(a),
            "lc-select-list__item--selected": g(L)
          }])
        }, [
          ($(), ke(zt(u(L)), Ae({
            id: `${j(i)}-option-${T}`
          }, { ref_for: !0 }, {
            ...fu(L, ["href", "target", "to"]),
            ...L?.additionalProps ?? {}
          }, {
            "aria-label": L.ariaLabelText,
            "aria-selected": g(L),
            class: "lc-select-list__item-button",
            role: "option",
            tabindex: "-1",
            type: k(L) && !g(L) ? void 0 : "button",
            onClickPassive: (P) => p(L.value)
          }), {
            default: Te(() => [
              ne("span", null, Oe(L.label), 1),
              g(L) ? ($(), ke(j(Ke), {
                key: 0,
                class: "lc-select-list__item-checkmark",
                name: e.variant === "discreet" ? "checkmark-small" : "checkmark"
              }, null, 8, ["name"])) : de("", !0)
            ]),
            _: 2
          }, 1040, ["id", "aria-label", "aria-selected", "type", "onClickPassive"]))
        ], 2))), 128))
      ], 40, _m)
    ], 2));
  }
});
function Ma(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function Cm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function xs(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var Ql = xs((function(e, t) {
  e.exports = /* @__PURE__ */ (function() {
    var n = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function r(c) {
      return c.split("").reverse().join("");
    }
    function s(c, p) {
      return c.substring(0, p.length) === p;
    }
    function i(c, p) {
      return c.slice(-1 * p.length) === p;
    }
    function a(c, p, k) {
      if ((c[p] || c[k]) && c[p] === c[k]) throw new Error(p);
    }
    function o(c) {
      return typeof c == "number" && isFinite(c);
    }
    function l(c, p) {
      return c = c.toString().split("e"), (+((c = (c = Math.round(+(c[0] + "e" + (c[1] ? +c[1] + p : p)))).toString().split("e"))[0] + "e" + (c[1] ? +c[1] - p : -p))).toFixed(p);
    }
    function h(c, p, k, g, b, C, A, D, L, T, P, U) {
      var K, B, X, H = U, _ = "", E = "";
      return C && (U = C(U)), !!o(U) && (c !== !1 && parseFloat(U.toFixed(c)) === 0 && (U = 0), U < 0 && (K = !0, U = Math.abs(U)), c !== !1 && (U = l(U, c)), (U = U.toString()).indexOf(".") !== -1 ? (X = (B = U.split("."))[0], k && (_ = k + B[1])) : X = U, p && (X = r(X).match(/.{1,3}/g), X = r(X.join(r(p)))), K && D && (E += D), g && (E += g), K && L && (E += L), E += X, E += _, b && (E += b), T && (E = T(E, H)), E);
    }
    function v(c, p, k, g, b, C, A, D, L, T, P, U) {
      var K, B = "";
      return P && (U = P(U)), !(!U || typeof U != "string") && (D && s(U, D) && (U = U.replace(D, ""), K = !0), g && s(U, g) && (U = U.replace(g, "")), L && s(U, L) && (U = U.replace(L, ""), K = !0), b && i(U, b) && (U = U.slice(0, -1 * b.length)), p && (U = U.split(p).join("")), k && (U = U.replace(k, ".")), K && (B += "-"), (B = (B += U).replace(/[^0-9\.\-.]/g, "")) !== "" && (B = Number(B), A && (B = A(B)), !!o(B) && B));
    }
    function u(c) {
      var p, k, g, b = {};
      for (c.suffix === void 0 && (c.suffix = c.postfix), p = 0; p < n.length; p += 1) if ((g = c[k = n[p]]) === void 0) k !== "negative" || b.negativeBefore ? k === "mark" && b.thousand !== "." ? b[k] = "." : b[k] = !1 : b[k] = "-";
      else if (k === "decimals") {
        if (!(g >= 0 && g < 8)) throw new Error(k);
        b[k] = g;
      } else if (k === "encoder" || k === "decoder" || k === "edit" || k === "undo") {
        if (typeof g != "function") throw new Error(k);
        b[k] = g;
      } else {
        if (typeof g != "string") throw new Error(k);
        b[k] = g;
      }
      return a(b, "mark", "thousand"), a(b, "prefix", "negative"), a(b, "prefix", "negativeBefore"), b;
    }
    function f(c, p, k) {
      var g, b = [];
      for (g = 0; g < n.length; g += 1) b.push(c[n[g]]);
      return b.push(k), p.apply("", b);
    }
    function m(c) {
      if (!(this instanceof m)) return new m(c);
      typeof c == "object" && (c = u(c), this.to = function(p) {
        return f(c, h, p);
      }, this.from = function(p) {
        return f(c, v, p);
      });
    }
    return m;
  })();
})), Em = Cm(xs((function(e, t) {
  (function(n) {
    function r(F) {
      return s(F) && typeof F.from == "function";
    }
    function s(F) {
      return typeof F == "object" && typeof F.to == "function";
    }
    function i(F) {
      F.parentElement.removeChild(F);
    }
    function a(F) {
      return F != null;
    }
    function o(F) {
      F.preventDefault();
    }
    function l(F) {
      return F.filter((function(S) {
        return !this[S] && (this[S] = !0);
      }), {});
    }
    function h(F, S) {
      return Math.round(F / S) * S;
    }
    function v(F, S) {
      var w = F.getBoundingClientRect(), G = F.ownerDocument, M = G.documentElement, ie = C(G);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (ie.x = 0), S ? w.top + ie.y - M.clientTop : w.left + ie.x - M.clientLeft;
    }
    function u(F) {
      return typeof F == "number" && !isNaN(F) && isFinite(F);
    }
    function f(F, S, w) {
      w > 0 && (k(F, S), setTimeout((function() {
        g(F, S);
      }), w));
    }
    function m(F) {
      return Math.max(Math.min(F, 100), 0);
    }
    function c(F) {
      return Array.isArray(F) ? F : [F];
    }
    function p(F) {
      var S = (F = String(F)).split(".");
      return S.length > 1 ? S[1].length : 0;
    }
    function k(F, S) {
      F.classList && !/\s/.test(S) ? F.classList.add(S) : F.className += " " + S;
    }
    function g(F, S) {
      F.classList && !/\s/.test(S) ? F.classList.remove(S) : F.className = F.className.replace(new RegExp("(^|\\b)" + S.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(F, S) {
      return F.classList ? F.classList.contains(S) : new RegExp("\\b" + S + "\\b").test(F.className);
    }
    function C(F) {
      var S = window.pageXOffset !== void 0, w = (F.compatMode || "") === "CSS1Compat";
      return { x: S ? window.pageXOffset : w ? F.documentElement.scrollLeft : F.body.scrollLeft, y: S ? window.pageYOffset : w ? F.documentElement.scrollTop : F.body.scrollTop };
    }
    function A() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function D() {
      var F = !1;
      try {
        var S = Object.defineProperty({}, "passive", { get: function() {
          F = !0;
        } });
        window.addEventListener("test", null, S);
      } catch {
      }
      return F;
    }
    function L() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function T(F, S) {
      return 100 / (S - F);
    }
    function P(F, S, w) {
      return 100 * S / (F[w + 1] - F[w]);
    }
    function U(F, S) {
      return P(F, F[0] < 0 ? S + Math.abs(F[0]) : S - F[0], 0);
    }
    function K(F, S) {
      return S * (F[1] - F[0]) / 100 + F[0];
    }
    function B(F, S) {
      for (var w = 1; F >= S[w]; ) w += 1;
      return w;
    }
    function X(F, S, w) {
      if (w >= F.slice(-1)[0]) return 100;
      var G = B(w, F), M = F[G - 1], ie = F[G], I = S[G - 1], J = S[G];
      return I + U([M, ie], w) / T(I, J);
    }
    function H(F, S, w) {
      if (w >= 100) return F.slice(-1)[0];
      var G = B(w, S), M = F[G - 1], ie = F[G], I = S[G - 1];
      return K([M, ie], (w - I) * T(I, S[G]));
    }
    function _(F, S, w, G) {
      if (G === 100) return G;
      var M = B(G, F), ie = F[M - 1], I = F[M];
      return w ? G - ie > (I - ie) / 2 ? I : ie : S[M - 1] ? F[M - 1] + h(G - F[M - 1], S[M - 1]) : G;
    }
    var E, R;
    n.PipsMode = void 0, (R = n.PipsMode || (n.PipsMode = {})).Range = "range", R.Steps = "steps", R.Positions = "positions", R.Count = "count", R.Values = "values", n.PipsType = void 0, (E = n.PipsType || (n.PipsType = {}))[E.None = -1] = "None", E[E.NoValue = 0] = "NoValue", E[E.LargeValue = 1] = "LargeValue", E[E.SmallValue = 2] = "SmallValue";
    var V = (function() {
      function F(S, w, G) {
        var M;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [G || !1], this.xNumSteps = [!1], this.snap = w;
        var ie = [];
        for (Object.keys(S).forEach((function(I) {
          ie.push([c(S[I]), I]);
        })), ie.sort((function(I, J) {
          return I[0][0] - J[0][0];
        })), M = 0; M < ie.length; M++) this.handleEntryPoint(ie[M][1], ie[M][0]);
        for (this.xNumSteps = this.xSteps.slice(0), M = 0; M < this.xNumSteps.length; M++) this.handleStepPoint(M, this.xNumSteps[M]);
      }
      return F.prototype.getDistance = function(S) {
        for (var w = [], G = 0; G < this.xNumSteps.length - 1; G++) w[G] = P(this.xVal, S, G);
        return w;
      }, F.prototype.getAbsoluteDistance = function(S, w, G) {
        var M, ie = 0;
        if (S < this.xPct[this.xPct.length - 1]) for (; S > this.xPct[ie + 1]; ) ie++;
        else S === this.xPct[this.xPct.length - 1] && (ie = this.xPct.length - 2);
        G || S !== this.xPct[ie + 1] || ie++, w === null && (w = []);
        var I = 1, J = w[ie], y = 0, ue = 0, Ee = 0, d = 0;
        for (M = G ? (S - this.xPct[ie]) / (this.xPct[ie + 1] - this.xPct[ie]) : (this.xPct[ie + 1] - S) / (this.xPct[ie + 1] - this.xPct[ie]); J > 0; ) y = this.xPct[ie + 1 + d] - this.xPct[ie + d], w[ie + d] * I + 100 - 100 * M > 100 ? (ue = y * M, I = (J - 100 * M) / w[ie + d], M = 1) : (ue = w[ie + d] * y / 100 * I, I = 0), G ? (Ee -= ue, this.xPct.length + d >= 1 && d--) : (Ee += ue, this.xPct.length - d >= 1 && d++), J = w[ie + d] * I;
        return S + Ee;
      }, F.prototype.toStepping = function(S) {
        return S = X(this.xVal, this.xPct, S);
      }, F.prototype.fromStepping = function(S) {
        return H(this.xVal, this.xPct, S);
      }, F.prototype.getStep = function(S) {
        return S = _(this.xPct, this.xSteps, this.snap, S);
      }, F.prototype.getDefaultStep = function(S, w, G) {
        var M = B(S, this.xPct);
        return (S === 100 || w && S === this.xPct[M - 1]) && (M = Math.max(M - 1, 1)), (this.xVal[M] - this.xVal[M - 1]) / G;
      }, F.prototype.getNearbySteps = function(S) {
        var w = B(S, this.xPct);
        return { stepBefore: { startValue: this.xVal[w - 2], step: this.xNumSteps[w - 2], highestStep: this.xHighestCompleteStep[w - 2] }, thisStep: { startValue: this.xVal[w - 1], step: this.xNumSteps[w - 1], highestStep: this.xHighestCompleteStep[w - 1] }, stepAfter: { startValue: this.xVal[w], step: this.xNumSteps[w], highestStep: this.xHighestCompleteStep[w] } };
      }, F.prototype.countStepDecimals = function() {
        var S = this.xNumSteps.map(p);
        return Math.max.apply(null, S);
      }, F.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, F.prototype.convert = function(S) {
        return this.getStep(this.toStepping(S));
      }, F.prototype.handleEntryPoint = function(S, w) {
        var G;
        if (!u(G = S === "min" ? 0 : S === "max" ? 100 : parseFloat(S)) || !u(w[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(G), this.xVal.push(w[0]);
        var M = Number(w[1]);
        G ? this.xSteps.push(!isNaN(M) && M) : isNaN(M) || (this.xSteps[0] = M), this.xHighestCompleteStep.push(0);
      }, F.prototype.handleStepPoint = function(S, w) {
        if (w) if (this.xVal[S] !== this.xVal[S + 1]) {
          this.xSteps[S] = P([this.xVal[S], this.xVal[S + 1]], w, 0) / T(this.xPct[S], this.xPct[S + 1]);
          var G = (this.xVal[S + 1] - this.xVal[S]) / this.xNumSteps[S], M = Math.ceil(Number(G.toFixed(3)) - 1), ie = this.xVal[S] + this.xNumSteps[S] * M;
          this.xHighestCompleteStep[S] = ie;
        } else this.xSteps[S] = this.xHighestCompleteStep[S] = this.xVal[S];
      }, F;
    })(), q = { to: function(F) {
      return F === void 0 ? "" : F.toFixed(2);
    }, from: Number }, O = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, Q = { tooltips: ".__tooltips", aria: ".__aria" };
    function ae(F, S) {
      if (!u(S)) throw new Error("noUiSlider: 'step' is not numeric.");
      F.singleStep = S;
    }
    function le(F, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      F.keyboardPageMultiplier = S;
    }
    function me(F, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      F.keyboardMultiplier = S;
    }
    function $e(F, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      F.keyboardDefaultStep = S;
    }
    function xe(F, S) {
      if (typeof S != "object" || Array.isArray(S)) throw new Error("noUiSlider: 'range' is not an object.");
      if (S.min === void 0 || S.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      F.spectrum = new V(S, F.snap || !1, F.singleStep);
    }
    function fe(F, S) {
      if (S = c(S), !Array.isArray(S) || !S.length) throw new Error("noUiSlider: 'start' option is incorrect.");
      F.handles = S.length, F.start = S;
    }
    function be(F, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
      F.snap = S;
    }
    function _e(F, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
      F.animate = S;
    }
    function Me(F, S) {
      if (typeof S != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      F.animationDuration = S;
    }
    function qe(F, S) {
      var w, G = [!1];
      if (S === "lower" ? S = [!0, !1] : S === "upper" && (S = [!1, !0]), S === !0 || S === !1) {
        for (w = 1; w < F.handles; w++) G.push(S);
        G.push(!1);
      } else {
        if (!Array.isArray(S) || !S.length || S.length !== F.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        G = S;
      }
      F.connect = G;
    }
    function ce(F, S) {
      switch (S) {
        case "horizontal":
          F.ort = 0;
          break;
        case "vertical":
          F.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function se(F, S) {
      if (!u(S)) throw new Error("noUiSlider: 'margin' option must be numeric.");
      S !== 0 && (F.margin = F.spectrum.getDistance(S));
    }
    function pe(F, S) {
      if (!u(S)) throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (F.limit = F.spectrum.getDistance(S), !F.limit || F.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function Pe(F, S) {
      var w;
      if (!u(S) && !Array.isArray(S)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(S) && S.length !== 2 && !u(S[0]) && !u(S[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (S !== 0) {
        for (Array.isArray(S) || (S = [S, S]), F.padding = [F.spectrum.getDistance(S[0]), F.spectrum.getDistance(S[1])], w = 0; w < F.spectrum.xNumSteps.length - 1; w++) if (F.padding[0][w] < 0 || F.padding[1][w] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var G = S[0] + S[1], M = F.spectrum.xVal[0];
        if (G / (F.spectrum.xVal[F.spectrum.xVal.length - 1] - M) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function He(F, S) {
      switch (S) {
        case "ltr":
          F.dir = 0;
          break;
        case "rtl":
          F.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function Ue(F, S) {
      if (typeof S != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var w = S.indexOf("tap") >= 0, G = S.indexOf("drag") >= 0, M = S.indexOf("fixed") >= 0, ie = S.indexOf("snap") >= 0, I = S.indexOf("hover") >= 0, J = S.indexOf("unconstrained") >= 0, y = S.indexOf("drag-all") >= 0, ue = S.indexOf("smooth-steps") >= 0;
      if (M) {
        if (F.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        se(F, F.start[1] - F.start[0]);
      }
      if (J && (F.margin || F.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      F.events = { tap: w || ie, drag: G, dragAll: y, smoothSteps: ue, fixed: M, snap: ie, hover: I, unconstrained: J };
    }
    function ze(F, S) {
      if (S !== !1) if (S === !0 || s(S)) {
        F.tooltips = [];
        for (var w = 0; w < F.handles; w++) F.tooltips.push(S);
      } else {
        if ((S = c(S)).length !== F.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        S.forEach((function(G) {
          if (typeof G != "boolean" && !s(G)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        })), F.tooltips = S;
      }
    }
    function Ne(F, S) {
      if (S.length !== F.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
      F.handleAttributes = S;
    }
    function Qe(F, S) {
      if (!s(S)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      F.ariaFormat = S;
    }
    function vt(F, S) {
      if (!r(S)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      F.format = S;
    }
    function mt(F, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      F.keyboardSupport = S;
    }
    function dt(F, S) {
      F.documentElement = S;
    }
    function St(F, S) {
      if (typeof S != "string" && S !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      F.cssPrefix = S;
    }
    function Et(F, S) {
      if (typeof S != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof F.cssPrefix == "string" ? (F.cssClasses = {}, Object.keys(S).forEach((function(w) {
        F.cssClasses[w] = F.cssPrefix + S[w];
      }))) : F.cssClasses = S;
    }
    function it(F) {
      var S = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: q, format: q }, w = { step: { r: !1, t: ae }, keyboardPageMultiplier: { r: !1, t: le }, keyboardMultiplier: { r: !1, t: me }, keyboardDefaultStep: { r: !1, t: $e }, start: { r: !0, t: fe }, connect: { r: !0, t: qe }, direction: { r: !0, t: He }, snap: { r: !1, t: be }, animate: { r: !1, t: _e }, animationDuration: { r: !1, t: Me }, range: { r: !0, t: xe }, orientation: { r: !1, t: ce }, margin: { r: !1, t: se }, limit: { r: !1, t: pe }, padding: { r: !1, t: Pe }, behaviour: { r: !0, t: Ue }, ariaFormat: { r: !1, t: Qe }, format: { r: !1, t: vt }, tooltips: { r: !1, t: ze }, keyboardSupport: { r: !0, t: mt }, documentElement: { r: !1, t: dt }, cssPrefix: { r: !0, t: St }, cssClasses: { r: !0, t: Et }, handleAttributes: { r: !1, t: Ne } }, G = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: O, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      F.format && !F.ariaFormat && (F.ariaFormat = F.format), Object.keys(w).forEach((function(y) {
        if (a(F[y]) || G[y] !== void 0) w[y].t(S, a(F[y]) ? F[y] : G[y]);
        else if (w[y].r) throw new Error("noUiSlider: '" + y + "' is required.");
      })), S.pips = F.pips;
      var M = document.createElement("div"), ie = M.style.msTransform !== void 0, I = M.style.transform !== void 0;
      S.transformRule = I ? "transform" : ie ? "msTransform" : "webkitTransform";
      var J = [["left", "top"], ["right", "bottom"]];
      return S.style = J[S.dir][S.ort], S;
    }
    function Nt(F, S, w) {
      var G, M, ie, I, J, y = A(), ue = L() && D(), Ee = F, d = S.spectrum, re = [], te = [], x = [], N = 0, ee = {}, Ie = F.ownerDocument, we = S.documentElement || Ie.documentElement, Le = Ie.body, Ze = Ie.dir === "rtl" || S.ort === 1 ? 0 : 100;
      function gt(z, Y) {
        var oe = Ie.createElement("div");
        return Y && k(oe, Y), z.appendChild(oe), oe;
      }
      function et(z, Y) {
        var oe = gt(z, S.cssClasses.origin), he = gt(oe, S.cssClasses.handle);
        if (gt(he, S.cssClasses.touchArea), he.setAttribute("data-handle", String(Y)), S.keyboardSupport && (he.setAttribute("tabindex", "0"), he.addEventListener("keydown", (function(Ce) {
          return Ls(Ce, Y);
        }))), S.handleAttributes !== void 0) {
          var De = S.handleAttributes[Y];
          Object.keys(De).forEach((function(Ce) {
            he.setAttribute(Ce, De[Ce]);
          }));
        }
        return he.setAttribute("role", "slider"), he.setAttribute("aria-orientation", S.ort ? "vertical" : "horizontal"), Y === 0 ? k(he, S.cssClasses.handleLower) : Y === S.handles - 1 && k(he, S.cssClasses.handleUpper), oe;
      }
      function We(z, Y) {
        return !!Y && gt(z, S.cssClasses.connect);
      }
      function st(z, Y) {
        var oe = gt(Y, S.cssClasses.connects);
        M = [], (ie = []).push(We(oe, z[0]));
        for (var he = 0; he < S.handles; he++) M.push(et(Y, he)), x[he] = he, ie.push(We(oe, z[he + 1]));
      }
      function yt(z) {
        return k(z, S.cssClasses.target), S.dir === 0 ? k(z, S.cssClasses.ltr) : k(z, S.cssClasses.rtl), S.ort === 0 ? k(z, S.cssClasses.horizontal) : k(z, S.cssClasses.vertical), k(z, getComputedStyle(z).direction === "rtl" ? S.cssClasses.textDirectionRtl : S.cssClasses.textDirectionLtr), gt(z, S.cssClasses.base);
      }
      function Tt(z, Y) {
        return !(!S.tooltips || !S.tooltips[Y]) && gt(z.firstChild, S.cssClasses.tooltip);
      }
      function fn() {
        return Ee.hasAttribute("disabled");
      }
      function an(z) {
        return M[z].hasAttribute("disabled");
      }
      function tt() {
        J && (Xn("update" + Q.tooltips), J.forEach((function(z) {
          z && i(z);
        })), J = null);
      }
      function It() {
        tt(), J = M.map(Tt), hr("update" + Q.tooltips, (function(z, Y, oe) {
          if (J && S.tooltips && J[Y] !== !1) {
            var he = z[Y];
            S.tooltips[Y] !== !0 && (he = S.tooltips[Y].to(oe[Y])), J[Y].innerHTML = he;
          }
        }));
      }
      function bt() {
        Xn("update" + Q.aria), hr("update" + Q.aria, (function(z, Y, oe, he, De) {
          x.forEach((function(Ce) {
            var Ve = M[Ce], Re = ka(te, Ce, 0, !0, !0, !0), ut = ka(te, Ce, 100, !0, !0, !0), lt = De[Ce], Je = String(S.ariaFormat.to(oe[Ce]));
            Re = d.fromStepping(Re).toFixed(1), ut = d.fromStepping(ut).toFixed(1), lt = d.fromStepping(lt).toFixed(1), Ve.children[0].setAttribute("aria-valuemin", Re), Ve.children[0].setAttribute("aria-valuemax", ut), Ve.children[0].setAttribute("aria-valuenow", lt), Ve.children[0].setAttribute("aria-valuetext", Je);
          }));
        }));
      }
      function Vt(z) {
        if (z.mode === n.PipsMode.Range || z.mode === n.PipsMode.Steps) return d.xVal;
        if (z.mode === n.PipsMode.Count) {
          if (z.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var Y = z.values - 1, oe = 100 / Y, he = []; Y--; ) he[Y] = Y * oe;
          return he.push(100), Ft(he, z.stepped);
        }
        return z.mode === n.PipsMode.Positions ? Ft(z.values, z.stepped) : z.mode === n.PipsMode.Values ? z.stepped ? z.values.map((function(De) {
          return d.fromStepping(d.getStep(d.toStepping(De)));
        })) : z.values : [];
      }
      function Ft(z, Y) {
        return z.map((function(oe) {
          return d.fromStepping(Y ? d.getStep(oe) : oe);
        }));
      }
      function xa(z) {
        function Y(lt, Je) {
          return Number((lt + Je).toFixed(7));
        }
        var oe = Vt(z), he = {}, De = d.xVal[0], Ce = d.xVal[d.xVal.length - 1], Ve = !1, Re = !1, ut = 0;
        return (oe = l(oe.slice().sort((function(lt, Je) {
          return lt - Je;
        }))))[0] !== De && (oe.unshift(De), Ve = !0), oe[oe.length - 1] !== Ce && (oe.push(Ce), Re = !0), oe.forEach((function(lt, Je) {
          var nt, Ye, wt, Dt, ft, Oi, gr, Ri, Fi, Ni, br = lt, Dn = oe[Je + 1], Pi = z.mode === n.PipsMode.Steps;
          for (Pi && (nt = d.xNumSteps[Je]), nt || (nt = Dn - br), Dn === void 0 && (Dn = br), nt = Math.max(nt, 1e-7), Ye = br; Ye <= Dn; Ye = Y(Ye, nt)) {
            for (Ri = (ft = (Dt = d.toStepping(Ye)) - ut) / (z.density || 1), Ni = ft / (Fi = Math.round(Ri)), wt = 1; wt <= Fi; wt += 1) he[(Oi = ut + wt * Ni).toFixed(5)] = [d.fromStepping(Oi), 0];
            gr = oe.indexOf(Ye) > -1 ? n.PipsType.LargeValue : Pi ? n.PipsType.SmallValue : n.PipsType.NoValue, !Je && Ve && Ye !== Dn && (gr = 0), Ye === Dn && Re || (he[Dt.toFixed(5)] = [Ye, gr]), ut = Dt;
          }
        })), he;
      }
      function ks(z, Y, oe) {
        var he, De, Ce = Ie.createElement("div"), Ve = ((he = {})[n.PipsType.None] = "", he[n.PipsType.NoValue] = S.cssClasses.valueNormal, he[n.PipsType.LargeValue] = S.cssClasses.valueLarge, he[n.PipsType.SmallValue] = S.cssClasses.valueSub, he), Re = ((De = {})[n.PipsType.None] = "", De[n.PipsType.NoValue] = S.cssClasses.markerNormal, De[n.PipsType.LargeValue] = S.cssClasses.markerLarge, De[n.PipsType.SmallValue] = S.cssClasses.markerSub, De), ut = [S.cssClasses.valueHorizontal, S.cssClasses.valueVertical], lt = [S.cssClasses.markerHorizontal, S.cssClasses.markerVertical];
        function Je(Ye, wt) {
          var Dt = wt === S.cssClasses.value, ft = Dt ? Ve : Re;
          return wt + " " + (Dt ? ut : lt)[S.ort] + " " + ft[Ye];
        }
        function nt(Ye, wt, Dt) {
          if ((Dt = Y ? Y(wt, Dt) : Dt) !== n.PipsType.None) {
            var ft = gt(Ce, !1);
            ft.className = Je(Dt, S.cssClasses.marker), ft.style[S.style] = Ye + "%", Dt > n.PipsType.NoValue && ((ft = gt(Ce, !1)).className = Je(Dt, S.cssClasses.value), ft.setAttribute("data-value", String(wt)), ft.style[S.style] = Ye + "%", ft.innerHTML = String(oe.to(wt)));
          }
        }
        return k(Ce, S.cssClasses.pips), k(Ce, S.ort === 0 ? S.cssClasses.pipsHorizontal : S.cssClasses.pipsVertical), Object.keys(z).forEach((function(Ye) {
          nt(Ye, z[Ye][0], z[Ye][1]);
        })), Ce;
      }
      function cr() {
        I && (i(I), I = null);
      }
      function ur(z) {
        cr();
        var Y = xa(z), oe = z.filter, he = z.format || { to: function(De) {
          return String(Math.round(De));
        } };
        return I = Ee.appendChild(ks(Y, oe, he));
      }
      function Ei() {
        var z = G.getBoundingClientRect(), Y = "offset" + ["Width", "Height"][S.ort];
        return S.ort === 0 ? z.width || G[Y] : z.height || G[Y];
      }
      function hn(z, Y, oe, he) {
        var De = function(Ve) {
          var Re = Ss(Ve, he.pageOffset, he.target || Y);
          return !!Re && !(fn() && !he.doNotReject) && !(b(Ee, S.cssClasses.tap) && !he.doNotReject) && !(z === y.start && Re.buttons !== void 0 && Re.buttons > 1) && (!he.hover || !Re.buttons) && (ue || Re.preventDefault(), Re.calcPoint = Re.points[S.ort], void oe(Re, he));
        }, Ce = [];
        return z.split(" ").forEach((function(Ve) {
          Y.addEventListener(Ve, De, !!ue && { passive: !0 }), Ce.push([Ve, De]);
        })), Ce;
      }
      function Ss(z, Y, oe) {
        var he = z.type.indexOf("touch") === 0, De = z.type.indexOf("mouse") === 0, Ce = z.type.indexOf("pointer") === 0, Ve = 0, Re = 0;
        if (z.type.indexOf("MSPointer") === 0 && (Ce = !0), z.type === "mousedown" && !z.buttons && !z.touches) return !1;
        if (he) {
          var ut = function(nt) {
            var Ye = nt.target;
            return Ye === oe || oe.contains(Ye) || z.composed && z.composedPath().shift() === oe;
          };
          if (z.type === "touchstart") {
            var lt = Array.prototype.filter.call(z.touches, ut);
            if (lt.length > 1) return !1;
            Ve = lt[0].pageX, Re = lt[0].pageY;
          } else {
            var Je = Array.prototype.find.call(z.changedTouches, ut);
            if (!Je) return !1;
            Ve = Je.pageX, Re = Je.pageY;
          }
        }
        return Y = Y || C(Ie), (De || Ce) && (Ve = z.clientX + Y.x, Re = z.clientY + Y.y), z.pageOffset = Y, z.points = [Ve, Re], z.cursor = De || Ce, z;
      }
      function Ti(z) {
        var Y = 100 * (z - v(G, S.ort)) / Ei();
        return Y = m(Y), S.dir ? 100 - Y : Y;
      }
      function _s(z) {
        var Y = 100, oe = !1;
        return M.forEach((function(he, De) {
          if (!an(De)) {
            var Ce = te[De], Ve = Math.abs(Ce - z);
            (Ve < Y || Ve <= Y && z > Ce || Ve === 100 && Y === 100) && (oe = De, Y = Ve);
          }
        })), oe;
      }
      function Cs(z, Y) {
        z.type === "mouseout" && z.target.nodeName === "HTML" && z.relatedTarget === null && dr(z, Y);
      }
      function Es(z, Y) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && z.buttons === 0 && Y.buttonsProperty !== 0) return dr(z, Y);
        var oe = (S.dir ? -1 : 1) * (z.calcPoint - Y.startCalcPoint);
        Ai(oe > 0, 100 * oe / Y.baseSize, Y.locations, Y.handleNumbers, Y.connect);
      }
      function dr(z, Y) {
        Y.handle && (g(Y.handle, S.cssClasses.active), N -= 1), Y.listeners.forEach((function(oe) {
          we.removeEventListener(oe[0], oe[1]);
        })), N === 0 && (g(Ee, S.cssClasses.drag), mr(), z.cursor && (Le.style.cursor = "", Le.removeEventListener("selectstart", o))), S.events.smoothSteps && (Y.handleNumbers.forEach((function(oe) {
          vn(oe, te[oe], !0, !0, !1, !1);
        })), Y.handleNumbers.forEach((function(oe) {
          ct("update", oe);
        }))), Y.handleNumbers.forEach((function(oe) {
          ct("change", oe), ct("set", oe), ct("end", oe);
        }));
      }
      function fr(z, Y) {
        if (!Y.handleNumbers.some(an)) {
          var oe;
          Y.handleNumbers.length === 1 && (oe = M[Y.handleNumbers[0]].children[0], N += 1, k(oe, S.cssClasses.active)), z.stopPropagation();
          var he = [], De = hn(y.move, we, Es, { target: z.target, handle: oe, connect: Y.connect, listeners: he, startCalcPoint: z.calcPoint, baseSize: Ei(), pageOffset: z.pageOffset, handleNumbers: Y.handleNumbers, buttonsProperty: z.buttons, locations: te.slice() }), Ce = hn(y.end, we, dr, { target: z.target, handle: oe, listeners: he, doNotReject: !0, handleNumbers: Y.handleNumbers }), Ve = hn("mouseout", we, Cs, { target: z.target, handle: oe, listeners: he, doNotReject: !0, handleNumbers: Y.handleNumbers });
          he.push.apply(he, De.concat(Ce, Ve)), z.cursor && (Le.style.cursor = getComputedStyle(z.target).cursor, M.length > 1 && k(Ee, S.cssClasses.drag), Le.addEventListener("selectstart", o, !1)), Y.handleNumbers.forEach((function(Re) {
            ct("start", Re);
          }));
        }
      }
      function Ts(z) {
        z.stopPropagation();
        var Y = Ti(z.calcPoint), oe = _s(Y);
        oe !== !1 && (S.events.snap || f(Ee, S.cssClasses.tap, S.animationDuration), vn(oe, Y, !0, !0), mr(), ct("slide", oe, !0), ct("update", oe, !0), S.events.snap ? fr(z, { handleNumbers: [oe] }) : (ct("change", oe, !0), ct("set", oe, !0)));
      }
      function As(z) {
        var Y = Ti(z.calcPoint), oe = d.getStep(Y), he = d.fromStepping(oe);
        Object.keys(ee).forEach((function(De) {
          De.split(".")[0] === "hover" && ee[De].forEach((function(Ce) {
            Ce.call(_a, he);
          }));
        }));
      }
      function Ls(z, Y) {
        if (fn() || an(Y)) return !1;
        var oe = ["Left", "Right"], he = ["Down", "Up"], De = ["PageDown", "PageUp"], Ce = ["Home", "End"];
        S.dir && !S.ort ? oe.reverse() : S.ort && !S.dir && (he.reverse(), De.reverse());
        var Ve, Re = z.key.replace("Arrow", ""), ut = Re === De[0], lt = Re === De[1], Je = Re === he[0] || Re === oe[0] || ut, nt = Re === he[1] || Re === oe[1] || lt, Ye = Re === Ce[0], wt = Re === Ce[1];
        if (!(Je || nt || Ye || wt)) return !0;
        if (z.preventDefault(), nt || Je) {
          var Dt = Je ? 0 : 1, ft = Mi(Y)[Dt];
          if (ft === null) return !1;
          ft === !1 && (ft = d.getDefaultStep(te[Y], Je, S.keyboardDefaultStep)), ft *= lt || ut ? S.keyboardPageMultiplier : S.keyboardMultiplier, ft = Math.max(ft, 1e-7), ft *= Je ? -1 : 1, Ve = re[Y] + ft;
        } else Ve = wt ? S.spectrum.xVal[S.spectrum.xVal.length - 1] : S.spectrum.xVal[0];
        return vn(Y, d.toStepping(Ve), !0, !0), ct("slide", Y), ct("update", Y), ct("change", Y), ct("set", Y), !1;
      }
      function $s(z) {
        z.fixed || M.forEach((function(Y, oe) {
          hn(y.start, Y.children[0], fr, { handleNumbers: [oe] });
        })), z.tap && hn(y.start, G, Ts, {}), z.hover && hn(y.move, G, As, { hover: !0 }), z.drag && ie.forEach((function(Y, oe) {
          if (Y !== !1 && oe !== 0 && oe !== ie.length - 1) {
            var he = M[oe - 1], De = M[oe], Ce = [Y], Ve = [he, De], Re = [oe - 1, oe];
            k(Y, S.cssClasses.draggable), z.fixed && (Ce.push(he.children[0]), Ce.push(De.children[0])), z.dragAll && (Ve = M, Re = x), Ce.forEach((function(ut) {
              hn(y.start, ut, fr, { handles: Ve, handleNumbers: Re, connect: Y });
            }));
          }
        }));
      }
      function hr(z, Y) {
        ee[z] = ee[z] || [], ee[z].push(Y), z.split(".")[0] === "update" && M.forEach((function(oe, he) {
          ct("update", he);
        }));
      }
      function Is(z) {
        return z === Q.aria || z === Q.tooltips;
      }
      function Xn(z) {
        var Y = z && z.split(".")[0], oe = Y ? z.substring(Y.length) : z;
        Object.keys(ee).forEach((function(he) {
          var De = he.split(".")[0], Ce = he.substring(De.length);
          Y && Y !== De || oe && oe !== Ce || Is(Ce) && oe !== Ce || delete ee[he];
        }));
      }
      function ct(z, Y, oe) {
        Object.keys(ee).forEach((function(he) {
          var De = he.split(".")[0];
          z === De && ee[he].forEach((function(Ce) {
            Ce.call(_a, re.map(S.format.to), Y, re.slice(), oe || !1, te.slice(), _a);
          }));
        }));
      }
      function ka(z, Y, oe, he, De, Ce, Ve) {
        var Re;
        return M.length > 1 && !S.events.unconstrained && (he && Y > 0 && (Re = d.getAbsoluteDistance(z[Y - 1], S.margin, !1), oe = Math.max(oe, Re)), De && Y < M.length - 1 && (Re = d.getAbsoluteDistance(z[Y + 1], S.margin, !0), oe = Math.min(oe, Re))), M.length > 1 && S.limit && (he && Y > 0 && (Re = d.getAbsoluteDistance(z[Y - 1], S.limit, !1), oe = Math.min(oe, Re)), De && Y < M.length - 1 && (Re = d.getAbsoluteDistance(z[Y + 1], S.limit, !0), oe = Math.max(oe, Re))), S.padding && (Y === 0 && (Re = d.getAbsoluteDistance(0, S.padding[0], !1), oe = Math.max(oe, Re)), Y === M.length - 1 && (Re = d.getAbsoluteDistance(100, S.padding[1], !0), oe = Math.min(oe, Re))), Ve || (oe = d.getStep(oe)), !((oe = m(oe)) === z[Y] && !Ce) && oe;
      }
      function vr(z, Y) {
        var oe = S.ort;
        return (oe ? Y : z) + ", " + (oe ? z : Y);
      }
      function Ai(z, Y, oe, he, De) {
        var Ce = oe.slice(), Ve = he[0], Re = S.events.smoothSteps, ut = [!z, z], lt = [z, !z];
        he = he.slice(), z && he.reverse(), he.length > 1 ? he.forEach((function(nt, Ye) {
          var wt = ka(Ce, nt, Ce[nt] + Y, ut[Ye], lt[Ye], !1, Re);
          wt === !1 ? Y = 0 : (Y = wt - Ce[nt], Ce[nt] = wt);
        })) : ut = lt = [!0];
        var Je = !1;
        he.forEach((function(nt, Ye) {
          Je = vn(nt, oe[nt] + Y, ut[Ye], lt[Ye], !1, Re) || Je;
        })), Je && (he.forEach((function(nt) {
          ct("update", nt), ct("slide", nt);
        })), De != null && ct("drag", Ve));
      }
      function Li(z, Y) {
        return S.dir ? 100 - z - Y : z;
      }
      function Ds(z, Y) {
        te[z] = Y, re[z] = d.fromStepping(Y);
        var oe = "translate(" + vr(Li(Y, 0) - Ze + "%", "0") + ")";
        M[z].style[S.transformRule] = oe, $i(z), $i(z + 1);
      }
      function mr() {
        x.forEach((function(z) {
          var Y = te[z] > 50 ? -1 : 1, oe = 3 + (M.length + Y * z);
          M[z].style.zIndex = String(oe);
        }));
      }
      function vn(z, Y, oe, he, De, Ce) {
        return De || (Y = ka(te, z, Y, oe, he, !1, Ce)), Y !== !1 && (Ds(z, Y), !0);
      }
      function $i(z) {
        if (ie[z]) {
          var Y = 0, oe = 100;
          z !== 0 && (Y = te[z - 1]), z !== ie.length - 1 && (oe = te[z]);
          var he = oe - Y, De = "translate(" + vr(Li(Y, he) + "%", "0") + ")", Ce = "scale(" + vr(he / 100, "1") + ")";
          ie[z].style[S.transformRule] = De + " " + Ce;
        }
      }
      function Ii(z, Y) {
        return z === null || z === !1 || z === void 0 ? te[Y] : (typeof z == "number" && (z = String(z)), (z = S.format.from(z)) !== !1 && (z = d.toStepping(z)), z === !1 || isNaN(z) ? te[Y] : z);
      }
      function Sa(z, Y, oe) {
        var he = c(z), De = te[0] === void 0;
        Y = Y === void 0 || Y, S.animate && !De && f(Ee, S.cssClasses.tap, S.animationDuration), x.forEach((function(Re) {
          vn(Re, Ii(he[Re], Re), !0, !1, oe);
        }));
        var Ce = x.length === 1 ? 0 : 1;
        if (De && d.hasNoSize() && (oe = !0, te[0] = 0, x.length > 1)) {
          var Ve = 100 / (x.length - 1);
          x.forEach((function(Re) {
            te[Re] = Re * Ve;
          }));
        }
        for (; Ce < x.length; ++Ce) x.forEach((function(Re) {
          vn(Re, te[Re], !0, !0, oe);
        }));
        mr(), x.forEach((function(Re) {
          ct("update", Re), he[Re] !== null && Y && ct("set", Re);
        }));
      }
      function Ms(z) {
        Sa(S.start, z);
      }
      function Os(z, Y, oe, he) {
        if (!((z = Number(z)) >= 0 && z < x.length)) throw new Error("noUiSlider: invalid handle number, got: " + z);
        vn(z, Ii(Y, z), !0, !0, he), ct("update", z), oe && ct("set", z);
      }
      function Di(z) {
        if (z === void 0 && (z = !1), z) return re.length === 1 ? re[0] : re.slice(0);
        var Y = re.map(S.format.to);
        return Y.length === 1 ? Y[0] : Y;
      }
      function Rs() {
        for (Xn(Q.aria), Xn(Q.tooltips), Object.keys(S.cssClasses).forEach((function(z) {
          g(Ee, S.cssClasses[z]);
        })); Ee.firstChild; ) Ee.removeChild(Ee.firstChild);
        delete Ee.noUiSlider;
      }
      function Mi(z) {
        var Y = te[z], oe = d.getNearbySteps(Y), he = re[z], De = oe.thisStep.step, Ce = null;
        if (S.snap) return [he - oe.stepBefore.startValue || null, oe.stepAfter.startValue - he || null];
        De !== !1 && he + De > oe.stepAfter.startValue && (De = oe.stepAfter.startValue - he), Ce = he > oe.thisStep.startValue ? oe.thisStep.step : oe.stepBefore.step !== !1 && he - oe.stepBefore.highestStep, Y === 100 ? De = null : Y === 0 && (Ce = null);
        var Ve = d.countStepDecimals();
        return De !== null && De !== !1 && (De = Number(De.toFixed(Ve))), Ce !== null && Ce !== !1 && (Ce = Number(Ce.toFixed(Ve))), [Ce, De];
      }
      function Fs() {
        return x.map(Mi);
      }
      function Ns(z, Y) {
        var oe = Di(), he = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        he.forEach((function(Ce) {
          z[Ce] !== void 0 && (w[Ce] = z[Ce]);
        }));
        var De = it(w);
        he.forEach((function(Ce) {
          z[Ce] !== void 0 && (S[Ce] = De[Ce]);
        })), d = De.spectrum, S.margin = De.margin, S.limit = De.limit, S.padding = De.padding, S.pips ? ur(S.pips) : cr(), S.tooltips ? It() : tt(), te = [], Sa(a(z.start) ? z.start : oe, Y);
      }
      function Ps() {
        G = yt(Ee), st(S.connect, G), $s(S.events), Sa(S.start), S.pips && ur(S.pips), S.tooltips && It(), bt();
      }
      Ps();
      var _a = { destroy: Rs, steps: Fs, on: hr, off: Xn, get: Di, set: Sa, setHandle: Os, reset: Ms, __moveHandles: function(z, Y, oe) {
        Ai(z, Y, te, oe);
      }, options: w, updateOptions: Ns, target: Ee, removePips: cr, removeTooltips: tt, getPositions: function() {
        return te.slice();
      }, getTooltips: function() {
        return J;
      }, getOrigins: function() {
        return M;
      }, pips: ur };
      return _a;
    }
    function _t(F, S) {
      if (!F || !F.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + F);
      if (F.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
      var w = Nt(F, it(S), S);
      return F.noUiSlider = w, w;
    }
    var at = { __spectrum: V, cssClasses: O, create: _t };
    n.create = _t, n.cssClasses = O, n.default = at, Object.defineProperty(n, "__esModule", { value: !0 });
  })(t);
})));
function eo(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  const n = t.slice().sort();
  return e.length === t.length && e.slice().sort().every((function(r, s) {
    return r === n[s];
  }));
}
var ei = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const n = (function(a, o, l) {
    const { value: h, modelValue: v, min: u } = Ca(a);
    let f = v && v.value !== void 0 ? v : h;
    const m = ge(f.value);
    if (Ma(f.value) && (f = ge(u.value)), Array.isArray(f.value) && f.value.length == 0) throw new Error("Slider v-model must not be an empty array");
    return { value: f, initialValue: m };
  })(e), r = (function(a, o, l) {
    const { classes: h, showTooltip: v, tooltipPosition: u, orientation: f } = Ca(a), m = W((() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...h.value })));
    return { classList: W((() => {
      const c = { ...m.value };
      return Object.keys(c).forEach(((p) => {
        c[p] = Array.isArray(c[p]) ? c[p].filter(((k) => k !== null)).join(" ") : c[p];
      })), v.value !== "always" && (c.target += ` ${v.value === "drag" ? c.tooltipDrag : c.tooltipFocus}`), f.value === "horizontal" && (c.tooltip += u.value === "bottom" ? ` ${c.tooltipBottom}` : ` ${c.tooltipTop}`), f.value === "vertical" && (c.tooltip += u.value === "right" ? ` ${c.tooltipRight}` : ` ${c.tooltipLeft}`), c;
    })) };
  })(e), s = (function(a, o, l) {
    const { format: h, step: v } = Ca(a), u = l.value, f = l.classList, m = W((() => h && h.value ? typeof h.value == "function" ? { to: h.value } : Ql({ ...h.value }) : Ql({ decimals: v.value >= 0 ? 0 : 2 }))), c = W((() => Array.isArray(u.value) ? u.value.map(((p) => m.value)) : m.value));
    return { tooltipFormat: m, tooltipsFormat: c, tooltipsMerge: (p, k, g) => {
      var b = getComputedStyle(p).direction === "rtl", C = p.noUiSlider.options.direction === "rtl", A = p.noUiSlider.options.orientation === "vertical", D = p.noUiSlider.getTooltips(), L = p.noUiSlider.getOrigins();
      D.forEach((function(T, P) {
        T && L[P].appendChild(T);
      })), p.noUiSlider.on("update", (function(T, P, U, K, B) {
        var X = [[]], H = [[]], _ = [[]], E = 0;
        D[0] && (X[0][0] = 0, H[0][0] = B[0], _[0][0] = m.value.to(parseFloat(T[0])));
        for (var R = 1; R < T.length; R++) (!D[R] || T[R] - T[R - 1] > k) && (X[++E] = [], _[E] = [], H[E] = []), D[R] && (X[E].push(R), _[E].push(m.value.to(parseFloat(T[R]))), H[E].push(B[R]));
        X.forEach((function(V, q) {
          for (var O = V.length, Q = 0; Q < O; Q++) {
            var ae = V[Q];
            if (Q === O - 1) {
              var le = 0;
              H[q].forEach((function(fe) {
                le += 1e3 - fe;
              }));
              var me = A ? "bottom" : "right", $e = C ? 0 : O - 1, xe = 1e3 - H[q][$e];
              le = (b && !A ? 100 : 0) + le / O - xe, D[ae].innerHTML = _[q].join(g), D[ae].style.display = "block", D[ae].style[me] = le + "%", f.value.tooltipHidden.split(" ").forEach(((fe) => {
                D[ae].classList.contains(fe) && D[ae].classList.remove(fe);
              }));
            } else D[ae].style.display = "none", f.value.tooltipHidden.split(" ").forEach(((fe) => {
              D[ae].classList.add(fe);
            }));
          }
        }));
      }));
    } };
  })(e, 0, { value: n.value, classList: r.classList }), i = (function(a, o, l) {
    const { orientation: h, direction: v, tooltips: u, step: f, min: m, max: c, merge: p, id: k, disabled: g, options: b, classes: C, format: A, lazy: D, ariaLabelledby: L, aria: T } = Ca(a), P = l.value, U = l.initialValue, K = l.tooltipsFormat, B = l.tooltipsMerge, X = l.tooltipFormat, H = l.classList, _ = ge(null), E = ge(null), R = ge(!1), V = W((() => {
      let fe = { cssPrefix: "", cssClasses: H.value, orientation: h.value, direction: v.value, tooltips: !!u.value && K.value, connect: "lower", start: Ma(P.value) ? m.value : P.value, range: { min: m.value, max: c.value } };
      if (f.value > 0 && (fe.step = f.value), Array.isArray(P.value) && (fe.connect = !0), L && L.value || T && Object.keys(T.value).length) {
        let be = Array.isArray(P.value) ? P.value : [P.value];
        fe.handleAttributes = be.map(((_e) => Object.assign({}, T.value, L && L.value ? { "aria-labelledby": L.value } : {})));
      }
      return A.value && (fe.ariaFormat = X.value), fe;
    })), q = W((() => {
      let fe = { id: k && k.value ? k.value : void 0 };
      return g.value && (fe.disabled = !0), fe;
    })), O = W((() => Array.isArray(P.value))), Q = () => {
      let fe = E.value.get();
      return Array.isArray(fe) ? fe.map(((be) => parseFloat(be))) : parseFloat(fe);
    }, ae = function(fe) {
      let be = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      E.value.set(fe, be);
    }, le = (fe) => {
      o.emit("input", fe), o.emit("update:modelValue", fe), o.emit("update", fe);
    }, me = () => {
      E.value = Em.create(_.value, Object.assign({}, V.value, b.value)), u.value && O.value && p.value >= 0 && B(_.value, p.value, " - "), E.value.on("set", (() => {
        const fe = Q();
        o.emit("change", fe), o.emit("set", fe), D.value && le(fe);
      })), E.value.on("update", (() => {
        if (!R.value) return;
        const fe = Q();
        O.value && eo(P.value, fe) || !O.value && P.value == fe ? o.emit("update", fe) : D.value || le(fe);
      })), E.value.on("start", (() => {
        o.emit("start", Q());
      })), E.value.on("end", (() => {
        o.emit("end", Q());
      })), E.value.on("slide", (() => {
        o.emit("slide", Q());
      })), E.value.on("drag", (() => {
        o.emit("drag", Q());
      })), _.value.querySelectorAll("[data-handle]").forEach(((fe) => {
        fe.onblur = () => {
          _.value && H.value.focused.split(" ").forEach(((be) => {
            _.value.classList.remove(be);
          }));
        }, fe.onfocus = () => {
          H.value.focused.split(" ").forEach(((be) => {
            _.value.classList.add(be);
          }));
        };
      })), R.value = !0;
    }, $e = () => {
      E.value.off(), E.value.destroy(), E.value = null;
    }, xe = (fe, be) => {
      R.value = !1, $e(), me();
    };
    return pt(me), Ln($e), Be(O, xe, { immediate: !1 }), Be(m, xe, { immediate: !1 }), Be(c, xe, { immediate: !1 }), Be(f, xe, { immediate: !1 }), Be(h, xe, { immediate: !1 }), Be(v, xe, { immediate: !1 }), Be(u, xe, { immediate: !1 }), Be(p, xe, { immediate: !1 }), Be(A, xe, { immediate: !1, deep: !0 }), Be(b, xe, { immediate: !1, deep: !0 }), Be(C, xe, { immediate: !1, deep: !0 }), Be(P, ((fe, be) => {
      be && (typeof be == "object" && typeof fe == "object" && fe && Object.keys(be) > Object.keys(fe) || typeof be == "object" && typeof fe != "object" || Ma(fe)) && xe();
    }), { immediate: !1 }), Be(P, ((fe) => {
      if (Ma(fe)) return void ae(m.value, !1);
      let be = Q();
      O.value && !Array.isArray(be) && (be = [be]), (O.value && !eo(fe, be) || !O.value && fe != be) && ae(fe, !1);
    }), { deep: !0 }), { slider: _, slider$: E, isRange: O, sliderProps: q, init: me, destroy: $e, refresh: xe, update: ae, reset: () => {
      le(U.value);
    } };
  })(e, t, { value: n.value, initialValue: n.initialValue, tooltipFormat: s.tooltipFormat, tooltipsFormat: s.tooltipsFormat, tooltipsMerge: s.tooltipsMerge, classList: r.classList });
  return { ...r, ...s, ...i };
} };
ei.render = function(e, t, n, r, s, i) {
  return $(), Z("div", Ae(e.sliderProps, { ref: "slider" }), null, 16);
}, ei.__file = "src/Slider.vue";
const Tm = ["data-click-name"], Am = { class: "lc-slider__wrap" }, Lm = {
  key: 0,
  class: "lc-slider__min"
}, $m = {
  key: 0,
  class: "lc-slider__slider-marks"
}, Im = ["data-testid"], Dm = {
  key: 1,
  class: "lc-slider__max"
}, Mm = 1, f2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcSlider",
  props: {
    containerClass: {},
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    format: { type: Function, default: (e) => String(e) },
    helpMessage: {},
    hideMax: { type: Boolean },
    hideMin: { type: Boolean },
    hideStepMarkers: { type: Boolean },
    lazy: { type: Boolean, default: !0 },
    marker: {},
    max: {},
    min: {},
    name: {},
    noFeedback: { type: Boolean },
    step: { default: 1 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = ge(!1), r = ot("slider"), s = t, i = W({
      get: () => e.value,
      set: (f) => s("update:value", f)
    }), a = W(() => {
      if (!e.marker) return;
      const { snap: f, steps: m } = e.marker;
      return {
        range: {
          min: e.min,
          ...m,
          max: e.max
        },
        snap: f
      };
    }), o = W(() => {
      if (a.value) return Object.keys(a.value.range);
      const f = (e.max - e.min) / e.step + Mm;
      return Array.from({ length: f }, (m, c) => c);
    }), l = (f) => {
      const m = r.value;
      if (!m) return;
      const c = new Event(f, { bubbles: !0 });
      m.dispatchEvent(c);
    }, h = () => {
      n.value || (l("focusin"), l("focusout"));
    }, v = (f) => {
      n.value = f === "focusin", l(f);
    }, u = (f) => ["max", "min"].includes(String(f));
    return (f, m) => ($(), Z("div", {
      ref: "slider",
      class: ye(["lc-slider", [
        {
          "lc-slider--disabled": e.disabled,
          "lc-slider--fixed-steps": !!a.value
        },
        e.containerClass,
        f.$attrs.class
      ]]),
      "data-click-name": e.dataClickName || `${e.name?.toLowerCase()}_slider`
    }, [
      ne("div", Am, [
        e.hideMin ? de("", !0) : ($(), Z("span", Lm, [
          ve(f.$slots, "min", Lt(Ot({ min: e.min })), () => [
            xt(Oe(e.format(e.min)), 1)
          ])
        ])),
        ne("div", {
          class: "lc-slider__slider-container",
          onFocusin: m[1] || (m[1] = sa(() => v("focusin"), ["stop"])),
          onFocusout: m[2] || (m[2] = sa(() => v("focusout"), ["stop"]))
        }, [
          Fe(j(ei), Ae({
            ...en(f.$attrs, ["class"]),
            ...f.$props,
            lazy: e.lazy
          }, {
            modelValue: i.value,
            "onUpdate:modelValue": m[0] || (m[0] = (c) => i.value = c),
            class: "lc-slider__slider",
            options: a.value,
            onChange: h
          }), null, 16, ["modelValue", "options"]),
          e.hideStepMarkers ? de("", !0) : ($(), Z("div", $m, [
            ($(!0), Z(Xe, null, ht(o.value, (c) => ($(), Z("span", {
              key: c,
              class: ye(["lc-slider__slider-mark", {
                [`lc-slider__slider-mark--${c}`]: u(c)
              }]),
              "data-testid": `lc-slider-mark-${c}`,
              style: Ct(
                typeof c == "string" && !u(c) ? `left:${c}%` : null
              )
            }, null, 14, Im))), 128))
          ]))
        ], 32),
        e.hideMax ? de("", !0) : ($(), Z("span", Dm, [
          ve(f.$slots, "max", Lt(Ot({ max: e.max })), () => [
            xt(Oe(e.format(e.max)), 1)
          ])
        ]))
      ]),
      e.noFeedback ? de("", !0) : ($(), ke(j($n), Ae({
        key: 0,
        class: "lc-slider__feedback"
      }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 10, Tm));
  }
});
function xn() {
  return xn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xn.apply(this, arguments);
}
var Om = 0.996, Rm = function(t, n) {
  return n === void 0 && (n = Om), t * n / (1 - n);
};
function Fm(e) {
  return e[e.length - 1];
}
function Nm(e) {
  return e.reduce(function(t, n) {
    return t + n;
  }) / e.length;
}
var Pm = function(t, n, r) {
  return Math.min(Math.max(n, t), r);
};
function Br(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function to(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function Zn(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && Zn(t);
  }), e;
}
function Bm() {
  var e = {};
  function t(s, i) {
    return e[s] = (e[s] || []).concat(i), function() {
      return n(s, i);
    };
  }
  function n(s, i) {
    e[s] = (e[s] || []).filter(function(a) {
      return a !== i;
    });
  }
  function r(s, i) {
    s in e && e[s].forEach(function(a) {
      return a(i);
    });
  }
  return Zn({
    on: t,
    off: n,
    dispatch: r
  });
}
function zm(e) {
  var t = [], n = function(a) {
    return a.addEventListener("wheel", e, {
      passive: !1
    }), t.push(a), function() {
      return r(a);
    };
  }, r = function(a) {
    a.removeEventListener("wheel", e), t = t.filter(function(o) {
      return o !== a;
    });
  }, s = function() {
    t.forEach(r);
  };
  return Zn({
    observe: n,
    unobserve: r,
    disconnect: s
  });
}
var Vm = 16 * 1.125, Hm = typeof window < "u" && window.innerHeight || 800, zr = [1, Vm, Hm];
function Um(e) {
  var t = e.deltaX * zr[e.deltaMode], n = e.deltaY * zr[e.deltaMode], r = (e.deltaZ || 0) * zr[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, n, r]
  };
}
var qm = [-1, -1, -1];
function jm(e, t) {
  if (!t)
    return e;
  var n = t === !0 ? qm : t.map(function(r) {
    return r ? -1 : 1;
  });
  return xn({}, e, {
    axisDelta: e.axisDelta.map(function(r, s) {
      return r * n[s];
    })
  });
}
var no = 700, Zm = function(t) {
  return xn({}, t, {
    axisDelta: t.axisDelta.map(function(n) {
      return Pm(n, -no, no);
    })
  });
}, Vr = process.env.NODE_ENV !== "production", Wm = 0.6, Ym = 0.96, Xm = 2, ao = 5, ro = /* @__PURE__ */ Zn({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), Gm = 400;
function io() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: Gm
  };
}
function Km(e) {
  e === void 0 && (e = {});
  var t = Bm(), n = t.on, r = t.off, s = t.dispatch, i = ro, a = io(), o, l = !1, h, v = function(_) {
    Array.isArray(_) ? _.forEach(function(E) {
      return c(E);
    }) : c(_);
  }, u = function(_) {
    return _ === void 0 && (_ = {}), Object.values(_).some(function(E) {
      return E == null;
    }) ? (Vr && console.error("updateOptions ignored! undefined & null options not allowed"), i) : i = Zn(xn({}, ro, i, _));
  }, f = function(_) {
    var E = xn({
      event: o,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: a.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: a.axisVelocity,
      axisMovement: a.axisMovement,
      get axisMovementProjection() {
        return Br(E.axisMovement, E.axisVelocity.map(function(R) {
          return Rm(R);
        }));
      }
    }, _);
    s("wheel", xn({}, E, {
      previous: h
    })), h = E;
  }, m = function(_, E) {
    var R = i, V = R.preventWheelAction, q = E[0], O = E[1], Q = E[2];
    if (typeof V == "boolean") return V;
    switch (V) {
      case "x":
        return Math.abs(q) >= _;
      case "y":
        return Math.abs(O) >= _;
      case "z":
        return Math.abs(Q) >= _;
      default:
        return Vr && console.warn("unsupported preventWheelAction value: " + V, "warn"), !1;
    }
  }, c = function(_) {
    var E = Zm(jm(Um(_), i.reverseSign)), R = E.axisDelta, V = E.timeStamp, q = to(R);
    if (_.preventDefault && m(q, R) && _.preventDefault(), a.isStarted ? a.isMomentum && q > Math.max(2, a.lastAbsDelta * 2) && (P(!0), L()) : L(), q === 0 && Object.is && Object.is(_.deltaX, -0)) {
      l = !0;
      return;
    }
    o = _, a.axisMovement = Br(a.axisMovement, R), a.lastAbsDelta = q, a.scrollPointsToMerge.push({
      axisDelta: R,
      timeStamp: V
    }), p(), f({
      axisDelta: R,
      isStart: !a.isStartPublished
    }), a.isStartPublished = !0, T();
  }, p = function() {
    a.scrollPointsToMerge.length === Xm ? (a.scrollPoints.unshift({
      axisDeltaSum: a.scrollPointsToMerge.map(function(_) {
        return _.axisDelta;
      }).reduce(Br),
      timeStamp: Nm(a.scrollPointsToMerge.map(function(_) {
        return _.timeStamp;
      }))
    }), g(), a.scrollPointsToMerge.length = 0, a.scrollPoints.length = 1, a.isMomentum || A()) : a.isStartPublished || k();
  }, k = function() {
    a.axisVelocity = Fm(a.scrollPointsToMerge).axisDelta.map(function(_) {
      return _ / a.willEndTimeout;
    });
  }, g = function() {
    var _ = a.scrollPoints, E = _[0], R = _[1];
    if (!(!R || !E)) {
      var V = E.timeStamp - R.timeStamp;
      if (V <= 0) {
        Vr && console.warn("invalid deltaTime");
        return;
      }
      var q = E.axisDeltaSum.map(function(Q) {
        return Q / V;
      }), O = q.map(function(Q, ae) {
        return Q / (a.axisVelocity[ae] || 1);
      });
      a.axisVelocity = q, a.accelerationFactors.push(O), b(V);
    }
  }, b = function(_) {
    var E = Math.ceil(_ / 10) * 10 * 1.2;
    a.isMomentum || (E = Math.max(100, E * 2)), a.willEndTimeout = Math.min(1e3, Math.round(E));
  }, C = function(_) {
    return _ === 0 ? !0 : _ <= Ym && _ >= Wm;
  }, A = function() {
    if (a.accelerationFactors.length >= ao) {
      if (l && (l = !1, to(a.axisVelocity) >= 0.2)) {
        D();
        return;
      }
      var _ = a.accelerationFactors.slice(ao * -1), E = _.every(function(R) {
        var V = !!R.reduce(function(O, Q) {
          return O && O < 1 && O === Q ? 1 : 0;
        }), q = R.filter(C).length === R.length;
        return V || q;
      });
      E && D(), a.accelerationFactors = _;
    }
  }, D = function() {
    a.isMomentum = !0;
  }, L = function() {
    a = io(), a.isStarted = !0, a.startTime = Date.now(), h = void 0, l = !1;
  }, T = /* @__PURE__ */ (function() {
    var H;
    return function() {
      clearTimeout(H), H = setTimeout(P, a.willEndTimeout);
    };
  })(), P = function(_) {
    _ === void 0 && (_ = !1), a.isStarted && (a.isMomentum && _ ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), a.isMomentum = !1, a.isStarted = !1);
  }, U = zm(v), K = U.observe, B = U.unobserve, X = U.disconnect;
  return u(e), Zn({
    on: n,
    off: r,
    observe: K,
    unobserve: B,
    disconnect: X,
    feedWheel: v,
    updateOptions: u
  });
}
var Jm = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
Ci.globalOptions = void 0;
var Qm = process.env.NODE_ENV !== "production";
function Ci(e) {
  e === void 0 && (e = {});
  var t, n = function() {
  };
  function r(i, a) {
    var o, l, h = a.mergeOptions, v = a.optionsAtMedia, u = h(Jm, Ci.globalOptions), f = h(u, e);
    t = v(f);
    var m = i.internalEngine(), c = (o = t.target) != null ? o : i.containerNode().parentNode, p = (l = t.forceWheelAxis) != null ? l : m.options.axis, k = Km({
      preventWheelAction: p,
      reverseSign: [!0, !0, !1]
    });
    function g() {
      T = (p === "x" ? m.containerRect.width : m.containerRect.height) / 2;
    }
    var b = k.observe(c), C = k.on("wheel", q), A = !1, D, L = 0, T = 0, P = !1;
    g(), i.on("resize", g);
    function U(O) {
      try {
        D = new MouseEvent("mousedown", O.event), E(D);
      } catch {
        return Qm && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
      }
      A = !0, L = 0, B(), t.wheelDraggingClass && c.classList.add(t.wheelDraggingClass);
    }
    function K(O) {
      A = !1, E(_("mouseup", O)), X(), t.wheelDraggingClass && c.classList.remove(t.wheelDraggingClass);
    }
    function B() {
      document.documentElement.addEventListener("mousemove", H, !0), document.documentElement.addEventListener("mouseup", H, !0), document.documentElement.addEventListener("mousedown", H, !0);
    }
    function X() {
      document.documentElement.removeEventListener("mousemove", H, !0), document.documentElement.removeEventListener("mouseup", H, !0), document.documentElement.removeEventListener("mousedown", H, !0);
    }
    function H(O) {
      A && O.isTrusted && O.stopImmediatePropagation();
    }
    function _(O, Q) {
      var ae, le;
      if (p === m.options.axis) {
        var me = Q.axisMovement;
        ae = me[0], le = me[1];
      } else {
        var $e = Q.axisMovement;
        le = $e[0], ae = $e[1];
      }
      var xe = R(Q), fe = xe.isAtBoundary;
      if (fe) {
        var be = Math.min(L / T, 1), _e = 0.25 + be * 0.5, Me = ae > 0 ? -1 : 1, qe = L * Me, ce = qe * _e;
        ae += ce, le += ce;
      }
      if (!m.options.skipSnaps && !m.options.dragFree) {
        var se = m.containerRect.width, pe = m.containerRect.height;
        ae = ae < 0 ? Math.max(ae, -se) : Math.min(ae, se), le = le < 0 ? Math.max(le, -pe) : Math.min(le, pe);
      }
      return new MouseEvent(O, {
        clientX: D.clientX + ae,
        clientY: D.clientY + le,
        screenX: D.screenX + ae,
        screenY: D.screenY + le,
        movementX: ae,
        movementY: le,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function E(O) {
      i.containerNode().dispatchEvent(O);
    }
    function R(O) {
      var Q = O.axisDelta, ae = Q[0], le = Q[1], me = i.scrollProgress(), $e = me < 1, xe = me > 0, fe = p === "x" ? ae : le, be = fe < 0, _e = fe > 0, Me = be && !$e || _e && !xe;
      return {
        isAtBoundary: Me,
        primaryAxisDelta: fe
      };
    }
    function V(O) {
      var Q = R(O), ae = Q.isAtBoundary, le = Q.primaryAxisDelta;
      if (ae && !O.isMomentum) {
        if (L += Math.abs(le), L > T)
          return P = !0, K(O), !0;
      } else
        L = 0;
      return !1;
    }
    function q(O) {
      var Q = O.axisDelta, ae = Q[0], le = Q[1], me = p === "x" ? ae : le, $e = p === "x" ? le : ae, xe = O.isMomentum && O.previous && !O.previous.isMomentum, fe = O.isEnding && !O.isMomentum || xe, be = Math.abs(me) > Math.abs($e);
      be && !A && !O.isMomentum && !P && U(O), P && O.isEnding && (P = !1), A && (V(O) || (fe ? K(O) : E(_("mousemove", O))));
    }
    n = function() {
      b(), C(), i.off("resize", g), X();
    };
  }
  var s = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return n();
    }
  };
  return s;
}
const e1 = { class: "lc-slot-wheel__wrap" }, h2 = /* @__PURE__ */ Se({
  __name: "LcSlotWheel",
  props: {
    options: {},
    value: {}
  },
  emits: ["optionsChanged", "ready", "reInit", "update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = {
      axis: "y",
      loop: !0,
      skipSnaps: !0
    }, i = [
      Ja({
        draggable: "lc-slot-wheel--draggable",
        dragging: "lc-slot-wheel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-slot-wheel__slide--snapped"
      }),
      Ci()
    ], [a, o] = er(
      {
        ...s,
        startIndex: Math.max(
          0,
          e.options.findIndex((L) => L.value === e.value)
        )
      },
      i
    ), l = Wn(Xr, () => null, !0), h = mo(), v = () => {
      o.value?.reInit({
        ...s,
        watchDrag: !1
      });
    }, u = () => {
      o.value?.reInit({
        ...s,
        watchDrag: !0
      });
    }, f = (L) => Math.max(
      0,
      e.options.findIndex((T) => T.value === L)
    ), m = (L) => !L || h.value === "reduce", c = (L, T = !0) => {
      o.value?.scrollTo(f(L), m(T));
    }, p = () => {
      D(), r("ready");
    }, k = () => {
      l?.disable();
    }, g = () => {
      l?.enable();
    }, b = () => {
      D(), r("reInit");
    }, C = () => {
      const L = o.value?.selectedScrollSnap() ?? 0;
      r("update:value", e.options[L].value);
    }, A = () => {
      r("optionsChanged");
    }, D = () => {
      if (!o.value) return;
      const { rootNode: L, slideNodes: T } = o.value, U = L().getBoundingClientRect(), K = U.top + U.height / 2;
      T().forEach((B) => {
        const X = B.getBoundingClientRect(), E = (X.top + X.height / 2 - K) / (U.height / 2), R = Math.max(-1, Math.min(1, E)), V = 1 - Math.abs(R) * 0.3, q = B.style.transform.split(" ").filter((O) => !O.startsWith("scale("));
        q.push(`scale(${V})`), B.style.transform = q.join(" ");
      });
    };
    return pt(() => {
      o.value && o.value.on("init", p).on("pointerDown", k).on("pointerUp", g).on("reInit", b).on("scroll", D).on("select", C).on("slidesChanged", A);
    }), Be(
      () => e.value,
      (L) => c(L)
    ), t({
      disable: v,
      enable: u,
      moveToOption: c
    }), (L, T) => ($(), Z("div", {
      ref_key: "emblaRef",
      ref: a,
      class: "lc-slot-wheel"
    }, [
      ne("div", e1, [
        ($(!0), Z(Xe, null, ht(e.options, (P, U) => ($(), Z("div", {
          key: `${P.label}-${P.value}`,
          className: "lc-slot-wheel__option"
        }, [
          ve(L.$slots, "option", Ae({ ref_for: !0 }, { index: U, option: P }), () => [
            xt(Oe(P.label), 1)
          ])
        ]))), 128))
      ])
    ], 512));
  }
}), t1 = ["for"], n1 = ["id", "aria-label", "data-click-name"], a1 = { class: "lc-switch__toggle" }, v2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcSwitch",
  props: {
    ariaLabelText: {},
    dataClickName: {},
    disabled: { type: Boolean },
    icon: { default: "checkmark" },
    id: {},
    name: { default: "switch" },
    value: { type: Boolean },
    variant: { default: "success" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = $t(e.id), { vibrate: s } = go(), i = W(() => [
      "lc-switch",
      `lc-switch--variant-${e.variant}`,
      {
        "lc-switch--checked": e.value,
        "lc-switch--disabled": e.disabled
      }
    ]), a = W({
      get: () => e.value,
      set: (o) => {
        n("update:value", o), s();
      }
    });
    return (o, l) => ($(), Z("label", {
      class: ye([i.value, o.$attrs.class]),
      for: j(r)
    }, [
      Qt(ne("input", Ae({
        ...en(o.$attrs, ["class"]),
        disabled: e.disabled,
        name: e.name
      }, {
        id: j(r),
        "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
        "aria-label": e.ariaLabelText,
        class: "lc-switch__input",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_switch`,
        role: "switch",
        type: "checkbox",
        onKeydown: l[1] || (l[1] = ii((h) => a.value = !a.value, ["enter"]))
      }), null, 16, n1), [
        [co, a.value]
      ]),
      l[2] || (l[2] = ne("div", { class: "lc-switch__track" }, null, -1)),
      ne("div", a1, [
        Fe(j(Ke), {
          class: "lc-switch__icon",
          name: e.icon
        }, null, 8, ["name"])
      ])
    ], 10, t1));
  }
}), m2 = ["info", "success"], g2 = /* @__PURE__ */ Se({
  __name: "LcTable",
  props: {
    bordered: { type: Boolean },
    padding: { default: "medium" }
  },
  setup(e) {
    const t = W(() => [
      "lc-table",
      `lc-table--padding-${e.padding}`,
      {
        "lc-table--bordered": e.bordered
      }
    ]);
    return (n, r) => ($(), Z("table", {
      class: ye(t.value)
    }, [
      ve(n.$slots, "default")
    ], 2));
  }
}), b2 = ["medium", "small"], p2 = ["column", "row"], y2 = ["bottom", "top"], w2 = ["automatic", "manual"], x2 = ["default", "divider"], k2 = /* @__PURE__ */ Symbol();
var Nn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.End = "End", e.Home = "Home", e))(Nn || {});
const r1 = ["id"], i1 = ["id"], l1 = { class: "lc-tabs__tablist-inner" }, o1 = ["id", "aria-controls", "aria-selected", "disabled", "tabindex", "onClickPassive"], s1 = {
  key: 1,
  class: "lc-tabs__header"
}, c1 = ["aria-labelledby"], u1 = ["id", "aria-labelledby"], S2 = /* @__PURE__ */ Se({
  __name: "LcTabs",
  props: {
    adaptiveHeight: { type: Boolean },
    disableSwipe: { type: Boolean },
    id: {},
    navigationPosition: { default: "top" },
    renderOnlyVisible: { type: Boolean },
    containerClass: {},
    tabFlexDirection: { default: "column" },
    tabs: {},
    trigger: { default: "automatic" },
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = ot("carousel"), i = ot("container"), a = ot("tabs"), o = $t(e.id), l = ge(0), h = ge(0), v = ge(null), u = ge(null), f = ge(!1), m = ge(!1);
    let c = null;
    const p = W(() => [
      "lc-tabs",
      `lc-tabs--navigation-${e.navigationPosition}`,
      `lc-tabs--variant-${e.variant}`,
      {
        "lc-tabs--tablist-hidden": b.value
      }
    ]), k = () => {
      m.value = !0, c && clearTimeout(c), c = setTimeout(() => m.value = !1, 250);
    }, g = () => {
      const B = a.value?.[l.value];
      B && (v.value = `${B.offsetWidth}px`, u.value = `${B.offsetLeft}px`);
    };
    qt(window, "resize", [g, k]), ac(i, g);
    const b = W(() => e.tabs.length <= 1), C = (B, X) => {
      B !== l.value && (l.value = B, X?.skipCarousel || s.value?.moveToIndex(B), X?.skipUpdateEvent || r("update:value", e.tabs[B].name));
    }, A = (B) => {
      a.value?.[B].focus();
    }, D = (B) => {
      if (B !== l.value)
        return {
          "aria-hidden": "true",
          inert: "true"
        };
    }, L = () => h.value === e.tabs.length - 1 ? 0 : h.value + 1, T = () => h.value === 0 ? e.tabs.length - 1 : h.value - 1, P = (B) => e.tabs.findIndex((X) => X.name === B), U = (B) => {
      if (!tn(B.key, Nn)) return;
      B.preventDefault(), B.stopPropagation();
      let X;
      switch (B.key) {
        case Nn.ArrowLeft:
          X = T();
          break;
        case Nn.ArrowRight:
          X = L();
          break;
        case Nn.End:
          X = e.tabs.length - 1;
          break;
        case Nn.Home:
          X = 0;
          break;
      }
      h.value = X, e.trigger === "automatic" && C(X);
    }, K = () => {
      const B = P(e.value);
      B !== -1 && (l.value = B, h.value = B);
    };
    return Zs(K), Ws(K), pt(() => {
      g(), b.value || (f.value = !0);
    }), Be(l, g), Be(h, A), Be(
      () => e.value,
      (B) => {
        if (!B) return;
        const X = P(B);
        X !== -1 && C(X, { skipUpdateEvent: !0 });
      }
    ), t({
      containerRef: i
    }), (B, X) => ($(), Z("section", {
      id: j(o),
      class: ye(p.value)
    }, [
      ve(B.$slots, "top"),
      b.value ? de("", !0) : ($(), Z("div", {
        key: 0,
        ref: "container",
        class: ye(["lc-tabs__nav_container", e.containerClass])
      }, [
        ne("nav", {
          id: j(o),
          class: ye(["lc-tabs__tablist", {
            "lc-tabs__tablist--no-transition": m.value
          }]),
          role: "tablist",
          style: Ct({
            "--active-tab-index": l.value,
            ...u.value && { "--indicator-offset": u.value },
            ...v.value && { "--indicator-size": v.value },
            "--tab-count": e.tabs.length
          })
        }, [
          ne("div", l1, [
            ($(!0), Z(Xe, null, ht(e.tabs, (H, _) => ($(), Z("button", {
              id: `${j(o)}-tab-${_}`,
              key: H.name,
              ref_for: !0,
              ref: "tabs",
              "aria-controls": `${j(o)}-tabpanel-${_}`,
              "aria-selected": l.value === _,
              class: ye(["lc-tabs__tab", `lc-tabs__tab--flex-${e.tabFlexDirection}`]),
              disabled: !f.value,
              role: "tab",
              tabindex: l.value !== _ ? -1 : void 0,
              type: "button",
              onClickPassive: (E) => C(_),
              onKeydown: U
            }, [
              B.$slots.tab ? ve(B.$slots, "tab", Ae({ ref_for: !0 }, { tab: H, index: _ }), void 0, void 0, 0) : ($(), Z(Xe, { key: 1 }, [
                H.icon ? ($(), ke(j(Ke), {
                  key: 0,
                  name: H.icon,
                  size: e.variant === "divider" ? "small" : "medium"
                }, null, 8, ["name", "size"])) : de("", !0),
                xt(" " + Oe(H.title ?? H.name), 1)
              ], 64))
            ], 42, o1))), 128))
          ])
        ], 14, i1),
        ve(B.$slots, "subnav")
      ], 2)),
      B.$slots.header ? ($(), Z("header", s1, [
        ve(B.$slots, "header")
      ])) : de("", !0),
      !f.value && e.tabs.length > 0 ? ($(), Z("div", {
        key: 2,
        "aria-labelledby": `${j(o)}-tab-${l.value}`,
        class: ye(["lc-tabs__tabpanel", "lc-tabs__tabpanel--single-tab"]),
        role: "tabpanel"
      }, [
        ve(B.$slots, "tab-panel", {
          index: l.value,
          tab: e.tabs[l.value]
        })
      ], 8, c1)) : de("", !0),
      b.value ? de("", !0) : ($(), ke(j(Kd), {
        key: 3,
        ref: "carousel",
        "adaptive-height": e.renderOnlyVisible ? !1 : e.adaptiveHeight,
        class: ye(["lc-tabs__carousel", {
          "lc-tabs__carousel--unmounted": !f.value
        }]),
        "default-index": l.value,
        "disable-swipe": e.disableSwipe || b.value,
        duration: 15,
        "key-prop": "name",
        slides: e.tabs,
        onChanged: X[0] || (X[0] = (H) => C(H, { skipCarousel: !0 })),
        onReady: X[1] || (X[1] = (H) => f.value = !0)
      }, {
        slide: Te(({ index: H, isVisible: _, slide: E }) => [
          ne("div", Ae({
            id: `${j(o)}-tabpanel-${H}`
          }, D(H), {
            "aria-labelledby": `${j(o)}-tab-${H}`,
            class: "lc-tabs__tabpanel",
            role: "tabpanel"
          }), [
            !e.renderOnlyVisible || _ || H === l.value ? ve(B.$slots, "tab-panel", Lt(Ot({ tab: E, index: H })), void 0, void 0, 0) : de("", !0)
          ], 16, u1)
        ]),
        _: 3
      }, 8, ["adaptive-height", "class", "default-index", "disable-swipe", "slides"]))
    ], 10, r1));
  }
}), d1 = ["for"], f1 = ["id"], h1 = ["id", "aria-labelledby", "data-click-error", "data-click-name"], v1 = { class: "lc-textarea__feedback-wrap" }, m1 = { class: "lc-textarea__counter" }, _2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcTextarea",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    maxlength: { default: 82 },
    name: { default: "textarea" },
    noFeedback: { type: Boolean },
    placeholder: {},
    resizeable: { type: Boolean },
    rows: { default: 2 },
    spellcheck: { type: Boolean },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ot("textarea"), s = $t(e.id), i = ge(!1), a = W(() => [
      "lc-textarea",
      {
        "lc-textarea--disabled": e.disabled,
        "lc-textarea--error": !!e.errorMessage,
        "lc-textarea--has-label": !!e.label
      }
    ]), o = W(() => typeof h.value == "number" ? String(h.value).length : h.value?.length ?? 0), l = W(() => [
      "lc-textarea__label",
      {
        "lc-textarea__label--floating": i.value || !!e.value || typeof e.value == "number"
      }
    ]), h = W({
      get: () => e.value,
      set: (v) => n("update:value", v)
    });
    return pt(() => {
      e.autofocus && r.value?.focus();
    }), (v, u) => ($(), Z("div", {
      class: ye([a.value, v.$attrs.class])
    }, [
      ne("label", {
        class: "lc-textarea__wrap",
        for: j(s)
      }, [
        e.label ? ($(), Z("span", {
          key: 0,
          id: `${j(s)}-label`,
          class: ye(l.value)
        }, Oe(e.label), 11, f1)) : de("", !0),
        Qt(ne("textarea", Ae({
          id: j(s),
          ref: "textarea"
        }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          maxlength: e.maxlength,
          name: e.name,
          placeholder: e.placeholder,
          resizeable: e.resizeable,
          rows: e.rows,
          spellcheck: e.spellcheck
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => h.value = f),
          "aria-labelledby": e.label ? `${j(s)}-label` : void 0,
          class: "lc-textarea__input",
          "data-click-error": e.errorMessage ?? "",
          "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_textarea`,
          onFocusin: u[1] || (u[1] = (f) => i.value = !0),
          onFocusout: u[2] || (u[2] = (f) => i.value = !1)
        }), null, 16, h1), [
          [Ys, h.value]
        ])
      ], 8, d1),
      ne("div", v1, [
        e.noFeedback ? de("", !0) : ($(), ke(j($n), Ae({ key: 0 }, { disabled: e.disabled }, {
          content: e.errorMessage || e.helpMessage,
          variant: e.errorMessage ? "error" : "default"
        }), null, 16, ["content", "variant"])),
        ne("span", m1, [
          ne("span", null, Oe(o.value) + "/" + Oe(e.maxlength), 1)
        ])
      ])
    ], 2));
  }
}), g1 = { class: "lc-toast__indicator" }, b1 = { class: "lc-toast__content" }, p1 = {
  key: 0,
  class: "lc-toast__title"
}, y1 = {
  key: 0,
  class: "lc-toast__text"
}, C2 = /* @__PURE__ */ Se({
  __name: "LcToast",
  props: {
    closable: { type: Boolean, default: !0 },
    headline: {},
    text: {},
    variant: { default: "info" }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      danger: "alert-triangle",
      info: "info",
      success: "checkmark",
      warning: "bell",
      win: "winning"
    };
    return (n, r) => ($(), Z("article", {
      class: ye(["lc-toast", `lc-toast--variant-${e.variant}`]),
      role: "alert"
    }, [
      ne("aside", g1, [
        Fe(j(Ke), {
          name: t[e.variant]
        }, null, 8, ["name"])
      ]),
      ne("section", b1, [
        e.headline ? ($(), Z("span", p1, Oe(e.headline), 1)) : de("", !0),
        ve(n.$slots, "default", {}, () => [
          e.text ? ($(), Z("p", y1, Oe(e.text), 1)) : de("", !0)
        ])
      ]),
      e.closable ? ($(), ke(j(kt), {
        key: 0,
        "aria-label": j(je).lcToast.closeButtonAriaLabel,
        class: "lc-toast__button-close",
        icon: "close",
        size: "small",
        variant: "tertiary",
        onClickPassive: r[0] || (r[0] = (s) => n.$emit("close"))
      }, null, 8, ["aria-label"])) : de("", !0)
    ], 2));
  }
}), E2 = ["danger", "info", "success", "warning", "win"], w1 = ["left", "right"], x1 = 0.4, k1 = 0.75, lo = 0.85, S1 = 0.2, oo = 150, _1 = 8, C1 = {
  key: 1,
  class: "lc-swipeable__action-label"
}, T2 = /* @__PURE__ */ Se({
  __name: "LcSwipeable",
  props: {
    disabled: { type: Boolean },
    leftAction: {},
    pointerTypes: {},
    rightAction: {}
  },
  emits: ["swipe-end", "swipe-start", "trigger"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = ot("lcSwipeableRef"), i = An(), a = ge(null), o = ge(0), l = ge(0), h = ge(0), v = ge(!1), u = ge(!1), f = ge(!1), m = ge(!1), c = ge(!1), p = ge(null);
    let k = 0, g = null;
    const { direction: b, distanceX: C } = rc(s, {
      onSwipe: () => {
        if (p.value === null || e.disabled || !s.value) return;
        v.value || R();
        const ce = s.value.clientWidth, se = l.value - C.value, pe = H(se);
        if (pe && !P(pe)) {
          o.value = 0;
          return;
        }
        const Pe = K(pe), He = X(se, ce, U(pe));
        m.value = _(ce, Pe), h.value = Math.min(1, Math.abs(C.value) / (ce * Pe));
        const Ue = !!(pe && T(pe)?.fullSwipe && m.value);
        V(Ue), q(pe), o.value = Ue && pe ? E(pe, ce) : He, pe && pe !== a.value && O(pe);
      },
      onSwipeEnd: (ce, se) => _e(se),
      pointerTypes: e.pointerTypes,
      threshold: _1
    }), A = W(() => w1.map((ce) => ({ action: T(ce), side: ce }))), D = W(() => [
      "lc-swipeable__content",
      { "lc-swipeable__content--dragging": v.value && !u.value }
    ]), L = W(() => lo + (1 - lo) * h.value), T = (ce) => ce === "left" ? e.leftAction : ce === "right" ? e.rightAction : void 0, P = (ce) => !!(T(ce) || i[`${ce}-action`]), U = (ce) => T(ce)?.resistanceThreshold ?? k1, K = (ce) => {
      const se = T(ce);
      return se?.fullSwipe ? U(ce) : se?.activationThreshold ?? x1;
    }, B = () => {
      if (!s.value) return 0;
      const ce = s.value.querySelector(
        ".lc-swipeable__content"
      );
      if (!ce) return 0;
      const se = getComputedStyle(ce).transform;
      if (!se || se === "none") return 0;
      const pe = new DOMMatrix(se).m41;
      return Number.isFinite(pe) ? pe : 0;
    }, X = (ce, se, pe) => {
      const Pe = se * pe, He = Math.abs(ce);
      if (He <= Pe) return ce;
      const Ue = se * S1, Ne = (1 - 1 / ((He - Pe) / Ue + 1)) * Ue;
      return Math.sign(ce) * (Pe + Ne);
    }, H = (ce) => ce < 0 ? "left" : ce > 0 ? "right" : null, _ = (ce, se) => Math.abs(C.value) >= ce * se, E = (ce, se) => ce === "left" ? -se : se, R = () => {
      l.value = B(), v.value = !0, p.value !== null && me(p.value);
    }, V = (ce) => {
      ce !== f.value && (f.value = ce, u.value = !0, k = performance.now());
    }, q = (ce) => {
      !u.value || f.value || !(performance.now() - k >= oo) && ce === a.value || (u.value = !1);
    }, O = (ce) => {
      a.value = ce, c.value = !0, r("swipe-start", ce);
    }, Q = () => {
      !c.value || !a.value || (c.value = !1, r("swipe-end", a.value));
    }, ae = () => {
      l.value = 0, h.value = 0, v.value = !1, f.value = !1, u.value = !1;
    }, le = (ce) => !e.pointerTypes || e.pointerTypes.includes(ce.pointerType), me = (ce) => {
      s.value?.setPointerCapture?.(ce);
    }, $e = (ce) => {
      s.value?.hasPointerCapture?.(ce) && s.value.releasePointerCapture(ce);
    }, xe = () => {
      g !== null && (clearTimeout(g), g = null);
    }, fe = () => {
      xe(), p.value === null && (a.value = null);
    }, be = () => {
      xe(), g = setTimeout(fe, oo);
    }, _e = (ce) => {
      if (p.value === null) return;
      $e(p.value), p.value = null, Q();
      const se = f.value;
      ae(), m.value = !1;
      const pe = !e.disabled && (ce === "left" || ce === "right") && P(ce) && s.value !== null && _(s.value.clientWidth, K(ce));
      (!pe || !se) && (o.value = 0), (!pe || !se) && be(), pe && r("trigger", ce);
    }, Me = () => {
      u.value = !1, p.value === null && o.value === 0 && fe();
    }, qe = () => {
      const ce = a.value, se = c.value;
      p.value !== null && ($e(p.value), p.value = null), ae(), o.value = 0, m.value = !1, c.value = !1, se && ce && r("swipe-end", ce), be();
    };
    return qt(s, "pointerdown", (ce) => {
      le(ce) && (xe(), p.value = ce.pointerId);
    }), qt(window, ["pointerup", "pointercancel"], (ce) => {
      ce.pointerId === p.value && _e(b.value);
    }), qt(window, "pointermove", (ce) => {
      p.value !== null && (ce.pointerType !== "mouse" || ce.buttons !== 0 || _e(b.value));
    }), qt(s, "pointercancel", qe), Be(
      () => e.disabled,
      (ce) => {
        ce && qe();
      }
    ), ai(xe), t({ close: qe }), (ce, se) => ($(), Z("div", {
      ref_key: "lcSwipeableRef",
      ref: s,
      class: "lc-swipeable"
    }, [
      ($(!0), Z(Xe, null, ht(A.value, ({ side: pe, action: Pe }) => ($(), Z(Xe, { key: pe }, [
        Pe || ce.$slots[`${pe}-action`] ? ($(), Z("div", {
          key: 0,
          class: ye([
            "lc-swipeable__action",
            `lc-swipeable__action--${pe}`,
            {
              "lc-swipeable__action--hidden": a.value !== pe,
              "lc-swipeable__action--dragging": v.value && !u.value,
              "lc-swipeable__action--past-threshold": m.value && a.value === pe
            }
          ])
        }, [
          ve(ce.$slots, `${pe}-action`, {}, () => [
            Pe ? ($(), Z("span", {
              key: 0,
              class: "lc-swipeable__action-icon",
              style: Ct(a.value === pe ? { transform: `scale(${L.value})` } : void 0)
            }, [
              Fe(j(Ke), {
                name: Pe.icon
              }, null, 8, ["name"])
            ], 4)) : de("", !0),
            Pe?.label ? ($(), Z("span", C1, Oe(Pe.label), 1)) : de("", !0)
          ])
        ], 2)) : de("", !0)
      ], 64))), 128)),
      ne("div", {
        class: ye(D.value),
        style: Ct({ transform: `translateX(${o.value}px)` }),
        onTransitionend: sa(Me, ["self"])
      }, [
        ve(ce.$slots, "default")
      ], 38)
    ], 512));
  }
}), E1 = { class: "lc-lottery-remaining-picks__headline" }, T1 = { class: "lc-lottery-remaining-picks__done" }, A1 = {
  "aria-hidden": "true",
  class: "lc-lottery-remaining-picks__check"
}, L1 = {
  key: 0,
  class: "lc-lottery-remaining-picks__label"
}, $1 = /* @__PURE__ */ Se({
  __name: "LcLotteryRemainingPicks",
  props: {
    complete: { type: Boolean, default: !1 },
    doneLabel: { default: () => je.lcLotteryRemainingPicks.doneLabel }
  },
  setup(e) {
    const t = ge(!1);
    Be(
      () => e.complete,
      (r, s) => {
        r && !s ? t.value = !0 : r || (t.value = !1);
      }
    );
    const n = (r) => {
      const s = e.doneLabel ? "lc-lottery-remaining-picks-label" : "lc-lottery-remaining-picks-pop";
      r.animationName === s && (t.value = !1);
    };
    return (r, s) => ($(), Z("div", {
      class: ye([
        "lc-lottery-remaining-picks",
        {
          "lc-lottery-remaining-picks--complete": e.complete,
          "lc-lottery-remaining-picks--playing": t.value
        }
      ]),
      onAnimationend: n
    }, [
      ne("div", E1, [
        ve(r.$slots, "default", { countClass: "lc-lottery-remaining-picks__count" })
      ]),
      ne("div", T1, [
        ne("span", A1, [
          Fe(j(Ke), {
            name: "checkmark-small",
            size: "medium"
          })
        ]),
        e.doneLabel ? ($(), Z("span", L1, Oe(e.doneLabel), 1)) : de("", !0)
      ])
    ], 34));
  }
}), I1 = ["aria-hidden"], D1 = ["aria-hidden"], M1 = {
  key: 1,
  class: "lc-lottery-editor-card__labels"
}, O1 = {
  key: 0,
  class: "lc-lottery-editor-card__label"
}, R1 = {
  key: 1,
  class: "lc-lottery-editor-card__label"
}, F1 = { class: "lc-lottery-editor-card__footer" }, N1 = "medium", A2 = /* @__PURE__ */ Se({
  __name: "LcLotteryEditorCard",
  props: /* @__PURE__ */ Sn({
    id: {},
    radius: { default: "large" },
    shadow: { default: "small" },
    betType: {},
    clearDisabled: { type: Boolean },
    clearLabel: { default: () => je.lcLotteryEditorCard.clearLabel },
    complete: { type: Boolean },
    doneLabel: {},
    expanded: { type: Boolean },
    fields: {},
    quickPickLabel: { default: () => je.lcLotteryEditorCard.quickPickLabel },
    remaining: {},
    toggleAriaLabel: { default: () => je.lcLotteryEditorCard.toggleAriaLabel },
    wager: {},
    separated: { type: Boolean, default: !1 }
  }, {
    expanded: { type: Boolean, default: !0 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ Sn(["clear", "collapse", "collapsed", "expand", "expanded", "quick-pick", "update:expanded"], ["update:expanded"]),
  setup(e, { emit: t }) {
    const n = t, r = Wa(e, "expanded"), s = ot("summary"), i = ot("numbers"), a = (f) => i.value?.$el?.querySelector(f) ?? void 0, o = W(() => a(".lc-lottery-numbers__number")), { width: l } = Hr(s), { width: h } = Hr(o), v = W(
      () => e.fields?.reduce((f, { numbers: m }) => f + m.length, 0) ?? 0
    ), u = W(() => {
      if (!l.value || !h.value || !v.value) return;
      const f = a(".lc-lottery-numbers__list"), m = f && parseFloat(getComputedStyle(f).columnGap) || 0, c = Math.max(
        1,
        Math.floor((l.value + m) / (h.value + m))
      ), p = Math.ceil(v.value / c);
      return p > 1 ? p : void 0;
    });
    return (f, m) => ($(), ke(j(ya), Ae({
      modelValue: r.value,
      "onUpdate:modelValue": m[2] || (m[2] = (c) => r.value = c),
      animated: "",
      "body-class": "lc-lottery-editor-card__body",
      class: ["lc-lottery-editor-card", { "lc-lottery-editor-card--separated": e.separated }],
      expandable: "",
      "footer-class": "lc-lottery-editor-card__footer-slot",
      "header-class": r.value ? "lc-lottery-editor-card__header--expanded" : "lc-lottery-editor-card__header"
    }, { id: e.id, radius: e.radius, shadow: e.shadow, toggleAriaLabel: e.toggleAriaLabel }, {
      onCollapse: m[3] || (m[3] = (c) => n("collapse")),
      onCollapsed: m[4] || (m[4] = (c) => n("collapsed")),
      onExpand: m[5] || (m[5] = (c) => n("expand")),
      onExpanded: m[6] || (m[6] = (c) => n("expanded"))
    }), {
      header: Te(() => [
        ne("div", {
          class: ye([
            "lc-lottery-editor-card__header-content",
            { "lc-lottery-editor-card__header-content--collapsed": !r.value }
          ])
        }, [
          ne("div", {
            "aria-hidden": !r.value,
            class: "lc-lottery-editor-card__expanded"
          }, [
            Fe(j($1), Lt(Ot({ complete: e.complete, doneLabel: e.doneLabel, remaining: e.remaining })), {
              default: Te(({ countClass: c }) => [
                ve(f.$slots, "headline", Lt(Ot({ countClass: c })))
              ]),
              _: 3
            }, 16)
          ], 8, I1),
          ne("div", {
            ref: "summary",
            "aria-hidden": r.value,
            class: "lc-lottery-editor-card__summary"
          }, [
            e.fields ? ($(), ke(j(qh), Ae({
              key: 0,
              ref: "numbers"
            }, { fields: e.fields }, {
              rows: u.value,
              size: N1
            }), null, 16, ["rows"])) : de("", !0),
            e.wager || e.betType ? ($(), Z("div", M1, [
              e.wager ? ($(), Z("span", O1, Oe(e.wager), 1)) : de("", !0),
              e.betType ? ($(), Z("span", R1, Oe(e.betType), 1)) : de("", !0)
            ])) : de("", !0)
          ], 8, D1)
        ], 2)
      ]),
      footer: Te(() => [
        ne("div", F1, [
          Fe(j(kt), {
            class: "lc-lottery-editor-card__clear",
            disabled: e.clearDisabled,
            icon: "trash-full",
            size: "medium",
            variant: e.clearDisabled ? "tertiary" : "raised",
            onClick: m[0] || (m[0] = (c) => n("clear"))
          }, {
            default: Te(() => [
              xt(Oe(e.clearLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "variant"]),
          Fe(j(kt), {
            class: "lc-lottery-editor-card__quick-pick",
            icon: "flash",
            size: "medium",
            variant: "raised",
            onClick: m[1] || (m[1] = (c) => n("quick-pick"))
          }, {
            default: Te(() => [
              xt(Oe(e.quickPickLabel), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: Te(() => [
        e.separated ? ($(), ke(j(ui), {
          key: 0,
          class: "lc-lottery-editor-card__divider"
        })) : de("", !0),
        ve(f.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "class", "header-class"]));
  }
});
export {
  Zo as AmplitudeEvents,
  Pt as FORM_FIELD_EVENTS,
  ag as LC_BOTTOM_SHEET_CLOSE_TRIGGERS,
  j1 as LC_BUTTON_ICON_POSITIONS,
  Z1 as LC_BUTTON_SIZES,
  Y1 as LC_BUTTON_TRIGGERS,
  W1 as LC_BUTTON_TYPES,
  X1 as LC_BUTTON_VARIANTS,
  K1 as LC_CARD_RADII,
  J1 as LC_CARD_SHADOWS,
  Q1 as LC_CARD_VARIANTS,
  ig as LC_CAROUSEL_MOVE_TRIGGERS,
  rg as LC_CAROUSEL_VARIANTS,
  og as LC_COUNTDOWN_VARIANTS,
  yg as LC_FORM_FIELD_INTERACTION_MODES,
  H1 as LC_ICON_NAMES,
  V1 as LC_ICON_SIZES,
  Sg as LC_INFO_BUTTON_VARIANTS,
  Dg as LC_INFO_TEXT_ICON_ALIGNMENTS,
  Mg as LC_INFO_TEXT_SIZES,
  ug as LC_INPUT_MODES,
  dg as LC_INPUT_TYPES,
  Fg as LC_LOTTERY_CUTOFF_TIME_VARIANTS,
  kg as LC_LOTTERY_JACPOT_SIZES,
  Bg as LC_LOTTERY_NUMBER_SELECTOR_VARIANTS,
  Ng as LC_LOTTERY_NUMBER_SIZES,
  Pg as LC_LOTTERY_NUMBER_SPACINGS,
  Hg as LC_LOTTERY_TEASER_VARIANTS,
  qg as LC_MENU_BUTTON_PLACEMENTS,
  Wg as LC_MESSAGE_BOX_SIZES,
  Yg as LC_MESSAGE_BOX_VARIANTS,
  eg as LC_MODAL_CLOSE_TRIGGERS,
  tg as LC_MODAL_SPACINGS,
  Kg as LC_PASSWORD_INPUT_TYPES,
  Qg as LC_PROGRESS_INDICATOR_SIZES,
  e2 as LC_PROGRESS_INDICATOR_VARIANTS,
  a2 as LC_RADIO_GROUP_LAYOUTS,
  s2 as LC_SCRATCHCARD_TEASER_VARIANTS,
  u2 as LC_SELECT_LIST_VARIANTS,
  G1 as LC_SEPARATOR_VARIANTS,
  i2 as LC_SKELETON_RADII,
  m2 as LC_SWITCH_VARIANTS,
  b2 as LC_TABLE_PADDINGS,
  p2 as LC_TABS_FLEX_DIRECTIONS,
  y2 as LC_TABS_NAVIGATION_POSITIONS,
  w2 as LC_TABS_TRIGGERS,
  x2 as LC_TABS_VARIANTS,
  _g as LC_TEASER_BACKGROUND_PATTERNS,
  Cg as LC_TEASER_BADGE_VARIANTS,
  Eg as LC_TEASER_HERO_BADGE_VARIANTS,
  Ko as LC_TEASER_VARIANTS,
  E2 as LC_TOAST_VARIANTS,
  U1 as LcBadge,
  ng as LcBottomSheet,
  kt as LcButton,
  Zr as LcButtonActiveKeys,
  ya as LcCard,
  Kd as LcCarousel,
  Oa as LcCarouselActiveKeys,
  lg as LcCheckbox,
  Ur as LcCountBubble,
  af as LcCountdown,
  sg as LcDataList,
  cg as LcDataListItem,
  fg as LcDateInput,
  hg as LcDescriptionList,
  vg as LcDigitInput,
  ln as LcDigitInputActiveKeys,
  mg as LcDigitInputGroup,
  Mf as LcExpandable,
  gg as LcExpandableList,
  bg as LcFlyOut,
  pg as LcForm,
  wg as LcFormField,
  xg as LcHeader,
  Qf as LcHighFrequencyBall,
  Wo as LcHighFrequencyBallBackground,
  Tg as LcHighFrequencyTeaser,
  Ag as LcHighFrequencyTeaserWatch,
  Ke as LcIcon,
  $g as LcImage,
  Go as LcInfoButton,
  Ig as LcInfoText,
  tr as LcInput,
  Og as LcLinkList,
  Rg as LcLinkListItem,
  Hl as LcLotteryCutoffTime,
  A2 as LcLotteryEditorCard,
  Yo as LcLotteryJackpot,
  zg as LcLotteryNumberSelector,
  Zt as LcLotteryNumberSelectorActiveKeys,
  qh as LcLotteryNumbers,
  $1 as LcLotteryRemainingPicks,
  Vg as LcLotteryTeaser,
  Ug as LcMaskedValueDisplay,
  jg as LcMenuButton,
  Ut as LcMenuButtonActiveKeys,
  Zg as LcMessageBox,
  Mo as LcModal,
  Xg as LcMoneyInput,
  Gg as LcPasswordInput,
  Jg as LcProgressIndicator,
  um as LcRadio,
  t2 as LcRadioCard,
  n2 as LcRadioGroup,
  r2 as LcRating,
  l2 as LcRemoteList,
  o2 as LcScratchcardTeaser,
  c2 as LcSelect,
  Gt as LcSelectActiveKeys,
  d2 as LcSelectList,
  Wt as LcSelectListActiveKeys,
  ui as LcSeparator,
  mm as LcSkeleton,
  f2 as LcSlider,
  h2 as LcSlotWheel,
  T2 as LcSwipeable,
  v2 as LcSwitch,
  g2 as LcTable,
  S2 as LcTabs,
  Nn as LcTabsActiveKeys,
  nr as LcTeaser,
  x0 as LcTeaserBadge,
  S0 as LcTeaserHeroBadge,
  Jo as LcTeaserHeroBadgeColor,
  _2 as LcTextarea,
  C2 as LcToast,
  Xr as carouselContext,
  je as globalConfig,
  _0 as isHeroBadge,
  vu as nuxtAppContext,
  q1 as setGlobalConfig,
  k2 as tabContext
};
